
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  /**
 * @todo Notice that `grid.detail` and `gridToPoints.gpgpu.scale` seem linearly
 *   connected to affect performance, probably because `pointsToGrid` tends to
 *   overlap more and cause more blending when the ratio of points to cells is
 *   high...?
 *   In any case, a way to decouple this would be to have a separate set of
 *   tracer points for rendering only that just follow the grid forces, so there
 *   can be more rendered points for the number of material points.
 *
 * @todo Fix grid artefacts:
 * - One clearer cause is `gridToPoints.positionAdjust[1] = 1`;
 *   explore, isolate, identify.
 * - One possible lesser cause is `grid.limit = 1e8`; probably to do with
 *   points crossing cells coinciding with time-step, seems to be helped by
 *   tweaking `passes` higher or lower (higher increases accuracy, lower seems
 *   to let points jump cells).
 */ var $0ae6c16566b9f761$exports = {};
(function(global, factory) {
    $0ae6c16566b9f761$exports = factory();
})($0ae6c16566b9f761$exports, function() {
    "use strict";
    var isTypedArray = function(x) {
        return x instanceof Uint8Array || x instanceof Uint16Array || x instanceof Uint32Array || x instanceof Int8Array || x instanceof Int16Array || x instanceof Int32Array || x instanceof Float32Array || x instanceof Float64Array || x instanceof Uint8ClampedArray;
    };
    var extend = function(base, opts) {
        var keys = Object.keys(opts);
        for(var i = 0; i < keys.length; ++i)base[keys[i]] = opts[keys[i]];
        return base;
    };
    // Error checking and parameter validation.
    //
    // Statements for the form `check.someProcedure(...)` get removed by
    // a browserify transform for optimized/minified bundles.
    //
    /* globals atob */ var endl = "\n";
    // only used for extracting shader names.  if atob not present, then errors
    // will be slightly crappier
    function decodeB64(str) {
        if (typeof atob !== "undefined") return atob(str);
        return "base64:" + str;
    }
    function raise(message) {
        var error = new Error("(regl) " + message);
        console.error(error);
        throw error;
    }
    function check(pred, message) {
        if (!pred) raise(message);
    }
    function encolon(message) {
        if (message) return ": " + message;
        return "";
    }
    function checkParameter(param, possibilities, message) {
        if (!(param in possibilities)) raise("unknown parameter (" + param + ")" + encolon(message) + ". possible values: " + Object.keys(possibilities).join());
    }
    function checkIsTypedArray(data, message) {
        if (!isTypedArray(data)) raise("invalid parameter type" + encolon(message) + ". must be a typed array");
    }
    function standardTypeEh(value, type) {
        switch(type){
            case "number":
                return typeof value === "number";
            case "object":
                return typeof value === "object";
            case "string":
                return typeof value === "string";
            case "boolean":
                return typeof value === "boolean";
            case "function":
                return typeof value === "function";
            case "undefined":
                return typeof value === "undefined";
            case "symbol":
                return typeof value === "symbol";
        }
    }
    function checkTypeOf(value, type, message) {
        if (!standardTypeEh(value, type)) raise("invalid parameter type" + encolon(message) + ". expected " + type + ", got " + typeof value);
    }
    function checkNonNegativeInt(value, message) {
        if (!(value >= 0 && (value | 0) === value)) raise("invalid parameter type, (" + value + ")" + encolon(message) + ". must be a nonnegative integer");
    }
    function checkOneOf(value, list, message) {
        if (list.indexOf(value) < 0) raise("invalid value" + encolon(message) + ". must be one of: " + list);
    }
    var constructorKeys = [
        "gl",
        "canvas",
        "container",
        "attributes",
        "pixelRatio",
        "extensions",
        "optionalExtensions",
        "profile",
        "onDone"
    ];
    function checkConstructor(obj) {
        Object.keys(obj).forEach(function(key) {
            if (constructorKeys.indexOf(key) < 0) raise('invalid regl constructor argument "' + key + '". must be one of ' + constructorKeys);
        });
    }
    function leftPad(str, n) {
        str = str + "";
        while(str.length < n)str = " " + str;
        return str;
    }
    function ShaderFile() {
        this.name = "unknown";
        this.lines = [];
        this.index = {};
        this.hasErrors = false;
    }
    function ShaderLine(number, line) {
        this.number = number;
        this.line = line;
        this.errors = [];
    }
    function ShaderError(fileNumber, lineNumber, message) {
        this.file = fileNumber;
        this.line = lineNumber;
        this.message = message;
    }
    function guessCommand() {
        var error = new Error();
        var stack = (error.stack || error).toString();
        var pat = /compileProcedure.*\n\s*at.*\((.*)\)/.exec(stack);
        if (pat) return pat[1];
        var pat2 = /compileProcedure.*\n\s*at\s+(.*)(\n|$)/.exec(stack);
        if (pat2) return pat2[1];
        return "unknown";
    }
    function guessCallSite() {
        var error = new Error();
        var stack = (error.stack || error).toString();
        var pat = /at REGLCommand.*\n\s+at.*\((.*)\)/.exec(stack);
        if (pat) return pat[1];
        var pat2 = /at REGLCommand.*\n\s+at\s+(.*)\n/.exec(stack);
        if (pat2) return pat2[1];
        return "unknown";
    }
    function parseSource(source, command) {
        var lines = source.split("\n");
        var lineNumber = 1;
        var fileNumber = 0;
        var files = {
            unknown: new ShaderFile(),
            0: new ShaderFile()
        };
        files.unknown.name = files[0].name = command || guessCommand();
        files.unknown.lines.push(new ShaderLine(0, ""));
        for(var i = 0; i < lines.length; ++i){
            var line = lines[i];
            var parts = /^\s*#\s*(\w+)\s+(.+)\s*$/.exec(line);
            if (parts) switch(parts[1]){
                case "line":
                    var lineNumberInfo = /(\d+)(\s+\d+)?/.exec(parts[2]);
                    if (lineNumberInfo) {
                        lineNumber = lineNumberInfo[1] | 0;
                        if (lineNumberInfo[2]) {
                            fileNumber = lineNumberInfo[2] | 0;
                            if (!(fileNumber in files)) files[fileNumber] = new ShaderFile();
                        }
                    }
                    break;
                case "define":
                    var nameInfo = /SHADER_NAME(_B64)?\s+(.*)$/.exec(parts[2]);
                    if (nameInfo) files[fileNumber].name = nameInfo[1] ? decodeB64(nameInfo[2]) : nameInfo[2];
                    break;
            }
            files[fileNumber].lines.push(new ShaderLine(lineNumber++, line));
        }
        Object.keys(files).forEach(function(fileNumber) {
            var file = files[fileNumber];
            file.lines.forEach(function(line) {
                file.index[line.number] = line;
            });
        });
        return files;
    }
    function parseErrorLog(errLog) {
        var result = [];
        errLog.split("\n").forEach(function(errMsg) {
            if (errMsg.length < 5) return;
            var parts = /^ERROR:\s+(\d+):(\d+):\s*(.*)$/.exec(errMsg);
            if (parts) result.push(new ShaderError(parts[1] | 0, parts[2] | 0, parts[3].trim()));
            else if (errMsg.length > 0) result.push(new ShaderError("unknown", 0, errMsg));
        });
        return result;
    }
    function annotateFiles(files, errors) {
        errors.forEach(function(error) {
            var file = files[error.file];
            if (file) {
                var line = file.index[error.line];
                if (line) {
                    line.errors.push(error);
                    file.hasErrors = true;
                    return;
                }
            }
            files.unknown.hasErrors = true;
            files.unknown.lines[0].errors.push(error);
        });
    }
    function checkShaderError(gl, shader, source, type, command) {
        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
            var errLog = gl.getShaderInfoLog(shader);
            var typeName = type === gl.FRAGMENT_SHADER ? "fragment" : "vertex";
            checkCommandType(source, "string", typeName + " shader source must be a string", command);
            var files = parseSource(source, command);
            var errors = parseErrorLog(errLog);
            annotateFiles(files, errors);
            Object.keys(files).forEach(function(fileNumber) {
                var file = files[fileNumber];
                if (!file.hasErrors) return;
                var strings = [
                    ""
                ];
                var styles = [
                    ""
                ];
                function push(str, style) {
                    strings.push(str);
                    styles.push(style || "");
                }
                push("file number " + fileNumber + ": " + file.name + "\n", "color:red;text-decoration:underline;font-weight:bold");
                file.lines.forEach(function(line) {
                    if (line.errors.length > 0) {
                        push(leftPad(line.number, 4) + "|  ", "background-color:yellow; font-weight:bold");
                        push(line.line + endl, "color:red; background-color:yellow; font-weight:bold");
                        // try to guess token
                        var offset = 0;
                        line.errors.forEach(function(error) {
                            var message = error.message;
                            var token = /^\s*'(.*)'\s*:\s*(.*)$/.exec(message);
                            if (token) {
                                var tokenPat = token[1];
                                message = token[2];
                                switch(tokenPat){
                                    case "assign":
                                        tokenPat = "=";
                                        break;
                                }
                                offset = Math.max(line.line.indexOf(tokenPat, offset), 0);
                            } else offset = 0;
                            push(leftPad("| ", 6));
                            push(leftPad("^^^", offset + 3) + endl, "font-weight:bold");
                            push(leftPad("| ", 6));
                            push(message + endl, "font-weight:bold");
                        });
                        push(leftPad("| ", 6) + endl);
                    } else {
                        push(leftPad(line.number, 4) + "|  ");
                        push(line.line + endl, "color:red");
                    }
                });
                if (typeof document !== "undefined" && !window.chrome) {
                    styles[0] = strings.join("%c");
                    console.log.apply(console, styles);
                } else console.log(strings.join(""));
            });
            check.raise("Error compiling " + typeName + " shader, " + files[0].name);
        }
    }
    function checkLinkError(gl, program, fragShader, vertShader, command) {
        if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
            var errLog = gl.getProgramInfoLog(program);
            var fragParse = parseSource(fragShader, command);
            var vertParse = parseSource(vertShader, command);
            var header = 'Error linking program with vertex shader, "' + vertParse[0].name + '", and fragment shader "' + fragParse[0].name + '"';
            if (typeof document !== "undefined") console.log("%c" + header + endl + "%c" + errLog, "color:red;text-decoration:underline;font-weight:bold", "color:red");
            else console.log(header + endl + errLog);
            check.raise(header);
        }
    }
    function saveCommandRef(object) {
        object._commandRef = guessCommand();
    }
    function saveDrawCommandInfo(opts, uniforms, attributes, stringStore) {
        saveCommandRef(opts);
        function id(str) {
            if (str) return stringStore.id(str);
            return 0;
        }
        opts._fragId = id(opts.static.frag);
        opts._vertId = id(opts.static.vert);
        function addProps(dict, set) {
            Object.keys(set).forEach(function(u) {
                dict[stringStore.id(u)] = true;
            });
        }
        var uniformSet = opts._uniformSet = {};
        addProps(uniformSet, uniforms.static);
        addProps(uniformSet, uniforms.dynamic);
        var attributeSet = opts._attributeSet = {};
        addProps(attributeSet, attributes.static);
        addProps(attributeSet, attributes.dynamic);
        opts._hasCount = "count" in opts.static || "count" in opts.dynamic || "elements" in opts.static || "elements" in opts.dynamic;
    }
    function commandRaise(message, command) {
        var callSite = guessCallSite();
        raise(message + " in command " + (command || guessCommand()) + (callSite === "unknown" ? "" : " called from " + callSite));
    }
    function checkCommand(pred, message, command) {
        if (!pred) commandRaise(message, command || guessCommand());
    }
    function checkParameterCommand(param, possibilities, message, command) {
        if (!(param in possibilities)) commandRaise("unknown parameter (" + param + ")" + encolon(message) + ". possible values: " + Object.keys(possibilities).join(), command || guessCommand());
    }
    function checkCommandType(value, type, message, command) {
        if (!standardTypeEh(value, type)) commandRaise("invalid parameter type" + encolon(message) + ". expected " + type + ", got " + typeof value, command || guessCommand());
    }
    function checkOptional(block) {
        block();
    }
    function checkFramebufferFormat(attachment, texFormats, rbFormats) {
        if (attachment.texture) checkOneOf(attachment.texture._texture.internalformat, texFormats, "unsupported texture format for attachment");
        else checkOneOf(attachment.renderbuffer._renderbuffer.format, rbFormats, "unsupported renderbuffer format for attachment");
    }
    var GL_CLAMP_TO_EDGE = 0x812F;
    var GL_NEAREST = 0x2600;
    var GL_NEAREST_MIPMAP_NEAREST = 0x2700;
    var GL_LINEAR_MIPMAP_NEAREST = 0x2701;
    var GL_NEAREST_MIPMAP_LINEAR = 0x2702;
    var GL_LINEAR_MIPMAP_LINEAR = 0x2703;
    var GL_BYTE = 5120;
    var GL_UNSIGNED_BYTE = 5121;
    var GL_SHORT = 5122;
    var GL_UNSIGNED_SHORT = 5123;
    var GL_INT = 5124;
    var GL_UNSIGNED_INT = 5125;
    var GL_FLOAT = 5126;
    var GL_UNSIGNED_SHORT_4_4_4_4 = 0x8033;
    var GL_UNSIGNED_SHORT_5_5_5_1 = 0x8034;
    var GL_UNSIGNED_SHORT_5_6_5 = 0x8363;
    var GL_UNSIGNED_INT_24_8_WEBGL = 0x84FA;
    var GL_HALF_FLOAT_OES = 0x8D61;
    var TYPE_SIZE = {};
    TYPE_SIZE[GL_BYTE] = TYPE_SIZE[GL_UNSIGNED_BYTE] = 1;
    TYPE_SIZE[GL_SHORT] = TYPE_SIZE[GL_UNSIGNED_SHORT] = TYPE_SIZE[GL_HALF_FLOAT_OES] = TYPE_SIZE[GL_UNSIGNED_SHORT_5_6_5] = TYPE_SIZE[GL_UNSIGNED_SHORT_4_4_4_4] = TYPE_SIZE[GL_UNSIGNED_SHORT_5_5_5_1] = 2;
    TYPE_SIZE[GL_INT] = TYPE_SIZE[GL_UNSIGNED_INT] = TYPE_SIZE[GL_FLOAT] = TYPE_SIZE[GL_UNSIGNED_INT_24_8_WEBGL] = 4;
    function pixelSize(type, channels) {
        if (type === GL_UNSIGNED_SHORT_5_5_5_1 || type === GL_UNSIGNED_SHORT_4_4_4_4 || type === GL_UNSIGNED_SHORT_5_6_5) return 2;
        else if (type === GL_UNSIGNED_INT_24_8_WEBGL) return 4;
        else return TYPE_SIZE[type] * channels;
    }
    function isPow2(v) {
        return !(v & v - 1) && !!v;
    }
    function checkTexture2D(info, mipData, limits) {
        var i;
        var w = mipData.width;
        var h = mipData.height;
        var c = mipData.channels;
        // Check texture shape
        check(w > 0 && w <= limits.maxTextureSize && h > 0 && h <= limits.maxTextureSize, "invalid texture shape");
        // check wrap mode
        if (info.wrapS !== GL_CLAMP_TO_EDGE || info.wrapT !== GL_CLAMP_TO_EDGE) check(isPow2(w) && isPow2(h), "incompatible wrap mode for texture, both width and height must be power of 2");
        if (mipData.mipmask === 1) {
            if (w !== 1 && h !== 1) check(info.minFilter !== GL_NEAREST_MIPMAP_NEAREST && info.minFilter !== GL_NEAREST_MIPMAP_LINEAR && info.minFilter !== GL_LINEAR_MIPMAP_NEAREST && info.minFilter !== GL_LINEAR_MIPMAP_LINEAR, "min filter requires mipmap");
        } else {
            // texture must be power of 2
            check(isPow2(w) && isPow2(h), "texture must be a square power of 2 to support mipmapping");
            check(mipData.mipmask === (w << 1) - 1, "missing or incomplete mipmap data");
        }
        if (mipData.type === GL_FLOAT) {
            if (limits.extensions.indexOf("oes_texture_float_linear") < 0) check(info.minFilter === GL_NEAREST && info.magFilter === GL_NEAREST, "filter not supported, must enable oes_texture_float_linear");
            check(!info.genMipmaps, "mipmap generation not supported with float textures");
        }
        // check image complete
        var mipimages = mipData.images;
        for(i = 0; i < 16; ++i){
            if (mipimages[i]) {
                var mw = w >> i;
                var mh = h >> i;
                check(mipData.mipmask & 1 << i, "missing mipmap data");
                var img = mipimages[i];
                check(img.width === mw && img.height === mh, "invalid shape for mip images");
                check(img.format === mipData.format && img.internalformat === mipData.internalformat && img.type === mipData.type, "incompatible type for mip image");
                if (img.compressed) ;
                else if (img.data) {
                    // check(img.data.byteLength === mw * mh *
                    // Math.max(pixelSize(img.type, c), img.unpackAlignment),
                    var rowSize = Math.ceil(pixelSize(img.type, c) * mw / img.unpackAlignment) * img.unpackAlignment;
                    check(img.data.byteLength === rowSize * mh, "invalid data for image, buffer size is inconsistent with image format");
                } else if (img.element) ;
                else img.copy;
            } else if (!info.genMipmaps) check((mipData.mipmask & 1 << i) === 0, "extra mipmap data");
        }
        if (mipData.compressed) check(!info.genMipmaps, "mipmap generation for compressed images not supported");
    }
    function checkTextureCube(texture, info, faces, limits) {
        var w = texture.width;
        var h = texture.height;
        var c = texture.channels;
        // Check texture shape
        check(w > 0 && w <= limits.maxTextureSize && h > 0 && h <= limits.maxTextureSize, "invalid texture shape");
        check(w === h, "cube map must be square");
        check(info.wrapS === GL_CLAMP_TO_EDGE && info.wrapT === GL_CLAMP_TO_EDGE, "wrap mode not supported by cube map");
        for(var i = 0; i < faces.length; ++i){
            var face = faces[i];
            check(face.width === w && face.height === h, "inconsistent cube map face shape");
            if (info.genMipmaps) {
                check(!face.compressed, "can not generate mipmap for compressed textures");
                check(face.mipmask === 1, "can not specify mipmaps and generate mipmaps");
            }
            var mipmaps = face.images;
            for(var j = 0; j < 16; ++j){
                var img = mipmaps[j];
                if (img) {
                    var mw = w >> j;
                    var mh = h >> j;
                    check(face.mipmask & 1 << j, "missing mipmap data");
                    check(img.width === mw && img.height === mh, "invalid shape for mip images");
                    check(img.format === texture.format && img.internalformat === texture.internalformat && img.type === texture.type, "incompatible type for mip image");
                    if (img.compressed) ;
                    else if (img.data) check(img.data.byteLength === mw * mh * Math.max(pixelSize(img.type, c), img.unpackAlignment), "invalid data for image, buffer size is inconsistent with image format");
                    else if (img.element) ;
                    else img.copy;
                }
            }
        }
    }
    var check$1 = extend(check, {
        optional: checkOptional,
        raise: raise,
        commandRaise: commandRaise,
        command: checkCommand,
        parameter: checkParameter,
        commandParameter: checkParameterCommand,
        constructor: checkConstructor,
        type: checkTypeOf,
        commandType: checkCommandType,
        isTypedArray: checkIsTypedArray,
        nni: checkNonNegativeInt,
        oneOf: checkOneOf,
        shaderError: checkShaderError,
        linkError: checkLinkError,
        callSite: guessCallSite,
        saveCommandRef: saveCommandRef,
        saveDrawInfo: saveDrawCommandInfo,
        framebufferFormat: checkFramebufferFormat,
        guessCommand: guessCommand,
        texture2D: checkTexture2D,
        textureCube: checkTextureCube
    });
    var VARIABLE_COUNTER = 0;
    var DYN_FUNC = 0;
    var DYN_CONSTANT = 5;
    var DYN_ARRAY = 6;
    function DynamicVariable(type, data) {
        this.id = VARIABLE_COUNTER++;
        this.type = type;
        this.data = data;
    }
    function escapeStr(str) {
        return str.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
    }
    function splitParts(str) {
        if (str.length === 0) return [];
        var firstChar = str.charAt(0);
        var lastChar = str.charAt(str.length - 1);
        if (str.length > 1 && firstChar === lastChar && (firstChar === '"' || firstChar === "'")) return [
            '"' + escapeStr(str.substr(1, str.length - 2)) + '"'
        ];
        var parts = /\[(false|true|null|\d+|'[^']*'|"[^"]*")\]/.exec(str);
        if (parts) return splitParts(str.substr(0, parts.index)).concat(splitParts(parts[1])).concat(splitParts(str.substr(parts.index + parts[0].length)));
        var subparts = str.split(".");
        if (subparts.length === 1) return [
            '"' + escapeStr(str) + '"'
        ];
        var result = [];
        for(var i = 0; i < subparts.length; ++i)result = result.concat(splitParts(subparts[i]));
        return result;
    }
    function toAccessorString(str) {
        return "[" + splitParts(str).join("][") + "]";
    }
    function defineDynamic(type, data) {
        return new DynamicVariable(type, toAccessorString(data + ""));
    }
    function isDynamic(x) {
        return typeof x === "function" && !x._reglType || x instanceof DynamicVariable;
    }
    function unbox(x, path) {
        if (typeof x === "function") return new DynamicVariable(DYN_FUNC, x);
        else if (typeof x === "number" || typeof x === "boolean") return new DynamicVariable(DYN_CONSTANT, x);
        else if (Array.isArray(x)) return new DynamicVariable(DYN_ARRAY, x.map(function(y, i) {
            return unbox(y, path + "[" + i + "]");
        }));
        else if (x instanceof DynamicVariable) return x;
        check$1(false, "invalid option type in uniform " + path);
    }
    var dynamic = {
        DynamicVariable: DynamicVariable,
        define: defineDynamic,
        isDynamic: isDynamic,
        unbox: unbox,
        accessor: toAccessorString
    };
    /* globals requestAnimationFrame, cancelAnimationFrame */ var raf = {
        next: typeof requestAnimationFrame === "function" ? function(cb) {
            return requestAnimationFrame(cb);
        } : function(cb) {
            return setTimeout(cb, 16);
        },
        cancel: typeof cancelAnimationFrame === "function" ? function(raf) {
            return cancelAnimationFrame(raf);
        } : clearTimeout
    };
    /* globals performance */ var clock = typeof performance !== "undefined" && performance.now ? function() {
        return performance.now();
    } : function() {
        return +new Date();
    };
    function createStringStore() {
        var stringIds = {
            "": 0
        };
        var stringValues = [
            ""
        ];
        return {
            id: function(str) {
                var result = stringIds[str];
                if (result) return result;
                result = stringIds[str] = stringValues.length;
                stringValues.push(str);
                return result;
            },
            str: function(id) {
                return stringValues[id];
            }
        };
    }
    // Context and canvas creation helper functions
    function createCanvas(element, onDone, pixelRatio) {
        var canvas = document.createElement("canvas");
        extend(canvas.style, {
            border: 0,
            margin: 0,
            padding: 0,
            top: 0,
            left: 0,
            width: "100%",
            height: "100%"
        });
        element.appendChild(canvas);
        if (element === document.body) {
            canvas.style.position = "absolute";
            extend(element.style, {
                margin: 0,
                padding: 0
            });
        }
        function resize() {
            var w = window.innerWidth;
            var h = window.innerHeight;
            if (element !== document.body) {
                var bounds = canvas.getBoundingClientRect();
                w = bounds.right - bounds.left;
                h = bounds.bottom - bounds.top;
            }
            canvas.width = pixelRatio * w;
            canvas.height = pixelRatio * h;
        }
        var resizeObserver;
        if (element !== document.body && typeof ResizeObserver === "function") {
            // ignore 'ResizeObserver' is not defined
            // eslint-disable-next-line
            resizeObserver = new ResizeObserver(function() {
                // setTimeout to avoid flicker
                setTimeout(resize);
            });
            resizeObserver.observe(element);
        } else window.addEventListener("resize", resize, false);
        function onDestroy() {
            if (resizeObserver) resizeObserver.disconnect();
            else window.removeEventListener("resize", resize);
            element.removeChild(canvas);
        }
        resize();
        return {
            canvas: canvas,
            onDestroy: onDestroy
        };
    }
    function createContext(canvas, contextAttributes) {
        function get(name) {
            try {
                return canvas.getContext(name, contextAttributes);
            } catch (e) {
                return null;
            }
        }
        return get("webgl") || get("experimental-webgl") || get("webgl-experimental");
    }
    function isHTMLElement(obj) {
        return typeof obj.nodeName === "string" && typeof obj.appendChild === "function" && typeof obj.getBoundingClientRect === "function";
    }
    function isWebGLContext(obj) {
        return typeof obj.drawArrays === "function" || typeof obj.drawElements === "function";
    }
    function parseExtensions(input) {
        if (typeof input === "string") return input.split();
        check$1(Array.isArray(input), "invalid extension array");
        return input;
    }
    function getElement(desc) {
        if (typeof desc === "string") {
            check$1(typeof document !== "undefined", "not supported outside of DOM");
            return document.querySelector(desc);
        }
        return desc;
    }
    function parseArgs(args_) {
        var args = args_ || {};
        var element, container, canvas, gl;
        var contextAttributes = {};
        var extensions = [];
        var optionalExtensions = [];
        var pixelRatio = typeof window === "undefined" ? 1 : window.devicePixelRatio;
        var profile = false;
        var onDone = function(err) {
            if (err) check$1.raise(err);
        };
        var onDestroy = function() {};
        if (typeof args === "string") {
            check$1(typeof document !== "undefined", "selector queries only supported in DOM environments");
            element = document.querySelector(args);
            check$1(element, "invalid query string for element");
        } else if (typeof args === "object") {
            if (isHTMLElement(args)) element = args;
            else if (isWebGLContext(args)) {
                gl = args;
                canvas = gl.canvas;
            } else {
                check$1.constructor(args);
                if ("gl" in args) gl = args.gl;
                else if ("canvas" in args) canvas = getElement(args.canvas);
                else if ("container" in args) container = getElement(args.container);
                if ("attributes" in args) {
                    contextAttributes = args.attributes;
                    check$1.type(contextAttributes, "object", "invalid context attributes");
                }
                if ("extensions" in args) extensions = parseExtensions(args.extensions);
                if ("optionalExtensions" in args) optionalExtensions = parseExtensions(args.optionalExtensions);
                if ("onDone" in args) {
                    check$1.type(args.onDone, "function", "invalid or missing onDone callback");
                    onDone = args.onDone;
                }
                if ("profile" in args) profile = !!args.profile;
                if ("pixelRatio" in args) {
                    pixelRatio = +args.pixelRatio;
                    check$1(pixelRatio > 0, "invalid pixel ratio");
                }
            }
        } else check$1.raise("invalid arguments to regl");
        if (element) {
            if (element.nodeName.toLowerCase() === "canvas") canvas = element;
            else container = element;
        }
        if (!gl) {
            if (!canvas) {
                check$1(typeof document !== "undefined", "must manually specify webgl context outside of DOM environments");
                var result = createCanvas(container || document.body, onDone, pixelRatio);
                if (!result) return null;
                canvas = result.canvas;
                onDestroy = result.onDestroy;
            }
            // workaround for chromium bug, premultiplied alpha value is platform dependent
            if (contextAttributes.premultipliedAlpha === undefined) contextAttributes.premultipliedAlpha = true;
            gl = createContext(canvas, contextAttributes);
        }
        if (!gl) {
            onDestroy();
            onDone("webgl not supported, try upgrading your browser or graphics drivers http://get.webgl.org");
            return null;
        }
        return {
            gl: gl,
            canvas: canvas,
            container: container,
            extensions: extensions,
            optionalExtensions: optionalExtensions,
            pixelRatio: pixelRatio,
            profile: profile,
            onDone: onDone,
            onDestroy: onDestroy
        };
    }
    function createExtensionCache(gl, config) {
        var extensions = {};
        function tryLoadExtension(name_) {
            check$1.type(name_, "string", "extension name must be string");
            var name = name_.toLowerCase();
            var ext;
            try {
                ext = extensions[name] = gl.getExtension(name);
            } catch (e) {}
            return !!ext;
        }
        for(var i = 0; i < config.extensions.length; ++i){
            var name = config.extensions[i];
            if (!tryLoadExtension(name)) {
                config.onDestroy();
                config.onDone('"' + name + '" extension is not supported by the current WebGL context, try upgrading your system or a different browser');
                return null;
            }
        }
        config.optionalExtensions.forEach(tryLoadExtension);
        return {
            extensions: extensions,
            restore: function() {
                Object.keys(extensions).forEach(function(name) {
                    if (extensions[name] && !tryLoadExtension(name)) throw new Error("(regl): error restoring extension " + name);
                });
            }
        };
    }
    function loop(n, f) {
        var result = Array(n);
        for(var i = 0; i < n; ++i)result[i] = f(i);
        return result;
    }
    var GL_BYTE$1 = 5120;
    var GL_UNSIGNED_BYTE$2 = 5121;
    var GL_SHORT$1 = 5122;
    var GL_UNSIGNED_SHORT$1 = 5123;
    var GL_INT$1 = 5124;
    var GL_UNSIGNED_INT$1 = 5125;
    var GL_FLOAT$2 = 5126;
    function nextPow16(v) {
        for(var i = 16; i <= 268435456; i *= 16){
            if (v <= i) return i;
        }
        return 0;
    }
    function log2(v) {
        var r, shift;
        r = (v > 0xFFFF) << 4;
        v >>>= r;
        shift = (v > 0xFF) << 3;
        v >>>= shift;
        r |= shift;
        shift = (v > 0xF) << 2;
        v >>>= shift;
        r |= shift;
        shift = (v > 0x3) << 1;
        v >>>= shift;
        r |= shift;
        return r | v >> 1;
    }
    function createPool() {
        var bufferPool = loop(8, function() {
            return [];
        });
        function alloc(n) {
            var sz = nextPow16(n);
            var bin = bufferPool[log2(sz) >> 2];
            if (bin.length > 0) return bin.pop();
            return new ArrayBuffer(sz);
        }
        function free(buf) {
            bufferPool[log2(buf.byteLength) >> 2].push(buf);
        }
        function allocType(type, n) {
            var result = null;
            switch(type){
                case GL_BYTE$1:
                    result = new Int8Array(alloc(n), 0, n);
                    break;
                case GL_UNSIGNED_BYTE$2:
                    result = new Uint8Array(alloc(n), 0, n);
                    break;
                case GL_SHORT$1:
                    result = new Int16Array(alloc(2 * n), 0, n);
                    break;
                case GL_UNSIGNED_SHORT$1:
                    result = new Uint16Array(alloc(2 * n), 0, n);
                    break;
                case GL_INT$1:
                    result = new Int32Array(alloc(4 * n), 0, n);
                    break;
                case GL_UNSIGNED_INT$1:
                    result = new Uint32Array(alloc(4 * n), 0, n);
                    break;
                case GL_FLOAT$2:
                    result = new Float32Array(alloc(4 * n), 0, n);
                    break;
                default:
                    return null;
            }
            if (result.length !== n) return result.subarray(0, n);
            return result;
        }
        function freeType(array) {
            free(array.buffer);
        }
        return {
            alloc: alloc,
            free: free,
            allocType: allocType,
            freeType: freeType
        };
    }
    var pool = createPool();
    // zero pool for initial zero data
    pool.zero = createPool();
    var GL_SUBPIXEL_BITS = 0x0D50;
    var GL_RED_BITS = 0x0D52;
    var GL_GREEN_BITS = 0x0D53;
    var GL_BLUE_BITS = 0x0D54;
    var GL_ALPHA_BITS = 0x0D55;
    var GL_DEPTH_BITS = 0x0D56;
    var GL_STENCIL_BITS = 0x0D57;
    var GL_ALIASED_POINT_SIZE_RANGE = 0x846D;
    var GL_ALIASED_LINE_WIDTH_RANGE = 0x846E;
    var GL_MAX_TEXTURE_SIZE = 0x0D33;
    var GL_MAX_VIEWPORT_DIMS = 0x0D3A;
    var GL_MAX_VERTEX_ATTRIBS = 0x8869;
    var GL_MAX_VERTEX_UNIFORM_VECTORS = 0x8DFB;
    var GL_MAX_VARYING_VECTORS = 0x8DFC;
    var GL_MAX_COMBINED_TEXTURE_IMAGE_UNITS = 0x8B4D;
    var GL_MAX_VERTEX_TEXTURE_IMAGE_UNITS = 0x8B4C;
    var GL_MAX_TEXTURE_IMAGE_UNITS = 0x8872;
    var GL_MAX_FRAGMENT_UNIFORM_VECTORS = 0x8DFD;
    var GL_MAX_CUBE_MAP_TEXTURE_SIZE = 0x851C;
    var GL_MAX_RENDERBUFFER_SIZE = 0x84E8;
    var GL_VENDOR = 0x1F00;
    var GL_RENDERER = 0x1F01;
    var GL_VERSION = 0x1F02;
    var GL_SHADING_LANGUAGE_VERSION = 0x8B8C;
    var GL_MAX_TEXTURE_MAX_ANISOTROPY_EXT = 0x84FF;
    var GL_MAX_COLOR_ATTACHMENTS_WEBGL = 0x8CDF;
    var GL_MAX_DRAW_BUFFERS_WEBGL = 0x8824;
    var GL_TEXTURE_2D = 0x0DE1;
    var GL_TEXTURE_CUBE_MAP = 0x8513;
    var GL_TEXTURE_CUBE_MAP_POSITIVE_X = 0x8515;
    var GL_TEXTURE0 = 0x84C0;
    var GL_RGBA = 0x1908;
    var GL_FLOAT$1 = 0x1406;
    var GL_UNSIGNED_BYTE$1 = 0x1401;
    var GL_FRAMEBUFFER = 0x8D40;
    var GL_FRAMEBUFFER_COMPLETE = 0x8CD5;
    var GL_COLOR_ATTACHMENT0 = 0x8CE0;
    var GL_COLOR_BUFFER_BIT$1 = 0x4000;
    var wrapLimits = function(gl, extensions) {
        var maxAnisotropic = 1;
        if (extensions.ext_texture_filter_anisotropic) maxAnisotropic = gl.getParameter(GL_MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        var maxDrawbuffers = 1;
        var maxColorAttachments = 1;
        if (extensions.webgl_draw_buffers) {
            maxDrawbuffers = gl.getParameter(GL_MAX_DRAW_BUFFERS_WEBGL);
            maxColorAttachments = gl.getParameter(GL_MAX_COLOR_ATTACHMENTS_WEBGL);
        }
        // detect if reading float textures is available (Safari doesn't support)
        var readFloat = !!extensions.oes_texture_float;
        if (readFloat) {
            var readFloatTexture = gl.createTexture();
            gl.bindTexture(GL_TEXTURE_2D, readFloatTexture);
            gl.texImage2D(GL_TEXTURE_2D, 0, GL_RGBA, 1, 1, 0, GL_RGBA, GL_FLOAT$1, null);
            var fbo = gl.createFramebuffer();
            gl.bindFramebuffer(GL_FRAMEBUFFER, fbo);
            gl.framebufferTexture2D(GL_FRAMEBUFFER, GL_COLOR_ATTACHMENT0, GL_TEXTURE_2D, readFloatTexture, 0);
            gl.bindTexture(GL_TEXTURE_2D, null);
            if (gl.checkFramebufferStatus(GL_FRAMEBUFFER) !== GL_FRAMEBUFFER_COMPLETE) readFloat = false;
            else {
                gl.viewport(0, 0, 1, 1);
                gl.clearColor(1.0, 0.0, 0.0, 1.0);
                gl.clear(GL_COLOR_BUFFER_BIT$1);
                var pixels = pool.allocType(GL_FLOAT$1, 4);
                gl.readPixels(0, 0, 1, 1, GL_RGBA, GL_FLOAT$1, pixels);
                if (gl.getError()) readFloat = false;
                else {
                    gl.deleteFramebuffer(fbo);
                    gl.deleteTexture(readFloatTexture);
                    readFloat = pixels[0] === 1.0;
                }
                pool.freeType(pixels);
            }
        }
        // detect non power of two cube textures support (IE doesn't support)
        var isIE = typeof navigator !== "undefined" && (/MSIE/.test(navigator.userAgent) || /Trident\//.test(navigator.appVersion) || /Edge/.test(navigator.userAgent));
        var npotTextureCube = true;
        if (!isIE) {
            var cubeTexture = gl.createTexture();
            var data = pool.allocType(GL_UNSIGNED_BYTE$1, 36);
            gl.activeTexture(GL_TEXTURE0);
            gl.bindTexture(GL_TEXTURE_CUBE_MAP, cubeTexture);
            gl.texImage2D(GL_TEXTURE_CUBE_MAP_POSITIVE_X, 0, GL_RGBA, 3, 3, 0, GL_RGBA, GL_UNSIGNED_BYTE$1, data);
            pool.freeType(data);
            gl.bindTexture(GL_TEXTURE_CUBE_MAP, null);
            gl.deleteTexture(cubeTexture);
            npotTextureCube = !gl.getError();
        }
        return {
            // drawing buffer bit depth
            colorBits: [
                gl.getParameter(GL_RED_BITS),
                gl.getParameter(GL_GREEN_BITS),
                gl.getParameter(GL_BLUE_BITS),
                gl.getParameter(GL_ALPHA_BITS)
            ],
            depthBits: gl.getParameter(GL_DEPTH_BITS),
            stencilBits: gl.getParameter(GL_STENCIL_BITS),
            subpixelBits: gl.getParameter(GL_SUBPIXEL_BITS),
            // supported extensions
            extensions: Object.keys(extensions).filter(function(ext) {
                return !!extensions[ext];
            }),
            // max aniso samples
            maxAnisotropic: maxAnisotropic,
            // max draw buffers
            maxDrawbuffers: maxDrawbuffers,
            maxColorAttachments: maxColorAttachments,
            // point and line size ranges
            pointSizeDims: gl.getParameter(GL_ALIASED_POINT_SIZE_RANGE),
            lineWidthDims: gl.getParameter(GL_ALIASED_LINE_WIDTH_RANGE),
            maxViewportDims: gl.getParameter(GL_MAX_VIEWPORT_DIMS),
            maxCombinedTextureUnits: gl.getParameter(GL_MAX_COMBINED_TEXTURE_IMAGE_UNITS),
            maxCubeMapSize: gl.getParameter(GL_MAX_CUBE_MAP_TEXTURE_SIZE),
            maxRenderbufferSize: gl.getParameter(GL_MAX_RENDERBUFFER_SIZE),
            maxTextureUnits: gl.getParameter(GL_MAX_TEXTURE_IMAGE_UNITS),
            maxTextureSize: gl.getParameter(GL_MAX_TEXTURE_SIZE),
            maxAttributes: gl.getParameter(GL_MAX_VERTEX_ATTRIBS),
            maxVertexUniforms: gl.getParameter(GL_MAX_VERTEX_UNIFORM_VECTORS),
            maxVertexTextureUnits: gl.getParameter(GL_MAX_VERTEX_TEXTURE_IMAGE_UNITS),
            maxVaryingVectors: gl.getParameter(GL_MAX_VARYING_VECTORS),
            maxFragmentUniforms: gl.getParameter(GL_MAX_FRAGMENT_UNIFORM_VECTORS),
            // vendor info
            glsl: gl.getParameter(GL_SHADING_LANGUAGE_VERSION),
            renderer: gl.getParameter(GL_RENDERER),
            vendor: gl.getParameter(GL_VENDOR),
            version: gl.getParameter(GL_VERSION),
            // quirks
            readFloat: readFloat,
            npotTextureCube: npotTextureCube
        };
    };
    function isNDArrayLike(obj) {
        return !!obj && typeof obj === "object" && Array.isArray(obj.shape) && Array.isArray(obj.stride) && typeof obj.offset === "number" && obj.shape.length === obj.stride.length && (Array.isArray(obj.data) || isTypedArray(obj.data));
    }
    var values = function(obj) {
        return Object.keys(obj).map(function(key) {
            return obj[key];
        });
    };
    var flattenUtils = {
        shape: arrayShape$1,
        flatten: flattenArray
    };
    function flatten1D(array, nx, out) {
        for(var i = 0; i < nx; ++i)out[i] = array[i];
    }
    function flatten2D(array, nx, ny, out) {
        var ptr = 0;
        for(var i = 0; i < nx; ++i){
            var row = array[i];
            for(var j = 0; j < ny; ++j)out[ptr++] = row[j];
        }
    }
    function flatten3D(array, nx, ny, nz, out, ptr_) {
        var ptr = ptr_;
        for(var i = 0; i < nx; ++i){
            var row = array[i];
            for(var j = 0; j < ny; ++j){
                var col = row[j];
                for(var k = 0; k < nz; ++k)out[ptr++] = col[k];
            }
        }
    }
    function flattenRec(array, shape, level, out, ptr) {
        var stride = 1;
        for(var i = level + 1; i < shape.length; ++i)stride *= shape[i];
        var n = shape[level];
        if (shape.length - level === 4) {
            var nx = shape[level + 1];
            var ny = shape[level + 2];
            var nz = shape[level + 3];
            for(i = 0; i < n; ++i){
                flatten3D(array[i], nx, ny, nz, out, ptr);
                ptr += stride;
            }
        } else for(i = 0; i < n; ++i){
            flattenRec(array[i], shape, level + 1, out, ptr);
            ptr += stride;
        }
    }
    function flattenArray(array, shape, type, out_) {
        var sz = 1;
        if (shape.length) for(var i = 0; i < shape.length; ++i)sz *= shape[i];
        else sz = 0;
        var out = out_ || pool.allocType(type, sz);
        switch(shape.length){
            case 0:
                break;
            case 1:
                flatten1D(array, shape[0], out);
                break;
            case 2:
                flatten2D(array, shape[0], shape[1], out);
                break;
            case 3:
                flatten3D(array, shape[0], shape[1], shape[2], out, 0);
                break;
            default:
                flattenRec(array, shape, 0, out, 0);
        }
        return out;
    }
    function arrayShape$1(array_) {
        var shape = [];
        for(var array = array_; array.length; array = array[0])shape.push(array.length);
        return shape;
    }
    var arrayTypes = {
        "[object Int8Array]": 5120,
        "[object Int16Array]": 5122,
        "[object Int32Array]": 5124,
        "[object Uint8Array]": 5121,
        "[object Uint8ClampedArray]": 5121,
        "[object Uint16Array]": 5123,
        "[object Uint32Array]": 5125,
        "[object Float32Array]": 5126,
        "[object Float64Array]": 5121,
        "[object ArrayBuffer]": 5121
    };
    var int8 = 5120;
    var int16 = 5122;
    var int32 = 5124;
    var uint8 = 5121;
    var uint16 = 5123;
    var uint32 = 5125;
    var float = 5126;
    var float32 = 5126;
    var glTypes = {
        int8: int8,
        int16: int16,
        int32: int32,
        uint8: uint8,
        uint16: uint16,
        uint32: uint32,
        float: float,
        float32: float32
    };
    var dynamic$1 = 35048;
    var stream = 35040;
    var usageTypes = {
        dynamic: dynamic$1,
        stream: stream,
        "static": 35044
    };
    var arrayFlatten = flattenUtils.flatten;
    var arrayShape = flattenUtils.shape;
    var GL_STATIC_DRAW = 0x88E4;
    var GL_STREAM_DRAW = 0x88E0;
    var GL_UNSIGNED_BYTE$3 = 5121;
    var GL_FLOAT$3 = 5126;
    var DTYPES_SIZES = [];
    DTYPES_SIZES[5120] = 1 // int8
    ;
    DTYPES_SIZES[5122] = 2 // int16
    ;
    DTYPES_SIZES[5124] = 4 // int32
    ;
    DTYPES_SIZES[5121] = 1 // uint8
    ;
    DTYPES_SIZES[5123] = 2 // uint16
    ;
    DTYPES_SIZES[5125] = 4 // uint32
    ;
    DTYPES_SIZES[5126] = 4 // float32
    ;
    function typedArrayCode(data) {
        return arrayTypes[Object.prototype.toString.call(data)] | 0;
    }
    function copyArray(out, inp) {
        for(var i = 0; i < inp.length; ++i)out[i] = inp[i];
    }
    function transpose(result, data, shapeX, shapeY, strideX, strideY, offset) {
        var ptr = 0;
        for(var i = 0; i < shapeX; ++i)for(var j = 0; j < shapeY; ++j)result[ptr++] = data[strideX * i + strideY * j + offset];
    }
    function wrapBufferState(gl, stats, config, destroyBuffer) {
        var bufferCount = 0;
        var bufferSet = {};
        function REGLBuffer(type) {
            this.id = bufferCount++;
            this.buffer = gl.createBuffer();
            this.type = type;
            this.usage = GL_STATIC_DRAW;
            this.byteLength = 0;
            this.dimension = 1;
            this.dtype = GL_UNSIGNED_BYTE$3;
            this.persistentData = null;
            if (config.profile) this.stats = {
                size: 0
            };
        }
        REGLBuffer.prototype.bind = function() {
            gl.bindBuffer(this.type, this.buffer);
        };
        REGLBuffer.prototype.destroy = function() {
            destroy(this);
        };
        var streamPool = [];
        function createStream(type, data) {
            var buffer = streamPool.pop();
            if (!buffer) buffer = new REGLBuffer(type);
            buffer.bind();
            initBufferFromData(buffer, data, GL_STREAM_DRAW, 0, 1, false);
            return buffer;
        }
        function destroyStream(stream$$1) {
            streamPool.push(stream$$1);
        }
        function initBufferFromTypedArray(buffer, data, usage) {
            buffer.byteLength = data.byteLength;
            gl.bufferData(buffer.type, data, usage);
        }
        function initBufferFromData(buffer, data, usage, dtype, dimension, persist) {
            var shape;
            buffer.usage = usage;
            if (Array.isArray(data)) {
                buffer.dtype = dtype || GL_FLOAT$3;
                if (data.length > 0) {
                    var flatData;
                    if (Array.isArray(data[0])) {
                        shape = arrayShape(data);
                        var dim = 1;
                        for(var i = 1; i < shape.length; ++i)dim *= shape[i];
                        buffer.dimension = dim;
                        flatData = arrayFlatten(data, shape, buffer.dtype);
                        initBufferFromTypedArray(buffer, flatData, usage);
                        if (persist) buffer.persistentData = flatData;
                        else pool.freeType(flatData);
                    } else if (typeof data[0] === "number") {
                        buffer.dimension = dimension;
                        var typedData = pool.allocType(buffer.dtype, data.length);
                        copyArray(typedData, data);
                        initBufferFromTypedArray(buffer, typedData, usage);
                        if (persist) buffer.persistentData = typedData;
                        else pool.freeType(typedData);
                    } else if (isTypedArray(data[0])) {
                        buffer.dimension = data[0].length;
                        buffer.dtype = dtype || typedArrayCode(data[0]) || GL_FLOAT$3;
                        flatData = arrayFlatten(data, [
                            data.length,
                            data[0].length
                        ], buffer.dtype);
                        initBufferFromTypedArray(buffer, flatData, usage);
                        if (persist) buffer.persistentData = flatData;
                        else pool.freeType(flatData);
                    } else check$1.raise("invalid buffer data");
                }
            } else if (isTypedArray(data)) {
                buffer.dtype = dtype || typedArrayCode(data);
                buffer.dimension = dimension;
                initBufferFromTypedArray(buffer, data, usage);
                if (persist) buffer.persistentData = new Uint8Array(new Uint8Array(data.buffer));
            } else if (isNDArrayLike(data)) {
                shape = data.shape;
                var stride = data.stride;
                var offset = data.offset;
                var shapeX = 0;
                var shapeY = 0;
                var strideX = 0;
                var strideY = 0;
                if (shape.length === 1) {
                    shapeX = shape[0];
                    shapeY = 1;
                    strideX = stride[0];
                    strideY = 0;
                } else if (shape.length === 2) {
                    shapeX = shape[0];
                    shapeY = shape[1];
                    strideX = stride[0];
                    strideY = stride[1];
                } else check$1.raise("invalid shape");
                buffer.dtype = dtype || typedArrayCode(data.data) || GL_FLOAT$3;
                buffer.dimension = shapeY;
                var transposeData = pool.allocType(buffer.dtype, shapeX * shapeY);
                transpose(transposeData, data.data, shapeX, shapeY, strideX, strideY, offset);
                initBufferFromTypedArray(buffer, transposeData, usage);
                if (persist) buffer.persistentData = transposeData;
                else pool.freeType(transposeData);
            } else if (data instanceof ArrayBuffer) {
                buffer.dtype = GL_UNSIGNED_BYTE$3;
                buffer.dimension = dimension;
                initBufferFromTypedArray(buffer, data, usage);
                if (persist) buffer.persistentData = new Uint8Array(new Uint8Array(data));
            } else check$1.raise("invalid buffer data");
        }
        function destroy(buffer) {
            stats.bufferCount--;
            // remove attribute link
            destroyBuffer(buffer);
            var handle = buffer.buffer;
            check$1(handle, "buffer must not be deleted already");
            gl.deleteBuffer(handle);
            buffer.buffer = null;
            delete bufferSet[buffer.id];
        }
        function createBuffer(options, type, deferInit, persistent) {
            stats.bufferCount++;
            var buffer = new REGLBuffer(type);
            bufferSet[buffer.id] = buffer;
            function reglBuffer(options) {
                var usage = GL_STATIC_DRAW;
                var data = null;
                var byteLength = 0;
                var dtype = 0;
                var dimension = 1;
                if (Array.isArray(options) || isTypedArray(options) || isNDArrayLike(options) || options instanceof ArrayBuffer) data = options;
                else if (typeof options === "number") byteLength = options | 0;
                else if (options) {
                    check$1.type(options, "object", "buffer arguments must be an object, a number or an array");
                    if ("data" in options) {
                        check$1(data === null || Array.isArray(data) || isTypedArray(data) || isNDArrayLike(data), "invalid data for buffer");
                        data = options.data;
                    }
                    if ("usage" in options) {
                        check$1.parameter(options.usage, usageTypes, "invalid buffer usage");
                        usage = usageTypes[options.usage];
                    }
                    if ("type" in options) {
                        check$1.parameter(options.type, glTypes, "invalid buffer type");
                        dtype = glTypes[options.type];
                    }
                    if ("dimension" in options) {
                        check$1.type(options.dimension, "number", "invalid dimension");
                        dimension = options.dimension | 0;
                    }
                    if ("length" in options) {
                        check$1.nni(byteLength, "buffer length must be a nonnegative integer");
                        byteLength = options.length | 0;
                    }
                }
                buffer.bind();
                if (!data) {
                    // #475
                    if (byteLength) gl.bufferData(buffer.type, byteLength, usage);
                    buffer.dtype = dtype || GL_UNSIGNED_BYTE$3;
                    buffer.usage = usage;
                    buffer.dimension = dimension;
                    buffer.byteLength = byteLength;
                } else initBufferFromData(buffer, data, usage, dtype, dimension, persistent);
                if (config.profile) buffer.stats.size = buffer.byteLength * DTYPES_SIZES[buffer.dtype];
                return reglBuffer;
            }
            function setSubData(data, offset) {
                check$1(offset + data.byteLength <= buffer.byteLength, "invalid buffer subdata call, buffer is too small.  Can't write data of size " + data.byteLength + " starting from offset " + offset + " to a buffer of size " + buffer.byteLength);
                gl.bufferSubData(buffer.type, offset, data);
            }
            function subdata(data, offset_) {
                var offset = (offset_ || 0) | 0;
                var shape;
                buffer.bind();
                if (isTypedArray(data) || data instanceof ArrayBuffer) setSubData(data, offset);
                else if (Array.isArray(data)) {
                    if (data.length > 0) {
                        if (typeof data[0] === "number") {
                            var converted = pool.allocType(buffer.dtype, data.length);
                            copyArray(converted, data);
                            setSubData(converted, offset);
                            pool.freeType(converted);
                        } else if (Array.isArray(data[0]) || isTypedArray(data[0])) {
                            shape = arrayShape(data);
                            var flatData = arrayFlatten(data, shape, buffer.dtype);
                            setSubData(flatData, offset);
                            pool.freeType(flatData);
                        } else check$1.raise("invalid buffer data");
                    }
                } else if (isNDArrayLike(data)) {
                    shape = data.shape;
                    var stride = data.stride;
                    var shapeX = 0;
                    var shapeY = 0;
                    var strideX = 0;
                    var strideY = 0;
                    if (shape.length === 1) {
                        shapeX = shape[0];
                        shapeY = 1;
                        strideX = stride[0];
                        strideY = 0;
                    } else if (shape.length === 2) {
                        shapeX = shape[0];
                        shapeY = shape[1];
                        strideX = stride[0];
                        strideY = stride[1];
                    } else check$1.raise("invalid shape");
                    var dtype = Array.isArray(data.data) ? buffer.dtype : typedArrayCode(data.data);
                    var transposeData = pool.allocType(dtype, shapeX * shapeY);
                    transpose(transposeData, data.data, shapeX, shapeY, strideX, strideY, data.offset);
                    setSubData(transposeData, offset);
                    pool.freeType(transposeData);
                } else check$1.raise("invalid data for buffer subdata");
                return reglBuffer;
            }
            if (!deferInit) reglBuffer(options);
            reglBuffer._reglType = "buffer";
            reglBuffer._buffer = buffer;
            reglBuffer.subdata = subdata;
            if (config.profile) reglBuffer.stats = buffer.stats;
            reglBuffer.destroy = function() {
                destroy(buffer);
            };
            return reglBuffer;
        }
        function restoreBuffers() {
            values(bufferSet).forEach(function(buffer) {
                buffer.buffer = gl.createBuffer();
                gl.bindBuffer(buffer.type, buffer.buffer);
                gl.bufferData(buffer.type, buffer.persistentData || buffer.byteLength, buffer.usage);
            });
        }
        if (config.profile) stats.getTotalBufferSize = function() {
            var total = 0;
            // TODO: Right now, the streams are not part of the total count.
            Object.keys(bufferSet).forEach(function(key) {
                total += bufferSet[key].stats.size;
            });
            return total;
        };
        return {
            create: createBuffer,
            createStream: createStream,
            destroyStream: destroyStream,
            clear: function() {
                values(bufferSet).forEach(destroy);
                streamPool.forEach(destroy);
            },
            getBuffer: function(wrapper) {
                if (wrapper && wrapper._buffer instanceof REGLBuffer) return wrapper._buffer;
                return null;
            },
            restore: restoreBuffers,
            _initBuffer: initBufferFromData
        };
    }
    var points = 0;
    var point = 0;
    var lines = 1;
    var line = 1;
    var triangles = 4;
    var triangle = 4;
    var primTypes = {
        points: points,
        point: point,
        lines: lines,
        line: line,
        triangles: triangles,
        triangle: triangle,
        "line loop": 2,
        "line strip": 3,
        "triangle strip": 5,
        "triangle fan": 6
    };
    var GL_POINTS = 0;
    var GL_LINES = 1;
    var GL_TRIANGLES = 4;
    var GL_BYTE$2 = 5120;
    var GL_UNSIGNED_BYTE$4 = 5121;
    var GL_SHORT$2 = 5122;
    var GL_UNSIGNED_SHORT$2 = 5123;
    var GL_INT$2 = 5124;
    var GL_UNSIGNED_INT$2 = 5125;
    var GL_ELEMENT_ARRAY_BUFFER = 34963;
    var GL_STREAM_DRAW$1 = 0x88E0;
    var GL_STATIC_DRAW$1 = 0x88E4;
    function wrapElementsState(gl, extensions, bufferState, stats) {
        var elementSet = {};
        var elementCount = 0;
        var elementTypes = {
            "uint8": GL_UNSIGNED_BYTE$4,
            "uint16": GL_UNSIGNED_SHORT$2
        };
        if (extensions.oes_element_index_uint) elementTypes.uint32 = GL_UNSIGNED_INT$2;
        function REGLElementBuffer(buffer) {
            this.id = elementCount++;
            elementSet[this.id] = this;
            this.buffer = buffer;
            this.primType = GL_TRIANGLES;
            this.vertCount = 0;
            this.type = 0;
        }
        REGLElementBuffer.prototype.bind = function() {
            this.buffer.bind();
        };
        var bufferPool = [];
        function createElementStream(data) {
            var result = bufferPool.pop();
            if (!result) result = new REGLElementBuffer(bufferState.create(null, GL_ELEMENT_ARRAY_BUFFER, true, false)._buffer);
            initElements(result, data, GL_STREAM_DRAW$1, -1, -1, 0, 0);
            return result;
        }
        function destroyElementStream(elements) {
            bufferPool.push(elements);
        }
        function initElements(elements, data, usage, prim, count, byteLength, type) {
            elements.buffer.bind();
            var dtype;
            if (data) {
                var predictedType = type;
                if (!type && (!isTypedArray(data) || isNDArrayLike(data) && !isTypedArray(data.data))) predictedType = extensions.oes_element_index_uint ? GL_UNSIGNED_INT$2 : GL_UNSIGNED_SHORT$2;
                bufferState._initBuffer(elements.buffer, data, usage, predictedType, 3);
            } else {
                gl.bufferData(GL_ELEMENT_ARRAY_BUFFER, byteLength, usage);
                elements.buffer.dtype = dtype || GL_UNSIGNED_BYTE$4;
                elements.buffer.usage = usage;
                elements.buffer.dimension = 3;
                elements.buffer.byteLength = byteLength;
            }
            dtype = type;
            if (!type) {
                switch(elements.buffer.dtype){
                    case GL_UNSIGNED_BYTE$4:
                    case GL_BYTE$2:
                        dtype = GL_UNSIGNED_BYTE$4;
                        break;
                    case GL_UNSIGNED_SHORT$2:
                    case GL_SHORT$2:
                        dtype = GL_UNSIGNED_SHORT$2;
                        break;
                    case GL_UNSIGNED_INT$2:
                    case GL_INT$2:
                        dtype = GL_UNSIGNED_INT$2;
                        break;
                    default:
                        check$1.raise("unsupported type for element array");
                }
                elements.buffer.dtype = dtype;
            }
            elements.type = dtype;
            // Check oes_element_index_uint extension
            check$1(dtype !== GL_UNSIGNED_INT$2 || !!extensions.oes_element_index_uint, "32 bit element buffers not supported, enable oes_element_index_uint first");
            // try to guess default primitive type and arguments
            var vertCount = count;
            if (vertCount < 0) {
                vertCount = elements.buffer.byteLength;
                if (dtype === GL_UNSIGNED_SHORT$2) vertCount >>= 1;
                else if (dtype === GL_UNSIGNED_INT$2) vertCount >>= 2;
            }
            elements.vertCount = vertCount;
            // try to guess primitive type from cell dimension
            var primType = prim;
            if (prim < 0) {
                primType = GL_TRIANGLES;
                var dimension = elements.buffer.dimension;
                if (dimension === 1) primType = GL_POINTS;
                if (dimension === 2) primType = GL_LINES;
                if (dimension === 3) primType = GL_TRIANGLES;
            }
            elements.primType = primType;
        }
        function destroyElements(elements) {
            stats.elementsCount--;
            check$1(elements.buffer !== null, "must not double destroy elements");
            delete elementSet[elements.id];
            elements.buffer.destroy();
            elements.buffer = null;
        }
        function createElements(options, persistent) {
            var buffer = bufferState.create(null, GL_ELEMENT_ARRAY_BUFFER, true);
            var elements = new REGLElementBuffer(buffer._buffer);
            stats.elementsCount++;
            function reglElements(options) {
                if (!options) {
                    buffer();
                    elements.primType = GL_TRIANGLES;
                    elements.vertCount = 0;
                    elements.type = GL_UNSIGNED_BYTE$4;
                } else if (typeof options === "number") {
                    buffer(options);
                    elements.primType = GL_TRIANGLES;
                    elements.vertCount = options | 0;
                    elements.type = GL_UNSIGNED_BYTE$4;
                } else {
                    var data = null;
                    var usage = GL_STATIC_DRAW$1;
                    var primType = -1;
                    var vertCount = -1;
                    var byteLength = 0;
                    var dtype = 0;
                    if (Array.isArray(options) || isTypedArray(options) || isNDArrayLike(options)) data = options;
                    else {
                        check$1.type(options, "object", "invalid arguments for elements");
                        if ("data" in options) {
                            data = options.data;
                            check$1(Array.isArray(data) || isTypedArray(data) || isNDArrayLike(data), "invalid data for element buffer");
                        }
                        if ("usage" in options) {
                            check$1.parameter(options.usage, usageTypes, "invalid element buffer usage");
                            usage = usageTypes[options.usage];
                        }
                        if ("primitive" in options) {
                            check$1.parameter(options.primitive, primTypes, "invalid element buffer primitive");
                            primType = primTypes[options.primitive];
                        }
                        if ("count" in options) {
                            check$1(typeof options.count === "number" && options.count >= 0, "invalid vertex count for elements");
                            vertCount = options.count | 0;
                        }
                        if ("type" in options) {
                            check$1.parameter(options.type, elementTypes, "invalid buffer type");
                            dtype = elementTypes[options.type];
                        }
                        if ("length" in options) byteLength = options.length | 0;
                        else {
                            byteLength = vertCount;
                            if (dtype === GL_UNSIGNED_SHORT$2 || dtype === GL_SHORT$2) byteLength *= 2;
                            else if (dtype === GL_UNSIGNED_INT$2 || dtype === GL_INT$2) byteLength *= 4;
                        }
                    }
                    initElements(elements, data, usage, primType, vertCount, byteLength, dtype);
                }
                return reglElements;
            }
            reglElements(options);
            reglElements._reglType = "elements";
            reglElements._elements = elements;
            reglElements.subdata = function(data, offset) {
                buffer.subdata(data, offset);
                return reglElements;
            };
            reglElements.destroy = function() {
                destroyElements(elements);
            };
            return reglElements;
        }
        return {
            create: createElements,
            createStream: createElementStream,
            destroyStream: destroyElementStream,
            getElements: function(elements) {
                if (typeof elements === "function" && elements._elements instanceof REGLElementBuffer) return elements._elements;
                return null;
            },
            clear: function() {
                values(elementSet).forEach(destroyElements);
            }
        };
    }
    var FLOAT = new Float32Array(1);
    var INT = new Uint32Array(FLOAT.buffer);
    var GL_UNSIGNED_SHORT$4 = 5123;
    function convertToHalfFloat(array) {
        var ushorts = pool.allocType(GL_UNSIGNED_SHORT$4, array.length);
        for(var i = 0; i < array.length; ++i){
            if (isNaN(array[i])) ushorts[i] = 0xffff;
            else if (array[i] === Infinity) ushorts[i] = 0x7c00;
            else if (array[i] === -Infinity) ushorts[i] = 0xfc00;
            else {
                FLOAT[0] = array[i];
                var x = INT[0];
                var sgn = x >>> 31 << 15;
                var exp = (x << 1 >>> 24) - 127;
                var frac = x >> 13 & 1023;
                if (exp < -24) // round non-representable denormals to 0
                ushorts[i] = sgn;
                else if (exp < -14) {
                    // handle denormals
                    var s = -14 - exp;
                    ushorts[i] = sgn + (frac + 1024 >> s);
                } else if (exp > 15) // round overflow to +/- Infinity
                ushorts[i] = sgn + 0x7c00;
                else // otherwise convert directly
                ushorts[i] = sgn + (exp + 15 << 10) + frac;
            }
        }
        return ushorts;
    }
    function isArrayLike(s) {
        return Array.isArray(s) || isTypedArray(s);
    }
    var isPow2$1 = function(v) {
        return !(v & v - 1) && !!v;
    };
    var GL_COMPRESSED_TEXTURE_FORMATS = 0x86A3;
    var GL_TEXTURE_2D$1 = 0x0DE1;
    var GL_TEXTURE_CUBE_MAP$1 = 0x8513;
    var GL_TEXTURE_CUBE_MAP_POSITIVE_X$1 = 0x8515;
    var GL_RGBA$1 = 0x1908;
    var GL_ALPHA = 0x1906;
    var GL_RGB = 0x1907;
    var GL_LUMINANCE = 0x1909;
    var GL_LUMINANCE_ALPHA = 0x190A;
    var GL_RGBA4 = 0x8056;
    var GL_RGB5_A1 = 0x8057;
    var GL_RGB565 = 0x8D62;
    var GL_UNSIGNED_SHORT_4_4_4_4$1 = 0x8033;
    var GL_UNSIGNED_SHORT_5_5_5_1$1 = 0x8034;
    var GL_UNSIGNED_SHORT_5_6_5$1 = 0x8363;
    var GL_UNSIGNED_INT_24_8_WEBGL$1 = 0x84FA;
    var GL_DEPTH_COMPONENT = 0x1902;
    var GL_DEPTH_STENCIL = 0x84F9;
    var GL_SRGB_EXT = 0x8C40;
    var GL_SRGB_ALPHA_EXT = 0x8C42;
    var GL_HALF_FLOAT_OES$1 = 0x8D61;
    var GL_COMPRESSED_RGB_S3TC_DXT1_EXT = 0x83F0;
    var GL_COMPRESSED_RGBA_S3TC_DXT1_EXT = 0x83F1;
    var GL_COMPRESSED_RGBA_S3TC_DXT3_EXT = 0x83F2;
    var GL_COMPRESSED_RGBA_S3TC_DXT5_EXT = 0x83F3;
    var GL_COMPRESSED_RGB_ATC_WEBGL = 0x8C92;
    var GL_COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL = 0x8C93;
    var GL_COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL = 0x87EE;
    var GL_COMPRESSED_RGB_PVRTC_4BPPV1_IMG = 0x8C00;
    var GL_COMPRESSED_RGB_PVRTC_2BPPV1_IMG = 0x8C01;
    var GL_COMPRESSED_RGBA_PVRTC_4BPPV1_IMG = 0x8C02;
    var GL_COMPRESSED_RGBA_PVRTC_2BPPV1_IMG = 0x8C03;
    var GL_COMPRESSED_RGB_ETC1_WEBGL = 0x8D64;
    var GL_UNSIGNED_BYTE$5 = 0x1401;
    var GL_UNSIGNED_SHORT$3 = 0x1403;
    var GL_UNSIGNED_INT$3 = 0x1405;
    var GL_FLOAT$4 = 0x1406;
    var GL_TEXTURE_WRAP_S = 0x2802;
    var GL_TEXTURE_WRAP_T = 0x2803;
    var GL_REPEAT = 0x2901;
    var GL_CLAMP_TO_EDGE$1 = 0x812F;
    var GL_MIRRORED_REPEAT = 0x8370;
    var GL_TEXTURE_MAG_FILTER = 0x2800;
    var GL_TEXTURE_MIN_FILTER = 0x2801;
    var GL_NEAREST$1 = 0x2600;
    var GL_LINEAR = 0x2601;
    var GL_NEAREST_MIPMAP_NEAREST$1 = 0x2700;
    var GL_LINEAR_MIPMAP_NEAREST$1 = 0x2701;
    var GL_NEAREST_MIPMAP_LINEAR$1 = 0x2702;
    var GL_LINEAR_MIPMAP_LINEAR$1 = 0x2703;
    var GL_GENERATE_MIPMAP_HINT = 0x8192;
    var GL_DONT_CARE = 0x1100;
    var GL_FASTEST = 0x1101;
    var GL_NICEST = 0x1102;
    var GL_TEXTURE_MAX_ANISOTROPY_EXT = 0x84FE;
    var GL_UNPACK_ALIGNMENT = 0x0CF5;
    var GL_UNPACK_FLIP_Y_WEBGL = 0x9240;
    var GL_UNPACK_PREMULTIPLY_ALPHA_WEBGL = 0x9241;
    var GL_UNPACK_COLORSPACE_CONVERSION_WEBGL = 0x9243;
    var GL_BROWSER_DEFAULT_WEBGL = 0x9244;
    var GL_TEXTURE0$1 = 0x84C0;
    var MIPMAP_FILTERS = [
        GL_NEAREST_MIPMAP_NEAREST$1,
        GL_NEAREST_MIPMAP_LINEAR$1,
        GL_LINEAR_MIPMAP_NEAREST$1,
        GL_LINEAR_MIPMAP_LINEAR$1
    ];
    var CHANNELS_FORMAT = [
        0,
        GL_LUMINANCE,
        GL_LUMINANCE_ALPHA,
        GL_RGB,
        GL_RGBA$1
    ];
    var FORMAT_CHANNELS = {};
    FORMAT_CHANNELS[GL_LUMINANCE] = FORMAT_CHANNELS[GL_ALPHA] = FORMAT_CHANNELS[GL_DEPTH_COMPONENT] = 1;
    FORMAT_CHANNELS[GL_DEPTH_STENCIL] = FORMAT_CHANNELS[GL_LUMINANCE_ALPHA] = 2;
    FORMAT_CHANNELS[GL_RGB] = FORMAT_CHANNELS[GL_SRGB_EXT] = 3;
    FORMAT_CHANNELS[GL_RGBA$1] = FORMAT_CHANNELS[GL_SRGB_ALPHA_EXT] = 4;
    function objectName(str) {
        return "[object " + str + "]";
    }
    var CANVAS_CLASS = objectName("HTMLCanvasElement");
    var OFFSCREENCANVAS_CLASS = objectName("OffscreenCanvas");
    var CONTEXT2D_CLASS = objectName("CanvasRenderingContext2D");
    var BITMAP_CLASS = objectName("ImageBitmap");
    var IMAGE_CLASS = objectName("HTMLImageElement");
    var VIDEO_CLASS = objectName("HTMLVideoElement");
    var PIXEL_CLASSES = Object.keys(arrayTypes).concat([
        CANVAS_CLASS,
        OFFSCREENCANVAS_CLASS,
        CONTEXT2D_CLASS,
        BITMAP_CLASS,
        IMAGE_CLASS,
        VIDEO_CLASS
    ]);
    // for every texture type, store
    // the size in bytes.
    var TYPE_SIZES = [];
    TYPE_SIZES[GL_UNSIGNED_BYTE$5] = 1;
    TYPE_SIZES[GL_FLOAT$4] = 4;
    TYPE_SIZES[GL_HALF_FLOAT_OES$1] = 2;
    TYPE_SIZES[GL_UNSIGNED_SHORT$3] = 2;
    TYPE_SIZES[GL_UNSIGNED_INT$3] = 4;
    var FORMAT_SIZES_SPECIAL = [];
    FORMAT_SIZES_SPECIAL[GL_RGBA4] = 2;
    FORMAT_SIZES_SPECIAL[GL_RGB5_A1] = 2;
    FORMAT_SIZES_SPECIAL[GL_RGB565] = 2;
    FORMAT_SIZES_SPECIAL[GL_DEPTH_STENCIL] = 4;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGB_S3TC_DXT1_EXT] = 0.5;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_S3TC_DXT1_EXT] = 0.5;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_S3TC_DXT3_EXT] = 1;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_S3TC_DXT5_EXT] = 1;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGB_ATC_WEBGL] = 0.5;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL] = 1;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL] = 1;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGB_PVRTC_4BPPV1_IMG] = 0.5;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGB_PVRTC_2BPPV1_IMG] = 0.25;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_PVRTC_4BPPV1_IMG] = 0.5;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_PVRTC_2BPPV1_IMG] = 0.25;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGB_ETC1_WEBGL] = 0.5;
    function isNumericArray(arr) {
        return Array.isArray(arr) && (arr.length === 0 || typeof arr[0] === "number");
    }
    function isRectArray(arr) {
        if (!Array.isArray(arr)) return false;
        var width = arr.length;
        if (width === 0 || !isArrayLike(arr[0])) return false;
        return true;
    }
    function classString(x) {
        return Object.prototype.toString.call(x);
    }
    function isCanvasElement(object) {
        return classString(object) === CANVAS_CLASS;
    }
    function isOffscreenCanvas(object) {
        return classString(object) === OFFSCREENCANVAS_CLASS;
    }
    function isContext2D(object) {
        return classString(object) === CONTEXT2D_CLASS;
    }
    function isBitmap(object) {
        return classString(object) === BITMAP_CLASS;
    }
    function isImageElement(object) {
        return classString(object) === IMAGE_CLASS;
    }
    function isVideoElement(object) {
        return classString(object) === VIDEO_CLASS;
    }
    function isPixelData(object) {
        if (!object) return false;
        var className = classString(object);
        if (PIXEL_CLASSES.indexOf(className) >= 0) return true;
        return isNumericArray(object) || isRectArray(object) || isNDArrayLike(object);
    }
    function typedArrayCode$1(data) {
        return arrayTypes[Object.prototype.toString.call(data)] | 0;
    }
    function convertData(result, data) {
        var n = data.length;
        switch(result.type){
            case GL_UNSIGNED_BYTE$5:
            case GL_UNSIGNED_SHORT$3:
            case GL_UNSIGNED_INT$3:
            case GL_FLOAT$4:
                var converted = pool.allocType(result.type, n);
                converted.set(data);
                result.data = converted;
                break;
            case GL_HALF_FLOAT_OES$1:
                result.data = convertToHalfFloat(data);
                break;
            default:
                check$1.raise("unsupported texture type, must specify a typed array");
        }
    }
    function preConvert(image, n) {
        return pool.allocType(image.type === GL_HALF_FLOAT_OES$1 ? GL_FLOAT$4 : image.type, n);
    }
    function postConvert(image, data) {
        if (image.type === GL_HALF_FLOAT_OES$1) {
            image.data = convertToHalfFloat(data);
            pool.freeType(data);
        } else image.data = data;
    }
    function transposeData(image, array, strideX, strideY, strideC, offset) {
        var w = image.width;
        var h = image.height;
        var c = image.channels;
        var n = w * h * c;
        var data = preConvert(image, n);
        var p = 0;
        for(var i = 0; i < h; ++i){
            for(var j = 0; j < w; ++j)for(var k = 0; k < c; ++k)data[p++] = array[strideX * j + strideY * i + strideC * k + offset];
        }
        postConvert(image, data);
    }
    function getTextureSize(format, type, width, height, isMipmap, isCube) {
        var s;
        if (typeof FORMAT_SIZES_SPECIAL[format] !== "undefined") // we have a special array for dealing with weird color formats such as RGB5A1
        s = FORMAT_SIZES_SPECIAL[format];
        else s = FORMAT_CHANNELS[format] * TYPE_SIZES[type];
        if (isCube) s *= 6;
        if (isMipmap) {
            // compute the total size of all the mipmaps.
            var total = 0;
            var w = width;
            while(w >= 1){
                // we can only use mipmaps on a square image,
                // so we can simply use the width and ignore the height:
                total += s * w * w;
                w /= 2;
            }
            return total;
        } else return s * width * height;
    }
    function createTextureSet(gl, extensions, limits, reglPoll, contextState, stats, config) {
        // -------------------------------------------------------
        // Initialize constants and parameter tables here
        // -------------------------------------------------------
        var mipmapHint = {
            "don't care": GL_DONT_CARE,
            "dont care": GL_DONT_CARE,
            "nice": GL_NICEST,
            "fast": GL_FASTEST
        };
        var wrapModes = {
            "repeat": GL_REPEAT,
            "clamp": GL_CLAMP_TO_EDGE$1,
            "mirror": GL_MIRRORED_REPEAT
        };
        var magFilters = {
            "nearest": GL_NEAREST$1,
            "linear": GL_LINEAR
        };
        var minFilters = extend({
            "mipmap": GL_LINEAR_MIPMAP_LINEAR$1,
            "nearest mipmap nearest": GL_NEAREST_MIPMAP_NEAREST$1,
            "linear mipmap nearest": GL_LINEAR_MIPMAP_NEAREST$1,
            "nearest mipmap linear": GL_NEAREST_MIPMAP_LINEAR$1,
            "linear mipmap linear": GL_LINEAR_MIPMAP_LINEAR$1
        }, magFilters);
        var colorSpace = {
            "none": 0,
            "browser": GL_BROWSER_DEFAULT_WEBGL
        };
        var textureTypes = {
            "uint8": GL_UNSIGNED_BYTE$5,
            "rgba4": GL_UNSIGNED_SHORT_4_4_4_4$1,
            "rgb565": GL_UNSIGNED_SHORT_5_6_5$1,
            "rgb5 a1": GL_UNSIGNED_SHORT_5_5_5_1$1
        };
        var textureFormats = {
            "alpha": GL_ALPHA,
            "luminance": GL_LUMINANCE,
            "luminance alpha": GL_LUMINANCE_ALPHA,
            "rgb": GL_RGB,
            "rgba": GL_RGBA$1,
            "rgba4": GL_RGBA4,
            "rgb5 a1": GL_RGB5_A1,
            "rgb565": GL_RGB565
        };
        var compressedTextureFormats = {};
        if (extensions.ext_srgb) {
            textureFormats.srgb = GL_SRGB_EXT;
            textureFormats.srgba = GL_SRGB_ALPHA_EXT;
        }
        if (extensions.oes_texture_float) textureTypes.float32 = textureTypes.float = GL_FLOAT$4;
        if (extensions.oes_texture_half_float) textureTypes["float16"] = textureTypes["half float"] = GL_HALF_FLOAT_OES$1;
        if (extensions.webgl_depth_texture) {
            extend(textureFormats, {
                "depth": GL_DEPTH_COMPONENT,
                "depth stencil": GL_DEPTH_STENCIL
            });
            extend(textureTypes, {
                "uint16": GL_UNSIGNED_SHORT$3,
                "uint32": GL_UNSIGNED_INT$3,
                "depth stencil": GL_UNSIGNED_INT_24_8_WEBGL$1
            });
        }
        if (extensions.webgl_compressed_texture_s3tc) extend(compressedTextureFormats, {
            "rgb s3tc dxt1": GL_COMPRESSED_RGB_S3TC_DXT1_EXT,
            "rgba s3tc dxt1": GL_COMPRESSED_RGBA_S3TC_DXT1_EXT,
            "rgba s3tc dxt3": GL_COMPRESSED_RGBA_S3TC_DXT3_EXT,
            "rgba s3tc dxt5": GL_COMPRESSED_RGBA_S3TC_DXT5_EXT
        });
        if (extensions.webgl_compressed_texture_atc) extend(compressedTextureFormats, {
            "rgb atc": GL_COMPRESSED_RGB_ATC_WEBGL,
            "rgba atc explicit alpha": GL_COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL,
            "rgba atc interpolated alpha": GL_COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL
        });
        if (extensions.webgl_compressed_texture_pvrtc) extend(compressedTextureFormats, {
            "rgb pvrtc 4bppv1": GL_COMPRESSED_RGB_PVRTC_4BPPV1_IMG,
            "rgb pvrtc 2bppv1": GL_COMPRESSED_RGB_PVRTC_2BPPV1_IMG,
            "rgba pvrtc 4bppv1": GL_COMPRESSED_RGBA_PVRTC_4BPPV1_IMG,
            "rgba pvrtc 2bppv1": GL_COMPRESSED_RGBA_PVRTC_2BPPV1_IMG
        });
        if (extensions.webgl_compressed_texture_etc1) compressedTextureFormats["rgb etc1"] = GL_COMPRESSED_RGB_ETC1_WEBGL;
        // Copy over all texture formats
        var supportedCompressedFormats = Array.prototype.slice.call(gl.getParameter(GL_COMPRESSED_TEXTURE_FORMATS));
        Object.keys(compressedTextureFormats).forEach(function(name) {
            var format = compressedTextureFormats[name];
            if (supportedCompressedFormats.indexOf(format) >= 0) textureFormats[name] = format;
        });
        var supportedFormats = Object.keys(textureFormats);
        limits.textureFormats = supportedFormats;
        // associate with every format string its
        // corresponding GL-value.
        var textureFormatsInvert = [];
        Object.keys(textureFormats).forEach(function(key) {
            var val = textureFormats[key];
            textureFormatsInvert[val] = key;
        });
        // associate with every type string its
        // corresponding GL-value.
        var textureTypesInvert = [];
        Object.keys(textureTypes).forEach(function(key) {
            var val = textureTypes[key];
            textureTypesInvert[val] = key;
        });
        var magFiltersInvert = [];
        Object.keys(magFilters).forEach(function(key) {
            var val = magFilters[key];
            magFiltersInvert[val] = key;
        });
        var minFiltersInvert = [];
        Object.keys(minFilters).forEach(function(key) {
            var val = minFilters[key];
            minFiltersInvert[val] = key;
        });
        var wrapModesInvert = [];
        Object.keys(wrapModes).forEach(function(key) {
            var val = wrapModes[key];
            wrapModesInvert[val] = key;
        });
        // colorFormats[] gives the format (channels) associated to an
        // internalformat
        var colorFormats = supportedFormats.reduce(function(color, key) {
            var glenum = textureFormats[key];
            if (glenum === GL_LUMINANCE || glenum === GL_ALPHA || glenum === GL_LUMINANCE || glenum === GL_LUMINANCE_ALPHA || glenum === GL_DEPTH_COMPONENT || glenum === GL_DEPTH_STENCIL || extensions.ext_srgb && (glenum === GL_SRGB_EXT || glenum === GL_SRGB_ALPHA_EXT)) color[glenum] = glenum;
            else if (glenum === GL_RGB5_A1 || key.indexOf("rgba") >= 0) color[glenum] = GL_RGBA$1;
            else color[glenum] = GL_RGB;
            return color;
        }, {});
        function TexFlags() {
            // format info
            this.internalformat = GL_RGBA$1;
            this.format = GL_RGBA$1;
            this.type = GL_UNSIGNED_BYTE$5;
            this.compressed = false;
            // pixel storage
            this.premultiplyAlpha = false;
            this.flipY = false;
            this.unpackAlignment = 1;
            this.colorSpace = GL_BROWSER_DEFAULT_WEBGL;
            // shape info
            this.width = 0;
            this.height = 0;
            this.channels = 0;
        }
        function copyFlags(result, other) {
            result.internalformat = other.internalformat;
            result.format = other.format;
            result.type = other.type;
            result.compressed = other.compressed;
            result.premultiplyAlpha = other.premultiplyAlpha;
            result.flipY = other.flipY;
            result.unpackAlignment = other.unpackAlignment;
            result.colorSpace = other.colorSpace;
            result.width = other.width;
            result.height = other.height;
            result.channels = other.channels;
        }
        function parseFlags(flags, options) {
            if (typeof options !== "object" || !options) return;
            if ("premultiplyAlpha" in options) {
                check$1.type(options.premultiplyAlpha, "boolean", "invalid premultiplyAlpha");
                flags.premultiplyAlpha = options.premultiplyAlpha;
            }
            if ("flipY" in options) {
                check$1.type(options.flipY, "boolean", "invalid texture flip");
                flags.flipY = options.flipY;
            }
            if ("alignment" in options) {
                check$1.oneOf(options.alignment, [
                    1,
                    2,
                    4,
                    8
                ], "invalid texture unpack alignment");
                flags.unpackAlignment = options.alignment;
            }
            if ("colorSpace" in options) {
                check$1.parameter(options.colorSpace, colorSpace, "invalid colorSpace");
                flags.colorSpace = colorSpace[options.colorSpace];
            }
            if ("type" in options) {
                var type = options.type;
                check$1(extensions.oes_texture_float || !(type === "float" || type === "float32"), "you must enable the OES_texture_float extension in order to use floating point textures.");
                check$1(extensions.oes_texture_half_float || !(type === "half float" || type === "float16"), "you must enable the OES_texture_half_float extension in order to use 16-bit floating point textures.");
                check$1(extensions.webgl_depth_texture || !(type === "uint16" || type === "uint32" || type === "depth stencil"), "you must enable the WEBGL_depth_texture extension in order to use depth/stencil textures.");
                check$1.parameter(type, textureTypes, "invalid texture type");
                flags.type = textureTypes[type];
            }
            var w = flags.width;
            var h = flags.height;
            var c = flags.channels;
            var hasChannels = false;
            if ("shape" in options) {
                check$1(Array.isArray(options.shape) && options.shape.length >= 2, "shape must be an array");
                w = options.shape[0];
                h = options.shape[1];
                if (options.shape.length === 3) {
                    c = options.shape[2];
                    check$1(c > 0 && c <= 4, "invalid number of channels");
                    hasChannels = true;
                }
                check$1(w >= 0 && w <= limits.maxTextureSize, "invalid width");
                check$1(h >= 0 && h <= limits.maxTextureSize, "invalid height");
            } else {
                if ("radius" in options) {
                    w = h = options.radius;
                    check$1(w >= 0 && w <= limits.maxTextureSize, "invalid radius");
                }
                if ("width" in options) {
                    w = options.width;
                    check$1(w >= 0 && w <= limits.maxTextureSize, "invalid width");
                }
                if ("height" in options) {
                    h = options.height;
                    check$1(h >= 0 && h <= limits.maxTextureSize, "invalid height");
                }
                if ("channels" in options) {
                    c = options.channels;
                    check$1(c > 0 && c <= 4, "invalid number of channels");
                    hasChannels = true;
                }
            }
            flags.width = w | 0;
            flags.height = h | 0;
            flags.channels = c | 0;
            var hasFormat = false;
            if ("format" in options) {
                var formatStr = options.format;
                check$1(extensions.webgl_depth_texture || !(formatStr === "depth" || formatStr === "depth stencil"), "you must enable the WEBGL_depth_texture extension in order to use depth/stencil textures.");
                check$1.parameter(formatStr, textureFormats, "invalid texture format");
                var internalformat = flags.internalformat = textureFormats[formatStr];
                flags.format = colorFormats[internalformat];
                if (formatStr in textureTypes) {
                    if (!("type" in options)) flags.type = textureTypes[formatStr];
                }
                if (formatStr in compressedTextureFormats) flags.compressed = true;
                hasFormat = true;
            }
            // Reconcile channels and format
            if (!hasChannels && hasFormat) flags.channels = FORMAT_CHANNELS[flags.format];
            else if (hasChannels && !hasFormat) {
                if (flags.channels !== CHANNELS_FORMAT[flags.format]) flags.format = flags.internalformat = CHANNELS_FORMAT[flags.channels];
            } else if (hasFormat && hasChannels) check$1(flags.channels === FORMAT_CHANNELS[flags.format], "number of channels inconsistent with specified format");
        }
        function setFlags(flags) {
            gl.pixelStorei(GL_UNPACK_FLIP_Y_WEBGL, flags.flipY);
            gl.pixelStorei(GL_UNPACK_PREMULTIPLY_ALPHA_WEBGL, flags.premultiplyAlpha);
            gl.pixelStorei(GL_UNPACK_COLORSPACE_CONVERSION_WEBGL, flags.colorSpace);
            gl.pixelStorei(GL_UNPACK_ALIGNMENT, flags.unpackAlignment);
        }
        // -------------------------------------------------------
        // Tex image data
        // -------------------------------------------------------
        function TexImage() {
            TexFlags.call(this);
            this.xOffset = 0;
            this.yOffset = 0;
            // data
            this.data = null;
            this.needsFree = false;
            // html element
            this.element = null;
            // copyTexImage info
            this.needsCopy = false;
        }
        function parseImage(image, options) {
            var data = null;
            if (isPixelData(options)) data = options;
            else if (options) {
                check$1.type(options, "object", "invalid pixel data type");
                parseFlags(image, options);
                if ("x" in options) image.xOffset = options.x | 0;
                if ("y" in options) image.yOffset = options.y | 0;
                if (isPixelData(options.data)) data = options.data;
            }
            check$1(!image.compressed || data instanceof Uint8Array, "compressed texture data must be stored in a uint8array");
            if (options.copy) {
                check$1(!data, "can not specify copy and data field for the same texture");
                var viewW = contextState.viewportWidth;
                var viewH = contextState.viewportHeight;
                image.width = image.width || viewW - image.xOffset;
                image.height = image.height || viewH - image.yOffset;
                image.needsCopy = true;
                check$1(image.xOffset >= 0 && image.xOffset < viewW && image.yOffset >= 0 && image.yOffset < viewH && image.width > 0 && image.width <= viewW && image.height > 0 && image.height <= viewH, "copy texture read out of bounds");
            } else if (!data) {
                image.width = image.width || 1;
                image.height = image.height || 1;
                image.channels = image.channels || 4;
            } else if (isTypedArray(data)) {
                image.channels = image.channels || 4;
                image.data = data;
                if (!("type" in options) && image.type === GL_UNSIGNED_BYTE$5) image.type = typedArrayCode$1(data);
            } else if (isNumericArray(data)) {
                image.channels = image.channels || 4;
                convertData(image, data);
                image.alignment = 1;
                image.needsFree = true;
            } else if (isNDArrayLike(data)) {
                var array = data.data;
                if (!Array.isArray(array) && image.type === GL_UNSIGNED_BYTE$5) image.type = typedArrayCode$1(array);
                var shape = data.shape;
                var stride = data.stride;
                var shapeX, shapeY, shapeC, strideX, strideY, strideC;
                if (shape.length === 3) {
                    shapeC = shape[2];
                    strideC = stride[2];
                } else {
                    check$1(shape.length === 2, "invalid ndarray pixel data, must be 2 or 3D");
                    shapeC = 1;
                    strideC = 1;
                }
                shapeX = shape[0];
                shapeY = shape[1];
                strideX = stride[0];
                strideY = stride[1];
                image.alignment = 1;
                image.width = shapeX;
                image.height = shapeY;
                image.channels = shapeC;
                image.format = image.internalformat = CHANNELS_FORMAT[shapeC];
                image.needsFree = true;
                transposeData(image, array, strideX, strideY, strideC, data.offset);
            } else if (isCanvasElement(data) || isOffscreenCanvas(data) || isContext2D(data)) {
                if (isCanvasElement(data) || isOffscreenCanvas(data)) image.element = data;
                else image.element = data.canvas;
                image.width = image.element.width;
                image.height = image.element.height;
                image.channels = 4;
            } else if (isBitmap(data)) {
                image.element = data;
                image.width = data.width;
                image.height = data.height;
                image.channels = 4;
            } else if (isImageElement(data)) {
                image.element = data;
                image.width = data.naturalWidth;
                image.height = data.naturalHeight;
                image.channels = 4;
            } else if (isVideoElement(data)) {
                image.element = data;
                image.width = data.videoWidth;
                image.height = data.videoHeight;
                image.channels = 4;
            } else if (isRectArray(data)) {
                var w = image.width || data[0].length;
                var h = image.height || data.length;
                var c = image.channels;
                if (isArrayLike(data[0][0])) c = c || data[0][0].length;
                else c = c || 1;
                var arrayShape = flattenUtils.shape(data);
                var n = 1;
                for(var dd = 0; dd < arrayShape.length; ++dd)n *= arrayShape[dd];
                var allocData = preConvert(image, n);
                flattenUtils.flatten(data, arrayShape, "", allocData);
                postConvert(image, allocData);
                image.alignment = 1;
                image.width = w;
                image.height = h;
                image.channels = c;
                image.format = image.internalformat = CHANNELS_FORMAT[c];
                image.needsFree = true;
            }
            if (image.type === GL_FLOAT$4) check$1(limits.extensions.indexOf("oes_texture_float") >= 0, "oes_texture_float extension not enabled");
            else if (image.type === GL_HALF_FLOAT_OES$1) check$1(limits.extensions.indexOf("oes_texture_half_float") >= 0, "oes_texture_half_float extension not enabled");
        // do compressed texture  validation here.
        }
        function setImage(info, target, miplevel) {
            var element = info.element;
            var data = info.data;
            var internalformat = info.internalformat;
            var format = info.format;
            var type = info.type;
            var width = info.width;
            var height = info.height;
            setFlags(info);
            if (element) gl.texImage2D(target, miplevel, format, format, type, element);
            else if (info.compressed) gl.compressedTexImage2D(target, miplevel, internalformat, width, height, 0, data);
            else if (info.needsCopy) {
                reglPoll();
                gl.copyTexImage2D(target, miplevel, format, info.xOffset, info.yOffset, width, height, 0);
            } else gl.texImage2D(target, miplevel, format, width, height, 0, format, type, data || null);
        }
        function setSubImage(info, target, x, y, miplevel) {
            var element = info.element;
            var data = info.data;
            var internalformat = info.internalformat;
            var format = info.format;
            var type = info.type;
            var width = info.width;
            var height = info.height;
            setFlags(info);
            if (element) gl.texSubImage2D(target, miplevel, x, y, format, type, element);
            else if (info.compressed) gl.compressedTexSubImage2D(target, miplevel, x, y, internalformat, width, height, data);
            else if (info.needsCopy) {
                reglPoll();
                gl.copyTexSubImage2D(target, miplevel, x, y, info.xOffset, info.yOffset, width, height);
            } else gl.texSubImage2D(target, miplevel, x, y, width, height, format, type, data);
        }
        // texImage pool
        var imagePool = [];
        function allocImage() {
            return imagePool.pop() || new TexImage();
        }
        function freeImage(image) {
            if (image.needsFree) pool.freeType(image.data);
            TexImage.call(image);
            imagePool.push(image);
        }
        // -------------------------------------------------------
        // Mip map
        // -------------------------------------------------------
        function MipMap() {
            TexFlags.call(this);
            this.genMipmaps = false;
            this.mipmapHint = GL_DONT_CARE;
            this.mipmask = 0;
            this.images = Array(16);
        }
        function parseMipMapFromShape(mipmap, width, height) {
            var img = mipmap.images[0] = allocImage();
            mipmap.mipmask = 1;
            img.width = mipmap.width = width;
            img.height = mipmap.height = height;
            img.channels = mipmap.channels = 4;
        }
        function parseMipMapFromObject(mipmap, options) {
            var imgData = null;
            if (isPixelData(options)) {
                imgData = mipmap.images[0] = allocImage();
                copyFlags(imgData, mipmap);
                parseImage(imgData, options);
                mipmap.mipmask = 1;
            } else {
                parseFlags(mipmap, options);
                if (Array.isArray(options.mipmap)) {
                    var mipData = options.mipmap;
                    for(var i = 0; i < mipData.length; ++i){
                        imgData = mipmap.images[i] = allocImage();
                        copyFlags(imgData, mipmap);
                        imgData.width >>= i;
                        imgData.height >>= i;
                        parseImage(imgData, mipData[i]);
                        mipmap.mipmask |= 1 << i;
                    }
                } else {
                    imgData = mipmap.images[0] = allocImage();
                    copyFlags(imgData, mipmap);
                    parseImage(imgData, options);
                    mipmap.mipmask = 1;
                }
            }
            copyFlags(mipmap, mipmap.images[0]);
            // For textures of the compressed format WEBGL_compressed_texture_s3tc
            // we must have that
            //
            // "When level equals zero width and height must be a multiple of 4.
            // When level is greater than 0 width and height must be 0, 1, 2 or a multiple of 4. "
            //
            // but we do not yet support having multiple mipmap levels for compressed textures,
            // so we only test for level zero.
            if (mipmap.compressed && (mipmap.internalformat === GL_COMPRESSED_RGB_S3TC_DXT1_EXT || mipmap.internalformat === GL_COMPRESSED_RGBA_S3TC_DXT1_EXT || mipmap.internalformat === GL_COMPRESSED_RGBA_S3TC_DXT3_EXT || mipmap.internalformat === GL_COMPRESSED_RGBA_S3TC_DXT5_EXT)) check$1(mipmap.width % 4 === 0 && mipmap.height % 4 === 0, "for compressed texture formats, mipmap level 0 must have width and height that are a multiple of 4");
        }
        function setMipMap(mipmap, target) {
            var images = mipmap.images;
            for(var i = 0; i < images.length; ++i){
                if (!images[i]) return;
                setImage(images[i], target, i);
            }
        }
        var mipPool = [];
        function allocMipMap() {
            var result = mipPool.pop() || new MipMap();
            TexFlags.call(result);
            result.mipmask = 0;
            for(var i = 0; i < 16; ++i)result.images[i] = null;
            return result;
        }
        function freeMipMap(mipmap) {
            var images = mipmap.images;
            for(var i = 0; i < images.length; ++i){
                if (images[i]) freeImage(images[i]);
                images[i] = null;
            }
            mipPool.push(mipmap);
        }
        // -------------------------------------------------------
        // Tex info
        // -------------------------------------------------------
        function TexInfo() {
            this.minFilter = GL_NEAREST$1;
            this.magFilter = GL_NEAREST$1;
            this.wrapS = GL_CLAMP_TO_EDGE$1;
            this.wrapT = GL_CLAMP_TO_EDGE$1;
            this.anisotropic = 1;
            this.genMipmaps = false;
            this.mipmapHint = GL_DONT_CARE;
        }
        function parseTexInfo(info, options) {
            if ("min" in options) {
                var minFilter = options.min;
                check$1.parameter(minFilter, minFilters);
                info.minFilter = minFilters[minFilter];
                if (MIPMAP_FILTERS.indexOf(info.minFilter) >= 0 && !("faces" in options)) info.genMipmaps = true;
            }
            if ("mag" in options) {
                var magFilter = options.mag;
                check$1.parameter(magFilter, magFilters);
                info.magFilter = magFilters[magFilter];
            }
            var wrapS = info.wrapS;
            var wrapT = info.wrapT;
            if ("wrap" in options) {
                var wrap = options.wrap;
                if (typeof wrap === "string") {
                    check$1.parameter(wrap, wrapModes);
                    wrapS = wrapT = wrapModes[wrap];
                } else if (Array.isArray(wrap)) {
                    check$1.parameter(wrap[0], wrapModes);
                    check$1.parameter(wrap[1], wrapModes);
                    wrapS = wrapModes[wrap[0]];
                    wrapT = wrapModes[wrap[1]];
                }
            } else {
                if ("wrapS" in options) {
                    var optWrapS = options.wrapS;
                    check$1.parameter(optWrapS, wrapModes);
                    wrapS = wrapModes[optWrapS];
                }
                if ("wrapT" in options) {
                    var optWrapT = options.wrapT;
                    check$1.parameter(optWrapT, wrapModes);
                    wrapT = wrapModes[optWrapT];
                }
            }
            info.wrapS = wrapS;
            info.wrapT = wrapT;
            if ("anisotropic" in options) {
                var anisotropic = options.anisotropic;
                check$1(typeof anisotropic === "number" && anisotropic >= 1 && anisotropic <= limits.maxAnisotropic, "aniso samples must be between 1 and ");
                info.anisotropic = options.anisotropic;
            }
            if ("mipmap" in options) {
                var hasMipMap = false;
                switch(typeof options.mipmap){
                    case "string":
                        check$1.parameter(options.mipmap, mipmapHint, "invalid mipmap hint");
                        info.mipmapHint = mipmapHint[options.mipmap];
                        info.genMipmaps = true;
                        hasMipMap = true;
                        break;
                    case "boolean":
                        hasMipMap = info.genMipmaps = options.mipmap;
                        break;
                    case "object":
                        check$1(Array.isArray(options.mipmap), "invalid mipmap type");
                        info.genMipmaps = false;
                        hasMipMap = true;
                        break;
                    default:
                        check$1.raise("invalid mipmap type");
                }
                if (hasMipMap && !("min" in options)) info.minFilter = GL_NEAREST_MIPMAP_NEAREST$1;
            }
        }
        function setTexInfo(info, target) {
            gl.texParameteri(target, GL_TEXTURE_MIN_FILTER, info.minFilter);
            gl.texParameteri(target, GL_TEXTURE_MAG_FILTER, info.magFilter);
            gl.texParameteri(target, GL_TEXTURE_WRAP_S, info.wrapS);
            gl.texParameteri(target, GL_TEXTURE_WRAP_T, info.wrapT);
            if (extensions.ext_texture_filter_anisotropic) gl.texParameteri(target, GL_TEXTURE_MAX_ANISOTROPY_EXT, info.anisotropic);
            if (info.genMipmaps) {
                gl.hint(GL_GENERATE_MIPMAP_HINT, info.mipmapHint);
                gl.generateMipmap(target);
            }
        }
        // -------------------------------------------------------
        // Full texture object
        // -------------------------------------------------------
        var textureCount = 0;
        var textureSet = {};
        var numTexUnits = limits.maxTextureUnits;
        var textureUnits = Array(numTexUnits).map(function() {
            return null;
        });
        function REGLTexture(target) {
            TexFlags.call(this);
            this.mipmask = 0;
            this.internalformat = GL_RGBA$1;
            this.id = textureCount++;
            this.refCount = 1;
            this.target = target;
            this.texture = gl.createTexture();
            this.unit = -1;
            this.bindCount = 0;
            this.texInfo = new TexInfo();
            if (config.profile) this.stats = {
                size: 0
            };
        }
        function tempBind(texture) {
            gl.activeTexture(GL_TEXTURE0$1);
            gl.bindTexture(texture.target, texture.texture);
        }
        function tempRestore() {
            var prev = textureUnits[0];
            if (prev) gl.bindTexture(prev.target, prev.texture);
            else gl.bindTexture(GL_TEXTURE_2D$1, null);
        }
        function destroy(texture) {
            var handle = texture.texture;
            check$1(handle, "must not double destroy texture");
            var unit = texture.unit;
            var target = texture.target;
            if (unit >= 0) {
                gl.activeTexture(GL_TEXTURE0$1 + unit);
                gl.bindTexture(target, null);
                textureUnits[unit] = null;
            }
            gl.deleteTexture(handle);
            texture.texture = null;
            texture.params = null;
            texture.pixels = null;
            texture.refCount = 0;
            delete textureSet[texture.id];
            stats.textureCount--;
        }
        extend(REGLTexture.prototype, {
            bind: function() {
                var texture = this;
                texture.bindCount += 1;
                var unit = texture.unit;
                if (unit < 0) {
                    for(var i = 0; i < numTexUnits; ++i){
                        var other = textureUnits[i];
                        if (other) {
                            if (other.bindCount > 0) continue;
                            other.unit = -1;
                        }
                        textureUnits[i] = texture;
                        unit = i;
                        break;
                    }
                    if (unit >= numTexUnits) check$1.raise("insufficient number of texture units");
                    if (config.profile && stats.maxTextureUnits < unit + 1) stats.maxTextureUnits = unit + 1 // +1, since the units are zero-based
                    ;
                    texture.unit = unit;
                    gl.activeTexture(GL_TEXTURE0$1 + unit);
                    gl.bindTexture(texture.target, texture.texture);
                }
                return unit;
            },
            unbind: function() {
                this.bindCount -= 1;
            },
            decRef: function() {
                if (--this.refCount <= 0) destroy(this);
            }
        });
        function createTexture2D(a, b) {
            var texture = new REGLTexture(GL_TEXTURE_2D$1);
            textureSet[texture.id] = texture;
            stats.textureCount++;
            function reglTexture2D(a, b) {
                var texInfo = texture.texInfo;
                TexInfo.call(texInfo);
                var mipData = allocMipMap();
                if (typeof a === "number") {
                    if (typeof b === "number") parseMipMapFromShape(mipData, a | 0, b | 0);
                    else parseMipMapFromShape(mipData, a | 0, a | 0);
                } else if (a) {
                    check$1.type(a, "object", "invalid arguments to regl.texture");
                    parseTexInfo(texInfo, a);
                    parseMipMapFromObject(mipData, a);
                } else // empty textures get assigned a default shape of 1x1
                parseMipMapFromShape(mipData, 1, 1);
                if (texInfo.genMipmaps) mipData.mipmask = (mipData.width << 1) - 1;
                texture.mipmask = mipData.mipmask;
                copyFlags(texture, mipData);
                check$1.texture2D(texInfo, mipData, limits);
                texture.internalformat = mipData.internalformat;
                reglTexture2D.width = mipData.width;
                reglTexture2D.height = mipData.height;
                tempBind(texture);
                setMipMap(mipData, GL_TEXTURE_2D$1);
                setTexInfo(texInfo, GL_TEXTURE_2D$1);
                tempRestore();
                freeMipMap(mipData);
                if (config.profile) texture.stats.size = getTextureSize(texture.internalformat, texture.type, mipData.width, mipData.height, texInfo.genMipmaps, false);
                reglTexture2D.format = textureFormatsInvert[texture.internalformat];
                reglTexture2D.type = textureTypesInvert[texture.type];
                reglTexture2D.mag = magFiltersInvert[texInfo.magFilter];
                reglTexture2D.min = minFiltersInvert[texInfo.minFilter];
                reglTexture2D.wrapS = wrapModesInvert[texInfo.wrapS];
                reglTexture2D.wrapT = wrapModesInvert[texInfo.wrapT];
                return reglTexture2D;
            }
            function subimage(image, x_, y_, level_) {
                check$1(!!image, "must specify image data");
                var x = x_ | 0;
                var y = y_ | 0;
                var level = level_ | 0;
                var imageData = allocImage();
                copyFlags(imageData, texture);
                imageData.width = 0;
                imageData.height = 0;
                parseImage(imageData, image);
                imageData.width = imageData.width || (texture.width >> level) - x;
                imageData.height = imageData.height || (texture.height >> level) - y;
                check$1(texture.type === imageData.type && texture.format === imageData.format && texture.internalformat === imageData.internalformat, "incompatible format for texture.subimage");
                check$1(x >= 0 && y >= 0 && x + imageData.width <= texture.width && y + imageData.height <= texture.height, "texture.subimage write out of bounds");
                check$1(texture.mipmask & 1 << level, "missing mipmap data");
                check$1(imageData.data || imageData.element || imageData.needsCopy, "missing image data");
                tempBind(texture);
                setSubImage(imageData, GL_TEXTURE_2D$1, x, y, level);
                tempRestore();
                freeImage(imageData);
                return reglTexture2D;
            }
            function resize(w_, h_) {
                var w = w_ | 0;
                var h = h_ | 0 || w;
                if (w === texture.width && h === texture.height) return reglTexture2D;
                reglTexture2D.width = texture.width = w;
                reglTexture2D.height = texture.height = h;
                tempBind(texture);
                for(var i = 0; texture.mipmask >> i; ++i){
                    var _w = w >> i;
                    var _h = h >> i;
                    if (!_w || !_h) break;
                    gl.texImage2D(GL_TEXTURE_2D$1, i, texture.format, _w, _h, 0, texture.format, texture.type, null);
                }
                tempRestore();
                // also, recompute the texture size.
                if (config.profile) texture.stats.size = getTextureSize(texture.internalformat, texture.type, w, h, false, false);
                return reglTexture2D;
            }
            reglTexture2D(a, b);
            reglTexture2D.subimage = subimage;
            reglTexture2D.resize = resize;
            reglTexture2D._reglType = "texture2d";
            reglTexture2D._texture = texture;
            if (config.profile) reglTexture2D.stats = texture.stats;
            reglTexture2D.destroy = function() {
                texture.decRef();
            };
            return reglTexture2D;
        }
        function createTextureCube(a0, a1, a2, a3, a4, a5) {
            var texture = new REGLTexture(GL_TEXTURE_CUBE_MAP$1);
            textureSet[texture.id] = texture;
            stats.cubeCount++;
            var faces = new Array(6);
            function reglTextureCube(a0, a1, a2, a3, a4, a5) {
                var i;
                var texInfo = texture.texInfo;
                TexInfo.call(texInfo);
                for(i = 0; i < 6; ++i)faces[i] = allocMipMap();
                if (typeof a0 === "number" || !a0) {
                    var s = a0 | 0 || 1;
                    for(i = 0; i < 6; ++i)parseMipMapFromShape(faces[i], s, s);
                } else if (typeof a0 === "object") {
                    if (a1) {
                        parseMipMapFromObject(faces[0], a0);
                        parseMipMapFromObject(faces[1], a1);
                        parseMipMapFromObject(faces[2], a2);
                        parseMipMapFromObject(faces[3], a3);
                        parseMipMapFromObject(faces[4], a4);
                        parseMipMapFromObject(faces[5], a5);
                    } else {
                        parseTexInfo(texInfo, a0);
                        parseFlags(texture, a0);
                        if ("faces" in a0) {
                            var faceInput = a0.faces;
                            check$1(Array.isArray(faceInput) && faceInput.length === 6, "cube faces must be a length 6 array");
                            for(i = 0; i < 6; ++i){
                                check$1(typeof faceInput[i] === "object" && !!faceInput[i], "invalid input for cube map face");
                                copyFlags(faces[i], texture);
                                parseMipMapFromObject(faces[i], faceInput[i]);
                            }
                        } else for(i = 0; i < 6; ++i)parseMipMapFromObject(faces[i], a0);
                    }
                } else check$1.raise("invalid arguments to cube map");
                copyFlags(texture, faces[0]);
                check$1.optional(function() {
                    if (!limits.npotTextureCube) check$1(isPow2$1(texture.width) && isPow2$1(texture.height), "your browser does not support non power or two texture dimensions");
                });
                if (texInfo.genMipmaps) texture.mipmask = (faces[0].width << 1) - 1;
                else texture.mipmask = faces[0].mipmask;
                check$1.textureCube(texture, texInfo, faces, limits);
                texture.internalformat = faces[0].internalformat;
                reglTextureCube.width = faces[0].width;
                reglTextureCube.height = faces[0].height;
                tempBind(texture);
                for(i = 0; i < 6; ++i)setMipMap(faces[i], GL_TEXTURE_CUBE_MAP_POSITIVE_X$1 + i);
                setTexInfo(texInfo, GL_TEXTURE_CUBE_MAP$1);
                tempRestore();
                if (config.profile) texture.stats.size = getTextureSize(texture.internalformat, texture.type, reglTextureCube.width, reglTextureCube.height, texInfo.genMipmaps, true);
                reglTextureCube.format = textureFormatsInvert[texture.internalformat];
                reglTextureCube.type = textureTypesInvert[texture.type];
                reglTextureCube.mag = magFiltersInvert[texInfo.magFilter];
                reglTextureCube.min = minFiltersInvert[texInfo.minFilter];
                reglTextureCube.wrapS = wrapModesInvert[texInfo.wrapS];
                reglTextureCube.wrapT = wrapModesInvert[texInfo.wrapT];
                for(i = 0; i < 6; ++i)freeMipMap(faces[i]);
                return reglTextureCube;
            }
            function subimage(face, image, x_, y_, level_) {
                check$1(!!image, "must specify image data");
                check$1(typeof face === "number" && face === (face | 0) && face >= 0 && face < 6, "invalid face");
                var x = x_ | 0;
                var y = y_ | 0;
                var level = level_ | 0;
                var imageData = allocImage();
                copyFlags(imageData, texture);
                imageData.width = 0;
                imageData.height = 0;
                parseImage(imageData, image);
                imageData.width = imageData.width || (texture.width >> level) - x;
                imageData.height = imageData.height || (texture.height >> level) - y;
                check$1(texture.type === imageData.type && texture.format === imageData.format && texture.internalformat === imageData.internalformat, "incompatible format for texture.subimage");
                check$1(x >= 0 && y >= 0 && x + imageData.width <= texture.width && y + imageData.height <= texture.height, "texture.subimage write out of bounds");
                check$1(texture.mipmask & 1 << level, "missing mipmap data");
                check$1(imageData.data || imageData.element || imageData.needsCopy, "missing image data");
                tempBind(texture);
                setSubImage(imageData, GL_TEXTURE_CUBE_MAP_POSITIVE_X$1 + face, x, y, level);
                tempRestore();
                freeImage(imageData);
                return reglTextureCube;
            }
            function resize(radius_) {
                var radius = radius_ | 0;
                if (radius === texture.width) return;
                reglTextureCube.width = texture.width = radius;
                reglTextureCube.height = texture.height = radius;
                tempBind(texture);
                for(var i = 0; i < 6; ++i)for(var j = 0; texture.mipmask >> j; ++j)gl.texImage2D(GL_TEXTURE_CUBE_MAP_POSITIVE_X$1 + i, j, texture.format, radius >> j, radius >> j, 0, texture.format, texture.type, null);
                tempRestore();
                if (config.profile) texture.stats.size = getTextureSize(texture.internalformat, texture.type, reglTextureCube.width, reglTextureCube.height, false, true);
                return reglTextureCube;
            }
            reglTextureCube(a0, a1, a2, a3, a4, a5);
            reglTextureCube.subimage = subimage;
            reglTextureCube.resize = resize;
            reglTextureCube._reglType = "textureCube";
            reglTextureCube._texture = texture;
            if (config.profile) reglTextureCube.stats = texture.stats;
            reglTextureCube.destroy = function() {
                texture.decRef();
            };
            return reglTextureCube;
        }
        // Called when regl is destroyed
        function destroyTextures() {
            for(var i = 0; i < numTexUnits; ++i){
                gl.activeTexture(GL_TEXTURE0$1 + i);
                gl.bindTexture(GL_TEXTURE_2D$1, null);
                textureUnits[i] = null;
            }
            values(textureSet).forEach(destroy);
            stats.cubeCount = 0;
            stats.textureCount = 0;
        }
        if (config.profile) stats.getTotalTextureSize = function() {
            var total = 0;
            Object.keys(textureSet).forEach(function(key) {
                total += textureSet[key].stats.size;
            });
            return total;
        };
        function restoreTextures() {
            for(var i = 0; i < numTexUnits; ++i){
                var tex = textureUnits[i];
                if (tex) {
                    tex.bindCount = 0;
                    tex.unit = -1;
                    textureUnits[i] = null;
                }
            }
            values(textureSet).forEach(function(texture) {
                texture.texture = gl.createTexture();
                gl.bindTexture(texture.target, texture.texture);
                for(var i = 0; i < 32; ++i){
                    if ((texture.mipmask & 1 << i) === 0) continue;
                    if (texture.target === GL_TEXTURE_2D$1) gl.texImage2D(GL_TEXTURE_2D$1, i, texture.internalformat, texture.width >> i, texture.height >> i, 0, texture.internalformat, texture.type, null);
                    else for(var j = 0; j < 6; ++j)gl.texImage2D(GL_TEXTURE_CUBE_MAP_POSITIVE_X$1 + j, i, texture.internalformat, texture.width >> i, texture.height >> i, 0, texture.internalformat, texture.type, null);
                }
                setTexInfo(texture.texInfo, texture.target);
            });
        }
        function refreshTextures() {
            for(var i = 0; i < numTexUnits; ++i){
                var tex = textureUnits[i];
                if (tex) {
                    tex.bindCount = 0;
                    tex.unit = -1;
                    textureUnits[i] = null;
                }
                gl.activeTexture(GL_TEXTURE0$1 + i);
                gl.bindTexture(GL_TEXTURE_2D$1, null);
                gl.bindTexture(GL_TEXTURE_CUBE_MAP$1, null);
            }
        }
        return {
            create2D: createTexture2D,
            createCube: createTextureCube,
            clear: destroyTextures,
            getTexture: function(wrapper) {
                return null;
            },
            restore: restoreTextures,
            refresh: refreshTextures
        };
    }
    var GL_RENDERBUFFER = 0x8D41;
    var GL_RGBA4$1 = 0x8056;
    var GL_RGB5_A1$1 = 0x8057;
    var GL_RGB565$1 = 0x8D62;
    var GL_DEPTH_COMPONENT16 = 0x81A5;
    var GL_STENCIL_INDEX8 = 0x8D48;
    var GL_DEPTH_STENCIL$1 = 0x84F9;
    var GL_SRGB8_ALPHA8_EXT = 0x8C43;
    var GL_RGBA32F_EXT = 0x8814;
    var GL_RGBA16F_EXT = 0x881A;
    var GL_RGB16F_EXT = 0x881B;
    var FORMAT_SIZES = [];
    FORMAT_SIZES[GL_RGBA4$1] = 2;
    FORMAT_SIZES[GL_RGB5_A1$1] = 2;
    FORMAT_SIZES[GL_RGB565$1] = 2;
    FORMAT_SIZES[GL_DEPTH_COMPONENT16] = 2;
    FORMAT_SIZES[GL_STENCIL_INDEX8] = 1;
    FORMAT_SIZES[GL_DEPTH_STENCIL$1] = 4;
    FORMAT_SIZES[GL_SRGB8_ALPHA8_EXT] = 4;
    FORMAT_SIZES[GL_RGBA32F_EXT] = 16;
    FORMAT_SIZES[GL_RGBA16F_EXT] = 8;
    FORMAT_SIZES[GL_RGB16F_EXT] = 6;
    function getRenderbufferSize(format, width, height) {
        return FORMAT_SIZES[format] * width * height;
    }
    var wrapRenderbuffers = function(gl, extensions, limits, stats, config) {
        var formatTypes = {
            "rgba4": GL_RGBA4$1,
            "rgb565": GL_RGB565$1,
            "rgb5 a1": GL_RGB5_A1$1,
            "depth": GL_DEPTH_COMPONENT16,
            "stencil": GL_STENCIL_INDEX8,
            "depth stencil": GL_DEPTH_STENCIL$1
        };
        if (extensions.ext_srgb) formatTypes["srgba"] = GL_SRGB8_ALPHA8_EXT;
        if (extensions.ext_color_buffer_half_float) {
            formatTypes["rgba16f"] = GL_RGBA16F_EXT;
            formatTypes["rgb16f"] = GL_RGB16F_EXT;
        }
        if (extensions.webgl_color_buffer_float) formatTypes["rgba32f"] = GL_RGBA32F_EXT;
        var formatTypesInvert = [];
        Object.keys(formatTypes).forEach(function(key) {
            var val = formatTypes[key];
            formatTypesInvert[val] = key;
        });
        var renderbufferCount = 0;
        var renderbufferSet = {};
        function REGLRenderbuffer(renderbuffer) {
            this.id = renderbufferCount++;
            this.refCount = 1;
            this.renderbuffer = renderbuffer;
            this.format = GL_RGBA4$1;
            this.width = 0;
            this.height = 0;
            if (config.profile) this.stats = {
                size: 0
            };
        }
        REGLRenderbuffer.prototype.decRef = function() {
            if (--this.refCount <= 0) destroy(this);
        };
        function destroy(rb) {
            var handle = rb.renderbuffer;
            check$1(handle, "must not double destroy renderbuffer");
            gl.bindRenderbuffer(GL_RENDERBUFFER, null);
            gl.deleteRenderbuffer(handle);
            rb.renderbuffer = null;
            rb.refCount = 0;
            delete renderbufferSet[rb.id];
            stats.renderbufferCount--;
        }
        function createRenderbuffer(a, b) {
            var renderbuffer = new REGLRenderbuffer(gl.createRenderbuffer());
            renderbufferSet[renderbuffer.id] = renderbuffer;
            stats.renderbufferCount++;
            function reglRenderbuffer(a, b) {
                var w = 0;
                var h = 0;
                var format = GL_RGBA4$1;
                if (typeof a === "object" && a) {
                    var options = a;
                    if ("shape" in options) {
                        var shape = options.shape;
                        check$1(Array.isArray(shape) && shape.length >= 2, "invalid renderbuffer shape");
                        w = shape[0] | 0;
                        h = shape[1] | 0;
                    } else {
                        if ("radius" in options) w = h = options.radius | 0;
                        if ("width" in options) w = options.width | 0;
                        if ("height" in options) h = options.height | 0;
                    }
                    if ("format" in options) {
                        check$1.parameter(options.format, formatTypes, "invalid renderbuffer format");
                        format = formatTypes[options.format];
                    }
                } else if (typeof a === "number") {
                    w = a | 0;
                    if (typeof b === "number") h = b | 0;
                    else h = w;
                } else if (!a) w = h = 1;
                else check$1.raise("invalid arguments to renderbuffer constructor");
                // check shape
                check$1(w > 0 && h > 0 && w <= limits.maxRenderbufferSize && h <= limits.maxRenderbufferSize, "invalid renderbuffer size");
                if (w === renderbuffer.width && h === renderbuffer.height && format === renderbuffer.format) return;
                reglRenderbuffer.width = renderbuffer.width = w;
                reglRenderbuffer.height = renderbuffer.height = h;
                renderbuffer.format = format;
                gl.bindRenderbuffer(GL_RENDERBUFFER, renderbuffer.renderbuffer);
                gl.renderbufferStorage(GL_RENDERBUFFER, format, w, h);
                check$1(gl.getError() === 0, "invalid render buffer format");
                if (config.profile) renderbuffer.stats.size = getRenderbufferSize(renderbuffer.format, renderbuffer.width, renderbuffer.height);
                reglRenderbuffer.format = formatTypesInvert[renderbuffer.format];
                return reglRenderbuffer;
            }
            function resize(w_, h_) {
                var w = w_ | 0;
                var h = h_ | 0 || w;
                if (w === renderbuffer.width && h === renderbuffer.height) return reglRenderbuffer;
                // check shape
                check$1(w > 0 && h > 0 && w <= limits.maxRenderbufferSize && h <= limits.maxRenderbufferSize, "invalid renderbuffer size");
                reglRenderbuffer.width = renderbuffer.width = w;
                reglRenderbuffer.height = renderbuffer.height = h;
                gl.bindRenderbuffer(GL_RENDERBUFFER, renderbuffer.renderbuffer);
                gl.renderbufferStorage(GL_RENDERBUFFER, renderbuffer.format, w, h);
                check$1(gl.getError() === 0, "invalid render buffer format");
                // also, recompute size.
                if (config.profile) renderbuffer.stats.size = getRenderbufferSize(renderbuffer.format, renderbuffer.width, renderbuffer.height);
                return reglRenderbuffer;
            }
            reglRenderbuffer(a, b);
            reglRenderbuffer.resize = resize;
            reglRenderbuffer._reglType = "renderbuffer";
            reglRenderbuffer._renderbuffer = renderbuffer;
            if (config.profile) reglRenderbuffer.stats = renderbuffer.stats;
            reglRenderbuffer.destroy = function() {
                renderbuffer.decRef();
            };
            return reglRenderbuffer;
        }
        if (config.profile) stats.getTotalRenderbufferSize = function() {
            var total = 0;
            Object.keys(renderbufferSet).forEach(function(key) {
                total += renderbufferSet[key].stats.size;
            });
            return total;
        };
        function restoreRenderbuffers() {
            values(renderbufferSet).forEach(function(rb) {
                rb.renderbuffer = gl.createRenderbuffer();
                gl.bindRenderbuffer(GL_RENDERBUFFER, rb.renderbuffer);
                gl.renderbufferStorage(GL_RENDERBUFFER, rb.format, rb.width, rb.height);
            });
            gl.bindRenderbuffer(GL_RENDERBUFFER, null);
        }
        return {
            create: createRenderbuffer,
            clear: function() {
                values(renderbufferSet).forEach(destroy);
            },
            restore: restoreRenderbuffers
        };
    };
    // We store these constants so that the minifier can inline them
    var GL_FRAMEBUFFER$1 = 0x8D40;
    var GL_RENDERBUFFER$1 = 0x8D41;
    var GL_TEXTURE_2D$2 = 0x0DE1;
    var GL_TEXTURE_CUBE_MAP_POSITIVE_X$2 = 0x8515;
    var GL_COLOR_ATTACHMENT0$1 = 0x8CE0;
    var GL_DEPTH_ATTACHMENT = 0x8D00;
    var GL_STENCIL_ATTACHMENT = 0x8D20;
    var GL_DEPTH_STENCIL_ATTACHMENT = 0x821A;
    var GL_FRAMEBUFFER_COMPLETE$1 = 0x8CD5;
    var GL_FRAMEBUFFER_INCOMPLETE_ATTACHMENT = 0x8CD6;
    var GL_FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT = 0x8CD7;
    var GL_FRAMEBUFFER_INCOMPLETE_DIMENSIONS = 0x8CD9;
    var GL_FRAMEBUFFER_UNSUPPORTED = 0x8CDD;
    var GL_HALF_FLOAT_OES$2 = 0x8D61;
    var GL_UNSIGNED_BYTE$6 = 0x1401;
    var GL_FLOAT$5 = 0x1406;
    var GL_RGB$1 = 0x1907;
    var GL_RGBA$2 = 0x1908;
    var GL_DEPTH_COMPONENT$1 = 0x1902;
    var colorTextureFormatEnums = [
        GL_RGB$1,
        GL_RGBA$2
    ];
    // for every texture format, store
    // the number of channels
    var textureFormatChannels = [];
    textureFormatChannels[GL_RGBA$2] = 4;
    textureFormatChannels[GL_RGB$1] = 3;
    // for every texture type, store
    // the size in bytes.
    var textureTypeSizes = [];
    textureTypeSizes[GL_UNSIGNED_BYTE$6] = 1;
    textureTypeSizes[GL_FLOAT$5] = 4;
    textureTypeSizes[GL_HALF_FLOAT_OES$2] = 2;
    var GL_RGBA4$2 = 0x8056;
    var GL_RGB5_A1$2 = 0x8057;
    var GL_RGB565$2 = 0x8D62;
    var GL_DEPTH_COMPONENT16$1 = 0x81A5;
    var GL_STENCIL_INDEX8$1 = 0x8D48;
    var GL_DEPTH_STENCIL$2 = 0x84F9;
    var GL_SRGB8_ALPHA8_EXT$1 = 0x8C43;
    var GL_RGBA32F_EXT$1 = 0x8814;
    var GL_RGBA16F_EXT$1 = 0x881A;
    var GL_RGB16F_EXT$1 = 0x881B;
    var colorRenderbufferFormatEnums = [
        GL_RGBA4$2,
        GL_RGB5_A1$2,
        GL_RGB565$2,
        GL_SRGB8_ALPHA8_EXT$1,
        GL_RGBA16F_EXT$1,
        GL_RGB16F_EXT$1,
        GL_RGBA32F_EXT$1
    ];
    var statusCode = {};
    statusCode[GL_FRAMEBUFFER_COMPLETE$1] = "complete";
    statusCode[GL_FRAMEBUFFER_INCOMPLETE_ATTACHMENT] = "incomplete attachment";
    statusCode[GL_FRAMEBUFFER_INCOMPLETE_DIMENSIONS] = "incomplete dimensions";
    statusCode[GL_FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT] = "incomplete, missing attachment";
    statusCode[GL_FRAMEBUFFER_UNSUPPORTED] = "unsupported";
    function wrapFBOState(gl, extensions, limits, textureState, renderbufferState, stats) {
        var framebufferState = {
            cur: null,
            next: null,
            dirty: false,
            setFBO: null
        };
        var colorTextureFormats = [
            "rgba"
        ];
        var colorRenderbufferFormats = [
            "rgba4",
            "rgb565",
            "rgb5 a1"
        ];
        if (extensions.ext_srgb) colorRenderbufferFormats.push("srgba");
        if (extensions.ext_color_buffer_half_float) colorRenderbufferFormats.push("rgba16f", "rgb16f");
        if (extensions.webgl_color_buffer_float) colorRenderbufferFormats.push("rgba32f");
        var colorTypes = [
            "uint8"
        ];
        if (extensions.oes_texture_half_float) colorTypes.push("half float", "float16");
        if (extensions.oes_texture_float) colorTypes.push("float", "float32");
        function FramebufferAttachment(target, texture, renderbuffer) {
            this.target = target;
            this.texture = texture;
            this.renderbuffer = renderbuffer;
            var w = 0;
            var h = 0;
            if (texture) {
                w = texture.width;
                h = texture.height;
            } else if (renderbuffer) {
                w = renderbuffer.width;
                h = renderbuffer.height;
            }
            this.width = w;
            this.height = h;
        }
        function decRef(attachment) {
            if (attachment) {
                if (attachment.texture) attachment.texture._texture.decRef();
                if (attachment.renderbuffer) attachment.renderbuffer._renderbuffer.decRef();
            }
        }
        function incRefAndCheckShape(attachment, width, height) {
            if (!attachment) return;
            if (attachment.texture) {
                var texture = attachment.texture._texture;
                var tw = Math.max(1, texture.width);
                var th = Math.max(1, texture.height);
                check$1(tw === width && th === height, "inconsistent width/height for supplied texture");
                texture.refCount += 1;
            } else {
                var renderbuffer = attachment.renderbuffer._renderbuffer;
                check$1(renderbuffer.width === width && renderbuffer.height === height, "inconsistent width/height for renderbuffer");
                renderbuffer.refCount += 1;
            }
        }
        function attach(location, attachment) {
            if (attachment) {
                if (attachment.texture) gl.framebufferTexture2D(GL_FRAMEBUFFER$1, location, attachment.target, attachment.texture._texture.texture, 0);
                else gl.framebufferRenderbuffer(GL_FRAMEBUFFER$1, location, GL_RENDERBUFFER$1, attachment.renderbuffer._renderbuffer.renderbuffer);
            }
        }
        function parseAttachment(attachment) {
            var target = GL_TEXTURE_2D$2;
            var texture = null;
            var renderbuffer = null;
            var data = attachment;
            if (typeof attachment === "object") {
                data = attachment.data;
                if ("target" in attachment) target = attachment.target | 0;
            }
            check$1.type(data, "function", "invalid attachment data");
            var type = data._reglType;
            if (type === "texture2d") {
                texture = data;
                check$1(target === GL_TEXTURE_2D$2);
            } else if (type === "textureCube") {
                texture = data;
                check$1(target >= GL_TEXTURE_CUBE_MAP_POSITIVE_X$2 && target < GL_TEXTURE_CUBE_MAP_POSITIVE_X$2 + 6, "invalid cube map target");
            } else if (type === "renderbuffer") {
                renderbuffer = data;
                target = GL_RENDERBUFFER$1;
            } else check$1.raise("invalid regl object for attachment");
            return new FramebufferAttachment(target, texture, renderbuffer);
        }
        function allocAttachment(width, height, isTexture, format, type) {
            if (isTexture) {
                var texture = textureState.create2D({
                    width: width,
                    height: height,
                    format: format,
                    type: type
                });
                texture._texture.refCount = 0;
                return new FramebufferAttachment(GL_TEXTURE_2D$2, texture, null);
            } else {
                var rb = renderbufferState.create({
                    width: width,
                    height: height,
                    format: format
                });
                rb._renderbuffer.refCount = 0;
                return new FramebufferAttachment(GL_RENDERBUFFER$1, null, rb);
            }
        }
        function unwrapAttachment(attachment) {
            return attachment && (attachment.texture || attachment.renderbuffer);
        }
        function resizeAttachment(attachment, w, h) {
            if (attachment) {
                if (attachment.texture) attachment.texture.resize(w, h);
                else if (attachment.renderbuffer) attachment.renderbuffer.resize(w, h);
                attachment.width = w;
                attachment.height = h;
            }
        }
        var framebufferCount = 0;
        var framebufferSet = {};
        function REGLFramebuffer() {
            this.id = framebufferCount++;
            framebufferSet[this.id] = this;
            this.framebuffer = gl.createFramebuffer();
            this.width = 0;
            this.height = 0;
            this.colorAttachments = [];
            this.depthAttachment = null;
            this.stencilAttachment = null;
            this.depthStencilAttachment = null;
        }
        function decFBORefs(framebuffer) {
            framebuffer.colorAttachments.forEach(decRef);
            decRef(framebuffer.depthAttachment);
            decRef(framebuffer.stencilAttachment);
            decRef(framebuffer.depthStencilAttachment);
        }
        function destroy(framebuffer) {
            var handle = framebuffer.framebuffer;
            check$1(handle, "must not double destroy framebuffer");
            gl.deleteFramebuffer(handle);
            framebuffer.framebuffer = null;
            stats.framebufferCount--;
            delete framebufferSet[framebuffer.id];
        }
        function updateFramebuffer(framebuffer) {
            var i;
            gl.bindFramebuffer(GL_FRAMEBUFFER$1, framebuffer.framebuffer);
            var colorAttachments = framebuffer.colorAttachments;
            for(i = 0; i < colorAttachments.length; ++i)attach(GL_COLOR_ATTACHMENT0$1 + i, colorAttachments[i]);
            for(i = colorAttachments.length; i < limits.maxColorAttachments; ++i)gl.framebufferTexture2D(GL_FRAMEBUFFER$1, GL_COLOR_ATTACHMENT0$1 + i, GL_TEXTURE_2D$2, null, 0);
            gl.framebufferTexture2D(GL_FRAMEBUFFER$1, GL_DEPTH_STENCIL_ATTACHMENT, GL_TEXTURE_2D$2, null, 0);
            gl.framebufferTexture2D(GL_FRAMEBUFFER$1, GL_DEPTH_ATTACHMENT, GL_TEXTURE_2D$2, null, 0);
            gl.framebufferTexture2D(GL_FRAMEBUFFER$1, GL_STENCIL_ATTACHMENT, GL_TEXTURE_2D$2, null, 0);
            attach(GL_DEPTH_ATTACHMENT, framebuffer.depthAttachment);
            attach(GL_STENCIL_ATTACHMENT, framebuffer.stencilAttachment);
            attach(GL_DEPTH_STENCIL_ATTACHMENT, framebuffer.depthStencilAttachment);
            // Check status code
            var status = gl.checkFramebufferStatus(GL_FRAMEBUFFER$1);
            if (!gl.isContextLost() && status !== GL_FRAMEBUFFER_COMPLETE$1) check$1.raise("framebuffer configuration not supported, status = " + statusCode[status]);
            gl.bindFramebuffer(GL_FRAMEBUFFER$1, framebufferState.next ? framebufferState.next.framebuffer : null);
            framebufferState.cur = framebufferState.next;
            // FIXME: Clear error code here.  This is a work around for a bug in
            // headless-gl
            gl.getError();
        }
        function createFBO(a0, a1) {
            var framebuffer = new REGLFramebuffer();
            stats.framebufferCount++;
            function reglFramebuffer(a, b) {
                var i;
                check$1(framebufferState.next !== framebuffer, "can not update framebuffer which is currently in use");
                var width = 0;
                var height = 0;
                var needsDepth = true;
                var needsStencil = true;
                var colorBuffer = null;
                var colorTexture = true;
                var colorFormat = "rgba";
                var colorType = "uint8";
                var colorCount = 1;
                var depthBuffer = null;
                var stencilBuffer = null;
                var depthStencilBuffer = null;
                var depthStencilTexture = false;
                if (typeof a === "number") {
                    width = a | 0;
                    height = b | 0 || width;
                } else if (!a) width = height = 1;
                else {
                    check$1.type(a, "object", "invalid arguments for framebuffer");
                    var options = a;
                    if ("shape" in options) {
                        var shape = options.shape;
                        check$1(Array.isArray(shape) && shape.length >= 2, "invalid shape for framebuffer");
                        width = shape[0];
                        height = shape[1];
                    } else {
                        if ("radius" in options) width = height = options.radius;
                        if ("width" in options) width = options.width;
                        if ("height" in options) height = options.height;
                    }
                    if ("color" in options || "colors" in options) {
                        colorBuffer = options.color || options.colors;
                        if (Array.isArray(colorBuffer)) check$1(colorBuffer.length === 1 || extensions.webgl_draw_buffers, "multiple render targets not supported");
                    }
                    if (!colorBuffer) {
                        if ("colorCount" in options) {
                            colorCount = options.colorCount | 0;
                            check$1(colorCount > 0, "invalid color buffer count");
                        }
                        if ("colorTexture" in options) {
                            colorTexture = !!options.colorTexture;
                            colorFormat = "rgba4";
                        }
                        if ("colorType" in options) {
                            colorType = options.colorType;
                            if (!colorTexture) {
                                if (colorType === "half float" || colorType === "float16") {
                                    check$1(extensions.ext_color_buffer_half_float, "you must enable EXT_color_buffer_half_float to use 16-bit render buffers");
                                    colorFormat = "rgba16f";
                                } else if (colorType === "float" || colorType === "float32") {
                                    check$1(extensions.webgl_color_buffer_float, "you must enable WEBGL_color_buffer_float in order to use 32-bit floating point renderbuffers");
                                    colorFormat = "rgba32f";
                                }
                            } else {
                                check$1(extensions.oes_texture_float || !(colorType === "float" || colorType === "float32"), "you must enable OES_texture_float in order to use floating point framebuffer objects");
                                check$1(extensions.oes_texture_half_float || !(colorType === "half float" || colorType === "float16"), "you must enable OES_texture_half_float in order to use 16-bit floating point framebuffer objects");
                            }
                            check$1.oneOf(colorType, colorTypes, "invalid color type");
                        }
                        if ("colorFormat" in options) {
                            colorFormat = options.colorFormat;
                            if (colorTextureFormats.indexOf(colorFormat) >= 0) colorTexture = true;
                            else if (colorRenderbufferFormats.indexOf(colorFormat) >= 0) colorTexture = false;
                            else check$1.optional(function() {
                                if (colorTexture) check$1.oneOf(options.colorFormat, colorTextureFormats, "invalid color format for texture");
                                else check$1.oneOf(options.colorFormat, colorRenderbufferFormats, "invalid color format for renderbuffer");
                            });
                        }
                    }
                    if ("depthTexture" in options || "depthStencilTexture" in options) {
                        depthStencilTexture = !!(options.depthTexture || options.depthStencilTexture);
                        check$1(!depthStencilTexture || extensions.webgl_depth_texture, "webgl_depth_texture extension not supported");
                    }
                    if ("depth" in options) {
                        if (typeof options.depth === "boolean") needsDepth = options.depth;
                        else {
                            depthBuffer = options.depth;
                            needsStencil = false;
                        }
                    }
                    if ("stencil" in options) {
                        if (typeof options.stencil === "boolean") needsStencil = options.stencil;
                        else {
                            stencilBuffer = options.stencil;
                            needsDepth = false;
                        }
                    }
                    if ("depthStencil" in options) {
                        if (typeof options.depthStencil === "boolean") needsDepth = needsStencil = options.depthStencil;
                        else {
                            depthStencilBuffer = options.depthStencil;
                            needsDepth = false;
                            needsStencil = false;
                        }
                    }
                }
                // parse attachments
                var colorAttachments = null;
                var depthAttachment = null;
                var stencilAttachment = null;
                var depthStencilAttachment = null;
                // Set up color attachments
                if (Array.isArray(colorBuffer)) colorAttachments = colorBuffer.map(parseAttachment);
                else if (colorBuffer) colorAttachments = [
                    parseAttachment(colorBuffer)
                ];
                else {
                    colorAttachments = new Array(colorCount);
                    for(i = 0; i < colorCount; ++i)colorAttachments[i] = allocAttachment(width, height, colorTexture, colorFormat, colorType);
                }
                check$1(extensions.webgl_draw_buffers || colorAttachments.length <= 1, "you must enable the WEBGL_draw_buffers extension in order to use multiple color buffers.");
                check$1(colorAttachments.length <= limits.maxColorAttachments, "too many color attachments, not supported");
                width = width || colorAttachments[0].width;
                height = height || colorAttachments[0].height;
                if (depthBuffer) depthAttachment = parseAttachment(depthBuffer);
                else if (needsDepth && !needsStencil) depthAttachment = allocAttachment(width, height, depthStencilTexture, "depth", "uint32");
                if (stencilBuffer) stencilAttachment = parseAttachment(stencilBuffer);
                else if (needsStencil && !needsDepth) stencilAttachment = allocAttachment(width, height, false, "stencil", "uint8");
                if (depthStencilBuffer) depthStencilAttachment = parseAttachment(depthStencilBuffer);
                else if (!depthBuffer && !stencilBuffer && needsStencil && needsDepth) depthStencilAttachment = allocAttachment(width, height, depthStencilTexture, "depth stencil", "depth stencil");
                check$1(!!depthBuffer + !!stencilBuffer + !!depthStencilBuffer <= 1, "invalid framebuffer configuration, can specify exactly one depth/stencil attachment");
                var commonColorAttachmentSize = null;
                for(i = 0; i < colorAttachments.length; ++i){
                    incRefAndCheckShape(colorAttachments[i], width, height);
                    check$1(!colorAttachments[i] || colorAttachments[i].texture && colorTextureFormatEnums.indexOf(colorAttachments[i].texture._texture.format) >= 0 || colorAttachments[i].renderbuffer && colorRenderbufferFormatEnums.indexOf(colorAttachments[i].renderbuffer._renderbuffer.format) >= 0, "framebuffer color attachment " + i + " is invalid");
                    if (colorAttachments[i] && colorAttachments[i].texture) {
                        var colorAttachmentSize = textureFormatChannels[colorAttachments[i].texture._texture.format] * textureTypeSizes[colorAttachments[i].texture._texture.type];
                        if (commonColorAttachmentSize === null) commonColorAttachmentSize = colorAttachmentSize;
                        else // We need to make sure that all color attachments have the same number of bitplanes
                        // (that is, the same numer of bits per pixel)
                        // This is required by the GLES2.0 standard. See the beginning of Chapter 4 in that document.
                        check$1(commonColorAttachmentSize === colorAttachmentSize, "all color attachments much have the same number of bits per pixel.");
                    }
                }
                incRefAndCheckShape(depthAttachment, width, height);
                check$1(!depthAttachment || depthAttachment.texture && depthAttachment.texture._texture.format === GL_DEPTH_COMPONENT$1 || depthAttachment.renderbuffer && depthAttachment.renderbuffer._renderbuffer.format === GL_DEPTH_COMPONENT16$1, "invalid depth attachment for framebuffer object");
                incRefAndCheckShape(stencilAttachment, width, height);
                check$1(!stencilAttachment || stencilAttachment.renderbuffer && stencilAttachment.renderbuffer._renderbuffer.format === GL_STENCIL_INDEX8$1, "invalid stencil attachment for framebuffer object");
                incRefAndCheckShape(depthStencilAttachment, width, height);
                check$1(!depthStencilAttachment || depthStencilAttachment.texture && depthStencilAttachment.texture._texture.format === GL_DEPTH_STENCIL$2 || depthStencilAttachment.renderbuffer && depthStencilAttachment.renderbuffer._renderbuffer.format === GL_DEPTH_STENCIL$2, "invalid depth-stencil attachment for framebuffer object");
                // decrement references
                decFBORefs(framebuffer);
                framebuffer.width = width;
                framebuffer.height = height;
                framebuffer.colorAttachments = colorAttachments;
                framebuffer.depthAttachment = depthAttachment;
                framebuffer.stencilAttachment = stencilAttachment;
                framebuffer.depthStencilAttachment = depthStencilAttachment;
                reglFramebuffer.color = colorAttachments.map(unwrapAttachment);
                reglFramebuffer.depth = unwrapAttachment(depthAttachment);
                reglFramebuffer.stencil = unwrapAttachment(stencilAttachment);
                reglFramebuffer.depthStencil = unwrapAttachment(depthStencilAttachment);
                reglFramebuffer.width = framebuffer.width;
                reglFramebuffer.height = framebuffer.height;
                updateFramebuffer(framebuffer);
                return reglFramebuffer;
            }
            function resize(w_, h_) {
                check$1(framebufferState.next !== framebuffer, "can not resize a framebuffer which is currently in use");
                var w = Math.max(w_ | 0, 1);
                var h = Math.max(h_ | 0 || w, 1);
                if (w === framebuffer.width && h === framebuffer.height) return reglFramebuffer;
                // resize all buffers
                var colorAttachments = framebuffer.colorAttachments;
                for(var i = 0; i < colorAttachments.length; ++i)resizeAttachment(colorAttachments[i], w, h);
                resizeAttachment(framebuffer.depthAttachment, w, h);
                resizeAttachment(framebuffer.stencilAttachment, w, h);
                resizeAttachment(framebuffer.depthStencilAttachment, w, h);
                framebuffer.width = reglFramebuffer.width = w;
                framebuffer.height = reglFramebuffer.height = h;
                updateFramebuffer(framebuffer);
                return reglFramebuffer;
            }
            reglFramebuffer(a0, a1);
            return extend(reglFramebuffer, {
                resize: resize,
                _reglType: "framebuffer",
                _framebuffer: framebuffer,
                destroy: function() {
                    destroy(framebuffer);
                    decFBORefs(framebuffer);
                },
                use: function(block) {
                    framebufferState.setFBO({
                        framebuffer: reglFramebuffer
                    }, block);
                }
            });
        }
        function createCubeFBO(options) {
            var faces = Array(6);
            function reglFramebufferCube(a) {
                var i;
                check$1(faces.indexOf(framebufferState.next) < 0, "can not update framebuffer which is currently in use");
                var params = {
                    color: null
                };
                var radius = 0;
                var colorBuffer = null;
                var colorFormat = "rgba";
                var colorType = "uint8";
                var colorCount = 1;
                if (typeof a === "number") radius = a | 0;
                else if (!a) radius = 1;
                else {
                    check$1.type(a, "object", "invalid arguments for framebuffer");
                    var options = a;
                    if ("shape" in options) {
                        var shape = options.shape;
                        check$1(Array.isArray(shape) && shape.length >= 2, "invalid shape for framebuffer");
                        check$1(shape[0] === shape[1], "cube framebuffer must be square");
                        radius = shape[0];
                    } else {
                        if ("radius" in options) radius = options.radius | 0;
                        if ("width" in options) {
                            radius = options.width | 0;
                            if ("height" in options) check$1(options.height === radius, "must be square");
                        } else if ("height" in options) radius = options.height | 0;
                    }
                    if ("color" in options || "colors" in options) {
                        colorBuffer = options.color || options.colors;
                        if (Array.isArray(colorBuffer)) check$1(colorBuffer.length === 1 || extensions.webgl_draw_buffers, "multiple render targets not supported");
                    }
                    if (!colorBuffer) {
                        if ("colorCount" in options) {
                            colorCount = options.colorCount | 0;
                            check$1(colorCount > 0, "invalid color buffer count");
                        }
                        if ("colorType" in options) {
                            check$1.oneOf(options.colorType, colorTypes, "invalid color type");
                            colorType = options.colorType;
                        }
                        if ("colorFormat" in options) {
                            colorFormat = options.colorFormat;
                            check$1.oneOf(options.colorFormat, colorTextureFormats, "invalid color format for texture");
                        }
                    }
                    if ("depth" in options) params.depth = options.depth;
                    if ("stencil" in options) params.stencil = options.stencil;
                    if ("depthStencil" in options) params.depthStencil = options.depthStencil;
                }
                var colorCubes;
                if (colorBuffer) {
                    if (Array.isArray(colorBuffer)) {
                        colorCubes = [];
                        for(i = 0; i < colorBuffer.length; ++i)colorCubes[i] = colorBuffer[i];
                    } else colorCubes = [
                        colorBuffer
                    ];
                } else {
                    colorCubes = Array(colorCount);
                    var cubeMapParams = {
                        radius: radius,
                        format: colorFormat,
                        type: colorType
                    };
                    for(i = 0; i < colorCount; ++i)colorCubes[i] = textureState.createCube(cubeMapParams);
                }
                // Check color cubes
                params.color = Array(colorCubes.length);
                for(i = 0; i < colorCubes.length; ++i){
                    var cube = colorCubes[i];
                    check$1(typeof cube === "function" && cube._reglType === "textureCube", "invalid cube map");
                    radius = radius || cube.width;
                    check$1(cube.width === radius && cube.height === radius, "invalid cube map shape");
                    params.color[i] = {
                        target: GL_TEXTURE_CUBE_MAP_POSITIVE_X$2,
                        data: colorCubes[i]
                    };
                }
                for(i = 0; i < 6; ++i){
                    for(var j = 0; j < colorCubes.length; ++j)params.color[j].target = GL_TEXTURE_CUBE_MAP_POSITIVE_X$2 + i;
                    // reuse depth-stencil attachments across all cube maps
                    if (i > 0) {
                        params.depth = faces[0].depth;
                        params.stencil = faces[0].stencil;
                        params.depthStencil = faces[0].depthStencil;
                    }
                    if (faces[i]) faces[i](params);
                    else faces[i] = createFBO(params);
                }
                return extend(reglFramebufferCube, {
                    width: radius,
                    height: radius,
                    color: colorCubes
                });
            }
            function resize(radius_) {
                var i;
                var radius = radius_ | 0;
                check$1(radius > 0 && radius <= limits.maxCubeMapSize, "invalid radius for cube fbo");
                if (radius === reglFramebufferCube.width) return reglFramebufferCube;
                var colors = reglFramebufferCube.color;
                for(i = 0; i < colors.length; ++i)colors[i].resize(radius);
                for(i = 0; i < 6; ++i)faces[i].resize(radius);
                reglFramebufferCube.width = reglFramebufferCube.height = radius;
                return reglFramebufferCube;
            }
            reglFramebufferCube(options);
            return extend(reglFramebufferCube, {
                faces: faces,
                resize: resize,
                _reglType: "framebufferCube",
                destroy: function() {
                    faces.forEach(function(f) {
                        f.destroy();
                    });
                }
            });
        }
        function restoreFramebuffers() {
            framebufferState.cur = null;
            framebufferState.next = null;
            framebufferState.dirty = true;
            values(framebufferSet).forEach(function(fb) {
                fb.framebuffer = gl.createFramebuffer();
                updateFramebuffer(fb);
            });
        }
        return extend(framebufferState, {
            getFramebuffer: function(object) {
                if (typeof object === "function" && object._reglType === "framebuffer") {
                    var fbo = object._framebuffer;
                    if (fbo instanceof REGLFramebuffer) return fbo;
                }
                return null;
            },
            create: createFBO,
            createCube: createCubeFBO,
            clear: function() {
                values(framebufferSet).forEach(destroy);
            },
            restore: restoreFramebuffers
        });
    }
    var GL_FLOAT$6 = 5126;
    var GL_ARRAY_BUFFER$1 = 34962;
    var GL_ELEMENT_ARRAY_BUFFER$1 = 34963;
    var VAO_OPTIONS = [
        "attributes",
        "elements",
        "offset",
        "count",
        "primitive",
        "instances"
    ];
    function AttributeRecord() {
        this.state = 0;
        this.x = 0.0;
        this.y = 0.0;
        this.z = 0.0;
        this.w = 0.0;
        this.buffer = null;
        this.size = 0;
        this.normalized = false;
        this.type = GL_FLOAT$6;
        this.offset = 0;
        this.stride = 0;
        this.divisor = 0;
    }
    function wrapAttributeState(gl, extensions, limits, stats, bufferState, elementState, drawState) {
        var NUM_ATTRIBUTES = limits.maxAttributes;
        var attributeBindings = new Array(NUM_ATTRIBUTES);
        for(var i = 0; i < NUM_ATTRIBUTES; ++i)attributeBindings[i] = new AttributeRecord();
        var vaoCount = 0;
        var vaoSet = {};
        var state = {
            Record: AttributeRecord,
            scope: {},
            state: attributeBindings,
            currentVAO: null,
            targetVAO: null,
            restore: extVAO() ? restoreVAO : function() {},
            createVAO: createVAO,
            getVAO: getVAO,
            destroyBuffer: destroyBuffer,
            setVAO: extVAO() ? setVAOEXT : setVAOEmulated,
            clear: extVAO() ? destroyVAOEXT : function() {}
        };
        function destroyBuffer(buffer) {
            for(var i = 0; i < attributeBindings.length; ++i){
                var record = attributeBindings[i];
                if (record.buffer === buffer) {
                    gl.disableVertexAttribArray(i);
                    record.buffer = null;
                }
            }
        }
        function extVAO() {
            return extensions.oes_vertex_array_object;
        }
        function extInstanced() {
            return extensions.angle_instanced_arrays;
        }
        function getVAO(vao) {
            if (typeof vao === "function" && vao._vao) return vao._vao;
            return null;
        }
        function setVAOEXT(vao) {
            if (vao === state.currentVAO) return;
            var ext = extVAO();
            if (vao) ext.bindVertexArrayOES(vao.vao);
            else ext.bindVertexArrayOES(null);
            state.currentVAO = vao;
        }
        function setVAOEmulated(vao) {
            if (vao === state.currentVAO) return;
            if (vao) vao.bindAttrs();
            else {
                var exti = extInstanced();
                for(var i = 0; i < attributeBindings.length; ++i){
                    var binding = attributeBindings[i];
                    if (binding.buffer) {
                        gl.enableVertexAttribArray(i);
                        binding.buffer.bind();
                        gl.vertexAttribPointer(i, binding.size, binding.type, binding.normalized, binding.stride, binding.offfset);
                        if (exti && binding.divisor) exti.vertexAttribDivisorANGLE(i, binding.divisor);
                    } else {
                        gl.disableVertexAttribArray(i);
                        gl.vertexAttrib4f(i, binding.x, binding.y, binding.z, binding.w);
                    }
                }
                if (drawState.elements) gl.bindBuffer(GL_ELEMENT_ARRAY_BUFFER$1, drawState.elements.buffer.buffer);
                else gl.bindBuffer(GL_ELEMENT_ARRAY_BUFFER$1, null);
            }
            state.currentVAO = vao;
        }
        function destroyVAOEXT() {
            values(vaoSet).forEach(function(vao) {
                vao.destroy();
            });
        }
        function REGLVAO() {
            this.id = ++vaoCount;
            this.attributes = [];
            this.elements = null;
            this.ownsElements = false;
            this.count = 0;
            this.offset = 0;
            this.instances = -1;
            this.primitive = 4;
            var extension = extVAO();
            if (extension) this.vao = extension.createVertexArrayOES();
            else this.vao = null;
            vaoSet[this.id] = this;
            this.buffers = [];
        }
        REGLVAO.prototype.bindAttrs = function() {
            var exti = extInstanced();
            var attributes = this.attributes;
            for(var i = 0; i < attributes.length; ++i){
                var attr = attributes[i];
                if (attr.buffer) {
                    gl.enableVertexAttribArray(i);
                    gl.bindBuffer(GL_ARRAY_BUFFER$1, attr.buffer.buffer);
                    gl.vertexAttribPointer(i, attr.size, attr.type, attr.normalized, attr.stride, attr.offset);
                    if (exti && attr.divisor) exti.vertexAttribDivisorANGLE(i, attr.divisor);
                } else {
                    gl.disableVertexAttribArray(i);
                    gl.vertexAttrib4f(i, attr.x, attr.y, attr.z, attr.w);
                }
            }
            for(var j = attributes.length; j < NUM_ATTRIBUTES; ++j)gl.disableVertexAttribArray(j);
            var elements = elementState.getElements(this.elements);
            if (elements) gl.bindBuffer(GL_ELEMENT_ARRAY_BUFFER$1, elements.buffer.buffer);
            else gl.bindBuffer(GL_ELEMENT_ARRAY_BUFFER$1, null);
        };
        REGLVAO.prototype.refresh = function() {
            var ext = extVAO();
            if (ext) {
                ext.bindVertexArrayOES(this.vao);
                this.bindAttrs();
                state.currentVAO = null;
                ext.bindVertexArrayOES(null);
            }
        };
        REGLVAO.prototype.destroy = function() {
            if (this.vao) {
                var extension = extVAO();
                if (this === state.currentVAO) {
                    state.currentVAO = null;
                    extension.bindVertexArrayOES(null);
                }
                extension.deleteVertexArrayOES(this.vao);
                this.vao = null;
            }
            if (this.ownsElements) {
                this.elements.destroy();
                this.elements = null;
                this.ownsElements = false;
            }
            if (vaoSet[this.id]) {
                delete vaoSet[this.id];
                stats.vaoCount -= 1;
            }
        };
        function restoreVAO() {
            var ext = extVAO();
            if (ext) values(vaoSet).forEach(function(vao) {
                vao.refresh();
            });
        }
        function createVAO(_attr) {
            var vao = new REGLVAO();
            stats.vaoCount += 1;
            function updateVAO(options) {
                var attributes;
                if (Array.isArray(options)) {
                    attributes = options;
                    if (vao.elements && vao.ownsElements) vao.elements.destroy();
                    vao.elements = null;
                    vao.ownsElements = false;
                    vao.offset = 0;
                    vao.count = 0;
                    vao.instances = -1;
                    vao.primitive = 4;
                } else {
                    check$1(typeof options === "object", "invalid arguments for create vao");
                    check$1("attributes" in options, "must specify attributes for vao");
                    if (options.elements) {
                        var elements = options.elements;
                        if (vao.ownsElements) {
                            if (typeof elements === "function" && elements._reglType === "elements") {
                                vao.elements.destroy();
                                vao.ownsElements = false;
                            } else {
                                vao.elements(elements);
                                vao.ownsElements = false;
                            }
                        } else if (elementState.getElements(options.elements)) {
                            vao.elements = options.elements;
                            vao.ownsElements = false;
                        } else {
                            vao.elements = elementState.create(options.elements);
                            vao.ownsElements = true;
                        }
                    } else {
                        vao.elements = null;
                        vao.ownsElements = false;
                    }
                    attributes = options.attributes;
                    // set default vao
                    vao.offset = 0;
                    vao.count = -1;
                    vao.instances = -1;
                    vao.primitive = 4;
                    // copy element properties
                    if (vao.elements) {
                        vao.count = vao.elements._elements.vertCount;
                        vao.primitive = vao.elements._elements.primType;
                    }
                    if ("offset" in options) vao.offset = options.offset | 0;
                    if ("count" in options) vao.count = options.count | 0;
                    if ("instances" in options) vao.instances = options.instances | 0;
                    if ("primitive" in options) {
                        check$1(options.primitive in primTypes, "bad primitive type: " + options.primitive);
                        vao.primitive = primTypes[options.primitive];
                    }
                    check$1.optional(()=>{
                        var keys = Object.keys(options);
                        for(var i = 0; i < keys.length; ++i)check$1(VAO_OPTIONS.indexOf(keys[i]) >= 0, 'invalid option for vao: "' + keys[i] + '" valid options are ' + VAO_OPTIONS);
                    });
                    check$1(Array.isArray(attributes), "attributes must be an array");
                }
                check$1(attributes.length < NUM_ATTRIBUTES, "too many attributes");
                check$1(attributes.length > 0, "must specify at least one attribute");
                var bufUpdated = {};
                var nattributes = vao.attributes;
                nattributes.length = attributes.length;
                for(var i = 0; i < attributes.length; ++i){
                    var spec = attributes[i];
                    var rec = nattributes[i] = new AttributeRecord();
                    var data = spec.data || spec;
                    if (Array.isArray(data) || isTypedArray(data) || isNDArrayLike(data)) {
                        var buf;
                        if (vao.buffers[i]) {
                            buf = vao.buffers[i];
                            if (isTypedArray(data) && buf._buffer.byteLength >= data.byteLength) buf.subdata(data);
                            else {
                                buf.destroy();
                                vao.buffers[i] = null;
                            }
                        }
                        if (!vao.buffers[i]) buf = vao.buffers[i] = bufferState.create(spec, GL_ARRAY_BUFFER$1, false, true);
                        rec.buffer = bufferState.getBuffer(buf);
                        rec.size = rec.buffer.dimension | 0;
                        rec.normalized = false;
                        rec.type = rec.buffer.dtype;
                        rec.offset = 0;
                        rec.stride = 0;
                        rec.divisor = 0;
                        rec.state = 1;
                        bufUpdated[i] = 1;
                    } else if (bufferState.getBuffer(spec)) {
                        rec.buffer = bufferState.getBuffer(spec);
                        rec.size = rec.buffer.dimension | 0;
                        rec.normalized = false;
                        rec.type = rec.buffer.dtype;
                        rec.offset = 0;
                        rec.stride = 0;
                        rec.divisor = 0;
                        rec.state = 1;
                    } else if (bufferState.getBuffer(spec.buffer)) {
                        rec.buffer = bufferState.getBuffer(spec.buffer);
                        rec.size = (+spec.size || rec.buffer.dimension) | 0;
                        rec.normalized = !!spec.normalized || false;
                        if ("type" in spec) {
                            check$1.parameter(spec.type, glTypes, "invalid buffer type");
                            rec.type = glTypes[spec.type];
                        } else rec.type = rec.buffer.dtype;
                        rec.offset = (spec.offset || 0) | 0;
                        rec.stride = (spec.stride || 0) | 0;
                        rec.divisor = (spec.divisor || 0) | 0;
                        rec.state = 1;
                        check$1(rec.size >= 1 && rec.size <= 4, "size must be between 1 and 4");
                        check$1(rec.offset >= 0, "invalid offset");
                        check$1(rec.stride >= 0 && rec.stride <= 255, "stride must be between 0 and 255");
                        check$1(rec.divisor >= 0, "divisor must be positive");
                        check$1(!rec.divisor || !!extensions.angle_instanced_arrays, "ANGLE_instanced_arrays must be enabled to use divisor");
                    } else if ("x" in spec) {
                        check$1(i > 0, "first attribute must not be a constant");
                        rec.x = +spec.x || 0;
                        rec.y = +spec.y || 0;
                        rec.z = +spec.z || 0;
                        rec.w = +spec.w || 0;
                        rec.state = 2;
                    } else check$1(false, "invalid attribute spec for location " + i);
                }
                // retire unused buffers
                for(var j = 0; j < vao.buffers.length; ++j)if (!bufUpdated[j] && vao.buffers[j]) {
                    vao.buffers[j].destroy();
                    vao.buffers[j] = null;
                }
                vao.refresh();
                return updateVAO;
            }
            updateVAO.destroy = function() {
                for(var j = 0; j < vao.buffers.length; ++j)if (vao.buffers[j]) vao.buffers[j].destroy();
                vao.buffers.length = 0;
                if (vao.ownsElements) {
                    vao.elements.destroy();
                    vao.elements = null;
                    vao.ownsElements = false;
                }
                vao.destroy();
            };
            updateVAO._vao = vao;
            updateVAO._reglType = "vao";
            return updateVAO(_attr);
        }
        return state;
    }
    var GL_FRAGMENT_SHADER = 35632;
    var GL_VERTEX_SHADER = 35633;
    var GL_ACTIVE_UNIFORMS = 0x8B86;
    var GL_ACTIVE_ATTRIBUTES = 0x8B89;
    function wrapShaderState(gl, stringStore, stats, config) {
        // ===================================================
        // glsl compilation and linking
        // ===================================================
        var fragShaders = {};
        var vertShaders = {};
        function ActiveInfo(name, id, location, info) {
            this.name = name;
            this.id = id;
            this.location = location;
            this.info = info;
        }
        function insertActiveInfo(list, info) {
            for(var i = 0; i < list.length; ++i)if (list[i].id === info.id) {
                list[i].location = info.location;
                return;
            }
            list.push(info);
        }
        function getShader(type, id, command) {
            var cache = type === GL_FRAGMENT_SHADER ? fragShaders : vertShaders;
            var shader = cache[id];
            if (!shader) {
                var source = stringStore.str(id);
                shader = gl.createShader(type);
                gl.shaderSource(shader, source);
                gl.compileShader(shader);
                check$1.shaderError(gl, shader, source, type, command);
                cache[id] = shader;
            }
            return shader;
        }
        // ===================================================
        // program linking
        // ===================================================
        var programCache = {};
        var programList = [];
        var PROGRAM_COUNTER = 0;
        function REGLProgram(fragId, vertId) {
            this.id = PROGRAM_COUNTER++;
            this.fragId = fragId;
            this.vertId = vertId;
            this.program = null;
            this.uniforms = [];
            this.attributes = [];
            this.refCount = 1;
            if (config.profile) this.stats = {
                uniformsCount: 0,
                attributesCount: 0
            };
        }
        function linkProgram(desc, command, attributeLocations) {
            var i, info;
            // -------------------------------
            // compile & link
            // -------------------------------
            var fragShader = getShader(GL_FRAGMENT_SHADER, desc.fragId);
            var vertShader = getShader(GL_VERTEX_SHADER, desc.vertId);
            var program = desc.program = gl.createProgram();
            gl.attachShader(program, fragShader);
            gl.attachShader(program, vertShader);
            if (attributeLocations) for(i = 0; i < attributeLocations.length; ++i){
                var binding = attributeLocations[i];
                gl.bindAttribLocation(program, binding[0], binding[1]);
            }
            gl.linkProgram(program);
            check$1.linkError(gl, program, stringStore.str(desc.fragId), stringStore.str(desc.vertId), command);
            // -------------------------------
            // grab uniforms
            // -------------------------------
            var numUniforms = gl.getProgramParameter(program, GL_ACTIVE_UNIFORMS);
            if (config.profile) desc.stats.uniformsCount = numUniforms;
            var uniforms = desc.uniforms;
            for(i = 0; i < numUniforms; ++i){
                info = gl.getActiveUniform(program, i);
                if (info) {
                    if (info.size > 1) for(var j = 0; j < info.size; ++j){
                        var name = info.name.replace("[0]", "[" + j + "]");
                        insertActiveInfo(uniforms, new ActiveInfo(name, stringStore.id(name), gl.getUniformLocation(program, name), info));
                    }
                    else insertActiveInfo(uniforms, new ActiveInfo(info.name, stringStore.id(info.name), gl.getUniformLocation(program, info.name), info));
                }
            }
            // -------------------------------
            // grab attributes
            // -------------------------------
            var numAttributes = gl.getProgramParameter(program, GL_ACTIVE_ATTRIBUTES);
            if (config.profile) desc.stats.attributesCount = numAttributes;
            var attributes = desc.attributes;
            for(i = 0; i < numAttributes; ++i){
                info = gl.getActiveAttrib(program, i);
                if (info) insertActiveInfo(attributes, new ActiveInfo(info.name, stringStore.id(info.name), gl.getAttribLocation(program, info.name), info));
            }
        }
        if (config.profile) {
            stats.getMaxUniformsCount = function() {
                var m = 0;
                programList.forEach(function(desc) {
                    if (desc.stats.uniformsCount > m) m = desc.stats.uniformsCount;
                });
                return m;
            };
            stats.getMaxAttributesCount = function() {
                var m = 0;
                programList.forEach(function(desc) {
                    if (desc.stats.attributesCount > m) m = desc.stats.attributesCount;
                });
                return m;
            };
        }
        function restoreShaders() {
            fragShaders = {};
            vertShaders = {};
            for(var i = 0; i < programList.length; ++i)linkProgram(programList[i], null, programList[i].attributes.map(function(info) {
                return [
                    info.location,
                    info.name
                ];
            }));
        }
        return {
            clear: function() {
                var deleteShader = gl.deleteShader.bind(gl);
                values(fragShaders).forEach(deleteShader);
                fragShaders = {};
                values(vertShaders).forEach(deleteShader);
                vertShaders = {};
                programList.forEach(function(desc) {
                    gl.deleteProgram(desc.program);
                });
                programList.length = 0;
                programCache = {};
                stats.shaderCount = 0;
            },
            program: function(vertId, fragId, command, attribLocations) {
                check$1.command(vertId >= 0, "missing vertex shader", command);
                check$1.command(fragId >= 0, "missing fragment shader", command);
                var cache = programCache[fragId];
                if (!cache) cache = programCache[fragId] = {};
                var prevProgram = cache[vertId];
                if (prevProgram) {
                    prevProgram.refCount++;
                    if (!attribLocations) return prevProgram;
                }
                var program = new REGLProgram(fragId, vertId);
                stats.shaderCount++;
                linkProgram(program, command, attribLocations);
                if (!prevProgram) cache[vertId] = program;
                programList.push(program);
                return extend(program, {
                    destroy: function() {
                        program.refCount--;
                        if (program.refCount <= 0) {
                            gl.deleteProgram(program.program);
                            var idx = programList.indexOf(program);
                            programList.splice(idx, 1);
                            stats.shaderCount--;
                        }
                        // no program is linked to this vert anymore
                        if (cache[program.vertId].refCount <= 0) {
                            gl.deleteShader(vertShaders[program.vertId]);
                            delete vertShaders[program.vertId];
                            delete programCache[program.fragId][program.vertId];
                        }
                        // no program is linked to this frag anymore
                        if (!Object.keys(programCache[program.fragId]).length) {
                            gl.deleteShader(fragShaders[program.fragId]);
                            delete fragShaders[program.fragId];
                            delete programCache[program.fragId];
                        }
                    }
                });
            },
            restore: restoreShaders,
            shader: getShader,
            frag: -1,
            vert: -1
        };
    }
    var GL_RGBA$3 = 6408;
    var GL_UNSIGNED_BYTE$7 = 5121;
    var GL_PACK_ALIGNMENT = 0x0D05;
    var GL_FLOAT$7 = 0x1406 // 5126
    ;
    function wrapReadPixels(gl, framebufferState, reglPoll, context, glAttributes, extensions, limits) {
        function readPixelsImpl(input) {
            var type;
            if (framebufferState.next === null) {
                check$1(glAttributes.preserveDrawingBuffer, 'you must create a webgl context with "preserveDrawingBuffer":true in order to read pixels from the drawing buffer');
                type = GL_UNSIGNED_BYTE$7;
            } else {
                check$1(framebufferState.next.colorAttachments[0].texture !== null, "You cannot read from a renderbuffer");
                type = framebufferState.next.colorAttachments[0].texture._texture.type;
                check$1.optional(function() {
                    if (extensions.oes_texture_float) {
                        check$1(type === GL_UNSIGNED_BYTE$7 || type === GL_FLOAT$7, "Reading from a framebuffer is only allowed for the types 'uint8' and 'float'");
                        if (type === GL_FLOAT$7) check$1(limits.readFloat, "Reading 'float' values is not permitted in your browser. For a fallback, please see: https://www.npmjs.com/package/glsl-read-float");
                    } else check$1(type === GL_UNSIGNED_BYTE$7, "Reading from a framebuffer is only allowed for the type 'uint8'");
                });
            }
            var x = 0;
            var y = 0;
            var width = context.framebufferWidth;
            var height = context.framebufferHeight;
            var data = null;
            if (isTypedArray(input)) data = input;
            else if (input) {
                check$1.type(input, "object", "invalid arguments to regl.read()");
                x = input.x | 0;
                y = input.y | 0;
                check$1(x >= 0 && x < context.framebufferWidth, "invalid x offset for regl.read");
                check$1(y >= 0 && y < context.framebufferHeight, "invalid y offset for regl.read");
                width = (input.width || context.framebufferWidth - x) | 0;
                height = (input.height || context.framebufferHeight - y) | 0;
                data = input.data || null;
            }
            // sanity check input.data
            if (data) {
                if (type === GL_UNSIGNED_BYTE$7) check$1(data instanceof Uint8Array, "buffer must be 'Uint8Array' when reading from a framebuffer of type 'uint8'");
                else if (type === GL_FLOAT$7) check$1(data instanceof Float32Array, "buffer must be 'Float32Array' when reading from a framebuffer of type 'float'");
            }
            check$1(width > 0 && width + x <= context.framebufferWidth, "invalid width for read pixels");
            check$1(height > 0 && height + y <= context.framebufferHeight, "invalid height for read pixels");
            // Update WebGL state
            reglPoll();
            // Compute size
            var size = width * height * 4;
            // Allocate data
            if (!data) {
                if (type === GL_UNSIGNED_BYTE$7) data = new Uint8Array(size);
                else if (type === GL_FLOAT$7) data = data || new Float32Array(size);
            }
            // Type check
            check$1.isTypedArray(data, "data buffer for regl.read() must be a typedarray");
            check$1(data.byteLength >= size, "data buffer for regl.read() too small");
            // Run read pixels
            gl.pixelStorei(GL_PACK_ALIGNMENT, 4);
            gl.readPixels(x, y, width, height, GL_RGBA$3, type, data);
            return data;
        }
        function readPixelsFBO(options) {
            var result;
            framebufferState.setFBO({
                framebuffer: options.framebuffer
            }, function() {
                result = readPixelsImpl(options);
            });
            return result;
        }
        function readPixels(options) {
            if (!options || !("framebuffer" in options)) return readPixelsImpl(options);
            else return readPixelsFBO(options);
        }
        return readPixels;
    }
    function slice(x) {
        return Array.prototype.slice.call(x);
    }
    function join(x) {
        return slice(x).join("");
    }
    function createEnvironment() {
        // Unique variable id counter
        var varCounter = 0;
        // Linked values are passed from this scope into the generated code block
        // Calling link() passes a value into the generated scope and returns
        // the variable name which it is bound to
        var linkedNames = [];
        var linkedValues = [];
        function link(value) {
            for(var i = 0; i < linkedValues.length; ++i){
                if (linkedValues[i] === value) return linkedNames[i];
            }
            var name = "g" + varCounter++;
            linkedNames.push(name);
            linkedValues.push(value);
            return name;
        }
        // create a code block
        function block() {
            var code = [];
            function push() {
                code.push.apply(code, slice(arguments));
            }
            var vars = [];
            function def() {
                var name = "v" + varCounter++;
                vars.push(name);
                if (arguments.length > 0) {
                    code.push(name, "=");
                    code.push.apply(code, slice(arguments));
                    code.push(";");
                }
                return name;
            }
            return extend(push, {
                def: def,
                toString: function() {
                    return join([
                        vars.length > 0 ? "var " + vars.join(",") + ";" : "",
                        join(code)
                    ]);
                }
            });
        }
        function scope() {
            var entry = block();
            var exit = block();
            var entryToString = entry.toString;
            var exitToString = exit.toString;
            function save(object, prop) {
                exit(object, prop, "=", entry.def(object, prop), ";");
            }
            return extend(function() {
                entry.apply(entry, slice(arguments));
            }, {
                def: entry.def,
                entry: entry,
                exit: exit,
                save: save,
                set: function(object, prop, value) {
                    save(object, prop);
                    entry(object, prop, "=", value, ";");
                },
                toString: function() {
                    return entryToString() + exitToString();
                }
            });
        }
        function conditional() {
            var pred = join(arguments);
            var thenBlock = scope();
            var elseBlock = scope();
            var thenToString = thenBlock.toString;
            var elseToString = elseBlock.toString;
            return extend(thenBlock, {
                then: function() {
                    thenBlock.apply(thenBlock, slice(arguments));
                    return this;
                },
                else: function() {
                    elseBlock.apply(elseBlock, slice(arguments));
                    return this;
                },
                toString: function() {
                    var elseClause = elseToString();
                    if (elseClause) elseClause = "else{" + elseClause + "}";
                    return join([
                        "if(",
                        pred,
                        "){",
                        thenToString(),
                        "}",
                        elseClause
                    ]);
                }
            });
        }
        // procedure list
        var globalBlock = block();
        var procedures = {};
        function proc(name, count) {
            var args = [];
            function arg() {
                var name = "a" + args.length;
                args.push(name);
                return name;
            }
            count = count || 0;
            for(var i = 0; i < count; ++i)arg();
            var body = scope();
            var bodyToString = body.toString;
            var result = procedures[name] = extend(body, {
                arg: arg,
                toString: function() {
                    return join([
                        "function(",
                        args.join(),
                        "){",
                        bodyToString(),
                        "}"
                    ]);
                }
            });
            return result;
        }
        function compile() {
            var code = [
                '"use strict";',
                globalBlock,
                "return {"
            ];
            Object.keys(procedures).forEach(function(name) {
                code.push('"', name, '":', procedures[name].toString(), ",");
            });
            code.push("}");
            var src = join(code).replace(/;/g, ";\n").replace(/}/g, "}\n").replace(/{/g, "{\n");
            var proc = Function.apply(null, linkedNames.concat(src));
            return proc.apply(null, linkedValues);
        }
        return {
            global: globalBlock,
            link: link,
            block: block,
            proc: proc,
            scope: scope,
            cond: conditional,
            compile: compile
        };
    }
    // "cute" names for vector components
    var CUTE_COMPONENTS = "xyzw".split("");
    var GL_UNSIGNED_BYTE$8 = 5121;
    var ATTRIB_STATE_POINTER = 1;
    var ATTRIB_STATE_CONSTANT = 2;
    var DYN_FUNC$1 = 0;
    var DYN_PROP$1 = 1;
    var DYN_CONTEXT$1 = 2;
    var DYN_STATE$1 = 3;
    var DYN_THUNK = 4;
    var DYN_CONSTANT$1 = 5;
    var DYN_ARRAY$1 = 6;
    var S_DITHER = "dither";
    var S_BLEND_ENABLE = "blend.enable";
    var S_BLEND_COLOR = "blend.color";
    var S_BLEND_EQUATION = "blend.equation";
    var S_BLEND_FUNC = "blend.func";
    var S_DEPTH_ENABLE = "depth.enable";
    var S_DEPTH_FUNC = "depth.func";
    var S_DEPTH_RANGE = "depth.range";
    var S_DEPTH_MASK = "depth.mask";
    var S_COLOR_MASK = "colorMask";
    var S_CULL_ENABLE = "cull.enable";
    var S_CULL_FACE = "cull.face";
    var S_FRONT_FACE = "frontFace";
    var S_LINE_WIDTH = "lineWidth";
    var S_POLYGON_OFFSET_ENABLE = "polygonOffset.enable";
    var S_POLYGON_OFFSET_OFFSET = "polygonOffset.offset";
    var S_SAMPLE_ALPHA = "sample.alpha";
    var S_SAMPLE_ENABLE = "sample.enable";
    var S_SAMPLE_COVERAGE = "sample.coverage";
    var S_STENCIL_ENABLE = "stencil.enable";
    var S_STENCIL_MASK = "stencil.mask";
    var S_STENCIL_FUNC = "stencil.func";
    var S_STENCIL_OPFRONT = "stencil.opFront";
    var S_STENCIL_OPBACK = "stencil.opBack";
    var S_SCISSOR_ENABLE = "scissor.enable";
    var S_SCISSOR_BOX = "scissor.box";
    var S_VIEWPORT = "viewport";
    var S_PROFILE = "profile";
    var S_FRAMEBUFFER = "framebuffer";
    var S_VERT = "vert";
    var S_FRAG = "frag";
    var S_ELEMENTS = "elements";
    var S_PRIMITIVE = "primitive";
    var S_COUNT = "count";
    var S_OFFSET = "offset";
    var S_INSTANCES = "instances";
    var S_VAO = "vao";
    var SUFFIX_WIDTH = "Width";
    var SUFFIX_HEIGHT = "Height";
    var S_FRAMEBUFFER_WIDTH = S_FRAMEBUFFER + SUFFIX_WIDTH;
    var S_FRAMEBUFFER_HEIGHT = S_FRAMEBUFFER + SUFFIX_HEIGHT;
    var S_VIEWPORT_WIDTH = S_VIEWPORT + SUFFIX_WIDTH;
    var S_VIEWPORT_HEIGHT = S_VIEWPORT + SUFFIX_HEIGHT;
    var S_DRAWINGBUFFER = "drawingBuffer";
    var S_DRAWINGBUFFER_WIDTH = S_DRAWINGBUFFER + SUFFIX_WIDTH;
    var S_DRAWINGBUFFER_HEIGHT = S_DRAWINGBUFFER + SUFFIX_HEIGHT;
    var NESTED_OPTIONS = [
        S_BLEND_FUNC,
        S_BLEND_EQUATION,
        S_STENCIL_FUNC,
        S_STENCIL_OPFRONT,
        S_STENCIL_OPBACK,
        S_SAMPLE_COVERAGE,
        S_VIEWPORT,
        S_SCISSOR_BOX,
        S_POLYGON_OFFSET_OFFSET
    ];
    var GL_ARRAY_BUFFER$2 = 34962;
    var GL_ELEMENT_ARRAY_BUFFER$2 = 34963;
    var GL_FRAGMENT_SHADER$1 = 35632;
    var GL_VERTEX_SHADER$1 = 35633;
    var GL_TEXTURE_2D$3 = 0x0DE1;
    var GL_TEXTURE_CUBE_MAP$2 = 0x8513;
    var GL_CULL_FACE = 0x0B44;
    var GL_BLEND = 0x0BE2;
    var GL_DITHER = 0x0BD0;
    var GL_STENCIL_TEST = 0x0B90;
    var GL_DEPTH_TEST = 0x0B71;
    var GL_SCISSOR_TEST = 0x0C11;
    var GL_POLYGON_OFFSET_FILL = 0x8037;
    var GL_SAMPLE_ALPHA_TO_COVERAGE = 0x809E;
    var GL_SAMPLE_COVERAGE = 0x80A0;
    var GL_FLOAT$8 = 5126;
    var GL_FLOAT_VEC2 = 35664;
    var GL_FLOAT_VEC3 = 35665;
    var GL_FLOAT_VEC4 = 35666;
    var GL_INT$3 = 5124;
    var GL_INT_VEC2 = 35667;
    var GL_INT_VEC3 = 35668;
    var GL_INT_VEC4 = 35669;
    var GL_BOOL = 35670;
    var GL_BOOL_VEC2 = 35671;
    var GL_BOOL_VEC3 = 35672;
    var GL_BOOL_VEC4 = 35673;
    var GL_FLOAT_MAT2 = 35674;
    var GL_FLOAT_MAT3 = 35675;
    var GL_FLOAT_MAT4 = 35676;
    var GL_SAMPLER_2D = 35678;
    var GL_SAMPLER_CUBE = 35680;
    var GL_TRIANGLES$1 = 4;
    var GL_FRONT = 1028;
    var GL_BACK = 1029;
    var GL_CW = 0x0900;
    var GL_CCW = 0x0901;
    var GL_MIN_EXT = 0x8007;
    var GL_MAX_EXT = 0x8008;
    var GL_ALWAYS = 519;
    var GL_KEEP = 7680;
    var GL_ZERO = 0;
    var GL_ONE = 1;
    var GL_FUNC_ADD = 0x8006;
    var GL_LESS = 513;
    var GL_FRAMEBUFFER$2 = 0x8D40;
    var GL_COLOR_ATTACHMENT0$2 = 0x8CE0;
    var blendFuncs = {
        "0": 0,
        "1": 1,
        "zero": 0,
        "one": 1,
        "src color": 768,
        "one minus src color": 769,
        "src alpha": 770,
        "one minus src alpha": 771,
        "dst color": 774,
        "one minus dst color": 775,
        "dst alpha": 772,
        "one minus dst alpha": 773,
        "constant color": 32769,
        "one minus constant color": 32770,
        "constant alpha": 32771,
        "one minus constant alpha": 32772,
        "src alpha saturate": 776
    };
    // There are invalid values for srcRGB and dstRGB. See:
    // https://www.khronos.org/registry/webgl/specs/1.0/#6.13
    // https://github.com/KhronosGroup/WebGL/blob/0d3201f5f7ec3c0060bc1f04077461541f1987b9/conformance-suites/1.0.3/conformance/misc/webgl-specific.html#L56
    var invalidBlendCombinations = [
        "constant color, constant alpha",
        "one minus constant color, constant alpha",
        "constant color, one minus constant alpha",
        "one minus constant color, one minus constant alpha",
        "constant alpha, constant color",
        "constant alpha, one minus constant color",
        "one minus constant alpha, constant color",
        "one minus constant alpha, one minus constant color"
    ];
    var compareFuncs = {
        "never": 512,
        "less": 513,
        "<": 513,
        "equal": 514,
        "=": 514,
        "==": 514,
        "===": 514,
        "lequal": 515,
        "<=": 515,
        "greater": 516,
        ">": 516,
        "notequal": 517,
        "!=": 517,
        "!==": 517,
        "gequal": 518,
        ">=": 518,
        "always": 519
    };
    var stencilOps = {
        "0": 0,
        "zero": 0,
        "keep": 7680,
        "replace": 7681,
        "increment": 7682,
        "decrement": 7683,
        "increment wrap": 34055,
        "decrement wrap": 34056,
        "invert": 5386
    };
    var shaderType = {
        "frag": GL_FRAGMENT_SHADER$1,
        "vert": GL_VERTEX_SHADER$1
    };
    var orientationType = {
        "cw": GL_CW,
        "ccw": GL_CCW
    };
    function isBufferArgs(x) {
        return Array.isArray(x) || isTypedArray(x) || isNDArrayLike(x);
    }
    // Make sure viewport is processed first
    function sortState(state) {
        return state.sort(function(a, b) {
            if (a === S_VIEWPORT) return -1;
            else if (b === S_VIEWPORT) return 1;
            return a < b ? -1 : 1;
        });
    }
    function Declaration(thisDep, contextDep, propDep, append) {
        this.thisDep = thisDep;
        this.contextDep = contextDep;
        this.propDep = propDep;
        this.append = append;
    }
    function isStatic(decl) {
        return decl && !(decl.thisDep || decl.contextDep || decl.propDep);
    }
    function createStaticDecl(append) {
        return new Declaration(false, false, false, append);
    }
    function createDynamicDecl(dyn, append) {
        var type = dyn.type;
        if (type === DYN_FUNC$1) {
            var numArgs = dyn.data.length;
            return new Declaration(true, numArgs >= 1, numArgs >= 2, append);
        } else if (type === DYN_THUNK) {
            var data = dyn.data;
            return new Declaration(data.thisDep, data.contextDep, data.propDep, append);
        } else if (type === DYN_CONSTANT$1) return new Declaration(false, false, false, append);
        else if (type === DYN_ARRAY$1) {
            var thisDep = false;
            var contextDep = false;
            var propDep = false;
            for(var i = 0; i < dyn.data.length; ++i){
                var subDyn = dyn.data[i];
                if (subDyn.type === DYN_PROP$1) propDep = true;
                else if (subDyn.type === DYN_CONTEXT$1) contextDep = true;
                else if (subDyn.type === DYN_STATE$1) thisDep = true;
                else if (subDyn.type === DYN_FUNC$1) {
                    thisDep = true;
                    var subArgs = subDyn.data;
                    if (subArgs >= 1) contextDep = true;
                    if (subArgs >= 2) propDep = true;
                } else if (subDyn.type === DYN_THUNK) {
                    thisDep = thisDep || subDyn.data.thisDep;
                    contextDep = contextDep || subDyn.data.contextDep;
                    propDep = propDep || subDyn.data.propDep;
                }
            }
            return new Declaration(thisDep, contextDep, propDep, append);
        } else return new Declaration(type === DYN_STATE$1, type === DYN_CONTEXT$1, type === DYN_PROP$1, append);
    }
    var SCOPE_DECL = new Declaration(false, false, false, function() {});
    function reglCore(gl, stringStore, extensions, limits, bufferState, elementState, textureState, framebufferState, uniformState, attributeState, shaderState, drawState, contextState, timer, config) {
        var AttributeRecord = attributeState.Record;
        var blendEquations = {
            "add": 32774,
            "subtract": 32778,
            "reverse subtract": 32779
        };
        if (extensions.ext_blend_minmax) {
            blendEquations.min = GL_MIN_EXT;
            blendEquations.max = GL_MAX_EXT;
        }
        var extInstancing = extensions.angle_instanced_arrays;
        var extDrawBuffers = extensions.webgl_draw_buffers;
        var extVertexArrays = extensions.oes_vertex_array_object;
        // ===================================================
        // ===================================================
        // WEBGL STATE
        // ===================================================
        // ===================================================
        var currentState = {
            dirty: true,
            profile: config.profile
        };
        var nextState = {};
        var GL_STATE_NAMES = [];
        var GL_FLAGS = {};
        var GL_VARIABLES = {};
        function propName(name) {
            return name.replace(".", "_");
        }
        function stateFlag(sname, cap, init) {
            var name = propName(sname);
            GL_STATE_NAMES.push(sname);
            nextState[name] = currentState[name] = !!init;
            GL_FLAGS[name] = cap;
        }
        function stateVariable(sname, func, init) {
            var name = propName(sname);
            GL_STATE_NAMES.push(sname);
            if (Array.isArray(init)) {
                currentState[name] = init.slice();
                nextState[name] = init.slice();
            } else currentState[name] = nextState[name] = init;
            GL_VARIABLES[name] = func;
        }
        // Dithering
        stateFlag(S_DITHER, GL_DITHER);
        // Blending
        stateFlag(S_BLEND_ENABLE, GL_BLEND);
        stateVariable(S_BLEND_COLOR, "blendColor", [
            0,
            0,
            0,
            0
        ]);
        stateVariable(S_BLEND_EQUATION, "blendEquationSeparate", [
            GL_FUNC_ADD,
            GL_FUNC_ADD
        ]);
        stateVariable(S_BLEND_FUNC, "blendFuncSeparate", [
            GL_ONE,
            GL_ZERO,
            GL_ONE,
            GL_ZERO
        ]);
        // Depth
        stateFlag(S_DEPTH_ENABLE, GL_DEPTH_TEST, true);
        stateVariable(S_DEPTH_FUNC, "depthFunc", GL_LESS);
        stateVariable(S_DEPTH_RANGE, "depthRange", [
            0,
            1
        ]);
        stateVariable(S_DEPTH_MASK, "depthMask", true);
        // Color mask
        stateVariable(S_COLOR_MASK, S_COLOR_MASK, [
            true,
            true,
            true,
            true
        ]);
        // Face culling
        stateFlag(S_CULL_ENABLE, GL_CULL_FACE);
        stateVariable(S_CULL_FACE, "cullFace", GL_BACK);
        // Front face orientation
        stateVariable(S_FRONT_FACE, S_FRONT_FACE, GL_CCW);
        // Line width
        stateVariable(S_LINE_WIDTH, S_LINE_WIDTH, 1);
        // Polygon offset
        stateFlag(S_POLYGON_OFFSET_ENABLE, GL_POLYGON_OFFSET_FILL);
        stateVariable(S_POLYGON_OFFSET_OFFSET, "polygonOffset", [
            0,
            0
        ]);
        // Sample coverage
        stateFlag(S_SAMPLE_ALPHA, GL_SAMPLE_ALPHA_TO_COVERAGE);
        stateFlag(S_SAMPLE_ENABLE, GL_SAMPLE_COVERAGE);
        stateVariable(S_SAMPLE_COVERAGE, "sampleCoverage", [
            1,
            false
        ]);
        // Stencil
        stateFlag(S_STENCIL_ENABLE, GL_STENCIL_TEST);
        stateVariable(S_STENCIL_MASK, "stencilMask", -1);
        stateVariable(S_STENCIL_FUNC, "stencilFunc", [
            GL_ALWAYS,
            0,
            -1
        ]);
        stateVariable(S_STENCIL_OPFRONT, "stencilOpSeparate", [
            GL_FRONT,
            GL_KEEP,
            GL_KEEP,
            GL_KEEP
        ]);
        stateVariable(S_STENCIL_OPBACK, "stencilOpSeparate", [
            GL_BACK,
            GL_KEEP,
            GL_KEEP,
            GL_KEEP
        ]);
        // Scissor
        stateFlag(S_SCISSOR_ENABLE, GL_SCISSOR_TEST);
        stateVariable(S_SCISSOR_BOX, "scissor", [
            0,
            0,
            gl.drawingBufferWidth,
            gl.drawingBufferHeight
        ]);
        // Viewport
        stateVariable(S_VIEWPORT, S_VIEWPORT, [
            0,
            0,
            gl.drawingBufferWidth,
            gl.drawingBufferHeight
        ]);
        // ===================================================
        // ===================================================
        // ENVIRONMENT
        // ===================================================
        // ===================================================
        var sharedState = {
            gl: gl,
            context: contextState,
            strings: stringStore,
            next: nextState,
            current: currentState,
            draw: drawState,
            elements: elementState,
            buffer: bufferState,
            shader: shaderState,
            attributes: attributeState.state,
            vao: attributeState,
            uniforms: uniformState,
            framebuffer: framebufferState,
            extensions: extensions,
            timer: timer,
            isBufferArgs: isBufferArgs
        };
        var sharedConstants = {
            primTypes: primTypes,
            compareFuncs: compareFuncs,
            blendFuncs: blendFuncs,
            blendEquations: blendEquations,
            stencilOps: stencilOps,
            glTypes: glTypes,
            orientationType: orientationType
        };
        check$1.optional(function() {
            sharedState.isArrayLike = isArrayLike;
        });
        if (extDrawBuffers) {
            sharedConstants.backBuffer = [
                GL_BACK
            ];
            sharedConstants.drawBuffer = loop(limits.maxDrawbuffers, function(i) {
                if (i === 0) return [
                    0
                ];
                return loop(i, function(j) {
                    return GL_COLOR_ATTACHMENT0$2 + j;
                });
            });
        }
        var drawCallCounter = 0;
        function createREGLEnvironment() {
            var env = createEnvironment();
            var link = env.link;
            var global = env.global;
            env.id = drawCallCounter++;
            env.batchId = "0";
            // link shared state
            var SHARED = link(sharedState);
            var shared = env.shared = {
                props: "a0"
            };
            Object.keys(sharedState).forEach(function(prop) {
                shared[prop] = global.def(SHARED, ".", prop);
            });
            // Inject runtime assertion stuff for debug builds
            check$1.optional(function() {
                env.CHECK = link(check$1);
                env.commandStr = check$1.guessCommand();
                env.command = link(env.commandStr);
                env.assert = function(block, pred, message) {
                    block("if(!(", pred, "))", this.CHECK, ".commandRaise(", link(message), ",", this.command, ");");
                };
                sharedConstants.invalidBlendCombinations = invalidBlendCombinations;
            });
            // Copy GL state variables over
            var nextVars = env.next = {};
            var currentVars = env.current = {};
            Object.keys(GL_VARIABLES).forEach(function(variable) {
                if (Array.isArray(currentState[variable])) {
                    nextVars[variable] = global.def(shared.next, ".", variable);
                    currentVars[variable] = global.def(shared.current, ".", variable);
                }
            });
            // Initialize shared constants
            var constants = env.constants = {};
            Object.keys(sharedConstants).forEach(function(name) {
                constants[name] = global.def(JSON.stringify(sharedConstants[name]));
            });
            // Helper function for calling a block
            env.invoke = function(block, x) {
                switch(x.type){
                    case DYN_FUNC$1:
                        var argList = [
                            "this",
                            shared.context,
                            shared.props,
                            env.batchId
                        ];
                        return block.def(link(x.data), ".call(", argList.slice(0, Math.max(x.data.length + 1, 4)), ")");
                    case DYN_PROP$1:
                        return block.def(shared.props, x.data);
                    case DYN_CONTEXT$1:
                        return block.def(shared.context, x.data);
                    case DYN_STATE$1:
                        return block.def("this", x.data);
                    case DYN_THUNK:
                        x.data.append(env, block);
                        return x.data.ref;
                    case DYN_CONSTANT$1:
                        return x.data.toString();
                    case DYN_ARRAY$1:
                        return x.data.map(function(y) {
                            return env.invoke(block, y);
                        });
                }
            };
            env.attribCache = {};
            var scopeAttribs = {};
            env.scopeAttrib = function(name) {
                var id = stringStore.id(name);
                if (id in scopeAttribs) return scopeAttribs[id];
                var binding = attributeState.scope[id];
                if (!binding) binding = attributeState.scope[id] = new AttributeRecord();
                var result = scopeAttribs[id] = link(binding);
                return result;
            };
            return env;
        }
        // ===================================================
        // ===================================================
        // PARSING
        // ===================================================
        // ===================================================
        function parseProfile(options) {
            var staticOptions = options.static;
            var dynamicOptions = options.dynamic;
            var profileEnable;
            if (S_PROFILE in staticOptions) {
                var value = !!staticOptions[S_PROFILE];
                profileEnable = createStaticDecl(function(env, scope) {
                    return value;
                });
                profileEnable.enable = value;
            } else if (S_PROFILE in dynamicOptions) {
                var dyn = dynamicOptions[S_PROFILE];
                profileEnable = createDynamicDecl(dyn, function(env, scope) {
                    return env.invoke(scope, dyn);
                });
            }
            return profileEnable;
        }
        function parseFramebuffer(options, env) {
            var staticOptions = options.static;
            var dynamicOptions = options.dynamic;
            if (S_FRAMEBUFFER in staticOptions) {
                var framebuffer = staticOptions[S_FRAMEBUFFER];
                if (framebuffer) {
                    framebuffer = framebufferState.getFramebuffer(framebuffer);
                    check$1.command(framebuffer, "invalid framebuffer object");
                    return createStaticDecl(function(env, block) {
                        var FRAMEBUFFER = env.link(framebuffer);
                        var shared = env.shared;
                        block.set(shared.framebuffer, ".next", FRAMEBUFFER);
                        var CONTEXT = shared.context;
                        block.set(CONTEXT, "." + S_FRAMEBUFFER_WIDTH, FRAMEBUFFER + ".width");
                        block.set(CONTEXT, "." + S_FRAMEBUFFER_HEIGHT, FRAMEBUFFER + ".height");
                        return FRAMEBUFFER;
                    });
                } else return createStaticDecl(function(env, scope) {
                    var shared = env.shared;
                    scope.set(shared.framebuffer, ".next", "null");
                    var CONTEXT = shared.context;
                    scope.set(CONTEXT, "." + S_FRAMEBUFFER_WIDTH, CONTEXT + "." + S_DRAWINGBUFFER_WIDTH);
                    scope.set(CONTEXT, "." + S_FRAMEBUFFER_HEIGHT, CONTEXT + "." + S_DRAWINGBUFFER_HEIGHT);
                    return "null";
                });
            } else if (S_FRAMEBUFFER in dynamicOptions) {
                var dyn = dynamicOptions[S_FRAMEBUFFER];
                return createDynamicDecl(dyn, function(env, scope) {
                    var FRAMEBUFFER_FUNC = env.invoke(scope, dyn);
                    var shared = env.shared;
                    var FRAMEBUFFER_STATE = shared.framebuffer;
                    var FRAMEBUFFER = scope.def(FRAMEBUFFER_STATE, ".getFramebuffer(", FRAMEBUFFER_FUNC, ")");
                    check$1.optional(function() {
                        env.assert(scope, "!" + FRAMEBUFFER_FUNC + "||" + FRAMEBUFFER, "invalid framebuffer object");
                    });
                    scope.set(FRAMEBUFFER_STATE, ".next", FRAMEBUFFER);
                    var CONTEXT = shared.context;
                    scope.set(CONTEXT, "." + S_FRAMEBUFFER_WIDTH, FRAMEBUFFER + "?" + FRAMEBUFFER + ".width:" + CONTEXT + "." + S_DRAWINGBUFFER_WIDTH);
                    scope.set(CONTEXT, "." + S_FRAMEBUFFER_HEIGHT, FRAMEBUFFER + "?" + FRAMEBUFFER + ".height:" + CONTEXT + "." + S_DRAWINGBUFFER_HEIGHT);
                    return FRAMEBUFFER;
                });
            } else return null;
        }
        function parseViewportScissor(options, framebuffer, env) {
            var staticOptions = options.static;
            var dynamicOptions = options.dynamic;
            function parseBox(param) {
                if (param in staticOptions) {
                    var box = staticOptions[param];
                    check$1.commandType(box, "object", "invalid " + param, env.commandStr);
                    var isStatic = true;
                    var x = box.x | 0;
                    var y = box.y | 0;
                    var w, h;
                    if ("width" in box) {
                        w = box.width | 0;
                        check$1.command(w >= 0, "invalid " + param, env.commandStr);
                    } else isStatic = false;
                    if ("height" in box) {
                        h = box.height | 0;
                        check$1.command(h >= 0, "invalid " + param, env.commandStr);
                    } else isStatic = false;
                    return new Declaration(!isStatic && framebuffer && framebuffer.thisDep, !isStatic && framebuffer && framebuffer.contextDep, !isStatic && framebuffer && framebuffer.propDep, function(env, scope) {
                        var CONTEXT = env.shared.context;
                        var BOX_W = w;
                        if (!("width" in box)) BOX_W = scope.def(CONTEXT, ".", S_FRAMEBUFFER_WIDTH, "-", x);
                        var BOX_H = h;
                        if (!("height" in box)) BOX_H = scope.def(CONTEXT, ".", S_FRAMEBUFFER_HEIGHT, "-", y);
                        return [
                            x,
                            y,
                            BOX_W,
                            BOX_H
                        ];
                    });
                } else if (param in dynamicOptions) {
                    var dynBox = dynamicOptions[param];
                    var result = createDynamicDecl(dynBox, function(env, scope) {
                        var BOX = env.invoke(scope, dynBox);
                        check$1.optional(function() {
                            env.assert(scope, BOX + "&&typeof " + BOX + '==="object"', "invalid " + param);
                        });
                        var CONTEXT = env.shared.context;
                        var BOX_X = scope.def(BOX, ".x|0");
                        var BOX_Y = scope.def(BOX, ".y|0");
                        var BOX_W = scope.def('"width" in ', BOX, "?", BOX, ".width|0:", "(", CONTEXT, ".", S_FRAMEBUFFER_WIDTH, "-", BOX_X, ")");
                        var BOX_H = scope.def('"height" in ', BOX, "?", BOX, ".height|0:", "(", CONTEXT, ".", S_FRAMEBUFFER_HEIGHT, "-", BOX_Y, ")");
                        check$1.optional(function() {
                            env.assert(scope, BOX_W + ">=0&&" + BOX_H + ">=0", "invalid " + param);
                        });
                        return [
                            BOX_X,
                            BOX_Y,
                            BOX_W,
                            BOX_H
                        ];
                    });
                    if (framebuffer) {
                        result.thisDep = result.thisDep || framebuffer.thisDep;
                        result.contextDep = result.contextDep || framebuffer.contextDep;
                        result.propDep = result.propDep || framebuffer.propDep;
                    }
                    return result;
                } else if (framebuffer) return new Declaration(framebuffer.thisDep, framebuffer.contextDep, framebuffer.propDep, function(env, scope) {
                    var CONTEXT = env.shared.context;
                    return [
                        0,
                        0,
                        scope.def(CONTEXT, ".", S_FRAMEBUFFER_WIDTH),
                        scope.def(CONTEXT, ".", S_FRAMEBUFFER_HEIGHT)
                    ];
                });
                else return null;
            }
            var viewport = parseBox(S_VIEWPORT);
            if (viewport) {
                var prevViewport = viewport;
                viewport = new Declaration(viewport.thisDep, viewport.contextDep, viewport.propDep, function(env, scope) {
                    var VIEWPORT = prevViewport.append(env, scope);
                    var CONTEXT = env.shared.context;
                    scope.set(CONTEXT, "." + S_VIEWPORT_WIDTH, VIEWPORT[2]);
                    scope.set(CONTEXT, "." + S_VIEWPORT_HEIGHT, VIEWPORT[3]);
                    return VIEWPORT;
                });
            }
            return {
                viewport: viewport,
                scissor_box: parseBox(S_SCISSOR_BOX)
            };
        }
        function parseAttribLocations(options, attributes) {
            var staticOptions = options.static;
            var staticProgram = typeof staticOptions[S_FRAG] === "string" && typeof staticOptions[S_VERT] === "string";
            if (staticProgram) {
                if (Object.keys(attributes.dynamic).length > 0) return null;
                var staticAttributes = attributes.static;
                var sAttributes = Object.keys(staticAttributes);
                if (sAttributes.length > 0 && typeof staticAttributes[sAttributes[0]] === "number") {
                    var bindings = [];
                    for(var i = 0; i < sAttributes.length; ++i){
                        check$1(typeof staticAttributes[sAttributes[i]] === "number", "must specify all vertex attribute locations when using vaos");
                        bindings.push([
                            staticAttributes[sAttributes[i]] | 0,
                            sAttributes[i]
                        ]);
                    }
                    return bindings;
                }
            }
            return null;
        }
        function parseProgram(options, env, attribLocations) {
            var staticOptions = options.static;
            var dynamicOptions = options.dynamic;
            function parseShader(name) {
                if (name in staticOptions) {
                    var id = stringStore.id(staticOptions[name]);
                    check$1.optional(function() {
                        shaderState.shader(shaderType[name], id, check$1.guessCommand());
                    });
                    var result = createStaticDecl(function() {
                        return id;
                    });
                    result.id = id;
                    return result;
                } else if (name in dynamicOptions) {
                    var dyn = dynamicOptions[name];
                    return createDynamicDecl(dyn, function(env, scope) {
                        var str = env.invoke(scope, dyn);
                        var id = scope.def(env.shared.strings, ".id(", str, ")");
                        check$1.optional(function() {
                            scope(env.shared.shader, ".shader(", shaderType[name], ",", id, ",", env.command, ");");
                        });
                        return id;
                    });
                }
                return null;
            }
            var frag = parseShader(S_FRAG);
            var vert = parseShader(S_VERT);
            var program = null;
            var progVar;
            if (isStatic(frag) && isStatic(vert)) {
                program = shaderState.program(vert.id, frag.id, null, attribLocations);
                progVar = createStaticDecl(function(env, scope) {
                    return env.link(program);
                });
            } else progVar = new Declaration(frag && frag.thisDep || vert && vert.thisDep, frag && frag.contextDep || vert && vert.contextDep, frag && frag.propDep || vert && vert.propDep, function(env, scope) {
                var SHADER_STATE = env.shared.shader;
                var fragId;
                if (frag) fragId = frag.append(env, scope);
                else fragId = scope.def(SHADER_STATE, ".", S_FRAG);
                var vertId;
                if (vert) vertId = vert.append(env, scope);
                else vertId = scope.def(SHADER_STATE, ".", S_VERT);
                var progDef = SHADER_STATE + ".program(" + vertId + "," + fragId;
                check$1.optional(function() {
                    progDef += "," + env.command;
                });
                return scope.def(progDef + ")");
            });
            return {
                frag: frag,
                vert: vert,
                progVar: progVar,
                program: program
            };
        }
        function parseDraw(options, env) {
            var staticOptions = options.static;
            var dynamicOptions = options.dynamic;
            // TODO: should use VAO to get default values for offset properties
            // should move vao parse into here and out of the old stuff
            var staticDraw = {};
            var vaoActive = false;
            function parseVAO() {
                if (S_VAO in staticOptions) {
                    var vao = staticOptions[S_VAO];
                    if (vao !== null && attributeState.getVAO(vao) === null) vao = attributeState.createVAO(vao);
                    vaoActive = true;
                    staticDraw.vao = vao;
                    return createStaticDecl(function(env) {
                        var vaoRef = attributeState.getVAO(vao);
                        if (vaoRef) return env.link(vaoRef);
                        else return "null";
                    });
                } else if (S_VAO in dynamicOptions) {
                    vaoActive = true;
                    var dyn = dynamicOptions[S_VAO];
                    return createDynamicDecl(dyn, function(env, scope) {
                        var vaoRef = env.invoke(scope, dyn);
                        return scope.def(env.shared.vao + ".getVAO(" + vaoRef + ")");
                    });
                }
                return null;
            }
            var vao = parseVAO();
            var elementsActive = false;
            function parseElements() {
                if (S_ELEMENTS in staticOptions) {
                    var elements = staticOptions[S_ELEMENTS];
                    staticDraw.elements = elements;
                    if (isBufferArgs(elements)) {
                        var e = staticDraw.elements = elementState.create(elements, true);
                        elements = elementState.getElements(e);
                        elementsActive = true;
                    } else if (elements) {
                        elements = elementState.getElements(elements);
                        elementsActive = true;
                        check$1.command(elements, "invalid elements", env.commandStr);
                    }
                    var result = createStaticDecl(function(env, scope) {
                        if (elements) {
                            var result = env.link(elements);
                            env.ELEMENTS = result;
                            return result;
                        }
                        env.ELEMENTS = null;
                        return null;
                    });
                    result.value = elements;
                    return result;
                } else if (S_ELEMENTS in dynamicOptions) {
                    elementsActive = true;
                    var dyn = dynamicOptions[S_ELEMENTS];
                    return createDynamicDecl(dyn, function(env, scope) {
                        var shared = env.shared;
                        var IS_BUFFER_ARGS = shared.isBufferArgs;
                        var ELEMENT_STATE = shared.elements;
                        var elementDefn = env.invoke(scope, dyn);
                        var elements = scope.def("null");
                        var elementStream = scope.def(IS_BUFFER_ARGS, "(", elementDefn, ")");
                        var ifte = env.cond(elementStream).then(elements, "=", ELEMENT_STATE, ".createStream(", elementDefn, ");").else(elements, "=", ELEMENT_STATE, ".getElements(", elementDefn, ");");
                        check$1.optional(function() {
                            env.assert(ifte.else, "!" + elementDefn + "||" + elements, "invalid elements");
                        });
                        scope.entry(ifte);
                        scope.exit(env.cond(elementStream).then(ELEMENT_STATE, ".destroyStream(", elements, ");"));
                        env.ELEMENTS = elements;
                        return elements;
                    });
                } else if (vaoActive) return new Declaration(vao.thisDep, vao.contextDep, vao.propDep, function(env, scope) {
                    return scope.def(env.shared.vao + ".currentVAO?" + env.shared.elements + ".getElements(" + env.shared.vao + ".currentVAO.elements):null");
                });
                return null;
            }
            var elements = parseElements();
            function parsePrimitive() {
                if (S_PRIMITIVE in staticOptions) {
                    var primitive = staticOptions[S_PRIMITIVE];
                    staticDraw.primitive = primitive;
                    check$1.commandParameter(primitive, primTypes, "invalid primitve", env.commandStr);
                    return createStaticDecl(function(env, scope) {
                        return primTypes[primitive];
                    });
                } else if (S_PRIMITIVE in dynamicOptions) {
                    var dynPrimitive = dynamicOptions[S_PRIMITIVE];
                    return createDynamicDecl(dynPrimitive, function(env, scope) {
                        var PRIM_TYPES = env.constants.primTypes;
                        var prim = env.invoke(scope, dynPrimitive);
                        check$1.optional(function() {
                            env.assert(scope, prim + " in " + PRIM_TYPES, "invalid primitive, must be one of " + Object.keys(primTypes));
                        });
                        return scope.def(PRIM_TYPES, "[", prim, "]");
                    });
                } else if (elementsActive) {
                    if (isStatic(elements)) {
                        if (elements.value) return createStaticDecl(function(env, scope) {
                            return scope.def(env.ELEMENTS, ".primType");
                        });
                        else return createStaticDecl(function() {
                            return GL_TRIANGLES$1;
                        });
                    } else return new Declaration(elements.thisDep, elements.contextDep, elements.propDep, function(env, scope) {
                        var elements = env.ELEMENTS;
                        return scope.def(elements, "?", elements, ".primType:", GL_TRIANGLES$1);
                    });
                } else if (vaoActive) return new Declaration(vao.thisDep, vao.contextDep, vao.propDep, function(env, scope) {
                    return scope.def(env.shared.vao + ".currentVAO?" + env.shared.vao + ".currentVAO.primitive:" + GL_TRIANGLES$1);
                });
                return null;
            }
            function parseParam(param, isOffset) {
                if (param in staticOptions) {
                    var value = staticOptions[param] | 0;
                    if (isOffset) staticDraw.offset = value;
                    else staticDraw.instances = value;
                    check$1.command(!isOffset || value >= 0, "invalid " + param, env.commandStr);
                    return createStaticDecl(function(env, scope) {
                        if (isOffset) env.OFFSET = value;
                        return value;
                    });
                } else if (param in dynamicOptions) {
                    var dynValue = dynamicOptions[param];
                    return createDynamicDecl(dynValue, function(env, scope) {
                        var result = env.invoke(scope, dynValue);
                        if (isOffset) {
                            env.OFFSET = result;
                            check$1.optional(function() {
                                env.assert(scope, result + ">=0", "invalid " + param);
                            });
                        }
                        return result;
                    });
                } else if (isOffset) {
                    if (elementsActive) return createStaticDecl(function(env, scope) {
                        env.OFFSET = 0;
                        return 0;
                    });
                    else if (vaoActive) return new Declaration(vao.thisDep, vao.contextDep, vao.propDep, function(env, scope) {
                        return scope.def(env.shared.vao + ".currentVAO?" + env.shared.vao + ".currentVAO.offset:0");
                    });
                } else if (vaoActive) return new Declaration(vao.thisDep, vao.contextDep, vao.propDep, function(env, scope) {
                    return scope.def(env.shared.vao + ".currentVAO?" + env.shared.vao + ".currentVAO.instances:-1");
                });
                return null;
            }
            var OFFSET = parseParam(S_OFFSET, true);
            function parseVertCount() {
                if (S_COUNT in staticOptions) {
                    var count = staticOptions[S_COUNT] | 0;
                    staticDraw.count = count;
                    check$1.command(typeof count === "number" && count >= 0, "invalid vertex count", env.commandStr);
                    return createStaticDecl(function() {
                        return count;
                    });
                } else if (S_COUNT in dynamicOptions) {
                    var dynCount = dynamicOptions[S_COUNT];
                    return createDynamicDecl(dynCount, function(env, scope) {
                        var result = env.invoke(scope, dynCount);
                        check$1.optional(function() {
                            env.assert(scope, "typeof " + result + '==="number"&&' + result + ">=0&&" + result + "===(" + result + "|0)", "invalid vertex count");
                        });
                        return result;
                    });
                } else if (elementsActive) {
                    if (isStatic(elements)) {
                        if (elements) {
                            if (OFFSET) return new Declaration(OFFSET.thisDep, OFFSET.contextDep, OFFSET.propDep, function(env, scope) {
                                var result = scope.def(env.ELEMENTS, ".vertCount-", env.OFFSET);
                                check$1.optional(function() {
                                    env.assert(scope, result + ">=0", "invalid vertex offset/element buffer too small");
                                });
                                return result;
                            });
                            else return createStaticDecl(function(env, scope) {
                                return scope.def(env.ELEMENTS, ".vertCount");
                            });
                        } else {
                            var result = createStaticDecl(function() {
                                return -1;
                            });
                            check$1.optional(function() {
                                result.MISSING = true;
                            });
                            return result;
                        }
                    } else {
                        var variable = new Declaration(elements.thisDep || OFFSET.thisDep, elements.contextDep || OFFSET.contextDep, elements.propDep || OFFSET.propDep, function(env, scope) {
                            var elements = env.ELEMENTS;
                            if (env.OFFSET) return scope.def(elements, "?", elements, ".vertCount-", env.OFFSET, ":-1");
                            return scope.def(elements, "?", elements, ".vertCount:-1");
                        });
                        check$1.optional(function() {
                            variable.DYNAMIC = true;
                        });
                        return variable;
                    }
                } else if (vaoActive) {
                    var countVariable = new Declaration(vao.thisDep, vao.contextDep, vao.propDep, function(env, scope) {
                        return scope.def(env.shared.vao, ".currentVAO?", env.shared.vao, ".currentVAO.count:-1");
                    });
                    return countVariable;
                }
                return null;
            }
            var primitive = parsePrimitive();
            var count = parseVertCount();
            var instances = parseParam(S_INSTANCES, false);
            return {
                elements: elements,
                primitive: primitive,
                count: count,
                instances: instances,
                offset: OFFSET,
                vao: vao,
                vaoActive: vaoActive,
                elementsActive: elementsActive,
                // static draw props
                static: staticDraw
            };
        }
        function parseGLState(options, env) {
            var staticOptions = options.static;
            var dynamicOptions = options.dynamic;
            var STATE = {};
            GL_STATE_NAMES.forEach(function(prop) {
                var param = propName(prop);
                function parseParam(parseStatic, parseDynamic) {
                    if (prop in staticOptions) {
                        var value = parseStatic(staticOptions[prop]);
                        STATE[param] = createStaticDecl(function() {
                            return value;
                        });
                    } else if (prop in dynamicOptions) {
                        var dyn = dynamicOptions[prop];
                        STATE[param] = createDynamicDecl(dyn, function(env, scope) {
                            return parseDynamic(env, scope, env.invoke(scope, dyn));
                        });
                    }
                }
                switch(prop){
                    case S_CULL_ENABLE:
                    case S_BLEND_ENABLE:
                    case S_DITHER:
                    case S_STENCIL_ENABLE:
                    case S_DEPTH_ENABLE:
                    case S_SCISSOR_ENABLE:
                    case S_POLYGON_OFFSET_ENABLE:
                    case S_SAMPLE_ALPHA:
                    case S_SAMPLE_ENABLE:
                    case S_DEPTH_MASK:
                        return parseParam(function(value) {
                            check$1.commandType(value, "boolean", prop, env.commandStr);
                            return value;
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, "typeof " + value + '==="boolean"', "invalid flag " + prop, env.commandStr);
                            });
                            return value;
                        });
                    case S_DEPTH_FUNC:
                        return parseParam(function(value) {
                            check$1.commandParameter(value, compareFuncs, "invalid " + prop, env.commandStr);
                            return compareFuncs[value];
                        }, function(env, scope, value) {
                            var COMPARE_FUNCS = env.constants.compareFuncs;
                            check$1.optional(function() {
                                env.assert(scope, value + " in " + COMPARE_FUNCS, "invalid " + prop + ", must be one of " + Object.keys(compareFuncs));
                            });
                            return scope.def(COMPARE_FUNCS, "[", value, "]");
                        });
                    case S_DEPTH_RANGE:
                        return parseParam(function(value) {
                            check$1.command(isArrayLike(value) && value.length === 2 && typeof value[0] === "number" && typeof value[1] === "number" && value[0] <= value[1], "depth range is 2d array", env.commandStr);
                            return value;
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, env.shared.isArrayLike + "(" + value + ")&&" + value + ".length===2&&" + "typeof " + value + '[0]==="number"&&' + "typeof " + value + '[1]==="number"&&' + value + "[0]<=" + value + "[1]", "depth range must be a 2d array");
                            });
                            var Z_NEAR = scope.def("+", value, "[0]");
                            var Z_FAR = scope.def("+", value, "[1]");
                            return [
                                Z_NEAR,
                                Z_FAR
                            ];
                        });
                    case S_BLEND_FUNC:
                        return parseParam(function(value) {
                            check$1.commandType(value, "object", "blend.func", env.commandStr);
                            var srcRGB = "srcRGB" in value ? value.srcRGB : value.src;
                            var srcAlpha = "srcAlpha" in value ? value.srcAlpha : value.src;
                            var dstRGB = "dstRGB" in value ? value.dstRGB : value.dst;
                            var dstAlpha = "dstAlpha" in value ? value.dstAlpha : value.dst;
                            check$1.commandParameter(srcRGB, blendFuncs, param + ".srcRGB", env.commandStr);
                            check$1.commandParameter(srcAlpha, blendFuncs, param + ".srcAlpha", env.commandStr);
                            check$1.commandParameter(dstRGB, blendFuncs, param + ".dstRGB", env.commandStr);
                            check$1.commandParameter(dstAlpha, blendFuncs, param + ".dstAlpha", env.commandStr);
                            check$1.command(invalidBlendCombinations.indexOf(srcRGB + ", " + dstRGB) === -1, "unallowed blending combination (srcRGB, dstRGB) = (" + srcRGB + ", " + dstRGB + ")", env.commandStr);
                            return [
                                blendFuncs[srcRGB],
                                blendFuncs[dstRGB],
                                blendFuncs[srcAlpha],
                                blendFuncs[dstAlpha]
                            ];
                        }, function(env, scope, value) {
                            var BLEND_FUNCS = env.constants.blendFuncs;
                            check$1.optional(function() {
                                env.assert(scope, value + "&&typeof " + value + '==="object"', "invalid blend func, must be an object");
                            });
                            function read(prefix, suffix) {
                                var func = scope.def('"', prefix, suffix, '" in ', value, "?", value, ".", prefix, suffix, ":", value, ".", prefix);
                                check$1.optional(function() {
                                    env.assert(scope, func + " in " + BLEND_FUNCS, "invalid " + prop + "." + prefix + suffix + ", must be one of " + Object.keys(blendFuncs));
                                });
                                return func;
                            }
                            var srcRGB = read("src", "RGB");
                            var dstRGB = read("dst", "RGB");
                            check$1.optional(function() {
                                var INVALID_BLEND_COMBINATIONS = env.constants.invalidBlendCombinations;
                                env.assert(scope, INVALID_BLEND_COMBINATIONS + ".indexOf(" + srcRGB + '+", "+' + dstRGB + ") === -1 ", "unallowed blending combination for (srcRGB, dstRGB)");
                            });
                            var SRC_RGB = scope.def(BLEND_FUNCS, "[", srcRGB, "]");
                            var SRC_ALPHA = scope.def(BLEND_FUNCS, "[", read("src", "Alpha"), "]");
                            var DST_RGB = scope.def(BLEND_FUNCS, "[", dstRGB, "]");
                            var DST_ALPHA = scope.def(BLEND_FUNCS, "[", read("dst", "Alpha"), "]");
                            return [
                                SRC_RGB,
                                DST_RGB,
                                SRC_ALPHA,
                                DST_ALPHA
                            ];
                        });
                    case S_BLEND_EQUATION:
                        return parseParam(function(value) {
                            if (typeof value === "string") {
                                check$1.commandParameter(value, blendEquations, "invalid " + prop, env.commandStr);
                                return [
                                    blendEquations[value],
                                    blendEquations[value]
                                ];
                            } else if (typeof value === "object") {
                                check$1.commandParameter(value.rgb, blendEquations, prop + ".rgb", env.commandStr);
                                check$1.commandParameter(value.alpha, blendEquations, prop + ".alpha", env.commandStr);
                                return [
                                    blendEquations[value.rgb],
                                    blendEquations[value.alpha]
                                ];
                            } else check$1.commandRaise("invalid blend.equation", env.commandStr);
                        }, function(env, scope, value) {
                            var BLEND_EQUATIONS = env.constants.blendEquations;
                            var RGB = scope.def();
                            var ALPHA = scope.def();
                            var ifte = env.cond("typeof ", value, '==="string"');
                            check$1.optional(function() {
                                function checkProp(block, name, value) {
                                    env.assert(block, value + " in " + BLEND_EQUATIONS, "invalid " + name + ", must be one of " + Object.keys(blendEquations));
                                }
                                checkProp(ifte.then, prop, value);
                                env.assert(ifte.else, value + "&&typeof " + value + '==="object"', "invalid " + prop);
                                checkProp(ifte.else, prop + ".rgb", value + ".rgb");
                                checkProp(ifte.else, prop + ".alpha", value + ".alpha");
                            });
                            ifte.then(RGB, "=", ALPHA, "=", BLEND_EQUATIONS, "[", value, "];");
                            ifte.else(RGB, "=", BLEND_EQUATIONS, "[", value, ".rgb];", ALPHA, "=", BLEND_EQUATIONS, "[", value, ".alpha];");
                            scope(ifte);
                            return [
                                RGB,
                                ALPHA
                            ];
                        });
                    case S_BLEND_COLOR:
                        return parseParam(function(value) {
                            check$1.command(isArrayLike(value) && value.length === 4, "blend.color must be a 4d array", env.commandStr);
                            return loop(4, function(i) {
                                return +value[i];
                            });
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, env.shared.isArrayLike + "(" + value + ")&&" + value + ".length===4", "blend.color must be a 4d array");
                            });
                            return loop(4, function(i) {
                                return scope.def("+", value, "[", i, "]");
                            });
                        });
                    case S_STENCIL_MASK:
                        return parseParam(function(value) {
                            check$1.commandType(value, "number", param, env.commandStr);
                            return value | 0;
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, "typeof " + value + '==="number"', "invalid stencil.mask");
                            });
                            return scope.def(value, "|0");
                        });
                    case S_STENCIL_FUNC:
                        return parseParam(function(value) {
                            check$1.commandType(value, "object", param, env.commandStr);
                            var cmp = value.cmp || "keep";
                            var ref = value.ref || 0;
                            var mask = "mask" in value ? value.mask : -1;
                            check$1.commandParameter(cmp, compareFuncs, prop + ".cmp", env.commandStr);
                            check$1.commandType(ref, "number", prop + ".ref", env.commandStr);
                            check$1.commandType(mask, "number", prop + ".mask", env.commandStr);
                            return [
                                compareFuncs[cmp],
                                ref,
                                mask
                            ];
                        }, function(env, scope, value) {
                            var COMPARE_FUNCS = env.constants.compareFuncs;
                            check$1.optional(function() {
                                function assert() {
                                    env.assert(scope, Array.prototype.join.call(arguments, ""), "invalid stencil.func");
                                }
                                assert(value + "&&typeof ", value, '==="object"');
                                assert('!("cmp" in ', value, ")||(", value, ".cmp in ", COMPARE_FUNCS, ")");
                            });
                            var cmp = scope.def('"cmp" in ', value, "?", COMPARE_FUNCS, "[", value, ".cmp]", ":", GL_KEEP);
                            var ref = scope.def(value, ".ref|0");
                            var mask = scope.def('"mask" in ', value, "?", value, ".mask|0:-1");
                            return [
                                cmp,
                                ref,
                                mask
                            ];
                        });
                    case S_STENCIL_OPFRONT:
                    case S_STENCIL_OPBACK:
                        return parseParam(function(value) {
                            check$1.commandType(value, "object", param, env.commandStr);
                            var fail = value.fail || "keep";
                            var zfail = value.zfail || "keep";
                            var zpass = value.zpass || "keep";
                            check$1.commandParameter(fail, stencilOps, prop + ".fail", env.commandStr);
                            check$1.commandParameter(zfail, stencilOps, prop + ".zfail", env.commandStr);
                            check$1.commandParameter(zpass, stencilOps, prop + ".zpass", env.commandStr);
                            return [
                                prop === S_STENCIL_OPBACK ? GL_BACK : GL_FRONT,
                                stencilOps[fail],
                                stencilOps[zfail],
                                stencilOps[zpass]
                            ];
                        }, function(env, scope, value) {
                            var STENCIL_OPS = env.constants.stencilOps;
                            check$1.optional(function() {
                                env.assert(scope, value + "&&typeof " + value + '==="object"', "invalid " + prop);
                            });
                            function read(name) {
                                check$1.optional(function() {
                                    env.assert(scope, '!("' + name + '" in ' + value + ")||" + "(" + value + "." + name + " in " + STENCIL_OPS + ")", "invalid " + prop + "." + name + ", must be one of " + Object.keys(stencilOps));
                                });
                                return scope.def('"', name, '" in ', value, "?", STENCIL_OPS, "[", value, ".", name, "]:", GL_KEEP);
                            }
                            return [
                                prop === S_STENCIL_OPBACK ? GL_BACK : GL_FRONT,
                                read("fail"),
                                read("zfail"),
                                read("zpass")
                            ];
                        });
                    case S_POLYGON_OFFSET_OFFSET:
                        return parseParam(function(value) {
                            check$1.commandType(value, "object", param, env.commandStr);
                            var factor = value.factor | 0;
                            var units = value.units | 0;
                            check$1.commandType(factor, "number", param + ".factor", env.commandStr);
                            check$1.commandType(units, "number", param + ".units", env.commandStr);
                            return [
                                factor,
                                units
                            ];
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, value + "&&typeof " + value + '==="object"', "invalid " + prop);
                            });
                            var FACTOR = scope.def(value, ".factor|0");
                            var UNITS = scope.def(value, ".units|0");
                            return [
                                FACTOR,
                                UNITS
                            ];
                        });
                    case S_CULL_FACE:
                        return parseParam(function(value) {
                            var face = 0;
                            if (value === "front") face = GL_FRONT;
                            else if (value === "back") face = GL_BACK;
                            check$1.command(!!face, param, env.commandStr);
                            return face;
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, value + '==="front"||' + value + '==="back"', "invalid cull.face");
                            });
                            return scope.def(value, '==="front"?', GL_FRONT, ":", GL_BACK);
                        });
                    case S_LINE_WIDTH:
                        return parseParam(function(value) {
                            check$1.command(typeof value === "number" && value >= limits.lineWidthDims[0] && value <= limits.lineWidthDims[1], "invalid line width, must be a positive number between " + limits.lineWidthDims[0] + " and " + limits.lineWidthDims[1], env.commandStr);
                            return value;
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, "typeof " + value + '==="number"&&' + value + ">=" + limits.lineWidthDims[0] + "&&" + value + "<=" + limits.lineWidthDims[1], "invalid line width");
                            });
                            return value;
                        });
                    case S_FRONT_FACE:
                        return parseParam(function(value) {
                            check$1.commandParameter(value, orientationType, param, env.commandStr);
                            return orientationType[value];
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, value + '==="cw"||' + value + '==="ccw"', "invalid frontFace, must be one of cw,ccw");
                            });
                            return scope.def(value + '==="cw"?' + GL_CW + ":" + GL_CCW);
                        });
                    case S_COLOR_MASK:
                        return parseParam(function(value) {
                            check$1.command(isArrayLike(value) && value.length === 4, "color.mask must be length 4 array", env.commandStr);
                            return value.map(function(v) {
                                return !!v;
                            });
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, env.shared.isArrayLike + "(" + value + ")&&" + value + ".length===4", "invalid color.mask");
                            });
                            return loop(4, function(i) {
                                return "!!" + value + "[" + i + "]";
                            });
                        });
                    case S_SAMPLE_COVERAGE:
                        return parseParam(function(value) {
                            check$1.command(typeof value === "object" && value, param, env.commandStr);
                            var sampleValue = "value" in value ? value.value : 1;
                            var sampleInvert = !!value.invert;
                            check$1.command(typeof sampleValue === "number" && sampleValue >= 0 && sampleValue <= 1, "sample.coverage.value must be a number between 0 and 1", env.commandStr);
                            return [
                                sampleValue,
                                sampleInvert
                            ];
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, value + "&&typeof " + value + '==="object"', "invalid sample.coverage");
                            });
                            var VALUE = scope.def('"value" in ', value, "?+", value, ".value:1");
                            var INVERT = scope.def("!!", value, ".invert");
                            return [
                                VALUE,
                                INVERT
                            ];
                        });
                }
            });
            return STATE;
        }
        function parseUniforms(uniforms, env) {
            var staticUniforms = uniforms.static;
            var dynamicUniforms = uniforms.dynamic;
            var UNIFORMS = {};
            Object.keys(staticUniforms).forEach(function(name) {
                var value = staticUniforms[name];
                var result;
                if (typeof value === "number" || typeof value === "boolean") result = createStaticDecl(function() {
                    return value;
                });
                else if (typeof value === "function") {
                    var reglType = value._reglType;
                    if (reglType === "texture2d" || reglType === "textureCube") result = createStaticDecl(function(env) {
                        return env.link(value);
                    });
                    else if (reglType === "framebuffer" || reglType === "framebufferCube") {
                        check$1.command(value.color.length > 0, 'missing color attachment for framebuffer sent to uniform "' + name + '"', env.commandStr);
                        result = createStaticDecl(function(env) {
                            return env.link(value.color[0]);
                        });
                    } else check$1.commandRaise('invalid data for uniform "' + name + '"', env.commandStr);
                } else if (isArrayLike(value)) result = createStaticDecl(function(env) {
                    var ITEM = env.global.def("[", loop(value.length, function(i) {
                        check$1.command(typeof value[i] === "number" || typeof value[i] === "boolean", "invalid uniform " + name, env.commandStr);
                        return value[i];
                    }), "]");
                    return ITEM;
                });
                else check$1.commandRaise('invalid or missing data for uniform "' + name + '"', env.commandStr);
                result.value = value;
                UNIFORMS[name] = result;
            });
            Object.keys(dynamicUniforms).forEach(function(key) {
                var dyn = dynamicUniforms[key];
                UNIFORMS[key] = createDynamicDecl(dyn, function(env, scope) {
                    return env.invoke(scope, dyn);
                });
            });
            return UNIFORMS;
        }
        function parseAttributes(attributes, env) {
            var staticAttributes = attributes.static;
            var dynamicAttributes = attributes.dynamic;
            var attributeDefs = {};
            Object.keys(staticAttributes).forEach(function(attribute) {
                var value = staticAttributes[attribute];
                var id = stringStore.id(attribute);
                var record = new AttributeRecord();
                if (isBufferArgs(value)) {
                    record.state = ATTRIB_STATE_POINTER;
                    record.buffer = bufferState.getBuffer(bufferState.create(value, GL_ARRAY_BUFFER$2, false, true));
                    record.type = 0;
                } else {
                    var buffer = bufferState.getBuffer(value);
                    if (buffer) {
                        record.state = ATTRIB_STATE_POINTER;
                        record.buffer = buffer;
                        record.type = 0;
                    } else {
                        check$1.command(typeof value === "object" && value, "invalid data for attribute " + attribute, env.commandStr);
                        if ("constant" in value) {
                            var constant = value.constant;
                            record.buffer = "null";
                            record.state = ATTRIB_STATE_CONSTANT;
                            if (typeof constant === "number") record.x = constant;
                            else {
                                check$1.command(isArrayLike(constant) && constant.length > 0 && constant.length <= 4, "invalid constant for attribute " + attribute, env.commandStr);
                                CUTE_COMPONENTS.forEach(function(c, i) {
                                    if (i < constant.length) record[c] = constant[i];
                                });
                            }
                        } else {
                            if (isBufferArgs(value.buffer)) buffer = bufferState.getBuffer(bufferState.create(value.buffer, GL_ARRAY_BUFFER$2, false, true));
                            else buffer = bufferState.getBuffer(value.buffer);
                            check$1.command(!!buffer, 'missing buffer for attribute "' + attribute + '"', env.commandStr);
                            var offset = value.offset | 0;
                            check$1.command(offset >= 0, 'invalid offset for attribute "' + attribute + '"', env.commandStr);
                            var stride = value.stride | 0;
                            check$1.command(stride >= 0 && stride < 256, 'invalid stride for attribute "' + attribute + '", must be integer betweeen [0, 255]', env.commandStr);
                            var size = value.size | 0;
                            check$1.command(!("size" in value) || size > 0 && size <= 4, 'invalid size for attribute "' + attribute + '", must be 1,2,3,4', env.commandStr);
                            var normalized = !!value.normalized;
                            var type = 0;
                            if ("type" in value) {
                                check$1.commandParameter(value.type, glTypes, "invalid type for attribute " + attribute, env.commandStr);
                                type = glTypes[value.type];
                            }
                            var divisor = value.divisor | 0;
                            check$1.optional(function() {
                                if ("divisor" in value) {
                                    check$1.command(divisor === 0 || extInstancing, 'cannot specify divisor for attribute "' + attribute + '", instancing not supported', env.commandStr);
                                    check$1.command(divisor >= 0, 'invalid divisor for attribute "' + attribute + '"', env.commandStr);
                                }
                                var command = env.commandStr;
                                var VALID_KEYS = [
                                    "buffer",
                                    "offset",
                                    "divisor",
                                    "normalized",
                                    "type",
                                    "size",
                                    "stride"
                                ];
                                Object.keys(value).forEach(function(prop) {
                                    check$1.command(VALID_KEYS.indexOf(prop) >= 0, 'unknown parameter "' + prop + '" for attribute pointer "' + attribute + '" (valid parameters are ' + VALID_KEYS + ")", command);
                                });
                            });
                            record.buffer = buffer;
                            record.state = ATTRIB_STATE_POINTER;
                            record.size = size;
                            record.normalized = normalized;
                            record.type = type || buffer.dtype;
                            record.offset = offset;
                            record.stride = stride;
                            record.divisor = divisor;
                        }
                    }
                }
                attributeDefs[attribute] = createStaticDecl(function(env, scope) {
                    var cache = env.attribCache;
                    if (id in cache) return cache[id];
                    var result = {
                        isStream: false
                    };
                    Object.keys(record).forEach(function(key) {
                        result[key] = record[key];
                    });
                    if (record.buffer) {
                        result.buffer = env.link(record.buffer);
                        result.type = result.type || result.buffer + ".dtype";
                    }
                    cache[id] = result;
                    return result;
                });
            });
            Object.keys(dynamicAttributes).forEach(function(attribute) {
                var dyn = dynamicAttributes[attribute];
                function appendAttributeCode(env, block) {
                    var VALUE = env.invoke(block, dyn);
                    var shared = env.shared;
                    var constants = env.constants;
                    var IS_BUFFER_ARGS = shared.isBufferArgs;
                    var BUFFER_STATE = shared.buffer;
                    // Perform validation on attribute
                    check$1.optional(function() {
                        env.assert(block, VALUE + "&&(typeof " + VALUE + '==="object"||typeof ' + VALUE + '==="function")&&(' + IS_BUFFER_ARGS + "(" + VALUE + ")||" + BUFFER_STATE + ".getBuffer(" + VALUE + ")||" + BUFFER_STATE + ".getBuffer(" + VALUE + ".buffer)||" + IS_BUFFER_ARGS + "(" + VALUE + ".buffer)||" + '("constant" in ' + VALUE + "&&(typeof " + VALUE + '.constant==="number"||' + shared.isArrayLike + "(" + VALUE + ".constant))))", 'invalid dynamic attribute "' + attribute + '"');
                    });
                    // allocate names for result
                    var result = {
                        isStream: block.def(false)
                    };
                    var defaultRecord = new AttributeRecord();
                    defaultRecord.state = ATTRIB_STATE_POINTER;
                    Object.keys(defaultRecord).forEach(function(key) {
                        result[key] = block.def("" + defaultRecord[key]);
                    });
                    var BUFFER = result.buffer;
                    var TYPE = result.type;
                    block("if(", IS_BUFFER_ARGS, "(", VALUE, ")){", result.isStream, "=true;", BUFFER, "=", BUFFER_STATE, ".createStream(", GL_ARRAY_BUFFER$2, ",", VALUE, ");", TYPE, "=", BUFFER, ".dtype;", "}else{", BUFFER, "=", BUFFER_STATE, ".getBuffer(", VALUE, ");", "if(", BUFFER, "){", TYPE, "=", BUFFER, ".dtype;", '}else if("constant" in ', VALUE, "){", result.state, "=", ATTRIB_STATE_CONSTANT, ";", "if(typeof " + VALUE + '.constant === "number"){', result[CUTE_COMPONENTS[0]], "=", VALUE, ".constant;", CUTE_COMPONENTS.slice(1).map(function(n) {
                        return result[n];
                    }).join("="), "=0;", "}else{", CUTE_COMPONENTS.map(function(name, i) {
                        return result[name] + "=" + VALUE + ".constant.length>" + i + "?" + VALUE + ".constant[" + i + "]:0;";
                    }).join(""), "}}else{", "if(", IS_BUFFER_ARGS, "(", VALUE, ".buffer)){", BUFFER, "=", BUFFER_STATE, ".createStream(", GL_ARRAY_BUFFER$2, ",", VALUE, ".buffer);", "}else{", BUFFER, "=", BUFFER_STATE, ".getBuffer(", VALUE, ".buffer);", "}", TYPE, '="type" in ', VALUE, "?", constants.glTypes, "[", VALUE, ".type]:", BUFFER, ".dtype;", result.normalized, "=!!", VALUE, ".normalized;");
                    function emitReadRecord(name) {
                        block(result[name], "=", VALUE, ".", name, "|0;");
                    }
                    emitReadRecord("size");
                    emitReadRecord("offset");
                    emitReadRecord("stride");
                    emitReadRecord("divisor");
                    block("}}");
                    block.exit("if(", result.isStream, "){", BUFFER_STATE, ".destroyStream(", BUFFER, ");", "}");
                    return result;
                }
                attributeDefs[attribute] = createDynamicDecl(dyn, appendAttributeCode);
            });
            return attributeDefs;
        }
        function parseContext(context) {
            var staticContext = context.static;
            var dynamicContext = context.dynamic;
            var result = {};
            Object.keys(staticContext).forEach(function(name) {
                var value = staticContext[name];
                result[name] = createStaticDecl(function(env, scope) {
                    if (typeof value === "number" || typeof value === "boolean") return "" + value;
                    else return env.link(value);
                });
            });
            Object.keys(dynamicContext).forEach(function(name) {
                var dyn = dynamicContext[name];
                result[name] = createDynamicDecl(dyn, function(env, scope) {
                    return env.invoke(scope, dyn);
                });
            });
            return result;
        }
        function parseArguments(options, attributes, uniforms, context, env) {
            var staticOptions = options.static;
            var dynamicOptions = options.dynamic;
            check$1.optional(function() {
                var KEY_NAMES = [
                    S_FRAMEBUFFER,
                    S_VERT,
                    S_FRAG,
                    S_ELEMENTS,
                    S_PRIMITIVE,
                    S_OFFSET,
                    S_COUNT,
                    S_INSTANCES,
                    S_PROFILE,
                    S_VAO
                ].concat(GL_STATE_NAMES);
                function checkKeys(dict) {
                    Object.keys(dict).forEach(function(key) {
                        check$1.command(KEY_NAMES.indexOf(key) >= 0, 'unknown parameter "' + key + '"', env.commandStr);
                    });
                }
                checkKeys(staticOptions);
                checkKeys(dynamicOptions);
            });
            var attribLocations = parseAttribLocations(options, attributes);
            var framebuffer = parseFramebuffer(options, env);
            var viewportAndScissor = parseViewportScissor(options, framebuffer, env);
            var draw = parseDraw(options, env);
            var state = parseGLState(options, env);
            var shader = parseProgram(options, env, attribLocations);
            function copyBox(name) {
                var defn = viewportAndScissor[name];
                if (defn) state[name] = defn;
            }
            copyBox(S_VIEWPORT);
            copyBox(propName(S_SCISSOR_BOX));
            var dirty = Object.keys(state).length > 0;
            var result = {
                framebuffer: framebuffer,
                draw: draw,
                shader: shader,
                state: state,
                dirty: dirty,
                scopeVAO: null,
                drawVAO: null,
                useVAO: false,
                attributes: {}
            };
            result.profile = parseProfile(options, env);
            result.uniforms = parseUniforms(uniforms, env);
            result.drawVAO = result.scopeVAO = draw.vao;
            // special case: check if we can statically allocate a vertex array object for this program
            if (!result.drawVAO && shader.program && !attribLocations && extensions.angle_instanced_arrays && draw.static.elements) {
                var useVAO = true;
                var staticBindings = shader.program.attributes.map(function(attr) {
                    var binding = attributes.static[attr];
                    useVAO = useVAO && !!binding;
                    return binding;
                });
                if (useVAO && staticBindings.length > 0) {
                    var vao = attributeState.getVAO(attributeState.createVAO({
                        attributes: staticBindings,
                        elements: draw.static.elements
                    }));
                    result.drawVAO = new Declaration(null, null, null, function(env, scope) {
                        return env.link(vao);
                    });
                    result.useVAO = true;
                }
            }
            if (attribLocations) result.useVAO = true;
            else result.attributes = parseAttributes(attributes, env);
            result.context = parseContext(context, env);
            return result;
        }
        // ===================================================
        // ===================================================
        // COMMON UPDATE FUNCTIONS
        // ===================================================
        // ===================================================
        function emitContext(env, scope, context) {
            var shared = env.shared;
            var CONTEXT = shared.context;
            var contextEnter = env.scope();
            Object.keys(context).forEach(function(name) {
                scope.save(CONTEXT, "." + name);
                var defn = context[name];
                var value = defn.append(env, scope);
                if (Array.isArray(value)) contextEnter(CONTEXT, ".", name, "=[", value.join(), "];");
                else contextEnter(CONTEXT, ".", name, "=", value, ";");
            });
            scope(contextEnter);
        }
        // ===================================================
        // ===================================================
        // COMMON DRAWING FUNCTIONS
        // ===================================================
        // ===================================================
        function emitPollFramebuffer(env, scope, framebuffer, skipCheck) {
            var shared = env.shared;
            var GL = shared.gl;
            var FRAMEBUFFER_STATE = shared.framebuffer;
            var EXT_DRAW_BUFFERS;
            if (extDrawBuffers) EXT_DRAW_BUFFERS = scope.def(shared.extensions, ".webgl_draw_buffers");
            var constants = env.constants;
            var DRAW_BUFFERS = constants.drawBuffer;
            var BACK_BUFFER = constants.backBuffer;
            var NEXT;
            if (framebuffer) NEXT = framebuffer.append(env, scope);
            else NEXT = scope.def(FRAMEBUFFER_STATE, ".next");
            if (!skipCheck) scope("if(", NEXT, "!==", FRAMEBUFFER_STATE, ".cur){");
            scope("if(", NEXT, "){", GL, ".bindFramebuffer(", GL_FRAMEBUFFER$2, ",", NEXT, ".framebuffer);");
            if (extDrawBuffers) scope(EXT_DRAW_BUFFERS, ".drawBuffersWEBGL(", DRAW_BUFFERS, "[", NEXT, ".colorAttachments.length]);");
            scope("}else{", GL, ".bindFramebuffer(", GL_FRAMEBUFFER$2, ",null);");
            if (extDrawBuffers) scope(EXT_DRAW_BUFFERS, ".drawBuffersWEBGL(", BACK_BUFFER, ");");
            scope("}", FRAMEBUFFER_STATE, ".cur=", NEXT, ";");
            if (!skipCheck) scope("}");
        }
        function emitPollState(env, scope, args) {
            var shared = env.shared;
            var GL = shared.gl;
            var CURRENT_VARS = env.current;
            var NEXT_VARS = env.next;
            var CURRENT_STATE = shared.current;
            var NEXT_STATE = shared.next;
            var block = env.cond(CURRENT_STATE, ".dirty");
            GL_STATE_NAMES.forEach(function(prop) {
                var param = propName(prop);
                if (param in args.state) return;
                var NEXT, CURRENT;
                if (param in NEXT_VARS) {
                    NEXT = NEXT_VARS[param];
                    CURRENT = CURRENT_VARS[param];
                    var parts = loop(currentState[param].length, function(i) {
                        return block.def(NEXT, "[", i, "]");
                    });
                    block(env.cond(parts.map(function(p, i) {
                        return p + "!==" + CURRENT + "[" + i + "]";
                    }).join("||")).then(GL, ".", GL_VARIABLES[param], "(", parts, ");", parts.map(function(p, i) {
                        return CURRENT + "[" + i + "]=" + p;
                    }).join(";"), ";"));
                } else {
                    NEXT = block.def(NEXT_STATE, ".", param);
                    var ifte = env.cond(NEXT, "!==", CURRENT_STATE, ".", param);
                    block(ifte);
                    if (param in GL_FLAGS) ifte(env.cond(NEXT).then(GL, ".enable(", GL_FLAGS[param], ");").else(GL, ".disable(", GL_FLAGS[param], ");"), CURRENT_STATE, ".", param, "=", NEXT, ";");
                    else ifte(GL, ".", GL_VARIABLES[param], "(", NEXT, ");", CURRENT_STATE, ".", param, "=", NEXT, ";");
                }
            });
            if (Object.keys(args.state).length === 0) block(CURRENT_STATE, ".dirty=false;");
            scope(block);
        }
        function emitSetOptions(env, scope, options, filter) {
            var shared = env.shared;
            var CURRENT_VARS = env.current;
            var CURRENT_STATE = shared.current;
            var GL = shared.gl;
            sortState(Object.keys(options)).forEach(function(param) {
                var defn = options[param];
                if (filter && !filter(defn)) return;
                var variable = defn.append(env, scope);
                if (GL_FLAGS[param]) {
                    var flag = GL_FLAGS[param];
                    if (isStatic(defn)) {
                        if (variable) scope(GL, ".enable(", flag, ");");
                        else scope(GL, ".disable(", flag, ");");
                    } else scope(env.cond(variable).then(GL, ".enable(", flag, ");").else(GL, ".disable(", flag, ");"));
                    scope(CURRENT_STATE, ".", param, "=", variable, ";");
                } else if (isArrayLike(variable)) {
                    var CURRENT = CURRENT_VARS[param];
                    scope(GL, ".", GL_VARIABLES[param], "(", variable, ");", variable.map(function(v, i) {
                        return CURRENT + "[" + i + "]=" + v;
                    }).join(";"), ";");
                } else scope(GL, ".", GL_VARIABLES[param], "(", variable, ");", CURRENT_STATE, ".", param, "=", variable, ";");
            });
        }
        function injectExtensions(env, scope) {
            if (extInstancing) env.instancing = scope.def(env.shared.extensions, ".angle_instanced_arrays");
        }
        function emitProfile(env, scope, args, useScope, incrementCounter) {
            var shared = env.shared;
            var STATS = env.stats;
            var CURRENT_STATE = shared.current;
            var TIMER = shared.timer;
            var profileArg = args.profile;
            function perfCounter() {
                if (typeof performance === "undefined") return "Date.now()";
                else return "performance.now()";
            }
            var CPU_START, QUERY_COUNTER;
            function emitProfileStart(block) {
                CPU_START = scope.def();
                block(CPU_START, "=", perfCounter(), ";");
                if (typeof incrementCounter === "string") block(STATS, ".count+=", incrementCounter, ";");
                else block(STATS, ".count++;");
                if (timer) {
                    if (useScope) {
                        QUERY_COUNTER = scope.def();
                        block(QUERY_COUNTER, "=", TIMER, ".getNumPendingQueries();");
                    } else block(TIMER, ".beginQuery(", STATS, ");");
                }
            }
            function emitProfileEnd(block) {
                block(STATS, ".cpuTime+=", perfCounter(), "-", CPU_START, ";");
                if (timer) {
                    if (useScope) block(TIMER, ".pushScopeStats(", QUERY_COUNTER, ",", TIMER, ".getNumPendingQueries(),", STATS, ");");
                    else block(TIMER, ".endQuery();");
                }
            }
            function scopeProfile(value) {
                var prev = scope.def(CURRENT_STATE, ".profile");
                scope(CURRENT_STATE, ".profile=", value, ";");
                scope.exit(CURRENT_STATE, ".profile=", prev, ";");
            }
            var USE_PROFILE;
            if (profileArg) {
                if (isStatic(profileArg)) {
                    if (profileArg.enable) {
                        emitProfileStart(scope);
                        emitProfileEnd(scope.exit);
                        scopeProfile("true");
                    } else scopeProfile("false");
                    return;
                }
                USE_PROFILE = profileArg.append(env, scope);
                scopeProfile(USE_PROFILE);
            } else USE_PROFILE = scope.def(CURRENT_STATE, ".profile");
            var start = env.block();
            emitProfileStart(start);
            scope("if(", USE_PROFILE, "){", start, "}");
            var end = env.block();
            emitProfileEnd(end);
            scope.exit("if(", USE_PROFILE, "){", end, "}");
        }
        function emitAttributes(env, scope, args, attributes, filter) {
            var shared = env.shared;
            function typeLength(x) {
                switch(x){
                    case GL_FLOAT_VEC2:
                    case GL_INT_VEC2:
                    case GL_BOOL_VEC2:
                        return 2;
                    case GL_FLOAT_VEC3:
                    case GL_INT_VEC3:
                    case GL_BOOL_VEC3:
                        return 3;
                    case GL_FLOAT_VEC4:
                    case GL_INT_VEC4:
                    case GL_BOOL_VEC4:
                        return 4;
                    default:
                        return 1;
                }
            }
            function emitBindAttribute(ATTRIBUTE, size, record) {
                var GL = shared.gl;
                var LOCATION = scope.def(ATTRIBUTE, ".location");
                var BINDING = scope.def(shared.attributes, "[", LOCATION, "]");
                var STATE = record.state;
                var BUFFER = record.buffer;
                var CONST_COMPONENTS = [
                    record.x,
                    record.y,
                    record.z,
                    record.w
                ];
                var COMMON_KEYS = [
                    "buffer",
                    "normalized",
                    "offset",
                    "stride"
                ];
                function emitBuffer() {
                    scope("if(!", BINDING, ".buffer){", GL, ".enableVertexAttribArray(", LOCATION, ");}");
                    var TYPE = record.type;
                    var SIZE;
                    if (!record.size) SIZE = size;
                    else SIZE = scope.def(record.size, "||", size);
                    scope("if(", BINDING, ".type!==", TYPE, "||", BINDING, ".size!==", SIZE, "||", COMMON_KEYS.map(function(key) {
                        return BINDING + "." + key + "!==" + record[key];
                    }).join("||"), "){", GL, ".bindBuffer(", GL_ARRAY_BUFFER$2, ",", BUFFER, ".buffer);", GL, ".vertexAttribPointer(", [
                        LOCATION,
                        SIZE,
                        TYPE,
                        record.normalized,
                        record.stride,
                        record.offset
                    ], ");", BINDING, ".type=", TYPE, ";", BINDING, ".size=", SIZE, ";", COMMON_KEYS.map(function(key) {
                        return BINDING + "." + key + "=" + record[key] + ";";
                    }).join(""), "}");
                    if (extInstancing) {
                        var DIVISOR = record.divisor;
                        scope("if(", BINDING, ".divisor!==", DIVISOR, "){", env.instancing, ".vertexAttribDivisorANGLE(", [
                            LOCATION,
                            DIVISOR
                        ], ");", BINDING, ".divisor=", DIVISOR, ";}");
                    }
                }
                function emitConstant() {
                    scope("if(", BINDING, ".buffer){", GL, ".disableVertexAttribArray(", LOCATION, ");", BINDING, ".buffer=null;", "}if(", CUTE_COMPONENTS.map(function(c, i) {
                        return BINDING + "." + c + "!==" + CONST_COMPONENTS[i];
                    }).join("||"), "){", GL, ".vertexAttrib4f(", LOCATION, ",", CONST_COMPONENTS, ");", CUTE_COMPONENTS.map(function(c, i) {
                        return BINDING + "." + c + "=" + CONST_COMPONENTS[i] + ";";
                    }).join(""), "}");
                }
                if (STATE === ATTRIB_STATE_POINTER) emitBuffer();
                else if (STATE === ATTRIB_STATE_CONSTANT) emitConstant();
                else {
                    scope("if(", STATE, "===", ATTRIB_STATE_POINTER, "){");
                    emitBuffer();
                    scope("}else{");
                    emitConstant();
                    scope("}");
                }
            }
            attributes.forEach(function(attribute) {
                var name = attribute.name;
                var arg = args.attributes[name];
                var record;
                if (arg) {
                    if (!filter(arg)) return;
                    record = arg.append(env, scope);
                } else {
                    if (!filter(SCOPE_DECL)) return;
                    var scopeAttrib = env.scopeAttrib(name);
                    check$1.optional(function() {
                        env.assert(scope, scopeAttrib + ".state", "missing attribute " + name);
                    });
                    record = {};
                    Object.keys(new AttributeRecord()).forEach(function(key) {
                        record[key] = scope.def(scopeAttrib, ".", key);
                    });
                }
                emitBindAttribute(env.link(attribute), typeLength(attribute.info.type), record);
            });
        }
        function emitUniforms(env, scope, args, uniforms, filter, isBatchInnerLoop) {
            var shared = env.shared;
            var GL = shared.gl;
            var infix;
            for(var i = 0; i < uniforms.length; ++i){
                var uniform = uniforms[i];
                var name = uniform.name;
                var type = uniform.info.type;
                var arg = args.uniforms[name];
                var UNIFORM = env.link(uniform);
                var LOCATION = UNIFORM + ".location";
                var VALUE;
                if (arg) {
                    if (!filter(arg)) continue;
                    if (isStatic(arg)) {
                        var value = arg.value;
                        check$1.command(value !== null && typeof value !== "undefined", 'missing uniform "' + name + '"', env.commandStr);
                        if (type === GL_SAMPLER_2D || type === GL_SAMPLER_CUBE) {
                            check$1.command(typeof value === "function" && (type === GL_SAMPLER_2D && (value._reglType === "texture2d" || value._reglType === "framebuffer") || type === GL_SAMPLER_CUBE && (value._reglType === "textureCube" || value._reglType === "framebufferCube")), "invalid texture for uniform " + name, env.commandStr);
                            var TEX_VALUE = env.link(value._texture || value.color[0]._texture);
                            scope(GL, ".uniform1i(", LOCATION, ",", TEX_VALUE + ".bind());");
                            scope.exit(TEX_VALUE, ".unbind();");
                        } else if (type === GL_FLOAT_MAT2 || type === GL_FLOAT_MAT3 || type === GL_FLOAT_MAT4) {
                            check$1.optional(function() {
                                check$1.command(isArrayLike(value), "invalid matrix for uniform " + name, env.commandStr);
                                check$1.command(type === GL_FLOAT_MAT2 && value.length === 4 || type === GL_FLOAT_MAT3 && value.length === 9 || type === GL_FLOAT_MAT4 && value.length === 16, "invalid length for matrix uniform " + name, env.commandStr);
                            });
                            var MAT_VALUE = env.global.def("new Float32Array([" + Array.prototype.slice.call(value) + "])");
                            var dim = 2;
                            if (type === GL_FLOAT_MAT3) dim = 3;
                            else if (type === GL_FLOAT_MAT4) dim = 4;
                            scope(GL, ".uniformMatrix", dim, "fv(", LOCATION, ",false,", MAT_VALUE, ");");
                        } else {
                            switch(type){
                                case GL_FLOAT$8:
                                    check$1.commandType(value, "number", "uniform " + name, env.commandStr);
                                    infix = "1f";
                                    break;
                                case GL_FLOAT_VEC2:
                                    check$1.command(isArrayLike(value) && value.length === 2, "uniform " + name, env.commandStr);
                                    infix = "2f";
                                    break;
                                case GL_FLOAT_VEC3:
                                    check$1.command(isArrayLike(value) && value.length === 3, "uniform " + name, env.commandStr);
                                    infix = "3f";
                                    break;
                                case GL_FLOAT_VEC4:
                                    check$1.command(isArrayLike(value) && value.length === 4, "uniform " + name, env.commandStr);
                                    infix = "4f";
                                    break;
                                case GL_BOOL:
                                    check$1.commandType(value, "boolean", "uniform " + name, env.commandStr);
                                    infix = "1i";
                                    break;
                                case GL_INT$3:
                                    check$1.commandType(value, "number", "uniform " + name, env.commandStr);
                                    infix = "1i";
                                    break;
                                case GL_BOOL_VEC2:
                                    check$1.command(isArrayLike(value) && value.length === 2, "uniform " + name, env.commandStr);
                                    infix = "2i";
                                    break;
                                case GL_INT_VEC2:
                                    check$1.command(isArrayLike(value) && value.length === 2, "uniform " + name, env.commandStr);
                                    infix = "2i";
                                    break;
                                case GL_BOOL_VEC3:
                                    check$1.command(isArrayLike(value) && value.length === 3, "uniform " + name, env.commandStr);
                                    infix = "3i";
                                    break;
                                case GL_INT_VEC3:
                                    check$1.command(isArrayLike(value) && value.length === 3, "uniform " + name, env.commandStr);
                                    infix = "3i";
                                    break;
                                case GL_BOOL_VEC4:
                                    check$1.command(isArrayLike(value) && value.length === 4, "uniform " + name, env.commandStr);
                                    infix = "4i";
                                    break;
                                case GL_INT_VEC4:
                                    check$1.command(isArrayLike(value) && value.length === 4, "uniform " + name, env.commandStr);
                                    infix = "4i";
                                    break;
                            }
                            scope(GL, ".uniform", infix, "(", LOCATION, ",", isArrayLike(value) ? Array.prototype.slice.call(value) : value, ");");
                        }
                        continue;
                    } else VALUE = arg.append(env, scope);
                } else {
                    if (!filter(SCOPE_DECL)) continue;
                    VALUE = scope.def(shared.uniforms, "[", stringStore.id(name), "]");
                }
                if (type === GL_SAMPLER_2D) {
                    check$1(!Array.isArray(VALUE), "must specify a scalar prop for textures");
                    scope("if(", VALUE, "&&", VALUE, '._reglType==="framebuffer"){', VALUE, "=", VALUE, ".color[0];", "}");
                } else if (type === GL_SAMPLER_CUBE) {
                    check$1(!Array.isArray(VALUE), "must specify a scalar prop for cube maps");
                    scope("if(", VALUE, "&&", VALUE, '._reglType==="framebufferCube"){', VALUE, "=", VALUE, ".color[0];", "}");
                }
                // perform type validation
                check$1.optional(function() {
                    function emitCheck(pred, message) {
                        env.assert(scope, pred, 'bad data or missing for uniform "' + name + '".  ' + message);
                    }
                    function checkType(type) {
                        check$1(!Array.isArray(VALUE), "must not specify an array type for uniform");
                        emitCheck("typeof " + VALUE + '==="' + type + '"', "invalid type, expected " + type);
                    }
                    function checkVector(n, type) {
                        if (Array.isArray(VALUE)) check$1(VALUE.length === n, "must have length " + n);
                        else emitCheck(shared.isArrayLike + "(" + VALUE + ")&&" + VALUE + ".length===" + n, "invalid vector, should have length " + n, env.commandStr);
                    }
                    function checkTexture(target) {
                        check$1(!Array.isArray(VALUE), "must not specify a value type");
                        emitCheck("typeof " + VALUE + '==="function"&&' + VALUE + '._reglType==="texture' + (target === GL_TEXTURE_2D$3 ? "2d" : "Cube") + '"', "invalid texture type", env.commandStr);
                    }
                    switch(type){
                        case GL_INT$3:
                            checkType("number");
                            break;
                        case GL_INT_VEC2:
                            checkVector(2, "number");
                            break;
                        case GL_INT_VEC3:
                            checkVector(3, "number");
                            break;
                        case GL_INT_VEC4:
                            checkVector(4, "number");
                            break;
                        case GL_FLOAT$8:
                            checkType("number");
                            break;
                        case GL_FLOAT_VEC2:
                            checkVector(2, "number");
                            break;
                        case GL_FLOAT_VEC3:
                            checkVector(3, "number");
                            break;
                        case GL_FLOAT_VEC4:
                            checkVector(4, "number");
                            break;
                        case GL_BOOL:
                            checkType("boolean");
                            break;
                        case GL_BOOL_VEC2:
                            checkVector(2, "boolean");
                            break;
                        case GL_BOOL_VEC3:
                            checkVector(3, "boolean");
                            break;
                        case GL_BOOL_VEC4:
                            checkVector(4, "boolean");
                            break;
                        case GL_FLOAT_MAT2:
                            checkVector(4, "number");
                            break;
                        case GL_FLOAT_MAT3:
                            checkVector(9, "number");
                            break;
                        case GL_FLOAT_MAT4:
                            checkVector(16, "number");
                            break;
                        case GL_SAMPLER_2D:
                            checkTexture(GL_TEXTURE_2D$3);
                            break;
                        case GL_SAMPLER_CUBE:
                            checkTexture(GL_TEXTURE_CUBE_MAP$2);
                            break;
                    }
                });
                var unroll = 1;
                switch(type){
                    case GL_SAMPLER_2D:
                    case GL_SAMPLER_CUBE:
                        var TEX = scope.def(VALUE, "._texture");
                        scope(GL, ".uniform1i(", LOCATION, ",", TEX, ".bind());");
                        scope.exit(TEX, ".unbind();");
                        continue;
                    case GL_INT$3:
                    case GL_BOOL:
                        infix = "1i";
                        break;
                    case GL_INT_VEC2:
                    case GL_BOOL_VEC2:
                        infix = "2i";
                        unroll = 2;
                        break;
                    case GL_INT_VEC3:
                    case GL_BOOL_VEC3:
                        infix = "3i";
                        unroll = 3;
                        break;
                    case GL_INT_VEC4:
                    case GL_BOOL_VEC4:
                        infix = "4i";
                        unroll = 4;
                        break;
                    case GL_FLOAT$8:
                        infix = "1f";
                        break;
                    case GL_FLOAT_VEC2:
                        infix = "2f";
                        unroll = 2;
                        break;
                    case GL_FLOAT_VEC3:
                        infix = "3f";
                        unroll = 3;
                        break;
                    case GL_FLOAT_VEC4:
                        infix = "4f";
                        unroll = 4;
                        break;
                    case GL_FLOAT_MAT2:
                        infix = "Matrix2fv";
                        break;
                    case GL_FLOAT_MAT3:
                        infix = "Matrix3fv";
                        break;
                    case GL_FLOAT_MAT4:
                        infix = "Matrix4fv";
                        break;
                }
                if (infix.charAt(0) === "M") {
                    scope(GL, ".uniform", infix, "(", LOCATION, ",");
                    var matSize = Math.pow(type - GL_FLOAT_MAT2 + 2, 2);
                    var STORAGE = env.global.def("new Float32Array(", matSize, ")");
                    if (Array.isArray(VALUE)) scope("false,(", loop(matSize, function(i) {
                        return STORAGE + "[" + i + "]=" + VALUE[i];
                    }), ",", STORAGE, ")");
                    else scope("false,(Array.isArray(", VALUE, ")||", VALUE, " instanceof Float32Array)?", VALUE, ":(", loop(matSize, function(i) {
                        return STORAGE + "[" + i + "]=" + VALUE + "[" + i + "]";
                    }), ",", STORAGE, ")");
                    scope(");");
                } else if (unroll > 1) {
                    var prev = [];
                    var cur = [];
                    for(var j = 0; j < unroll; ++j){
                        if (Array.isArray(VALUE)) cur.push(VALUE[j]);
                        else cur.push(scope.def(VALUE + "[" + j + "]"));
                        if (isBatchInnerLoop) prev.push(scope.def());
                    }
                    if (isBatchInnerLoop) scope("if(!", env.batchId, "||", prev.map(function(p, i) {
                        return p + "!==" + cur[i];
                    }).join("||"), "){", prev.map(function(p, i) {
                        return p + "=" + cur[i] + ";";
                    }).join(""));
                    scope(GL, ".uniform", infix, "(", LOCATION, ",", cur.join(","), ");");
                    if (isBatchInnerLoop) scope("}");
                } else {
                    check$1(!Array.isArray(VALUE), "uniform value must not be an array");
                    if (isBatchInnerLoop) {
                        var prevS = scope.def();
                        scope("if(!", env.batchId, "||", prevS, "!==", VALUE, "){", prevS, "=", VALUE, ";");
                    }
                    scope(GL, ".uniform", infix, "(", LOCATION, ",", VALUE, ");");
                    if (isBatchInnerLoop) scope("}");
                }
            }
        }
        function emitDraw(env, outer, inner, args) {
            var shared = env.shared;
            var GL = shared.gl;
            var DRAW_STATE = shared.draw;
            var drawOptions = args.draw;
            function emitElements() {
                var defn = drawOptions.elements;
                var ELEMENTS;
                var scope = outer;
                if (defn) {
                    if (defn.contextDep && args.contextDynamic || defn.propDep) scope = inner;
                    ELEMENTS = defn.append(env, scope);
                    if (drawOptions.elementsActive) scope("if(" + ELEMENTS + ")" + GL + ".bindBuffer(" + GL_ELEMENT_ARRAY_BUFFER$2 + "," + ELEMENTS + ".buffer.buffer);");
                } else {
                    ELEMENTS = scope.def();
                    scope(ELEMENTS, "=", DRAW_STATE, ".", S_ELEMENTS, ";", "if(", ELEMENTS, "){", GL, ".bindBuffer(", GL_ELEMENT_ARRAY_BUFFER$2, ",", ELEMENTS, ".buffer.buffer);}", "else if(", shared.vao, ".currentVAO){", ELEMENTS, "=", env.shared.elements + ".getElements(" + shared.vao, ".currentVAO.elements);", !extVertexArrays ? "if(" + ELEMENTS + ")" + GL + ".bindBuffer(" + GL_ELEMENT_ARRAY_BUFFER$2 + "," + ELEMENTS + ".buffer.buffer);" : "", "}");
                }
                return ELEMENTS;
            }
            function emitCount() {
                var defn = drawOptions.count;
                var COUNT;
                var scope = outer;
                if (defn) {
                    if (defn.contextDep && args.contextDynamic || defn.propDep) scope = inner;
                    COUNT = defn.append(env, scope);
                    check$1.optional(function() {
                        if (defn.MISSING) env.assert(outer, "false", "missing vertex count");
                        if (defn.DYNAMIC) env.assert(scope, COUNT + ">=0", "missing vertex count");
                    });
                } else {
                    COUNT = scope.def(DRAW_STATE, ".", S_COUNT);
                    check$1.optional(function() {
                        env.assert(scope, COUNT + ">=0", "missing vertex count");
                    });
                }
                return COUNT;
            }
            var ELEMENTS = emitElements();
            function emitValue(name) {
                var defn = drawOptions[name];
                if (defn) {
                    if (defn.contextDep && args.contextDynamic || defn.propDep) return defn.append(env, inner);
                    else return defn.append(env, outer);
                } else return outer.def(DRAW_STATE, ".", name);
            }
            var PRIMITIVE = emitValue(S_PRIMITIVE);
            var OFFSET = emitValue(S_OFFSET);
            var COUNT = emitCount();
            if (typeof COUNT === "number") {
                if (COUNT === 0) return;
            } else {
                inner("if(", COUNT, "){");
                inner.exit("}");
            }
            var INSTANCES, EXT_INSTANCING;
            if (extInstancing) {
                INSTANCES = emitValue(S_INSTANCES);
                EXT_INSTANCING = env.instancing;
            }
            var ELEMENT_TYPE = ELEMENTS + ".type";
            var elementsStatic = drawOptions.elements && isStatic(drawOptions.elements) && !drawOptions.vaoActive;
            function emitInstancing() {
                function drawElements() {
                    inner(EXT_INSTANCING, ".drawElementsInstancedANGLE(", [
                        PRIMITIVE,
                        COUNT,
                        ELEMENT_TYPE,
                        OFFSET + "<<((" + ELEMENT_TYPE + "-" + GL_UNSIGNED_BYTE$8 + ")>>1)",
                        INSTANCES
                    ], ");");
                }
                function drawArrays() {
                    inner(EXT_INSTANCING, ".drawArraysInstancedANGLE(", [
                        PRIMITIVE,
                        OFFSET,
                        COUNT,
                        INSTANCES
                    ], ");");
                }
                if (ELEMENTS && ELEMENTS !== "null") {
                    if (!elementsStatic) {
                        inner("if(", ELEMENTS, "){");
                        drawElements();
                        inner("}else{");
                        drawArrays();
                        inner("}");
                    } else drawElements();
                } else drawArrays();
            }
            function emitRegular() {
                function drawElements() {
                    inner(GL + ".drawElements(" + [
                        PRIMITIVE,
                        COUNT,
                        ELEMENT_TYPE,
                        OFFSET + "<<((" + ELEMENT_TYPE + "-" + GL_UNSIGNED_BYTE$8 + ")>>1)"
                    ] + ");");
                }
                function drawArrays() {
                    inner(GL + ".drawArrays(" + [
                        PRIMITIVE,
                        OFFSET,
                        COUNT
                    ] + ");");
                }
                if (ELEMENTS && ELEMENTS !== "null") {
                    if (!elementsStatic) {
                        inner("if(", ELEMENTS, "){");
                        drawElements();
                        inner("}else{");
                        drawArrays();
                        inner("}");
                    } else drawElements();
                } else drawArrays();
            }
            if (extInstancing && (typeof INSTANCES !== "number" || INSTANCES >= 0)) {
                if (typeof INSTANCES === "string") {
                    inner("if(", INSTANCES, ">0){");
                    emitInstancing();
                    inner("}else if(", INSTANCES, "<0){");
                    emitRegular();
                    inner("}");
                } else emitInstancing();
            } else emitRegular();
        }
        function createBody(emitBody, parentEnv, args, program, count) {
            var env = createREGLEnvironment();
            var scope = env.proc("body", count);
            check$1.optional(function() {
                env.commandStr = parentEnv.commandStr;
                env.command = env.link(parentEnv.commandStr);
            });
            if (extInstancing) env.instancing = scope.def(env.shared.extensions, ".angle_instanced_arrays");
            emitBody(env, scope, args, program);
            return env.compile().body;
        }
        // ===================================================
        // ===================================================
        // DRAW PROC
        // ===================================================
        // ===================================================
        function emitDrawBody(env, draw, args, program) {
            injectExtensions(env, draw);
            if (args.useVAO) {
                if (args.drawVAO) draw(env.shared.vao, ".setVAO(", args.drawVAO.append(env, draw), ");");
                else draw(env.shared.vao, ".setVAO(", env.shared.vao, ".targetVAO);");
            } else {
                draw(env.shared.vao, ".setVAO(null);");
                emitAttributes(env, draw, args, program.attributes, function() {
                    return true;
                });
            }
            emitUniforms(env, draw, args, program.uniforms, function() {
                return true;
            }, false);
            emitDraw(env, draw, draw, args);
        }
        function emitDrawProc(env, args) {
            var draw = env.proc("draw", 1);
            injectExtensions(env, draw);
            emitContext(env, draw, args.context);
            emitPollFramebuffer(env, draw, args.framebuffer);
            emitPollState(env, draw, args);
            emitSetOptions(env, draw, args.state);
            emitProfile(env, draw, args, false, true);
            var program = args.shader.progVar.append(env, draw);
            draw(env.shared.gl, ".useProgram(", program, ".program);");
            if (args.shader.program) emitDrawBody(env, draw, args, args.shader.program);
            else {
                draw(env.shared.vao, ".setVAO(null);");
                var drawCache = env.global.def("{}");
                var PROG_ID = draw.def(program, ".id");
                var CACHED_PROC = draw.def(drawCache, "[", PROG_ID, "]");
                draw(env.cond(CACHED_PROC).then(CACHED_PROC, ".call(this,a0);").else(CACHED_PROC, "=", drawCache, "[", PROG_ID, "]=", env.link(function(program) {
                    return createBody(emitDrawBody, env, args, program, 1);
                }), "(", program, ");", CACHED_PROC, ".call(this,a0);"));
            }
            if (Object.keys(args.state).length > 0) draw(env.shared.current, ".dirty=true;");
            if (env.shared.vao) draw(env.shared.vao, ".setVAO(null);");
        }
        // ===================================================
        // ===================================================
        // BATCH PROC
        // ===================================================
        // ===================================================
        function emitBatchDynamicShaderBody(env, scope, args, program) {
            env.batchId = "a1";
            injectExtensions(env, scope);
            function all() {
                return true;
            }
            emitAttributes(env, scope, args, program.attributes, all);
            emitUniforms(env, scope, args, program.uniforms, all, false);
            emitDraw(env, scope, scope, args);
        }
        function emitBatchBody(env, scope, args, program) {
            injectExtensions(env, scope);
            var contextDynamic = args.contextDep;
            var BATCH_ID = scope.def();
            var PROP_LIST = "a0";
            var NUM_PROPS = "a1";
            var PROPS = scope.def();
            env.shared.props = PROPS;
            env.batchId = BATCH_ID;
            var outer = env.scope();
            var inner = env.scope();
            scope(outer.entry, "for(", BATCH_ID, "=0;", BATCH_ID, "<", NUM_PROPS, ";++", BATCH_ID, "){", PROPS, "=", PROP_LIST, "[", BATCH_ID, "];", inner, "}", outer.exit);
            function isInnerDefn(defn) {
                return defn.contextDep && contextDynamic || defn.propDep;
            }
            function isOuterDefn(defn) {
                return !isInnerDefn(defn);
            }
            if (args.needsContext) emitContext(env, inner, args.context);
            if (args.needsFramebuffer) emitPollFramebuffer(env, inner, args.framebuffer);
            emitSetOptions(env, inner, args.state, isInnerDefn);
            if (args.profile && isInnerDefn(args.profile)) emitProfile(env, inner, args, false, true);
            if (!program) {
                var progCache = env.global.def("{}");
                var PROGRAM = args.shader.progVar.append(env, inner);
                var PROG_ID = inner.def(PROGRAM, ".id");
                var CACHED_PROC = inner.def(progCache, "[", PROG_ID, "]");
                inner(env.shared.gl, ".useProgram(", PROGRAM, ".program);", "if(!", CACHED_PROC, "){", CACHED_PROC, "=", progCache, "[", PROG_ID, "]=", env.link(function(program) {
                    return createBody(emitBatchDynamicShaderBody, env, args, program, 2);
                }), "(", PROGRAM, ");}", CACHED_PROC, ".call(this,a0[", BATCH_ID, "],", BATCH_ID, ");");
            } else {
                if (args.useVAO) {
                    if (args.drawVAO) {
                        if (isInnerDefn(args.drawVAO)) // vao is a prop
                        inner(env.shared.vao, ".setVAO(", args.drawVAO.append(env, inner), ");");
                        else // vao is invariant
                        outer(env.shared.vao, ".setVAO(", args.drawVAO.append(env, outer), ");");
                    } else // scoped vao binding
                    outer(env.shared.vao, ".setVAO(", env.shared.vao, ".targetVAO);");
                } else {
                    outer(env.shared.vao, ".setVAO(null);");
                    emitAttributes(env, outer, args, program.attributes, isOuterDefn);
                    emitAttributes(env, inner, args, program.attributes, isInnerDefn);
                }
                emitUniforms(env, outer, args, program.uniforms, isOuterDefn, false);
                emitUniforms(env, inner, args, program.uniforms, isInnerDefn, true);
                emitDraw(env, outer, inner, args);
            }
        }
        function emitBatchProc(env, args) {
            var batch = env.proc("batch", 2);
            env.batchId = "0";
            injectExtensions(env, batch);
            // Check if any context variables depend on props
            var contextDynamic = false;
            var needsContext = true;
            Object.keys(args.context).forEach(function(name) {
                contextDynamic = contextDynamic || args.context[name].propDep;
            });
            if (!contextDynamic) {
                emitContext(env, batch, args.context);
                needsContext = false;
            }
            // framebuffer state affects framebufferWidth/height context vars
            var framebuffer = args.framebuffer;
            var needsFramebuffer = false;
            if (framebuffer) {
                if (framebuffer.propDep) contextDynamic = needsFramebuffer = true;
                else if (framebuffer.contextDep && contextDynamic) needsFramebuffer = true;
                if (!needsFramebuffer) emitPollFramebuffer(env, batch, framebuffer);
            } else emitPollFramebuffer(env, batch, null);
            // viewport is weird because it can affect context vars
            if (args.state.viewport && args.state.viewport.propDep) contextDynamic = true;
            function isInnerDefn(defn) {
                return defn.contextDep && contextDynamic || defn.propDep;
            }
            // set webgl options
            emitPollState(env, batch, args);
            emitSetOptions(env, batch, args.state, function(defn) {
                return !isInnerDefn(defn);
            });
            if (!args.profile || !isInnerDefn(args.profile)) emitProfile(env, batch, args, false, "a1");
            // Save these values to args so that the batch body routine can use them
            args.contextDep = contextDynamic;
            args.needsContext = needsContext;
            args.needsFramebuffer = needsFramebuffer;
            // determine if shader is dynamic
            var progDefn = args.shader.progVar;
            if (progDefn.contextDep && contextDynamic || progDefn.propDep) emitBatchBody(env, batch, args, null);
            else {
                var PROGRAM = progDefn.append(env, batch);
                batch(env.shared.gl, ".useProgram(", PROGRAM, ".program);");
                if (args.shader.program) emitBatchBody(env, batch, args, args.shader.program);
                else {
                    batch(env.shared.vao, ".setVAO(null);");
                    var batchCache = env.global.def("{}");
                    var PROG_ID = batch.def(PROGRAM, ".id");
                    var CACHED_PROC = batch.def(batchCache, "[", PROG_ID, "]");
                    batch(env.cond(CACHED_PROC).then(CACHED_PROC, ".call(this,a0,a1);").else(CACHED_PROC, "=", batchCache, "[", PROG_ID, "]=", env.link(function(program) {
                        return createBody(emitBatchBody, env, args, program, 2);
                    }), "(", PROGRAM, ");", CACHED_PROC, ".call(this,a0,a1);"));
                }
            }
            if (Object.keys(args.state).length > 0) batch(env.shared.current, ".dirty=true;");
            if (env.shared.vao) batch(env.shared.vao, ".setVAO(null);");
        }
        // ===================================================
        // ===================================================
        // SCOPE COMMAND
        // ===================================================
        // ===================================================
        function emitScopeProc(env, args) {
            var scope = env.proc("scope", 3);
            env.batchId = "a2";
            var shared = env.shared;
            var CURRENT_STATE = shared.current;
            emitContext(env, scope, args.context);
            if (args.framebuffer) args.framebuffer.append(env, scope);
            sortState(Object.keys(args.state)).forEach(function(name) {
                var defn = args.state[name];
                var value = defn.append(env, scope);
                if (isArrayLike(value)) value.forEach(function(v, i) {
                    scope.set(env.next[name], "[" + i + "]", v);
                });
                else scope.set(shared.next, "." + name, value);
            });
            emitProfile(env, scope, args, true, true);
            [
                S_ELEMENTS,
                S_OFFSET,
                S_COUNT,
                S_INSTANCES,
                S_PRIMITIVE
            ].forEach(function(opt) {
                var variable = args.draw[opt];
                if (!variable) return;
                scope.set(shared.draw, "." + opt, "" + variable.append(env, scope));
            });
            Object.keys(args.uniforms).forEach(function(opt) {
                var value = args.uniforms[opt].append(env, scope);
                if (Array.isArray(value)) value = "[" + value.join() + "]";
                scope.set(shared.uniforms, "[" + stringStore.id(opt) + "]", value);
            });
            Object.keys(args.attributes).forEach(function(name) {
                var record = args.attributes[name].append(env, scope);
                var scopeAttrib = env.scopeAttrib(name);
                Object.keys(new AttributeRecord()).forEach(function(prop) {
                    scope.set(scopeAttrib, "." + prop, record[prop]);
                });
            });
            if (args.scopeVAO) scope.set(shared.vao, ".targetVAO", args.scopeVAO.append(env, scope));
            function saveShader(name) {
                var shader = args.shader[name];
                if (shader) scope.set(shared.shader, "." + name, shader.append(env, scope));
            }
            saveShader(S_VERT);
            saveShader(S_FRAG);
            if (Object.keys(args.state).length > 0) {
                scope(CURRENT_STATE, ".dirty=true;");
                scope.exit(CURRENT_STATE, ".dirty=true;");
            }
            scope("a1(", env.shared.context, ",a0,", env.batchId, ");");
        }
        function isDynamicObject(object) {
            if (typeof object !== "object" || isArrayLike(object)) return;
            var props = Object.keys(object);
            for(var i = 0; i < props.length; ++i){
                if (dynamic.isDynamic(object[props[i]])) return true;
            }
            return false;
        }
        function splatObject(env, options, name) {
            var object = options.static[name];
            if (!object || !isDynamicObject(object)) return;
            var globals = env.global;
            var keys = Object.keys(object);
            var thisDep = false;
            var contextDep = false;
            var propDep = false;
            var objectRef = env.global.def("{}");
            keys.forEach(function(key) {
                var value = object[key];
                if (dynamic.isDynamic(value)) {
                    if (typeof value === "function") value = object[key] = dynamic.unbox(value);
                    var deps = createDynamicDecl(value, null);
                    thisDep = thisDep || deps.thisDep;
                    propDep = propDep || deps.propDep;
                    contextDep = contextDep || deps.contextDep;
                } else {
                    globals(objectRef, ".", key, "=");
                    switch(typeof value){
                        case "number":
                            globals(value);
                            break;
                        case "string":
                            globals('"', value, '"');
                            break;
                        case "object":
                            if (Array.isArray(value)) globals("[", value.join(), "]");
                            break;
                        default:
                            globals(env.link(value));
                            break;
                    }
                    globals(";");
                }
            });
            function appendBlock(env, block) {
                keys.forEach(function(key) {
                    var value = object[key];
                    if (!dynamic.isDynamic(value)) return;
                    var ref = env.invoke(block, value);
                    block(objectRef, ".", key, "=", ref, ";");
                });
            }
            options.dynamic[name] = new dynamic.DynamicVariable(DYN_THUNK, {
                thisDep: thisDep,
                contextDep: contextDep,
                propDep: propDep,
                ref: objectRef,
                append: appendBlock
            });
            delete options.static[name];
        }
        // ===========================================================================
        // ===========================================================================
        // MAIN DRAW COMMAND
        // ===========================================================================
        // ===========================================================================
        function compileCommand(options, attributes, uniforms, context, stats) {
            var env = createREGLEnvironment();
            // link stats, so that we can easily access it in the program.
            env.stats = env.link(stats);
            // splat options and attributes to allow for dynamic nested properties
            Object.keys(attributes.static).forEach(function(key) {
                splatObject(env, attributes, key);
            });
            NESTED_OPTIONS.forEach(function(name) {
                splatObject(env, options, name);
            });
            var args = parseArguments(options, attributes, uniforms, context, env);
            emitDrawProc(env, args);
            emitScopeProc(env, args);
            emitBatchProc(env, args);
            return extend(env.compile(), {
                destroy: function() {
                    args.shader.program.destroy();
                }
            });
        }
        // ===========================================================================
        // ===========================================================================
        // POLL / REFRESH
        // ===========================================================================
        // ===========================================================================
        return {
            next: nextState,
            current: currentState,
            procs: function() {
                var env = createREGLEnvironment();
                var poll = env.proc("poll");
                var refresh = env.proc("refresh");
                var common = env.block();
                poll(common);
                refresh(common);
                var shared = env.shared;
                var GL = shared.gl;
                var NEXT_STATE = shared.next;
                var CURRENT_STATE = shared.current;
                common(CURRENT_STATE, ".dirty=false;");
                emitPollFramebuffer(env, poll);
                emitPollFramebuffer(env, refresh, null, true);
                // Refresh updates all attribute state changes
                var INSTANCING;
                if (extInstancing) INSTANCING = env.link(extInstancing);
                // update vertex array bindings
                if (extensions.oes_vertex_array_object) refresh(env.link(extensions.oes_vertex_array_object), ".bindVertexArrayOES(null);");
                for(var i = 0; i < limits.maxAttributes; ++i){
                    var BINDING = refresh.def(shared.attributes, "[", i, "]");
                    var ifte = env.cond(BINDING, ".buffer");
                    ifte.then(GL, ".enableVertexAttribArray(", i, ");", GL, ".bindBuffer(", GL_ARRAY_BUFFER$2, ",", BINDING, ".buffer.buffer);", GL, ".vertexAttribPointer(", i, ",", BINDING, ".size,", BINDING, ".type,", BINDING, ".normalized,", BINDING, ".stride,", BINDING, ".offset);").else(GL, ".disableVertexAttribArray(", i, ");", GL, ".vertexAttrib4f(", i, ",", BINDING, ".x,", BINDING, ".y,", BINDING, ".z,", BINDING, ".w);", BINDING, ".buffer=null;");
                    refresh(ifte);
                    if (extInstancing) refresh(INSTANCING, ".vertexAttribDivisorANGLE(", i, ",", BINDING, ".divisor);");
                }
                refresh(env.shared.vao, ".currentVAO=null;", env.shared.vao, ".setVAO(", env.shared.vao, ".targetVAO);");
                Object.keys(GL_FLAGS).forEach(function(flag) {
                    var cap = GL_FLAGS[flag];
                    var NEXT = common.def(NEXT_STATE, ".", flag);
                    var block = env.block();
                    block("if(", NEXT, "){", GL, ".enable(", cap, ")}else{", GL, ".disable(", cap, ")}", CURRENT_STATE, ".", flag, "=", NEXT, ";");
                    refresh(block);
                    poll("if(", NEXT, "!==", CURRENT_STATE, ".", flag, "){", block, "}");
                });
                Object.keys(GL_VARIABLES).forEach(function(name) {
                    var func = GL_VARIABLES[name];
                    var init = currentState[name];
                    var NEXT, CURRENT;
                    var block = env.block();
                    block(GL, ".", func, "(");
                    if (isArrayLike(init)) {
                        var n = init.length;
                        NEXT = env.global.def(NEXT_STATE, ".", name);
                        CURRENT = env.global.def(CURRENT_STATE, ".", name);
                        block(loop(n, function(i) {
                            return NEXT + "[" + i + "]";
                        }), ");", loop(n, function(i) {
                            return CURRENT + "[" + i + "]=" + NEXT + "[" + i + "];";
                        }).join(""));
                        poll("if(", loop(n, function(i) {
                            return NEXT + "[" + i + "]!==" + CURRENT + "[" + i + "]";
                        }).join("||"), "){", block, "}");
                    } else {
                        NEXT = common.def(NEXT_STATE, ".", name);
                        CURRENT = common.def(CURRENT_STATE, ".", name);
                        block(NEXT, ");", CURRENT_STATE, ".", name, "=", NEXT, ";");
                        poll("if(", NEXT, "!==", CURRENT, "){", block, "}");
                    }
                    refresh(block);
                });
                return env.compile();
            }(),
            compile: compileCommand
        };
    }
    function stats() {
        return {
            vaoCount: 0,
            bufferCount: 0,
            elementsCount: 0,
            framebufferCount: 0,
            shaderCount: 0,
            textureCount: 0,
            cubeCount: 0,
            renderbufferCount: 0,
            maxTextureUnits: 0
        };
    }
    var GL_QUERY_RESULT_EXT = 0x8866;
    var GL_QUERY_RESULT_AVAILABLE_EXT = 0x8867;
    var GL_TIME_ELAPSED_EXT = 0x88BF;
    var createTimer = function(gl, extensions) {
        if (!extensions.ext_disjoint_timer_query) return null;
        // QUERY POOL BEGIN
        var queryPool = [];
        function allocQuery() {
            return queryPool.pop() || extensions.ext_disjoint_timer_query.createQueryEXT();
        }
        function freeQuery(query) {
            queryPool.push(query);
        }
        // QUERY POOL END
        var pendingQueries = [];
        function beginQuery(stats) {
            var query = allocQuery();
            extensions.ext_disjoint_timer_query.beginQueryEXT(GL_TIME_ELAPSED_EXT, query);
            pendingQueries.push(query);
            pushScopeStats(pendingQueries.length - 1, pendingQueries.length, stats);
        }
        function endQuery() {
            extensions.ext_disjoint_timer_query.endQueryEXT(GL_TIME_ELAPSED_EXT);
        }
        //
        // Pending stats pool.
        //
        function PendingStats() {
            this.startQueryIndex = -1;
            this.endQueryIndex = -1;
            this.sum = 0;
            this.stats = null;
        }
        var pendingStatsPool = [];
        function allocPendingStats() {
            return pendingStatsPool.pop() || new PendingStats();
        }
        function freePendingStats(pendingStats) {
            pendingStatsPool.push(pendingStats);
        }
        // Pending stats pool end
        var pendingStats = [];
        function pushScopeStats(start, end, stats) {
            var ps = allocPendingStats();
            ps.startQueryIndex = start;
            ps.endQueryIndex = end;
            ps.sum = 0;
            ps.stats = stats;
            pendingStats.push(ps);
        }
        // we should call this at the beginning of the frame,
        // in order to update gpuTime
        var timeSum = [];
        var queryPtr = [];
        function update() {
            var ptr, i;
            var n = pendingQueries.length;
            if (n === 0) return;
            // Reserve space
            queryPtr.length = Math.max(queryPtr.length, n + 1);
            timeSum.length = Math.max(timeSum.length, n + 1);
            timeSum[0] = 0;
            queryPtr[0] = 0;
            // Update all pending timer queries
            var queryTime = 0;
            ptr = 0;
            for(i = 0; i < pendingQueries.length; ++i){
                var query = pendingQueries[i];
                if (extensions.ext_disjoint_timer_query.getQueryObjectEXT(query, GL_QUERY_RESULT_AVAILABLE_EXT)) {
                    queryTime += extensions.ext_disjoint_timer_query.getQueryObjectEXT(query, GL_QUERY_RESULT_EXT);
                    freeQuery(query);
                } else pendingQueries[ptr++] = query;
                timeSum[i + 1] = queryTime;
                queryPtr[i + 1] = ptr;
            }
            pendingQueries.length = ptr;
            // Update all pending stat queries
            ptr = 0;
            for(i = 0; i < pendingStats.length; ++i){
                var stats = pendingStats[i];
                var start = stats.startQueryIndex;
                var end = stats.endQueryIndex;
                stats.sum += timeSum[end] - timeSum[start];
                var startPtr = queryPtr[start];
                var endPtr = queryPtr[end];
                if (endPtr === startPtr) {
                    stats.stats.gpuTime += stats.sum / 1e6;
                    freePendingStats(stats);
                } else {
                    stats.startQueryIndex = startPtr;
                    stats.endQueryIndex = endPtr;
                    pendingStats[ptr++] = stats;
                }
            }
            pendingStats.length = ptr;
        }
        return {
            beginQuery: beginQuery,
            endQuery: endQuery,
            pushScopeStats: pushScopeStats,
            update: update,
            getNumPendingQueries: function() {
                return pendingQueries.length;
            },
            clear: function() {
                queryPool.push.apply(queryPool, pendingQueries);
                for(var i = 0; i < queryPool.length; i++)extensions.ext_disjoint_timer_query.deleteQueryEXT(queryPool[i]);
                pendingQueries.length = 0;
                queryPool.length = 0;
            },
            restore: function() {
                pendingQueries.length = 0;
                queryPool.length = 0;
            }
        };
    };
    var GL_COLOR_BUFFER_BIT = 16384;
    var GL_DEPTH_BUFFER_BIT = 256;
    var GL_STENCIL_BUFFER_BIT = 1024;
    var GL_ARRAY_BUFFER = 34962;
    var CONTEXT_LOST_EVENT = "webglcontextlost";
    var CONTEXT_RESTORED_EVENT = "webglcontextrestored";
    var DYN_PROP = 1;
    var DYN_CONTEXT = 2;
    var DYN_STATE = 3;
    function find(haystack, needle) {
        for(var i = 0; i < haystack.length; ++i){
            if (haystack[i] === needle) return i;
        }
        return -1;
    }
    function wrapREGL(args) {
        var config = parseArgs(args);
        if (!config) return null;
        var gl = config.gl;
        var glAttributes = gl.getContextAttributes();
        var contextLost = gl.isContextLost();
        var extensionState = createExtensionCache(gl, config);
        if (!extensionState) return null;
        var stringStore = createStringStore();
        var stats$$1 = stats();
        var extensions = extensionState.extensions;
        var timer = createTimer(gl, extensions);
        var START_TIME = clock();
        var WIDTH = gl.drawingBufferWidth;
        var HEIGHT = gl.drawingBufferHeight;
        var contextState = {
            tick: 0,
            time: 0,
            viewportWidth: WIDTH,
            viewportHeight: HEIGHT,
            framebufferWidth: WIDTH,
            framebufferHeight: HEIGHT,
            drawingBufferWidth: WIDTH,
            drawingBufferHeight: HEIGHT,
            pixelRatio: config.pixelRatio
        };
        var uniformState = {};
        var drawState = {
            elements: null,
            primitive: 4,
            count: -1,
            offset: 0,
            instances: -1
        };
        var limits = wrapLimits(gl, extensions);
        var bufferState = wrapBufferState(gl, stats$$1, config, destroyBuffer);
        var elementState = wrapElementsState(gl, extensions, bufferState, stats$$1);
        var attributeState = wrapAttributeState(gl, extensions, limits, stats$$1, bufferState, elementState, drawState);
        function destroyBuffer(buffer) {
            return attributeState.destroyBuffer(buffer);
        }
        var shaderState = wrapShaderState(gl, stringStore, stats$$1, config);
        var textureState = createTextureSet(gl, extensions, limits, function() {
            core.procs.poll();
        }, contextState, stats$$1, config);
        var renderbufferState = wrapRenderbuffers(gl, extensions, limits, stats$$1, config);
        var framebufferState = wrapFBOState(gl, extensions, limits, textureState, renderbufferState, stats$$1);
        var core = reglCore(gl, stringStore, extensions, limits, bufferState, elementState, textureState, framebufferState, uniformState, attributeState, shaderState, drawState, contextState, timer, config);
        var readPixels = wrapReadPixels(gl, framebufferState, core.procs.poll, contextState, glAttributes, extensions, limits);
        var nextState = core.next;
        var canvas = gl.canvas;
        var rafCallbacks = [];
        var lossCallbacks = [];
        var restoreCallbacks = [];
        var destroyCallbacks = [
            config.onDestroy
        ];
        var activeRAF = null;
        function handleRAF() {
            if (rafCallbacks.length === 0) {
                if (timer) timer.update();
                activeRAF = null;
                return;
            }
            // schedule next animation frame
            activeRAF = raf.next(handleRAF);
            // poll for changes
            poll();
            // fire a callback for all pending rafs
            for(var i = rafCallbacks.length - 1; i >= 0; --i){
                var cb = rafCallbacks[i];
                if (cb) cb(contextState, null, 0);
            }
            // flush all pending webgl calls
            gl.flush();
            // poll GPU timers *after* gl.flush so we don't delay command dispatch
            if (timer) timer.update();
        }
        function startRAF() {
            if (!activeRAF && rafCallbacks.length > 0) activeRAF = raf.next(handleRAF);
        }
        function stopRAF() {
            if (activeRAF) {
                raf.cancel(handleRAF);
                activeRAF = null;
            }
        }
        function handleContextLoss(event) {
            event.preventDefault();
            // set context lost flag
            contextLost = true;
            // pause request animation frame
            stopRAF();
            // lose context
            lossCallbacks.forEach(function(cb) {
                cb();
            });
        }
        function handleContextRestored(event) {
            // clear error code
            gl.getError();
            // clear context lost flag
            contextLost = false;
            // refresh state
            extensionState.restore();
            shaderState.restore();
            bufferState.restore();
            textureState.restore();
            renderbufferState.restore();
            framebufferState.restore();
            attributeState.restore();
            if (timer) timer.restore();
            // refresh state
            core.procs.refresh();
            // restart RAF
            startRAF();
            // restore context
            restoreCallbacks.forEach(function(cb) {
                cb();
            });
        }
        if (canvas) {
            canvas.addEventListener(CONTEXT_LOST_EVENT, handleContextLoss, false);
            canvas.addEventListener(CONTEXT_RESTORED_EVENT, handleContextRestored, false);
        }
        function destroy() {
            rafCallbacks.length = 0;
            stopRAF();
            if (canvas) {
                canvas.removeEventListener(CONTEXT_LOST_EVENT, handleContextLoss);
                canvas.removeEventListener(CONTEXT_RESTORED_EVENT, handleContextRestored);
            }
            shaderState.clear();
            framebufferState.clear();
            renderbufferState.clear();
            attributeState.clear();
            textureState.clear();
            elementState.clear();
            bufferState.clear();
            if (timer) timer.clear();
            destroyCallbacks.forEach(function(cb) {
                cb();
            });
        }
        function compileProcedure(options) {
            check$1(!!options, "invalid args to regl({...})");
            check$1.type(options, "object", "invalid args to regl({...})");
            function flattenNestedOptions(options) {
                var result = extend({}, options);
                delete result.uniforms;
                delete result.attributes;
                delete result.context;
                delete result.vao;
                if ("stencil" in result && result.stencil.op) {
                    result.stencil.opBack = result.stencil.opFront = result.stencil.op;
                    delete result.stencil.op;
                }
                function merge(name) {
                    if (name in result) {
                        var child = result[name];
                        delete result[name];
                        Object.keys(child).forEach(function(prop) {
                            result[name + "." + prop] = child[prop];
                        });
                    }
                }
                merge("blend");
                merge("depth");
                merge("cull");
                merge("stencil");
                merge("polygonOffset");
                merge("scissor");
                merge("sample");
                if ("vao" in options) result.vao = options.vao;
                return result;
            }
            function separateDynamic(object, useArrays) {
                var staticItems = {};
                var dynamicItems = {};
                Object.keys(object).forEach(function(option) {
                    var value = object[option];
                    if (dynamic.isDynamic(value)) {
                        dynamicItems[option] = dynamic.unbox(value, option);
                        return;
                    } else if (useArrays && Array.isArray(value)) {
                        for(var i = 0; i < value.length; ++i)if (dynamic.isDynamic(value[i])) {
                            dynamicItems[option] = dynamic.unbox(value, option);
                            return;
                        }
                    }
                    staticItems[option] = value;
                });
                return {
                    dynamic: dynamicItems,
                    static: staticItems
                };
            }
            // Treat context variables separate from other dynamic variables
            var context = separateDynamic(options.context || {}, true);
            var uniforms = separateDynamic(options.uniforms || {}, true);
            var attributes = separateDynamic(options.attributes || {}, false);
            var opts = separateDynamic(flattenNestedOptions(options), false);
            var stats$$1 = {
                gpuTime: 0.0,
                cpuTime: 0.0,
                count: 0
            };
            var compiled = core.compile(opts, attributes, uniforms, context, stats$$1);
            var draw = compiled.draw;
            var batch = compiled.batch;
            var scope = compiled.scope;
            // FIXME: we should modify code generation for batch commands so this
            // isn't necessary
            var EMPTY_ARRAY = [];
            function reserve(count) {
                while(EMPTY_ARRAY.length < count)EMPTY_ARRAY.push(null);
                return EMPTY_ARRAY;
            }
            function REGLCommand(args, body) {
                var i;
                if (contextLost) check$1.raise("context lost");
                if (typeof args === "function") return scope.call(this, null, args, 0);
                else if (typeof body === "function") {
                    if (typeof args === "number") for(i = 0; i < args; ++i)scope.call(this, null, body, i);
                    else if (Array.isArray(args)) for(i = 0; i < args.length; ++i)scope.call(this, args[i], body, i);
                    else return scope.call(this, args, body, 0);
                } else if (typeof args === "number") {
                    if (args > 0) return batch.call(this, reserve(args | 0), args | 0);
                } else if (Array.isArray(args)) {
                    if (args.length) return batch.call(this, args, args.length);
                } else return draw.call(this, args);
            }
            return extend(REGLCommand, {
                stats: stats$$1,
                destroy: function() {
                    compiled.destroy();
                }
            });
        }
        var setFBO = framebufferState.setFBO = compileProcedure({
            framebuffer: dynamic.define.call(null, DYN_PROP, "framebuffer")
        });
        function clearImpl(_, options) {
            var clearFlags = 0;
            core.procs.poll();
            var c = options.color;
            if (c) {
                gl.clearColor(+c[0] || 0, +c[1] || 0, +c[2] || 0, +c[3] || 0);
                clearFlags |= GL_COLOR_BUFFER_BIT;
            }
            if ("depth" in options) {
                gl.clearDepth(+options.depth);
                clearFlags |= GL_DEPTH_BUFFER_BIT;
            }
            if ("stencil" in options) {
                gl.clearStencil(options.stencil | 0);
                clearFlags |= GL_STENCIL_BUFFER_BIT;
            }
            check$1(!!clearFlags, "called regl.clear with no buffer specified");
            gl.clear(clearFlags);
        }
        function clear(options) {
            check$1(typeof options === "object" && options, "regl.clear() takes an object as input");
            if ("framebuffer" in options) {
                if (options.framebuffer && options.framebuffer_reglType === "framebufferCube") for(var i = 0; i < 6; ++i)setFBO(extend({
                    framebuffer: options.framebuffer.faces[i]
                }, options), clearImpl);
                else setFBO(options, clearImpl);
            } else clearImpl(null, options);
        }
        function frame(cb) {
            check$1.type(cb, "function", "regl.frame() callback must be a function");
            rafCallbacks.push(cb);
            function cancel() {
                // FIXME:  should we check something other than equals cb here?
                // what if a user calls frame twice with the same callback...
                //
                var i = find(rafCallbacks, cb);
                check$1(i >= 0, "cannot cancel a frame twice");
                function pendingCancel() {
                    var index = find(rafCallbacks, pendingCancel);
                    rafCallbacks[index] = rafCallbacks[rafCallbacks.length - 1];
                    rafCallbacks.length -= 1;
                    if (rafCallbacks.length <= 0) stopRAF();
                }
                rafCallbacks[i] = pendingCancel;
            }
            startRAF();
            return {
                cancel: cancel
            };
        }
        // poll viewport
        function pollViewport() {
            var viewport = nextState.viewport;
            var scissorBox = nextState.scissor_box;
            viewport[0] = viewport[1] = scissorBox[0] = scissorBox[1] = 0;
            contextState.viewportWidth = contextState.framebufferWidth = contextState.drawingBufferWidth = viewport[2] = scissorBox[2] = gl.drawingBufferWidth;
            contextState.viewportHeight = contextState.framebufferHeight = contextState.drawingBufferHeight = viewport[3] = scissorBox[3] = gl.drawingBufferHeight;
        }
        function poll() {
            contextState.tick += 1;
            contextState.time = now();
            pollViewport();
            core.procs.poll();
        }
        function refresh() {
            textureState.refresh();
            pollViewport();
            core.procs.refresh();
            if (timer) timer.update();
        }
        function now() {
            return (clock() - START_TIME) / 1000.0;
        }
        refresh();
        function addListener(event, callback) {
            check$1.type(callback, "function", "listener callback must be a function");
            var callbacks;
            switch(event){
                case "frame":
                    return frame(callback);
                case "lost":
                    callbacks = lossCallbacks;
                    break;
                case "restore":
                    callbacks = restoreCallbacks;
                    break;
                case "destroy":
                    callbacks = destroyCallbacks;
                    break;
                default:
                    check$1.raise("invalid event, must be one of frame,lost,restore,destroy");
            }
            callbacks.push(callback);
            return {
                cancel: function() {
                    for(var i = 0; i < callbacks.length; ++i)if (callbacks[i] === callback) {
                        callbacks[i] = callbacks[callbacks.length - 1];
                        callbacks.pop();
                        return;
                    }
                }
            };
        }
        var regl = extend(compileProcedure, {
            // Clear current FBO
            clear: clear,
            // Short cuts for dynamic variables
            prop: dynamic.define.bind(null, DYN_PROP),
            context: dynamic.define.bind(null, DYN_CONTEXT),
            this: dynamic.define.bind(null, DYN_STATE),
            // executes an empty draw command
            draw: compileProcedure({}),
            // Resources
            buffer: function(options) {
                return bufferState.create(options, GL_ARRAY_BUFFER, false, false);
            },
            elements: function(options) {
                return elementState.create(options, false);
            },
            texture: textureState.create2D,
            cube: textureState.createCube,
            renderbuffer: renderbufferState.create,
            framebuffer: framebufferState.create,
            framebufferCube: framebufferState.createCube,
            vao: attributeState.createVAO,
            // Expose context attributes
            attributes: glAttributes,
            // Frame rendering
            frame: frame,
            on: addListener,
            // System limits
            limits: limits,
            hasExtension: function(name) {
                return limits.extensions.indexOf(name.toLowerCase()) >= 0;
            },
            // Read pixels
            read: readPixels,
            // Destroy regl and all associated resources
            destroy: destroy,
            // Direct GL state manipulation
            _gl: gl,
            _refresh: refresh,
            poll: function() {
                poll();
                if (timer) timer.update();
            },
            // Current time
            now: now,
            // regl Statistics Information
            stats: stats$$1
        });
        config.onDone(null, regl);
        return regl;
    }
    return wrapREGL;
});


const $7b6dab4ddb729928$export$dcfbb7940cfb3a48 = (out, x, y)=>(!out && (out = []), out[0] = x, out[1] = y, out);
const $7b6dab4ddb729928$export$ba8c70ce75474f8d = (out, x, y, z)=>(!out && (out = []), out[0] = x, out[1] = y, out[2] = z, out);
const $7b6dab4ddb729928$export$abee0037e1db715 = (out, x, y, z, w)=>(!out && (out = []), out[0] = x, out[1] = y, out[2] = z, out[3] = w, out);
const $7b6dab4ddb729928$export$d58a46c754825a51 = (out, a, b, c, d, e, f)=>(!out && (out = []), out[0] = a, out[1] = b, out[2] = c, out[3] = d, out[4] = e, out[5] = f, out);
const $7b6dab4ddb729928$export$644e79245f7d24b5 = (out, ...values)=>{
    if (!out) return values;
    for(let i = 0, n = values.length; i < n; i++)out[i] = values[i];
    return out;
};


const $60621a7e2196cae1$export$651a6eb01ea522f3 = (prefix, suffix = (msg)=>msg !== void 0 ? ": " + msg : "")=>class extends Error {
        origMessage;
        constructor(msg){
            super(prefix(msg) + suffix(msg));
            this.origMessage = msg !== void 0 ? String(msg) : "";
        }
    };


const $ceb358999aef0b00$export$772aa0961a81b065 = (0, $60621a7e2196cae1$export$651a6eb01ea522f3)(()=>"illegal arity");
const $ceb358999aef0b00$export$9f1b9fbfe882200d = (n)=>{
    throw new $ceb358999aef0b00$export$772aa0961a81b065(n);
};


function $95b5e67a435e9b9f$export$1af3c925c49f37a2(...fns) {
    let [a, b, c, d, e, f, g, h, i, j] = fns;
    switch(fns.length){
        case 0:
            (0, $ceb358999aef0b00$export$9f1b9fbfe882200d)(0);
        case 1:
            return a;
        case 2:
            return (...args)=>a(b(...args));
        case 3:
            return (...args)=>a(b(c(...args)));
        case 4:
            return (...args)=>a(b(c(d(...args))));
        case 5:
            return (...args)=>a(b(c(d(e(...args)))));
        case 6:
            return (...args)=>a(b(c(d(e(f(...args))))));
        case 7:
            return (...args)=>a(b(c(d(e(f(g(...args)))))));
        case 8:
            return (...args)=>a(b(c(d(e(f(g(h(...args))))))));
        case 9:
            return (...args)=>a(b(c(d(e(f(g(h(i(...args)))))))));
        case 10:
        default:
            const fn = (...args)=>a(b(c(d(e(f(g(h(i(j(...args))))))))));
            return fns.length === 10 ? fn : $95b5e67a435e9b9f$export$1af3c925c49f37a2(fn, ...fns.slice(10));
    }
}
function $95b5e67a435e9b9f$export$83fc47c523588c98(...fns) {
    return $95b5e67a435e9b9f$export$1af3c925c49f37a2.apply(null, fns.reverse());
}
const $95b5e67a435e9b9f$export$fd785a9ec61dece = $95b5e67a435e9b9f$export$83fc47c523588c98;
function $95b5e67a435e9b9f$export$8679f38bd904e883(...fns) {
    return async (...args)=>{
        let n = fns.length - 1;
        let res = fns[n](...args);
        while(n-- > 0)res = await fns[n](res);
        return res;
    };
}


const $b4429ed4e1faf6b1$export$c915e14294a7d06f = (x, fn)=>typeof x?.[fn] === "function";


const $c997f826e741f107$export$eca2c7e8e95bbf0a = (x)=>(0, $b4429ed4e1faf6b1$export$c915e14294a7d06f)(x, "xform") ? x.xform() : x;


function $6c7ed5fa5c325f41$export$1af3c925c49f37a2(...fns) {
    fns = fns.map((0, $c997f826e741f107$export$eca2c7e8e95bbf0a));
    return (0, $95b5e67a435e9b9f$export$1af3c925c49f37a2).apply(null, fns);
}


const $521819d7e6ff32ac$export$9652023d9040757 = (x)=>typeof x?.[Symbol.iterator] === "function";


const $63c7b28cc67d34c9$export$5adef4befe47917 = (rfn, fn)=>[
        rfn[0],
        rfn[1],
        fn
    ];


const $c178576fb16dc15d$export$47f9e8d3c41dafbd = 1e-6;
const $c178576fb16dc15d$export$a7d1fa727cb10b0e = Symbol();
const $c178576fb16dc15d$export$ca96bc7645ad7951 = ()=>{};
const $c178576fb16dc15d$export$d97419887230d749 = "*";
const $c178576fb16dc15d$export$ee2dc6a4697cf5e9 = "enable";
const $c178576fb16dc15d$export$f631a292dd99edd2 = "disable";




const $17f7234632212a4c$export$f0954fd7d5368655 = (x)=>x;
const $17f7234632212a4c$export$ba9e5d519bc326ca = ()=>true;
const $17f7234632212a4c$export$b3e22bcfd64c1022 = ()=>false;



const $db5c4a24e7c9329c$export$1e2f57719e155213 = (x)=>x != null && typeof x !== "function" && x.length !== void 0;




class $493adaf40334ae0e$export$ce266a425291df6c {
    value;
    constructor(val){
        this.value = val;
    }
    deref() {
        return this.value;
    }
}
const $493adaf40334ae0e$export$447808b60b7559bd = (x)=>new $493adaf40334ae0e$export$ce266a425291df6c(x);
const $493adaf40334ae0e$export$ebab785f9ea33473 = (x)=>x instanceof $493adaf40334ae0e$export$ce266a425291df6c;
const $493adaf40334ae0e$export$f2412ace46b7b087 = (x)=>x instanceof $493adaf40334ae0e$export$ce266a425291df6c ? x : new $493adaf40334ae0e$export$ce266a425291df6c(x);
const $493adaf40334ae0e$export$7ca7c14b24aa137b = (x)=>x instanceof $493adaf40334ae0e$export$ce266a425291df6c ? x.deref() : x;


const $ed3b48eeebf70979$var$__parseArgs = (args)=>args.length === 2 ? [
        void 0,
        args[1]
    ] : args.length === 3 ? [
        args[1],
        args[2]
    ] : (0, $ceb358999aef0b00$export$9f1b9fbfe882200d)(args.length);
function $ed3b48eeebf70979$export$533b26079ad0b4b(...args) {
    const rfn = args[0];
    const init = rfn[0];
    const complete = rfn[1];
    const reduce2 = rfn[2];
    args = $ed3b48eeebf70979$var$__parseArgs(args);
    const acc = args[0] == null ? init() : args[0];
    const src = args[1];
    return (0, $493adaf40334ae0e$export$7ca7c14b24aa137b)(complete((0, $b4429ed4e1faf6b1$export$c915e14294a7d06f)(src, "$reduce") ? src.$reduce(reduce2, acc) : (0, $db5c4a24e7c9329c$export$1e2f57719e155213)(src) ? $ed3b48eeebf70979$var$__reduceArray(reduce2, acc, src) : $ed3b48eeebf70979$var$__reduceIterable(reduce2, acc, src)));
}
function $ed3b48eeebf70979$export$7fef8bcdbb34f435(...args) {
    const [init, complete, reduce2] = args[0];
    args = $ed3b48eeebf70979$var$__parseArgs(args);
    let acc = args[0] == null ? init() : args[0];
    const src = args[1];
    for(let i = src.length; i-- > 0;){
        acc = reduce2(acc, src[i]);
        if ((0, $493adaf40334ae0e$export$ebab785f9ea33473)(acc)) {
            acc = acc.deref();
            break;
        }
    }
    return (0, $493adaf40334ae0e$export$7ca7c14b24aa137b)(complete(acc));
}
const $ed3b48eeebf70979$var$__reduceArray = (rfn, acc, src)=>{
    for(let i = 0, n = src.length; i < n; i++){
        acc = rfn(acc, src[i]);
        if ((0, $493adaf40334ae0e$export$ebab785f9ea33473)(acc)) {
            acc = acc.deref();
            break;
        }
    }
    return acc;
};
const $ed3b48eeebf70979$var$__reduceIterable = (rfn, acc, src)=>{
    for (let x of src){
        acc = rfn(acc, x);
        if ((0, $493adaf40334ae0e$export$ebab785f9ea33473)(acc)) {
            acc = acc.deref();
            break;
        }
    }
    return acc;
};
const $ed3b48eeebf70979$export$1650419e431d3ba3 = (init, rfn)=>[
        init,
        (0, $17f7234632212a4c$export$f0954fd7d5368655),
        rfn
    ];
const $ed3b48eeebf70979$export$8073770d92ccea36 = (rfn, args)=>{
    const n = args.length - 1;
    return (0, $521819d7e6ff32ac$export$9652023d9040757)(args[n]) ? args.length > 1 ? $ed3b48eeebf70979$export$533b26079ad0b4b(rfn.apply(null, args.slice(0, n)), args[n]) : $ed3b48eeebf70979$export$533b26079ad0b4b(rfn(), args[0]) : void 0;
};


function $12ae9ca953a11fa5$export$4cbf152802aa238(src) {
    return src ? [
        ...src
    ] : (0, $ed3b48eeebf70979$export$1650419e431d3ba3)(()=>[], (acc, x)=>(acc.push(x), acc));
}



function* $500ef1ced54ee1ed$export$6f58e2338da23f4d(xform, src) {
    const rfn = (0, $c997f826e741f107$export$eca2c7e8e95bbf0a)(xform)((0, $12ae9ca953a11fa5$export$4cbf152802aa238)());
    const complete = rfn[1];
    const reduce = rfn[2];
    for (let x of src){
        const y = reduce([], x);
        if ((0, $493adaf40334ae0e$export$ebab785f9ea33473)(y)) {
            yield* (0, $493adaf40334ae0e$export$7ca7c14b24aa137b)(complete(y.deref()));
            return;
        }
        if (y.length) yield* y;
    }
    yield* (0, $493adaf40334ae0e$export$7ca7c14b24aa137b)(complete([]));
}
function* $500ef1ced54ee1ed$export$a6bff14a9cefe0e8(xform, src) {
    const reduce = (0, $c997f826e741f107$export$eca2c7e8e95bbf0a)(xform)([
        (0, $c178576fb16dc15d$export$ca96bc7645ad7951),
        (0, $c178576fb16dc15d$export$ca96bc7645ad7951),
        (_, x)=>x
    ])[2];
    for (let x of src){
        let y = reduce((0, $c178576fb16dc15d$export$a7d1fa727cb10b0e), x);
        if ((0, $493adaf40334ae0e$export$ebab785f9ea33473)(y)) {
            y = (0, $493adaf40334ae0e$export$7ca7c14b24aa137b)(y.deref());
            if (y !== (0, $c178576fb16dc15d$export$a7d1fa727cb10b0e)) yield y;
            return;
        }
        if (y !== (0, $c178576fb16dc15d$export$a7d1fa727cb10b0e)) yield y;
    }
}
const $500ef1ced54ee1ed$export$9b6eac2a13c3d07 = (xform, args, impl = $500ef1ced54ee1ed$export$a6bff14a9cefe0e8)=>{
    const n = args.length - 1;
    return (0, $521819d7e6ff32ac$export$9652023d9040757)(args[n]) ? args.length > 1 ? impl(xform.apply(null, args.slice(0, n)), args[n]) : impl(xform(), args[0]) : void 0;
};


function $30dd3885a85c87e3$export$871de8747c9eaa88(fn, src) {
    return (0, $521819d7e6ff32ac$export$9652023d9040757)(src) ? (0, $500ef1ced54ee1ed$export$a6bff14a9cefe0e8)($30dd3885a85c87e3$export$871de8747c9eaa88(fn), src) : (rfn)=>{
        const r = rfn[2];
        return (0, $63c7b28cc67d34c9$export$5adef4befe47917)(rfn, (acc, x)=>r(acc, fn(x)));
    };
}
const $30dd3885a85c87e3$export$b876a215b1634849 = (fn, src)=>[
        ...$30dd3885a85c87e3$export$871de8747c9eaa88(fn, src)
    ];




function $f5b73307d86e3d18$export$e5bd5b3b105c2a71(...args) {
    return (0, $500ef1ced54ee1ed$export$9b6eac2a13c3d07)($f5b73307d86e3d18$export$e5bd5b3b105c2a71, args) || ((rfn)=>{
        const r = rfn[2];
        const fn = args[0];
        let i = args[1] || 0;
        return (0, $63c7b28cc67d34c9$export$5adef4befe47917)(rfn, (acc, x)=>r(acc, fn(i++, x)));
    });
}



function $3f0276f259a3bed3$export$d02631cccf789723(from, to, step) {
    return new $3f0276f259a3bed3$export$9a58ef0d7ad3278c(from, to, step);
}
class $3f0276f259a3bed3$export$9a58ef0d7ad3278c {
    from;
    to;
    step;
    constructor(from, to, step){
        if (from === void 0) {
            from = 0;
            to = Infinity;
        } else if (to === void 0) {
            to = from;
            from = 0;
        }
        step = step === void 0 ? from < to ? 1 : -1 : step;
        this.from = from;
        this.to = to;
        this.step = step;
    }
    *[Symbol.iterator]() {
        let { from: from, to: to, step: step } = this;
        if (step > 0) while(from < to){
            yield from;
            from += step;
        }
        else if (step < 0) while(from > to){
            yield from;
            from += step;
        }
    }
    $reduce(rfn, acc) {
        const step = this.step;
        if (step > 0) for(let i = this.from, n = this.to; i < n && !(0, $493adaf40334ae0e$export$ebab785f9ea33473)(acc); i += step)acc = rfn(acc, i);
        else for(let i = this.from, n = this.to; i > n && !(0, $493adaf40334ae0e$export$ebab785f9ea33473)(acc); i += step)acc = rfn(acc, i);
        return acc;
    }
}



function $e8b6d9d1007a6801$export$42d51816ce590c93(sep, src) {
    sep = sep || "";
    let first = true;
    return src ? [
        ...src
    ].join(sep) : (0, $ed3b48eeebf70979$export$1650419e431d3ba3)(()=>"", (acc, x)=>(acc = first ? acc + x : acc + sep + x, first = false, acc));
}






function $9658f286083977c8$export$b7df5d561049483a(n, src) {
    return (0, $521819d7e6ff32ac$export$9652023d9040757)(src) ? (0, $500ef1ced54ee1ed$export$6f58e2338da23f4d)($9658f286083977c8$export$b7df5d561049483a(n), src) : (rfn)=>{
        const r = rfn[2];
        let m = n;
        return (0, $63c7b28cc67d34c9$export$5adef4befe47917)(rfn, (acc, x)=>--m > 0 ? r(acc, x) : m === 0 ? (0, $493adaf40334ae0e$export$f2412ace46b7b087)(r(acc, x)) : (0, $493adaf40334ae0e$export$447808b60b7559bd)(acc));
    };
}






function $81615342410b85d5$export$9608d0eacffd6284(...args) {
    return $81615342410b85d5$var$$transduce($81615342410b85d5$export$9608d0eacffd6284, (0, $ed3b48eeebf70979$export$533b26079ad0b4b), args);
}
function $81615342410b85d5$export$9127dcda72bf6aca(...args) {
    return $81615342410b85d5$var$$transduce($81615342410b85d5$export$9127dcda72bf6aca, (0, $ed3b48eeebf70979$export$7fef8bcdbb34f435), args);
}
const $81615342410b85d5$var$$transduce = (tfn, rfn, args)=>{
    let acc, src;
    switch(args.length){
        case 4:
            src = args[3];
            acc = args[2];
            break;
        case 3:
            src = args[2];
            break;
        case 2:
            return (0, $30dd3885a85c87e3$export$871de8747c9eaa88)((x)=>tfn(args[0], args[1], x));
        default:
            (0, $ceb358999aef0b00$export$9f1b9fbfe882200d)(args.length);
    }
    return rfn((0, $c997f826e741f107$export$eca2c7e8e95bbf0a)(args[0])(args[1]), acc, src);
};


function* $0166cc9f7a98c958$export$8901015135f2fb22(...src) {
    const iters = src.map((s)=>s[Symbol.iterator]());
    while(true){
        const tuple = [];
        for (let i of iters){
            let v = i.next();
            if (v.done) return;
            tuple.push(v.value);
        }
        yield tuple;
    }
}



const $7047b0fefb1d1180$export$ab59e00737fb22e6 = (0, $60621a7e2196cae1$export$651a6eb01ea522f3)(()=>"unsupported operation");
const $7047b0fefb1d1180$export$98e633703a635f = (msg)=>{
    throw new $7047b0fefb1d1180$export$ab59e00737fb22e6(msg);
};


const $c501f434658309bf$export$c37d18c23b2ea60c = (dispatch = 0)=>{
    const impls = new Array(5);
    let fallback;
    const fn = (...args)=>{
        const g = impls[args[dispatch].length] || fallback;
        return g ? g(...args) : (0, $7047b0fefb1d1180$export$98e633703a635f)(`no impl for vec size ${args[dispatch].length}`);
    };
    fn.add = (dim, fn2)=>impls[dim] = fn2;
    fn.default = (fn2)=>fallback = fn2;
    fn.impl = (dim)=>dim != null ? impls[dim] || fallback : fallback;
    return fn;
};


const $a3f4ff62579ed7eb$export$19dc841295b49698 = "o,a";
const $a3f4ff62579ed7eb$export$ccd27f3e7091205c = "o,a,b";
const $a3f4ff62579ed7eb$export$eddecb323783c21c = "o,a,b,c";
const $a3f4ff62579ed7eb$export$9e772ae751f37666 = "o,a,n";
const $a3f4ff62579ed7eb$export$1b218a0354f287 = "o,a,n,b";
const $a3f4ff62579ed7eb$export$df3e578f53e12bf2 = "o,a,b,n";
const $a3f4ff62579ed7eb$export$8443f1c33458c80b = "io=0,ia=0,so=1,sa=1";
const $a3f4ff62579ed7eb$export$ff73a40106eb353 = "io=0,ia=0,ib=0,so=1,sa=1,sb=1";
const $a3f4ff62579ed7eb$export$bdb0d4b72a85649d = "io=0,ia=0,ib=0,ic=0,so=1,sa=1,sb=1,sc=1";
const $a3f4ff62579ed7eb$export$381b62756f034f68 = "!o&&(o=a);";
const $a3f4ff62579ed7eb$export$51277e3ac6690f26 = "!o&&(o=[]);";
const $a3f4ff62579ed7eb$export$8c51af9235380b8e = "!a&&(a=[]);";
const $a3f4ff62579ed7eb$export$da5c1e34018ecc43 = (op)=>([o, a, b])=>`${o}=${a}${op}${b};`;
const $a3f4ff62579ed7eb$export$6ab71ad6f57b0093 = (op)=>([o, a])=>`${o}=${a}${op}n;`;
const $a3f4ff62579ed7eb$export$124a2d9669280971 = (op1, op2)=>([o, a, b, c])=>`${o}=(${a}${op1}${b})${op2}${c};`;
const $a3f4ff62579ed7eb$export$db7c5d9768fee3d9 = (op1, op2)=>([o, a, b])=>`${o}=(${a}${op1}${b})${op2}n;`;
const $a3f4ff62579ed7eb$export$524378831b80c0aa = (op1, op2)=>([o, a, b])=>`${o}=(${a}${op1}n)${op2}${b};`;
const $a3f4ff62579ed7eb$export$f160d69d51fe9b08 = (op)=>([o, a, b])=>`${o}=(${a}${op}${b})|0;`;
const $a3f4ff62579ed7eb$export$6a70b64fb8d54a06 = (op)=>([o, a, b])=>`${o}=(${a}${op}${b})>>>0;`;
const $a3f4ff62579ed7eb$export$b4ea1049a5419b4f = (op)=>([o, a])=>`${o}=(${a}${op}n)|0;`;
const $a3f4ff62579ed7eb$export$9de9c213a2a487cd = (op)=>([o, a])=>`${o}=(${a}${op}n)>>>0;`;
const $a3f4ff62579ed7eb$export$9092249dcc75f1af = (op = "op")=>([o, a])=>`${o}=${op}(${a});`;
const $a3f4ff62579ed7eb$export$7b4ffff4916264f8 = (op = "op")=>([o, a, b])=>`${o}=${op}(${a},${b});`;
const $a3f4ff62579ed7eb$export$a0a1b70ab8c960e8 = (op = "op")=>([o, a, b, c])=>`${o}=${op}(${a},${b},${c});`;
const $a3f4ff62579ed7eb$export$a674f282bc507c82 = (op = "op")=>([o, a, b, c, d, e])=>`${o}=${op}(${a},${b},${c},${d},${e});`;
const $a3f4ff62579ed7eb$export$feb62a864ec0d6e5 = (op = "op")=>([o, a])=>`${o}=${op}(${a},n);`;
const $a3f4ff62579ed7eb$export$4061f92b6da4a345 = ([a, b])=>`${a}*${b}`;
const $a3f4ff62579ed7eb$export$15e237ef180bd438 = ([a, b])=>`s+=${a}*${b};`;
const $a3f4ff62579ed7eb$export$5e8f180ef0142226 = ([o, a])=>`${o}=${a};`;
const $a3f4ff62579ed7eb$export$76aa35f56db04732 = ([a])=>`${a}=n;`;
const $a3f4ff62579ed7eb$export$edd47d1eb2bf4a2e = ([o, a, b, c])=>`${o}=${a}+(${b}-${a})*${c};`;
const $a3f4ff62579ed7eb$export$e6a01c2ca00499b1 = ([o, a, b])=>`${o}=${a}+(${b}-${a})*n;`;


const $79c5830c48753a63$var$__lookup = (sym)=>(i)=>i > 1 ? `${sym}[i${sym}+${i}*s${sym}]` : i == 1 ? `${sym}[i${sym}+s${sym}]` : `${sym}[i${sym}]`;
const $79c5830c48753a63$var$__indicesStrided = (sym)=>(0, $30dd3885a85c87e3$export$871de8747c9eaa88)($79c5830c48753a63$var$__lookup(sym), (0, $3f0276f259a3bed3$export$d02631cccf789723)());
const $79c5830c48753a63$var$__indices = (sym)=>(0, $30dd3885a85c87e3$export$871de8747c9eaa88)((i)=>`${sym}[${i}]`, (0, $3f0276f259a3bed3$export$d02631cccf789723)());
const $79c5830c48753a63$var$__assemble = (dim, tpl, syms, ret = "a", opJoin = "", pre = "", post = "", strided = false)=>[
        pre,
        (0, $81615342410b85d5$export$9608d0eacffd6284)((0, $6c7ed5fa5c325f41$export$1af3c925c49f37a2)((0, $9658f286083977c8$export$b7df5d561049483a)(dim), (0, $f5b73307d86e3d18$export$e5bd5b3b105c2a71)((i, x)=>tpl(x, i))), (0, $e8b6d9d1007a6801$export$42d51816ce590c93)(opJoin), (0, $0166cc9f7a98c958$export$8901015135f2fb22).apply(null, syms.split(",").map(strided ? $79c5830c48753a63$var$__indicesStrided : $79c5830c48753a63$var$__indices))),
        post,
        ret !== "" ? `return ${ret};` : ""
    ];
const $79c5830c48753a63$var$__assembleG = (tpl, syms, ret = "a", pre, post, strided = false)=>[
        pre,
        "for(let i=a.length;--i>=0;) {",
        tpl(syms.split(",").map(strided ? (x)=>`${x}[i${x}+i*s${x}]` : (x)=>`${x}[i]`)),
        "}",
        post,
        ret !== null ? `return ${ret};` : ""
    ];
const $79c5830c48753a63$var$__assembleS = (tpl, syms = (0, $a3f4ff62579ed7eb$export$ccd27f3e7091205c), ret = "o", pre = (0, $a3f4ff62579ed7eb$export$381b62756f034f68), post)=>[
        pre,
        "while(k-->0) {",
        tpl(syms.split(",").map((x)=>`${x}[i${x}+k*s${x}]`)),
        "}",
        post,
        ret !== null ? `return ${ret};` : ""
    ];
const $79c5830c48753a63$export$326bc8646b307e15 = (o, args)=>`!${o} && (${o}=${args.split(",")[1]});`;
const $79c5830c48753a63$export$ef7acd7185315e22 = (dim, tpl, args, syms = args, ret = "a", opJoin, pre, post, strided = false)=>new Function(args, $79c5830c48753a63$var$__assemble(dim, tpl, syms, ret, opJoin, pre, post, strided).join(""));
const $79c5830c48753a63$export$419c6ef64208ae82 = (dim, fns, tpl, hofArgs, args, syms = args, ret = "a", opJoin = "", pre, post, strided = false)=>{
    return new Function(hofArgs, `return (${args})=>{${$79c5830c48753a63$var$__assemble(dim, tpl, syms, ret, opJoin, pre, post, strided).join("")}}`)(...fns);
};
const $79c5830c48753a63$export$aeba7862bf0c66c4 = (tpl, args, syms = args, ret = "a", pre, post, strided = false)=>new Function(args, $79c5830c48753a63$var$__assembleG(tpl, syms, ret, pre, post, strided).join(""));
const $79c5830c48753a63$export$6c4e26942fd16e7 = (tpl, args, syms = args, ret, pre, post)=>new Function(args, $79c5830c48753a63$var$__assembleS(tpl, syms, ret, pre, post).join(""));
const $79c5830c48753a63$export$a0e9b27d920ed100 = (fns, tpl, hofArgs, args, syms = args, ret = "a", pre, post, strided = false)=>new Function(hofArgs, `return (${args})=>{${$79c5830c48753a63$var$__assembleG(tpl, syms, ret, pre, post, strided).join("")}}`)(...fns);
const $79c5830c48753a63$export$e40cf5ce9a490533 = (tpl, args = (0, $a3f4ff62579ed7eb$export$ccd27f3e7091205c), syms, ret = "o", dispatch = 1, pre)=>{
    syms = syms || args;
    pre = pre != null ? pre : $79c5830c48753a63$export$326bc8646b307e15(ret, syms);
    const fn = (0, $c501f434658309bf$export$c37d18c23b2ea60c)(dispatch);
    const $ = (dim)=>fn.add(dim, $79c5830c48753a63$export$ef7acd7185315e22(dim, tpl, args, syms, ret, "", pre));
    fn.default($79c5830c48753a63$export$aeba7862bf0c66c4(tpl, args, syms, ret, pre));
    return [
        fn,
        $(2),
        $(3),
        $(4)
    ];
};
const $79c5830c48753a63$export$a913b214497a4223 = (op)=>$79c5830c48753a63$export$e40cf5ce9a490533((0, $a3f4ff62579ed7eb$export$9092249dcc75f1af)(op), (0, $a3f4ff62579ed7eb$export$19dc841295b49698));
const $79c5830c48753a63$export$baa6c46b014ab275 = (op, tpl, args = (0, $a3f4ff62579ed7eb$export$19dc841295b49698), syms, ret = "o", dispatch = 1, pre)=>{
    const _tpl = tpl || (0, $a3f4ff62579ed7eb$export$9092249dcc75f1af)("op");
    syms = syms || args;
    pre = pre != null ? pre : $79c5830c48753a63$export$326bc8646b307e15(ret, syms);
    const fn = (0, $c501f434658309bf$export$c37d18c23b2ea60c)(dispatch);
    const $ = (dim)=>fn.add(dim, $79c5830c48753a63$export$419c6ef64208ae82(dim, [
            op
        ], _tpl, "op", args, syms, ret, "", pre));
    fn.default($79c5830c48753a63$export$a0e9b27d920ed100([
        op
    ], _tpl, "op", args, syms, ret, pre));
    return [
        fn,
        $(2),
        $(3),
        $(4)
    ];
};
const $79c5830c48753a63$export$503c6222d3c48f54 = (tpl, args = (0, $a3f4ff62579ed7eb$export$ccd27f3e7091205c), idxArgs = (0, $a3f4ff62579ed7eb$export$ff73a40106eb353), syms = (0, $a3f4ff62579ed7eb$export$ccd27f3e7091205c), ret = "o", pre, sizes = [
    2,
    3,
    4
])=>[
        $79c5830c48753a63$export$6c4e26942fd16e7(tpl, `${args},k,${idxArgs}`, syms, ret, pre),
        ...sizes.map((dim)=>$79c5830c48753a63$export$ef7acd7185315e22(dim, tpl, `${args},${idxArgs}`, syms, ret, "", pre != null ? pre : $79c5830c48753a63$export$326bc8646b307e15(ret, syms), "", true))
    ];
const $79c5830c48753a63$export$e2ee6e441c8b1312 = (op, tpl, args = (0, $a3f4ff62579ed7eb$export$ccd27f3e7091205c), idxArgs = (0, $a3f4ff62579ed7eb$export$ff73a40106eb353), syms = (0, $a3f4ff62579ed7eb$export$ccd27f3e7091205c), ret = "o", pre, sizes = [
    2,
    3,
    4
])=>[
        new Function("op", `return (${args},k,${idxArgs})=>{${$79c5830c48753a63$var$__assembleS(tpl, syms, ret, pre).join("")}}`)(op),
        ...sizes.map((dim)=>$79c5830c48753a63$export$419c6ef64208ae82(dim, [
                op
            ], tpl, "op", `${args},${idxArgs}`, syms, ret, "", pre != null ? pre : $79c5830c48753a63$export$326bc8646b307e15(ret, syms), "", true))
    ];
const $79c5830c48753a63$export$5d7f662452a819b3 = (op)=>$79c5830c48753a63$export$e40cf5ce9a490533((0, $a3f4ff62579ed7eb$export$da5c1e34018ecc43)(op));
const $79c5830c48753a63$export$24ecd06eea36a882 = (op)=>$79c5830c48753a63$export$e40cf5ce9a490533((0, $a3f4ff62579ed7eb$export$6ab71ad6f57b0093)(op), (0, $a3f4ff62579ed7eb$export$9e772ae751f37666));
const $79c5830c48753a63$export$b74d4e1014d0409f = (op, signed = false)=>$79c5830c48753a63$export$e40cf5ce9a490533((signed ? (0, $a3f4ff62579ed7eb$export$f160d69d51fe9b08) : (0, $a3f4ff62579ed7eb$export$6a70b64fb8d54a06))(op));
const $79c5830c48753a63$export$e6949cab8a813996 = (op, signed = false)=>$79c5830c48753a63$export$e40cf5ce9a490533((signed ? (0, $a3f4ff62579ed7eb$export$b4ea1049a5419b4f) : (0, $a3f4ff62579ed7eb$export$9de9c213a2a487cd))(op), (0, $a3f4ff62579ed7eb$export$9e772ae751f37666));


const [$3920c9be8d12f64a$export$523c9d3eb3d8d990, $3920c9be8d12f64a$export$b54ddf06b57709b1, $3920c9be8d12f64a$export$1c0ad2738a5ae4b0, $3920c9be8d12f64a$export$1f214a01989f466a] = (0, $79c5830c48753a63$export$24ecd06eea36a882)("*");



const [$4d9e51907a8688c0$export$6747e444d0e25f8e, $4d9e51907a8688c0$export$c8a0e366d15bb712, $4d9e51907a8688c0$export$cb6d410f870ee721, $4d9e51907a8688c0$export$9e7986c53a12814a] = (0, $79c5830c48753a63$export$24ecd06eea36a882)("/");



const [$9864db8839f9aff0$export$6897c284b6f9f4dc, $9864db8839f9aff0$export$eb08a4e6e8934de4, $9864db8839f9aff0$export$2f6df6f9964c34d8, $9864db8839f9aff0$export$2cac2c285d867dd] = (0, $79c5830c48753a63$export$e40cf5ce9a490533)(([o, a])=>`${o}=1/${a};`);




const $3fa47dff646d40f0$export$7e4aa119212bc614 = (x)=>typeof x === "number";


const $98a0a2b1e7a2e447$export$844ec244b1367d54 = (x)=>typeof x === "string";



const $4a444b4abe5f0f2f$export$10a4c2bfc9c71dbd = (0, $60621a7e2196cae1$export$651a6eb01ea522f3)(()=>"illegal argument(s)");
const $4a444b4abe5f0f2f$export$85f6a9f917d452ba = (msg)=>{
    throw new $4a444b4abe5f0f2f$export$10a4c2bfc9c71dbd(msg);
};


const $a2ec0bb3243ca28e$export$6b5c1ceb16d01dc3 = Math.PI;
const $a2ec0bb3243ca28e$export$ad5b0b9ab7d48f58 = $a2ec0bb3243ca28e$export$6b5c1ceb16d01dc3 * 2;
const $a2ec0bb3243ca28e$export$f504979d7e0a75c7 = $a2ec0bb3243ca28e$export$6b5c1ceb16d01dc3 / 2;
const $a2ec0bb3243ca28e$export$b1eb83e43ef0f9f8 = $a2ec0bb3243ca28e$export$6b5c1ceb16d01dc3 / 3;
const $a2ec0bb3243ca28e$export$cfa25d10e00ab635 = $a2ec0bb3243ca28e$export$6b5c1ceb16d01dc3 / 4;
const $a2ec0bb3243ca28e$export$4b53cc5148232136 = $a2ec0bb3243ca28e$export$6b5c1ceb16d01dc3 / 6;
const $a2ec0bb3243ca28e$export$588dca789ffa0fd0 = 1 / $a2ec0bb3243ca28e$export$6b5c1ceb16d01dc3;
const $a2ec0bb3243ca28e$export$3a7bf289cac70393 = 1 / $a2ec0bb3243ca28e$export$ad5b0b9ab7d48f58;
const $a2ec0bb3243ca28e$export$24b096bfbaf849b7 = 1 / $a2ec0bb3243ca28e$export$f504979d7e0a75c7;
const $a2ec0bb3243ca28e$export$460c4029b1a54a2e = $a2ec0bb3243ca28e$export$6b5c1ceb16d01dc3 / 180;
const $a2ec0bb3243ca28e$export$914076c8150813e5 = 180 / $a2ec0bb3243ca28e$export$6b5c1ceb16d01dc3;
const $a2ec0bb3243ca28e$export$ed904dc4011d96f7 = (1 + Math.sqrt(5)) / 2;
const $a2ec0bb3243ca28e$export$3681641e15b6e2c3 = Math.SQRT2;
const $a2ec0bb3243ca28e$export$1b2407b91ae96221 = Math.sqrt(3);
const $a2ec0bb3243ca28e$export$2bfcf97b5c0e010 = $a2ec0bb3243ca28e$export$3681641e15b6e2c3 / 2;
const $a2ec0bb3243ca28e$export$d98365b4d5f896cf = $a2ec0bb3243ca28e$export$1b2407b91ae96221 / 2;
const $a2ec0bb3243ca28e$export$f76cf7896cad0d31 = 1 / 3;
const $a2ec0bb3243ca28e$export$2ff8b3422c5a9edf = 2 / 3;
const $a2ec0bb3243ca28e$export$d7977f56a0faa834 = 1 / 6;
let $a2ec0bb3243ca28e$export$56469a43a57ad8b6 = 1e-6;



const $4d3964704e49b256$export$842a2cf37af977e1 = (a, b)=>a - b * Math.floor(a / b);
const $4d3964704e49b256$export$a57bfe0eb79af278 = (x)=>x - Math.floor(x);
const $4d3964704e49b256$export$1fe87bd59b089f0 = (x)=>x < 0 ? Math.ceil(x) : Math.floor(x);
const $4d3964704e49b256$export$7978a6ddf29f4374 = (x, prec = 1)=>Math.round(x / prec) * prec;
const $4d3964704e49b256$export$b14a5ccef74ecd64 = (x, prec = 1)=>Math.floor(x / prec) * prec;
const $4d3964704e49b256$export$5decc23a0e946e4c = (x, prec = 1)=>Math.ceil(x / prec) * prec;
const $4d3964704e49b256$export$4958c7111439d6cc = (x, eps = (0, $a2ec0bb3243ca28e$export$56469a43a57ad8b6))=>{
    const f = $4d3964704e49b256$export$a57bfe0eb79af278(x);
    return f <= eps || f >= 1 - eps ? Math.round(x) : x;
};


function $4ed1b3506b2ec5f8$export$c7d5ea85f8b34f37(fn, cache = /* @__PURE__ */ Object.create(null)) {
    return (...args)=>{
        const key = JSON.stringify(args);
        if (key !== void 0) return key in cache ? cache[key] : cache[key] = fn.apply(null, args);
        return fn.apply(null, args);
    };
}
function $4ed1b3506b2ec5f8$export$a3f97b6995b6ef5e(fn, cache = /* @__PURE__ */ Object.create(null)) {
    return async (...args)=>{
        const key = JSON.stringify(args);
        if (key !== void 0) return key in cache ? cache[key] : cache[key] = await fn.apply(null, args);
        return await fn.apply(null, args);
    };
}



function $c3953dd333ba541b$export$3647141da7a2bad3(fn, cache = /* @__PURE__ */ Object.create(null)) {
    return (...xs)=>{
        const key = xs.join("-");
        return key in cache ? cache[key] : cache[key] = fn(...xs);
    };
}
function $c3953dd333ba541b$export$65a014ca2a9b2e5e(fn, cache = /* @__PURE__ */ Object.create(null)) {
    return async (...xs)=>{
        const key = xs.join("-");
        return key in cache ? cache[key] : cache[key] = await fn(...xs);
    };
}



const $0b071b47d307b055$export$76d90c956114f2c2 = (0, $c3953dd333ba541b$export$3647141da7a2bad3)((ch, n)=>ch.repeat(n));


const $e5056a5c59c8a501$export$bc3bea8325045070 = (0, $c3953dd333ba541b$export$3647141da7a2bad3)((n, ch = " ")=>{
    const buf = (0, $0b071b47d307b055$export$76d90c956114f2c2)(String(ch), n);
    return (x, len)=>{
        if (x == null) return buf;
        x = x.toString();
        len = len !== void 0 ? len : x.length;
        return len < n ? buf.substring(len) + x : x;
    };
});
const $e5056a5c59c8a501$export$4ef3c22bdc855b90 = $e5056a5c59c8a501$export$bc3bea8325045070(2, "0");
const $e5056a5c59c8a501$export$daec30a5ef5beb6b = $e5056a5c59c8a501$export$bc3bea8325045070(3, "0");
const $e5056a5c59c8a501$export$12b700018201cb9d = $e5056a5c59c8a501$export$bc3bea8325045070(4, "0");


const $83531aacd0ec98c2$export$6b5cd3983e3ee5ab = (0, $4ed1b3506b2ec5f8$export$c7d5ea85f8b34f37)((prec, special = false)=>special ? (x)=>$83531aacd0ec98c2$var$__nanOrInf(x) || x.toFixed(prec) : (x)=>x.toFixed(prec));
const $83531aacd0ec98c2$export$e22069805c35feb2 = (0, $4ed1b3506b2ec5f8$export$c7d5ea85f8b34f37)((width, prec = 3)=>{
    const l = width - prec - 1;
    const pl = Math.pow(10, l);
    const pln = -Math.pow(10, l - 1);
    const pr = Math.pow(10, -(prec - 1));
    const pad = (0, $e5056a5c59c8a501$export$bc3bea8325045070)(width);
    return (x)=>{
        const ax = Math.abs(x);
        return pad($83531aacd0ec98c2$var$__nanOrInf(x) || (x === 0 ? "0" : ax < pr || ax >= pl ? $83531aacd0ec98c2$var$__exp(x, width) : x.toFixed(prec - (x < pln ? 1 : 0))));
    };
});
const $83531aacd0ec98c2$var$__exp = (x, w)=>x.toExponential(Math.max(w - 4 - (Math.log(Math.abs(x)) / Math.LN10 >= 10 ? 2 : 1) - (x < 0 ? 1 : 0), 0));
const $83531aacd0ec98c2$var$__nanOrInf = (x)=>isNaN(x) ? "NaN" : x === Infinity ? "+\u221E" : x === -Infinity ? "-\u221E" : void 0;


const $47e1f5bee596f8ab$export$6074e20ba5c64bef = (0, $4ed1b3506b2ec5f8$export$c7d5ea85f8b34f37)((size, prec = 3, d = ",", pre = "[", post = "]")=>{
    const f = typeof prec === "number" ? (0, $83531aacd0ec98c2$export$6b5cd3983e3ee5ab)(prec) : prec;
    switch(size){
        case 1:
            return (v)=>`${pre}${f(v[0])}${post}`;
        case 2:
            return (v)=>`${pre}${f(v[0])}${d}${f(v[1])}${post}`;
        case 3:
            return (v)=>`${pre}${f(v[0])}${d}${f(v[1])}${d}${f(v[2])}${post}`;
        case 4:
            return (v)=>`${pre}${f(v[0])}${d}${f(v[1])}${d}${f(v[2])}${d}${f(v[3])}${post}`;
        default:
            return (v)=>{
                const res = [];
                for(let i = 0; i < v.length; i++)res.push(f(v[i]));
                return `${pre}${res.join(d)}${post}`;
            };
    }
});


var $ef43b15731fb6a0a$export$c486935b7b0b00f7 = /* @__PURE__ */ ((GLType2)=>{
    GLType2[GLType2["I8"] = 5120] = "I8";
    GLType2[GLType2["U8"] = 5121] = "U8";
    GLType2[GLType2["I16"] = 5122] = "I16";
    GLType2[GLType2["U16"] = 5123] = "U16";
    GLType2[GLType2["I32"] = 5124] = "I32";
    GLType2[GLType2["U32"] = 5125] = "U32";
    GLType2[GLType2["F32"] = 5126] = "F32";
    return GLType2;
})($ef43b15731fb6a0a$export$c486935b7b0b00f7 || {});
const $ef43b15731fb6a0a$export$7e50410e6851a5db = {
    [5120 /* I8 */ ]: "i8",
    [5121 /* U8 */ ]: "u8",
    [5122 /* I16 */ ]: "i16",
    [5123 /* U16 */ ]: "u16",
    [5124 /* I32 */ ]: "i32",
    [5125 /* U32 */ ]: "u32",
    [5126 /* F32 */ ]: "f32"
};
const $ef43b15731fb6a0a$export$ccc3907fb755d361 = {
    i8: 5120 /* I8 */ ,
    u8: 5121 /* U8 */ ,
    u8c: 5121 /* U8 */ ,
    i16: 5122 /* I16 */ ,
    u16: 5123 /* U16 */ ,
    i32: 5124 /* I32 */ ,
    u32: 5125 /* U32 */ ,
    f32: 5126 /* F32 */ ,
    f64: void 0
};
const $ef43b15731fb6a0a$export$77a8a3ec2376cb23 = {
    u8: 1,
    u8c: 1,
    i8: 1,
    u16: 2,
    i16: 2,
    u32: 4,
    i32: 4,
    i64: 8,
    u64: 8,
    f32: 4,
    f64: 8
};
const $ef43b15731fb6a0a$export$4c68bfc8c9124205 = {
    i8: 0,
    u8: 0,
    u8c: 0,
    i16: 1,
    u16: 1,
    i32: 2,
    u32: 2,
    i64: 3,
    u64: 3,
    f32: 2,
    f64: 3
};
const $ef43b15731fb6a0a$export$7f91e23c347e83e3 = {
    f32: Float32Array,
    f64: Float64Array
};
const $ef43b15731fb6a0a$export$62a9a53bce51b47f = {
    i8: Int8Array,
    i16: Int16Array,
    i32: Int32Array
};
const $ef43b15731fb6a0a$export$89dd89c1ab6a21e0 = {
    u8: Uint8Array,
    u8c: Uint8ClampedArray,
    u16: Uint16Array,
    u32: Uint32Array
};
const $ef43b15731fb6a0a$export$20fb4bf8497f343f = {
    i64: BigInt64Array,
    u64: BigUint64Array
};
const $ef43b15731fb6a0a$export$3b381702ed33cf2b = {
    ...$ef43b15731fb6a0a$export$7f91e23c347e83e3,
    ...$ef43b15731fb6a0a$export$62a9a53bce51b47f,
    ...$ef43b15731fb6a0a$export$89dd89c1ab6a21e0
};
const $ef43b15731fb6a0a$export$afc4952745a9c0bc = (type)=>{
    const t = $ef43b15731fb6a0a$export$7e50410e6851a5db[type];
    return t !== void 0 ? t : type;
};
const $ef43b15731fb6a0a$export$44655affa77d94c2 = (type)=>{
    const t = $ef43b15731fb6a0a$export$ccc3907fb755d361[type];
    return t !== void 0 ? t : type;
};
const $ef43b15731fb6a0a$export$49ed6a48804688ff = (...args)=>args.map((x)=>x | 0);
const $ef43b15731fb6a0a$export$30043de3fae42dd1 = (type)=>$ef43b15731fb6a0a$export$77a8a3ec2376cb23[type] || $ef43b15731fb6a0a$export$77a8a3ec2376cb23[$ef43b15731fb6a0a$export$afc4952745a9c0bc(type)];
function $ef43b15731fb6a0a$export$ee441149f193b45a(type, ...args) {
    const ctor = $ef43b15731fb6a0a$export$20fb4bf8497f343f[type];
    return new (ctor || $ef43b15731fb6a0a$export$3b381702ed33cf2b[$ef43b15731fb6a0a$export$afc4952745a9c0bc(type)])(...args);
}
function $ef43b15731fb6a0a$export$8aa2910912d5a0d6(type, data, stride) {
    const $data = Array.isArray(data) ? data : [
        ...data
    ];
    if (stride === void 0) stride = $data[0].length;
    const num = $data.length;
    const res = $ef43b15731fb6a0a$export$ee441149f193b45a(type, num * stride);
    for(let i = 0, j = 0; i < num; i++, j += stride)res.set($data[i], j);
    return res;
}
const $ef43b15731fb6a0a$export$3c3c83d33ac519a3 = (x)=>{
    if (Array.isArray(x)) return "f64";
    for(let id in $ef43b15731fb6a0a$export$3b381702ed33cf2b){
        if (x instanceof $ef43b15731fb6a0a$export$3b381702ed33cf2b[id]) return id;
    }
    return "f64";
};
const $ef43b15731fb6a0a$export$1ef41013d4af1773 = (x)=>x <= 256 ? "u8" : x <= 65536 ? "u16" : "u32";
const $ef43b15731fb6a0a$export$32d1ef3a1ec2b22 = (x)=>x >= -128 && x < 128 ? "i8" : x >= -32768 && x < 32768 ? "i16" : "i32";
const $ef43b15731fb6a0a$export$febce5e071c36869 = (x)=>x > 16 ? "u32" : x > 8 ? "u16" : "u8";
const $ef43b15731fb6a0a$export$71cc2d6d50aeb7db = (x)=>x > 16 ? "i32" : x > 8 ? "i16" : "i8";
const $ef43b15731fb6a0a$export$5bf18276ad35cd3e = (t)=>t === "i64" ? "i32" : t === "i32" ? "i16" : t === "i16" ? "i8" : "i8";
const $ef43b15731fb6a0a$export$4f99611726c808da = (t)=>t === "i8" ? "i16" : t === "i16" ? "i32" : t === "i32" ? "i64" : "i64";
const $ef43b15731fb6a0a$export$8e455a4b51a8bb3f = (t)=>t === "u64" ? "u32" : t === "u32" ? "u16" : t === "u16" ? "u8" : "u8";
const $ef43b15731fb6a0a$export$1fad4022ed34f5c9 = (t)=>t === "u8" || t === "u8c" ? "u16" : t === "u16" ? "u32" : t === "u32" ? "u64" : "u64";
const $ef43b15731fb6a0a$export$45ae02d96eef78a7 = (t)=>t === "f64" ? "f32" : "f32";
const $ef43b15731fb6a0a$export$aa2b6251594b2509 = (t)=>t === "f32" ? "f64" : "f64";
const $ef43b15731fb6a0a$export$d3dad6665afedd1 = (t)=>t[0] === "i" ? $ef43b15731fb6a0a$export$5bf18276ad35cd3e(t) : t[0] === "u" ? $ef43b15731fb6a0a$export$8e455a4b51a8bb3f(t) : $ef43b15731fb6a0a$export$45ae02d96eef78a7(t);
const $ef43b15731fb6a0a$export$719ac81e6c2c015 = (t)=>t[0] === "i" ? $ef43b15731fb6a0a$export$4f99611726c808da(t) : t[0] === "u" ? $ef43b15731fb6a0a$export$1fad4022ed34f5c9(t) : $ef43b15731fb6a0a$export$aa2b6251594b2509(t);


const $db79a8db643979a1$export$9b6f948535b77d53 = (type, buf, num, size, byteOffset = 0, byteStride = size * (0, $ef43b15731fb6a0a$export$77a8a3ec2376cb23)[type])=>{
    const res = [];
    for(; num-- > 0; byteOffset += byteStride)res.push((0, $ef43b15731fb6a0a$export$ee441149f193b45a)(type, buf, byteOffset, size));
    return res;
};
const $db79a8db643979a1$export$90b90ea32db1a99a = (type, buf, src, byteOffset, byteStride)=>{
    const view = (0, $ef43b15731fb6a0a$export$ee441149f193b45a)(type, buf);
    const size = (0, $ef43b15731fb6a0a$export$77a8a3ec2376cb23)[type];
    byteOffset /= size;
    byteStride /= size;
    for (let x of src){
        view.set(x, byteOffset);
        byteOffset += byteStride;
    }
};
const $db79a8db643979a1$export$e9242f670cb20645 = (ctor, buf, num, start, cstride, estride)=>{
    const res = [];
    while(num-- > 0){
        res.push(new ctor(buf, start, cstride));
        start += estride;
    }
    return res;
};
const $db79a8db643979a1$export$1d55c56b05a9e712 = (set, buf, src, start, cstride, estride)=>{
    for (let v of src){
        set(buf, v, start, 0, cstride, 1);
        start += estride;
    }
    return buf;
};


const $6fbc282bb2566ed8$export$7d15b64cf5a3a4c4 = (x, min, max)=>x < min ? min : x > max ? max : x;
const $6fbc282bb2566ed8$export$ed542a978b878ee8 = (x)=>x > 0 ? x : 0;
const $6fbc282bb2566ed8$export$5c5ee632c52bc4a2 = (x)=>x < 0 ? 0 : x > 1 ? 1 : x;
const $6fbc282bb2566ed8$export$2cacbc8823b89e46 = (x)=>x < -1 ? -1 : x > 1 ? 1 : x;
const $6fbc282bb2566ed8$export$b45a0c02a3a6bd55 = (x)=>x < 0 ? 0 : x > 0.5 ? 0.5 : x;
const $6fbc282bb2566ed8$export$6fb785c609d82593 = (x, y)=>x < y ? [
        x,
        y
    ] : [
        y,
        x
    ];
const $6fbc282bb2566ed8$export$4997ffc0176396a6 = (x, min, max)=>{
    if (min === max) return min;
    if (x > max) {
        const d = max - min;
        x -= d;
        if (x > max) x -= d * ((x - min) / d | 0);
    } else if (x < min) {
        const d = max - min;
        x += d;
        if (x < min) x += d * ((min - x) / d + 1 | 0);
    }
    return x;
};
const $6fbc282bb2566ed8$export$a7a8c8bedec7ce92 = (x, min, max)=>x < min ? x - min + max : x > max ? x - max + min : x;
const $6fbc282bb2566ed8$export$69033939f8eff985 = (x)=>x < 0 ? x + 1 : x > 1 ? x - 1 : x;
const $6fbc282bb2566ed8$export$3b9374f2e8d1b471 = (x)=>x < -1 ? x + 2 : x > 1 ? x - 2 : x;
const $6fbc282bb2566ed8$export$412b6e2a7fbdce18 = (a, b)=>a <= b ? 0 : 1;
const $6fbc282bb2566ed8$export$5c7e4265f4166803 = (a, b, c)=>a <= b ? a <= c ? 0 : 2 : b <= c ? 1 : 2;
const $6fbc282bb2566ed8$export$abbc992e2f7a03ed = (a, b, c, d)=>a <= b ? a <= c ? a <= d ? 0 : 3 : c <= d ? 2 : 3 : b <= c ? b <= d ? 1 : 3 : c <= d ? 2 : 3;
const $6fbc282bb2566ed8$export$2e1916403c690d8e = (a, b)=>a >= b ? 0 : 1;
const $6fbc282bb2566ed8$export$530accaa463743fc = (a, b, c)=>a >= b ? a >= c ? 0 : 2 : b >= c ? 1 : 2;
const $6fbc282bb2566ed8$export$997ba4008db6478c = (a, b, c, d)=>a >= b ? a >= c ? a >= d ? 0 : 3 : c >= d ? 2 : 3 : b >= c ? b >= d ? 1 : 3 : c >= d ? 2 : 3;
const $6fbc282bb2566ed8$export$f77ef1d37ede6ae4 = (a, b)=>a !== 0 ? b !== 0 ? Math.min(a, b) : a : b;
const $6fbc282bb2566ed8$export$f930aa2517ecab05 = (a, b, c)=>$6fbc282bb2566ed8$export$f77ef1d37ede6ae4($6fbc282bb2566ed8$export$f77ef1d37ede6ae4(a, b), c);
const $6fbc282bb2566ed8$export$c64430f6ae3a9584 = (a, b, k)=>$6fbc282bb2566ed8$export$ae3040c47ea664a9(a, b, -k);
const $6fbc282bb2566ed8$export$ae3040c47ea664a9 = (a, b, k)=>{
    const ea = Math.exp(a * k);
    const eb = Math.exp(b * k);
    return (a * ea + b * eb) / (ea + eb);
};
const $6fbc282bb2566ed8$export$467571aff7e617ce = (x, min, max, k)=>$6fbc282bb2566ed8$export$c64430f6ae3a9584($6fbc282bb2566ed8$export$ae3040c47ea664a9(x, min, k), max, k);
const $6fbc282bb2566ed8$export$1f6feacb0939c1e9 = (a, b)=>Math.abs(a) < Math.abs(b) ? a : b;
const $6fbc282bb2566ed8$export$bb8a7d60274b5fc6 = (a, b)=>Math.abs(a) > Math.abs(b) ? a : b;
const $6fbc282bb2566ed8$export$f6826ccc4238a19 = (e, x)=>x < -e || x > e ? Math.abs(Math.abs((x - e) % (4 * e)) - 2 * e) - e : x;
const $6fbc282bb2566ed8$export$3d9f3a2fc40f5212 = (x)=>(x = Math.abs(x) % 2) > 1 ? 2 - x : x;
const $6fbc282bb2566ed8$export$ddf89a9c5af38f94 = (x, min, max)=>x >= min && x <= max;
const $6fbc282bb2566ed8$export$cc91a22e8d440ab2 = (x, min, max)=>x > min && x < max;



const $176ac089df32114b$export$c37d18c23b2ea60c = (dispatch = 1, fallback, ...optimized)=>{
    const impls = [
        ,
        , 
    ].concat(optimized);
    const fn = (...args)=>{
        const g = impls[args[dispatch].length] || fallback;
        return g ? g(...args) : (0, $7047b0fefb1d1180$export$98e633703a635f)(`no impl for vec size ${args[dispatch].length}`);
    };
    fn.add = (dim, fn2)=>impls[dim] = fn2;
    fn.default = (fn2)=>fallback = fn2;
    fn.impl = (dim)=>dim != null ? impls[dim] || fallback : fallback;
    return fn;
};


const $8d5e29c9cdc2a2fb$export$7cbc24fe51cbc1cb = (op, dispatch = 1, outA = true)=>{
    const a = outA ? (o, a2, b2, c2)=>{
        !o && (o = a2);
        for(let i = a2.length; i-- > 0;)o[i] = op(a2[i], b2[i], c2[i]);
        return o;
    } : (o, a2, b2, c2)=>{
        !o && (o = c2);
        for(let i = a2.length; i-- > 0;)o[i] = op(a2[i], b2[i], c2[i]);
        return o;
    };
    const b = outA ? (o, a2, b2, c2)=>{
        !o && (o = a2);
        o[0] = op(a2[0], b2[0], c2[0]);
        o[1] = op(a2[1], b2[1], c2[1]);
        return o;
    } : (o, a2, b2, c2)=>{
        !o && (o = c2);
        o[0] = op(a2[0], b2[0], c2[0]);
        o[1] = op(a2[1], b2[1], c2[1]);
        return o;
    };
    const c = outA ? (o, a2, b2, c2)=>{
        !o && (o = a2);
        o[0] = op(a2[0], b2[0], c2[0]);
        o[1] = op(a2[1], b2[1], c2[1]);
        o[2] = op(a2[2], b2[2], c2[2]);
        return o;
    } : (o, a2, b2, c2)=>{
        !o && (o = c2);
        o[0] = op(a2[0], b2[0], c2[0]);
        o[1] = op(a2[1], b2[1], c2[1]);
        o[2] = op(a2[2], b2[2], c2[2]);
        return o;
    };
    const d = outA ? (o, a2, b2, c2)=>{
        !o && (o = a2);
        o[0] = op(a2[0], b2[0], c2[0]);
        o[1] = op(a2[1], b2[1], c2[1]);
        o[2] = op(a2[2], b2[2], c2[2]);
        o[3] = op(a2[3], b2[3], c2[3]);
        return o;
    } : (o, a2, b2, c2)=>{
        !o && (o = c2);
        o[0] = op(a2[0], b2[0], c2[0]);
        o[1] = op(a2[1], b2[1], c2[1]);
        o[2] = op(a2[2], b2[2], c2[2]);
        o[3] = op(a2[3], b2[3], c2[3]);
        return o;
    };
    return [
        (0, $176ac089df32114b$export$c37d18c23b2ea60c)(dispatch, a, b, c, d),
        b,
        c,
        d
    ];
};


const [$6b941f0f0b9965ff$var$a, $6b941f0f0b9965ff$var$b, $6b941f0f0b9965ff$var$c, $6b941f0f0b9965ff$var$d] = (0, $8d5e29c9cdc2a2fb$export$7cbc24fe51cbc1cb)((0, $6fbc282bb2566ed8$export$7d15b64cf5a3a4c4));
const $6b941f0f0b9965ff$export$7d15b64cf5a3a4c4 = $6b941f0f0b9965ff$var$a;
const $6b941f0f0b9965ff$export$c3896cfb8a4e845c = $6b941f0f0b9965ff$var$b;
const $6b941f0f0b9965ff$export$c81ba8bb5d49ce82 = $6b941f0f0b9965ff$var$c;
const $6b941f0f0b9965ff$export$4cfdf484c27efa43 = $6b941f0f0b9965ff$var$d;


const $d08c29b2a90a41b3$export$beea375bf3818f1d = (proto, id, idx, strided = true, defNumeric = true)=>{
    const get = idx > 0 ? strided ? function() {
        return this.buf[this.offset + idx * this.stride];
    } : function() {
        return this.buf[this.offset + idx];
    } : function() {
        return this.buf[this.offset];
    };
    const set = idx > 0 ? strided ? function(n) {
        this.buf[this.offset + idx * this.stride] = n;
    } : function(n) {
        this.buf[this.offset + idx] = n;
    } : function(n) {
        this.buf[this.offset] = n;
    };
    defNumeric && Object.defineProperty(proto, idx, {
        get: get,
        set: set,
        enumerable: true
    });
    Object.defineProperty(proto, id, {
        get: get,
        set: set,
        enumerable: true
    });
};
const $d08c29b2a90a41b3$export$372fdd3dd278cc1c = (proto, props, strided, defNumeric)=>props.forEach((id, i)=>$d08c29b2a90a41b3$export$beea375bf3818f1d(proto, id, i, strided, defNumeric));




const $3284357e3f3c1ae1$var$abs = Math.abs;
const $3284357e3f3c1ae1$var$max = Math.max;
const $3284357e3f3c1ae1$export$3e1b8005eb6f3d68 = (a, b, eps = (0, $a2ec0bb3243ca28e$export$56469a43a57ad8b6))=>$3284357e3f3c1ae1$var$abs(a - b) <= eps;
const $3284357e3f3c1ae1$export$9dc0cc51b6ffc288 = (a, b, eps = (0, $a2ec0bb3243ca28e$export$56469a43a57ad8b6))=>$3284357e3f3c1ae1$var$abs(a - b) <= eps * $3284357e3f3c1ae1$var$max(1, $3284357e3f3c1ae1$var$abs(a), $3284357e3f3c1ae1$var$abs(b));




const $5db2d16f863dd08e$export$c63d26dbbb7a5033 = (a, b, eps = (0, $a2ec0bb3243ca28e$export$56469a43a57ad8b6))=>{
    return a.length === b.length && (0, $3284357e3f3c1ae1$export$3e1b8005eb6f3d68)(a[0], b[0], eps) && (0, $3284357e3f3c1ae1$export$3e1b8005eb6f3d68)(a[1], b[1], eps);
};
const $5db2d16f863dd08e$export$819cb4b1ecd374c5 = (a, b, eps = (0, $a2ec0bb3243ca28e$export$56469a43a57ad8b6))=>{
    return a.length === b.length && (0, $3284357e3f3c1ae1$export$3e1b8005eb6f3d68)(a[0], b[0], eps) && (0, $3284357e3f3c1ae1$export$3e1b8005eb6f3d68)(a[1], b[1], eps) && (0, $3284357e3f3c1ae1$export$3e1b8005eb6f3d68)(a[2], b[2], eps);
};
const $5db2d16f863dd08e$export$215c4845217d5cf1 = (a, b, eps = (0, $a2ec0bb3243ca28e$export$56469a43a57ad8b6))=>{
    return a.length === b.length && (0, $3284357e3f3c1ae1$export$3e1b8005eb6f3d68)(a[0], b[0], eps) && (0, $3284357e3f3c1ae1$export$3e1b8005eb6f3d68)(a[1], b[1], eps) && (0, $3284357e3f3c1ae1$export$3e1b8005eb6f3d68)(a[2], b[2], eps) && (0, $3284357e3f3c1ae1$export$3e1b8005eb6f3d68)(a[3], b[3], eps);
};
const $5db2d16f863dd08e$export$3e1b8005eb6f3d68 = (0, $176ac089df32114b$export$c37d18c23b2ea60c)(0, (v1, v2, eps = (0, $a2ec0bb3243ca28e$export$56469a43a57ad8b6))=>{
    if ((0, $b4429ed4e1faf6b1$export$c915e14294a7d06f)(v1, "eqDelta")) return v1.eqDelta(v2, eps);
    if ((0, $b4429ed4e1faf6b1$export$c915e14294a7d06f)(v2, "eqDelta")) return v2.eqDelta(v1, eps);
    return $5db2d16f863dd08e$export$75f4a8c48213224e(v1, v2, v1.length, eps);
}, $5db2d16f863dd08e$export$c63d26dbbb7a5033, $5db2d16f863dd08e$export$819cb4b1ecd374c5, $5db2d16f863dd08e$export$215c4845217d5cf1);
const $5db2d16f863dd08e$export$75f4a8c48213224e = (a, b, n, eps = (0, $a2ec0bb3243ca28e$export$56469a43a57ad8b6), ia = 0, ib = 0, sa = 1, sb = 1)=>{
    for(; n > 0; n--, ia += sa, ib += sb){
        if (!(0, $3284357e3f3c1ae1$export$3e1b8005eb6f3d68)(a[ia], b[ib], eps)) return false;
    }
    return true;
};
const $5db2d16f863dd08e$export$ae8a06ab824e4b05 = (a, b, eps = (0, $a2ec0bb3243ca28e$export$56469a43a57ad8b6))=>{
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for(let i = a.length; i-- > 0;){
        if (!$5db2d16f863dd08e$export$3e1b8005eb6f3d68(a[i], b[i], eps)) return false;
    }
    return true;
};
const $5db2d16f863dd08e$export$5e9bb4359042e24b = (p, pts, eps = (0, $a2ec0bb3243ca28e$export$56469a43a57ad8b6))=>{
    for(let i = pts.length; i-- > 0;){
        if ($5db2d16f863dd08e$export$3e1b8005eb6f3d68(p, pts[i], eps)) return true;
    }
    return false;
};


function* $9e7975b49bbe8ffd$export$b67c4b3d8ab4ccaf(ctor, buf, num, start, cstride, estride) {
    while(num-- > 0){
        yield new ctor(buf, start, cstride);
        start += estride;
    }
}
function* $9e7975b49bbe8ffd$export$de7c8d5f4bf654ca(buf, num, start, stride) {
    while(num-- > 0){
        yield buf[start];
        start += stride;
    }
}



const $fc7a0f972c2d34e4$var$INV_MAX = 1 / 2 ** 32;
class $fc7a0f972c2d34e4$export$d768fa07cecd88a {
    float(norm = 1) {
        return this.int() * $fc7a0f972c2d34e4$var$INV_MAX * norm;
    }
    probability(p) {
        return this.float() < p;
    }
    norm(norm = 1) {
        return (this.int() * $fc7a0f972c2d34e4$var$INV_MAX - 0.5) * 2 * norm;
    }
    normMinMax(min, max) {
        const x = this.minmax(min, max);
        return this.float() < 0.5 ? x : -x;
    }
    minmax(min, max) {
        return this.float() * (max - min) + min;
    }
    minmaxInt(min, max) {
        min |= 0;
        const range = (max | 0) - min;
        return range ? min + this.int() % range : min;
    }
    minmaxUint(min, max) {
        min >>>= 0;
        const range = (max >>> 0) - min;
        return range ? min + this.int() % range : min;
    }
}


class $0f408e5553254a76$export$1559ae9702bee384 extends (0, $fc7a0f972c2d34e4$export$d768fa07cecd88a) {
    constructor(rnd){
        super();
        this.rnd = rnd;
    }
    float(norm = 1) {
        return this.rnd() * norm;
    }
    norm(norm = 1) {
        return (this.rnd() - 0.5) * 2 * norm;
    }
    int() {
        return this.rnd() * 4294967296 >>> 0;
    }
}


const $b32334d124fee32c$export$52653a075d3f70dc = new (0, $0f408e5553254a76$export$1559ae9702bee384)(Math.random);



const $9c48d435d9d3b7f1$export$62aaebd2a7b17b1f = (o, a, b, rnd = (0, $b32334d124fee32c$export$52653a075d3f70dc))=>{
    !o && (o = a);
    o[0] = rnd.minmax(a[0], b[0]);
    o[1] = rnd.minmax(a[1], b[1]);
    return o;
};
const $9c48d435d9d3b7f1$export$31e07d78cb78bebb = (o, a, b, rnd = (0, $b32334d124fee32c$export$52653a075d3f70dc))=>{
    !o && (o = a);
    o[0] = rnd.minmax(a[0], b[0]);
    o[1] = rnd.minmax(a[1], b[1]);
    o[2] = rnd.minmax(a[2], b[2]);
    return o;
};
const $9c48d435d9d3b7f1$export$8027d34b10b79e76 = (o, a, b, rnd = (0, $b32334d124fee32c$export$52653a075d3f70dc))=>{
    !o && (o = a);
    o[0] = rnd.minmax(a[0], b[0]);
    o[1] = rnd.minmax(a[1], b[1]);
    o[2] = rnd.minmax(a[2], b[2]);
    o[3] = rnd.minmax(a[3], b[3]);
    return o;
};
const $9c48d435d9d3b7f1$export$a3bd1ea0f114ec36 = (0, $176ac089df32114b$export$c37d18c23b2ea60c)(1, (o, a, b, rnd = (0, $b32334d124fee32c$export$52653a075d3f70dc))=>{
    !o && (o = a);
    for(let i = a.length; i-- > 0;)o[i] = rnd.minmax(a[i], b[i]);
    return o;
});



const $f164dd17dabc2b83$export$55640438a4edf3d6 = (o, a)=>{
    !o && (o = []);
    o[0] = a[0];
    o[1] = a[1];
    return o;
};
const $f164dd17dabc2b83$export$9cbac02f28c9a9a9 = (o, a)=>{
    !o && (o = []);
    o[0] = a[0];
    o[1] = a[1];
    o[2] = a[2];
    return o;
};
const $f164dd17dabc2b83$export$a7c139a4194832bf = (o, a)=>{
    !o && (o = []);
    o[0] = a[0];
    o[1] = a[1];
    o[2] = a[2];
    o[3] = a[3];
    return o;
};
const $f164dd17dabc2b83$export$adaa4cf7ef1b65be = (0, $176ac089df32114b$export$c37d18c23b2ea60c)(1, (o, a)=>{
    !o && (o = []);
    for(let i = a.length; i-- > 0;)o[i] = a[i];
    return o;
}, $f164dd17dabc2b83$export$55640438a4edf3d6, $f164dd17dabc2b83$export$9cbac02f28c9a9a9, $f164dd17dabc2b83$export$a7c139a4194832bf);


const $e2f48c8a69497fe5$export$43bee75e5e14138e = Array.isArray;



var $66a7ab958e547697$import_meta = Object.assign(Object.create(null), {
    url: "file:///.yarn/cache/@thi.ng-errors-npm-2.5.34-3cc7cfbba1-19e4711ebe.zip/node_modules/@thi.ng/errors/assert.js"
});
var $0051ec4c8593a041$exports = {};
"use strict";


const $66a7ab958e547697$export$7750cdfb4db2c3d = (0, $60621a7e2196cae1$export$651a6eb01ea522f3)(()=>"Assertion failed");
const $66a7ab958e547697$export$a7a9523472993e97 = (typeof $0051ec4c8593a041$exports !== "undefined" && $0051ec4c8593a041$exports.env !== void 0 ? false : $66a7ab958e547697$import_meta.env ? $66a7ab958e547697$import_meta.env.MODE !== "production" || !!$66a7ab958e547697$import_meta.env.UMBRELLA_ASSERTS || !!$66a7ab958e547697$import_meta.env.VITE_UMBRELLA_ASSERTS : true) ? (test, msg)=>{
    if (typeof test === "function" && !test() || !test) throw new $66a7ab958e547697$export$7750cdfb4db2c3d(typeof msg === "function" ? msg() : msg);
} : ()=>{};



const $8f2988c0c6d4a536$export$5ffd082a0121a803 = {};
const $8f2988c0c6d4a536$export$b07aeb3c205b1fa7 = (mode, spec)=>{
    for(let id in spec){
        const val = spec[id];
        if ((0, $e2f48c8a69497fe5$export$43bee75e5e14138e)(val)) {
            const [a, b, c, d] = val;
            spec[id] = val.length === 2 ? (out, src)=>b(out, a(out, src)) : val.length === 3 ? (out, src)=>c(out, b(out, a(out, src))) : (out, src)=>d(out, c(out, b(out, a(out, src))));
        }
    }
    $8f2988c0c6d4a536$export$5ffd082a0121a803[mode] = {
        ...$8f2988c0c6d4a536$export$5ffd082a0121a803[mode],
        ...spec
    };
};
const $8f2988c0c6d4a536$export$9c68d69a4c5bbcf9 = (res, src, destMode, srcMode)=>{
    const spec = $8f2988c0c6d4a536$export$5ffd082a0121a803[destMode];
    (0, $66a7ab958e547697$export$a7a9523472993e97)(!!spec, `no conversions available for ${destMode}`);
    let $convert = spec[srcMode];
    return $convert ? $convert(res, src) : $8f2988c0c6d4a536$export$5ffd082a0121a803.rgb[srcMode] ? spec.rgb(res, $8f2988c0c6d4a536$export$5ffd082a0121a803.rgb[srcMode]([], src)) : (0, $7047b0fefb1d1180$export$98e633703a635f)(`can't convert: ${srcMode} -> ${destMode}`);
};


const $d321c2e7df9899b2$export$c5ff7c6cb12f5f46 = (x, n)=>(x << n | x >>> 32 - n) >>> 0;
const $d321c2e7df9899b2$export$b8ff662d454dbe46 = (x, n)=>(x >>> n | x << 32 - n) >>> 0;
const $d321c2e7df9899b2$export$f4b5465a1b117e52 = (x, n)=>n < 0 ? x << -n : x >>> n;


const $403765199d99fbe2$export$a6766c04eb5e4cc = (x)=>(x & 15) * 1118481;
const $403765199d99fbe2$export$184a3b3082834f83 = (x)=>(x & 15) * 286331153 >>> 0;
const $403765199d99fbe2$export$f4778deed24a996a = (x)=>(x & 255) * 65793;
const $403765199d99fbe2$export$6b434761b7a49cd6 = (x)=>(x & 255) * 16843009 >>> 0;
const $403765199d99fbe2$export$ae0bbf0f5cd52687 = (x)=>(x &= 65535, (x << 16 | x) >>> 0);
const $403765199d99fbe2$export$c525ac6623c954b0 = (x)=>(x >> 4 & 15) === (x & 15);
const $403765199d99fbe2$export$6af7a6e6a8f2df37 = (x)=>(x >> 8 & 255) === (x & 255);
const $403765199d99fbe2$export$dd24dc7e49b6b0eb = (x)=>(x & 3840) * 4352 | (x & 240) * 272 | (x & 15) * 17;
const $403765199d99fbe2$export$aea914411a6b4fb = (x)=>((x & 61440) * 69632 | (x & 3840) * 4352 | (x & 240) * 272 | (x & 15) * 17) >>> 0;









var $dad655db0acd665e$export$3e22a96a58989a47 = /* @__PURE__ */ ((Hue2)=>{
    Hue2[Hue2["RED"] = 0] = "RED";
    Hue2[Hue2["ORANGE"] = 1] = "ORANGE";
    Hue2[Hue2["YELLOW"] = 2] = "YELLOW";
    Hue2[Hue2["CHARTREUSE"] = 3] = "CHARTREUSE";
    Hue2[Hue2["GREEN"] = 4] = "GREEN";
    Hue2[Hue2["SPRING_GREEN"] = 5] = "SPRING_GREEN";
    Hue2[Hue2["CYAN"] = 6] = "CYAN";
    Hue2[Hue2["AZURE"] = 7] = "AZURE";
    Hue2[Hue2["BLUE"] = 8] = "BLUE";
    Hue2[Hue2["VIOLET"] = 9] = "VIOLET";
    Hue2[Hue2["MAGENTA"] = 10] = "MAGENTA";
    Hue2[Hue2["ROSE"] = 11] = "ROSE";
    return Hue2;
})($dad655db0acd665e$export$3e22a96a58989a47 || {});
class $dad655db0acd665e$export$f0e1837cf5c5bd36 {
    constructor(mode, value){
        this.mode = mode;
        this.value = value;
    }
    deref() {
        return this.value;
    }
}



const $248215317c303c9d$export$626336c2cd4b14de = (prec = 0)=>(x)=>(x * 100).toFixed(prec) + "%";


const $fa10cec494bd22e3$export$7a91b0fde7ec420f = Object.freeze([
    0,
    0,
    0,
    1
]);
const $fa10cec494bd22e3$export$29814851e0aa981f = Object.freeze([
    1,
    1,
    1,
    1
]);
const $fa10cec494bd22e3$export$aa201224bb439d47 = Object.freeze([
    1,
    0,
    0,
    1
]);
const $fa10cec494bd22e3$export$48d4b2cd5bc0e88b = Object.freeze([
    0,
    1,
    0,
    1
]);
const $fa10cec494bd22e3$export$738c3b9a44c87ecc = Object.freeze([
    0,
    0,
    1,
    1
]);
const $fa10cec494bd22e3$export$ee66ffc32b0b6a4b = Object.freeze([
    0,
    1,
    1,
    1
]);
const $fa10cec494bd22e3$export$8dd3b5a10b3b5fb0 = Object.freeze([
    1,
    0,
    1,
    1
]);
const $fa10cec494bd22e3$export$aab610c505c06a8f = Object.freeze([
    1,
    1,
    0,
    1
]);
const $fa10cec494bd22e3$export$618666431255d9df = [
    0.299,
    0.587,
    0.114
];
const $fa10cec494bd22e3$export$1a74005704ec0a02 = [
    0.2126,
    0.7152,
    0.0722
];
const $fa10cec494bd22e3$export$632e1bca6409b85c = [
    0.2627,
    0.678,
    0.0593
];
const $fa10cec494bd22e3$export$1b6b94cf37eb4b2f = [
    0.4360747,
    0.2225045,
    0.0139322,
    0.3850649,
    0.7168786,
    0.0971045,
    0.1430804,
    0.0606169,
    0.7141733
];
const $fa10cec494bd22e3$export$5bd959522fbb33fb = [
    3.1338561,
    -0.9787684,
    0.0719453,
    -1.6168667,
    1.9161415,
    -0.2289914,
    -0.4906146,
    0.033454,
    1.4052427
];
const $fa10cec494bd22e3$export$c462ec25d0e68dd8 = [
    0.4124564,
    0.2126729,
    0.0193339,
    0.3575761,
    0.7151522,
    0.119192,
    0.1804375,
    0.072175,
    0.9503041
];
const $fa10cec494bd22e3$export$68ca3d30fbda6075 = [
    3.2404542,
    -0.969266,
    0.0556434,
    -1.5371385,
    1.8760108,
    -0.2040259,
    -0.4985314,
    0.041556,
    1.0572252
];
const $fa10cec494bd22e3$export$1df56a526beedddf = [
    0.9555766,
    -0.0282895,
    0.0122982,
    -0.0230393,
    1.0099416,
    -0.020483,
    0.0631636,
    0.0210077,
    1.3299098
];
const $fa10cec494bd22e3$export$8e8b1dc9dd613fe0 = [
    1.0478112,
    0.0295424,
    -0.0092345,
    0.0228866,
    0.9904844,
    0.0150436,
    -0.050127,
    -0.0170491,
    0.7521316
];
const $fa10cec494bd22e3$export$eea70998d27a3f6e = [
    0.96422,
    1,
    0.82521
];
const $fa10cec494bd22e3$export$5c2abc406650e66e = [
    0.95047,
    1,
    1.08883
];
const $fa10cec494bd22e3$export$1f798654269ffd36 = [
    0.8189330101,
    0.0329845436,
    0.0482003018,
    0.3618667424,
    0.9293118715,
    0.2643662691,
    -0.1288597137,
    0.0361456387,
    0.633851707
];
const $fa10cec494bd22e3$export$c5727582d592af1 = [
    0.2104542553,
    1.9779984951,
    0.0259040371,
    0.793617785,
    -2.428592205,
    0.7827717662,
    -0.0040720468,
    0.4505937099,
    -0.808675766
];
let $fa10cec494bd22e3$export$7c02aa34d7a477ed = (0, $83531aacd0ec98c2$export$6b5cd3983e3ee5ab)(3);
let $fa10cec494bd22e3$export$ad91c6f2dc8f3b45 = (0, $248215317c303c9d$export$626336c2cd4b14de)(3);
const $fa10cec494bd22e3$export$c4b85a3b3361e135 = (x)=>{
    $fa10cec494bd22e3$export$7c02aa34d7a477ed = (0, $83531aacd0ec98c2$export$6b5cd3983e3ee5ab)(x);
    $fa10cec494bd22e3$export$ad91c6f2dc8f3b45 = (0, $248215317c303c9d$export$626336c2cd4b14de)(x);
};
const $fa10cec494bd22e3$export$e3eaf67d84630857 = 1 / 255;
const $fa10cec494bd22e3$export$56469a43a57ad8b6 = 1 / 256;


const $0295c010744b4ded$export$f36c8c226353f2dd = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    grey: "808080",
    green: "008000",
    greenyellow: "adff2f",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32",
    // additions
    transparent: "0000",
    rebeccapurple: "639"
};


let $dfc490e5513203b4$export$80420cae396846ed = {
    canvas: "fff",
    canvastext: "000",
    linktext: "001ee4",
    visitedtext: "4e2386",
    activetext: "eb3323",
    buttonface: "ddd",
    buttontext: "000",
    buttonborder: "000",
    field: "fff",
    fieldtext: "000",
    highlight: "bbd5fb",
    highlighttext: "000",
    mark: "000",
    marktext: "fff",
    graytext: "808080"
};
const $dfc490e5513203b4$export$2b03bcdd45faed66 = (cols)=>Object.assign($dfc490e5513203b4$export$80420cae396846ed, cols);


const $149947dd2be6e525$export$644e79245f7d24b5 = (out, ...values)=>{
    if (!out) return values;
    for(let i = values.length; i-- > 0;)out[i] = values[i];
    return out;
};
const $149947dd2be6e525$export$dcfbb7940cfb3a48 = (out, x, y)=>{
    !out && (out = []);
    out[0] = x;
    out[1] = y;
    return out;
};
const $149947dd2be6e525$export$ba8c70ce75474f8d = (out, x, y, z)=>{
    !out && (out = []);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
};
const $149947dd2be6e525$export$abee0037e1db715 = (out, x, y, z, w)=>{
    !out && (out = []);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
};
const $149947dd2be6e525$export$d58a46c754825a51 = (out, a, b, c, d, e, f)=>{
    !out && (out = []);
    out[0] = a;
    out[1] = b;
    out[2] = c;
    out[3] = d;
    out[4] = e;
    out[5] = f;
    return out;
};



const $08c29446d85a76d8$export$b9b70ffa6eb909fa = (out, src)=>(0, $149947dd2be6e525$export$abee0037e1db715)(out || [], (src >>> 16 & 255) * (0, $fa10cec494bd22e3$export$e3eaf67d84630857), (src >>> 8 & 255) * (0, $fa10cec494bd22e3$export$e3eaf67d84630857), (src & 255) * (0, $fa10cec494bd22e3$export$e3eaf67d84630857), (src >>> 24) * (0, $fa10cec494bd22e3$export$e3eaf67d84630857));
const $08c29446d85a76d8$export$bb762bbbffb67d5 = (out, src)=>(0, $149947dd2be6e525$export$abee0037e1db715)(out || [], (src & 255) * (0, $fa10cec494bd22e3$export$e3eaf67d84630857), (src >>> 8 & 255) * (0, $fa10cec494bd22e3$export$e3eaf67d84630857), (src >>> 16 & 255) * (0, $fa10cec494bd22e3$export$e3eaf67d84630857), (src >>> 24) * (0, $fa10cec494bd22e3$export$e3eaf67d84630857));
const $08c29446d85a76d8$export$dabb02671965e81b = (out, src)=>$08c29446d85a76d8$export$b9b70ffa6eb909fa(out, src | 4278190080);
const $08c29446d85a76d8$export$fb19f58995f09dd7 = (out, src)=>$08c29446d85a76d8$export$bb762bbbffb67d5(out, src | 4278190080);


const $000723b3b4eef467$export$59ad369bf4938177 = (src)=>{
    src = ((0, $98a0a2b1e7a2e447$export$844ec244b1367d54)(src) ? src : src.deref()).toLowerCase();
    const named = (0, $0295c010744b4ded$export$f36c8c226353f2dd)[src] || (0, $dfc490e5513203b4$export$80420cae396846ed)[src];
    if (named || src[0] === "#") return new (0, $dad655db0acd665e$export$f0e1837cf5c5bd36)("srgb", (0, $08c29446d85a76d8$export$b9b70ffa6eb909fa)([], $000723b3b4eef467$export$103711ef09c6edec(named || src)));
    const parts = src.split(/[(),/ ]+/);
    const [mode, a, b, c, d] = parts;
    (0, $66a7ab958e547697$export$a7a9523472993e97)(parts.length === 5 || parts.length === 6, `invalid color: ${src}`);
    switch(mode){
        case "rgb":
        case "rgba":
            return new (0, $dad655db0acd665e$export$f0e1837cf5c5bd36)("srgb", [
                $000723b3b4eef467$var$__numOrPercent(a, 1, (0, $fa10cec494bd22e3$export$e3eaf67d84630857), true),
                $000723b3b4eef467$var$__numOrPercent(b, 1, (0, $fa10cec494bd22e3$export$e3eaf67d84630857), true),
                $000723b3b4eef467$var$__numOrPercent(c, 1, (0, $fa10cec494bd22e3$export$e3eaf67d84630857), true),
                $000723b3b4eef467$var$__alpha(d)
            ]);
        case "hsl":
        case "hsla":
            return new (0, $dad655db0acd665e$export$f0e1837cf5c5bd36)("hsl", [
                $000723b3b4eef467$var$__hue(a),
                $000723b3b4eef467$var$__percent(b),
                $000723b3b4eef467$var$__percent(c),
                $000723b3b4eef467$var$__alpha(d)
            ]);
        case "lab":
            return new (0, $dad655db0acd665e$export$f0e1837cf5c5bd36)("lab50", [
                $000723b3b4eef467$var$__numOrPercent(a),
                $000723b3b4eef467$var$__numOrPercent(b, 1.25),
                $000723b3b4eef467$var$__numOrPercent(c, 1.25),
                $000723b3b4eef467$var$__alpha(d)
            ]);
        case "lch":
            return new (0, $dad655db0acd665e$export$f0e1837cf5c5bd36)(mode, [
                $000723b3b4eef467$var$__numOrPercent(a),
                $000723b3b4eef467$var$__numOrPercent(b, 1.5),
                $000723b3b4eef467$var$__hue(c),
                $000723b3b4eef467$var$__alpha(d)
            ]);
        case "oklab":
            return new (0, $dad655db0acd665e$export$f0e1837cf5c5bd36)(mode, [
                $000723b3b4eef467$var$__numOrPercent(a, 1, 1),
                $000723b3b4eef467$var$__numOrPercent(b, 0.4, 1),
                $000723b3b4eef467$var$__numOrPercent(c, 0.4, 1),
                $000723b3b4eef467$var$__alpha(d)
            ]);
        case "oklch":
            return new (0, $dad655db0acd665e$export$f0e1837cf5c5bd36)(mode, [
                $000723b3b4eef467$var$__numOrPercent(a, 1, 1),
                $000723b3b4eef467$var$__numOrPercent(b, 0.4, 1),
                $000723b3b4eef467$var$__hue(c),
                $000723b3b4eef467$var$__alpha(d)
            ]);
        default:
            (0, $7047b0fefb1d1180$export$98e633703a635f)(`color mode: ${mode}`);
    }
};
const $000723b3b4eef467$var$HUE_NORMS = {
    rad: (0, $a2ec0bb3243ca28e$export$ad5b0b9ab7d48f58),
    grad: 400,
    turn: 1,
    deg: 360
};
const $000723b3b4eef467$var$__hue = (x)=>{
    const match = /^(-?[0-9.]+)(deg|rad|grad|turn)?$/.exec(x);
    (0, $66a7ab958e547697$export$a7a9523472993e97)(!!match, `expected hue, got: ${x}`);
    return (0, $4d3964704e49b256$export$a57bfe0eb79af278)(parseFloat(match[1]) / ($000723b3b4eef467$var$HUE_NORMS[match[2]] || 360));
};
const $000723b3b4eef467$var$__alpha = (x)=>x ? $000723b3b4eef467$var$__numOrPercent(x, 1, 1, true) : 1;
const $000723b3b4eef467$var$__percent = (x, clamp = true)=>{
    (0, $66a7ab958e547697$export$a7a9523472993e97)(/^([0-9.]+)%$/.test(x), `expected percentage, got: ${x}`);
    const res = parseFloat(x) / 100;
    return clamp ? (0, $6fbc282bb2566ed8$export$5c5ee632c52bc4a2)(res) : res;
};
const $000723b3b4eef467$var$__numOrPercent = (x, scalePerc = 1, scale = 0.01, clamp = false)=>{
    (0, $66a7ab958e547697$export$a7a9523472993e97)(/^-?[0-9.]+%?$/.test(x), `expected number or percentage, got: ${x}`);
    const res = parseFloat(x) * (x.endsWith("%") ? 0.01 * scalePerc : scale);
    return clamp ? (0, $6fbc282bb2566ed8$export$5c5ee632c52bc4a2)(res) : res;
};
const $000723b3b4eef467$export$103711ef09c6edec = (src)=>{
    const match = /^#?([0-9a-f]{3,8})$/i.exec(src);
    if (match) {
        const hex = match[1];
        const val = parseInt(hex, 16);
        switch(hex.length){
            case 3:
                return ((0, $403765199d99fbe2$export$dd24dc7e49b6b0eb)(val) | 4278190080) >>> 0;
            case 4:
                return (0, $d321c2e7df9899b2$export$b8ff662d454dbe46)((0, $403765199d99fbe2$export$aea914411a6b4fb)(val), 8);
            case 6:
                return (val | 4278190080) >>> 0;
            case 8:
                return (0, $d321c2e7df9899b2$export$b8ff662d454dbe46)(val, 8);
            default:
        }
    }
    return (0, $4a444b4abe5f0f2f$export$85f6a9f917d452ba)(`invalid hex color: "${src}"`);
};




const $fa610d3ec54741e5$export$4598496351993abf = (x, def = 1)=>x != void 0 ? (0, $6fbc282bb2566ed8$export$5c5ee632c52bc4a2)(x) : def;
const $fa610d3ec54741e5$export$be435c896a95082 = (args)=>{
    if (typeof args[0] === "number") switch(args.length){
        case 1:
            return args.push(0, 0, 1), [
                args
            ];
        case 2:
            return args.push(0, 1), [
                args
            ];
        case 3:
            return args.push(1), [
                args
            ];
        default:
            return [
                args
            ];
    }
    return args;
};


const $8367b6b41e4dac9e$export$dd366fca209b6b9f = (spec)=>{
    const channels = spec.channels || {};
    const order = spec.order;
    const numChannels = order.length;
    order.reduce((acc, id)=>{
        acc[id] = {
            range: [
                0,
                1
            ],
            ...channels[id]
        };
        return acc;
    }, channels);
    const min = Object.freeze(order.map((id)=>channels[id].range[0]));
    const max = Object.freeze(order.map((id)=>channels[id].range[1]));
    const minR = (0, $f164dd17dabc2b83$export$a7c139a4194832bf)([], min);
    const maxR = (0, $f164dd17dabc2b83$export$a7c139a4194832bf)([], max);
    minR[numChannels - 1] = 1;
    const hueChanID = order.findIndex((id)=>!!channels[id].hue);
    const $Color = class {
        constructor(buf, offset = 0, stride = 1){
            this.offset = offset;
            this.stride = stride;
            this.buf = buf || [
                0,
                0,
                0,
                0
            ];
            this.offset = offset;
            this.stride = stride;
        }
        buf;
        get mode() {
            return spec.mode;
        }
        get length() {
            return numChannels;
        }
        get range() {
            return [
                min,
                max
            ];
        }
        get [Symbol.toStringTag]() {
            return spec.mode;
        }
        get xyz() {
            return [
                this[0],
                this[1],
                this[2]
            ];
        }
        [Symbol.iterator]() {
            return (0, $9e7975b49bbe8ffd$export$de7c8d5f4bf654ca)(this.buf, this.length, this.offset, this.stride);
        }
        copy() {
            return new $Color(this.deref());
        }
        copyView() {
            return new $Color(this.buf, this.offset, this.stride);
        }
        empty() {
            return new $Color();
        }
        deref() {
            return [
                this[0],
                this[1],
                this[2],
                this[3]
            ];
        }
        set(src) {
            return (0, $f164dd17dabc2b83$export$a7c139a4194832bf)(this, src);
        }
        clamp() {
            hueChanID >= 0 && (this[hueChanID] = (0, $4d3964704e49b256$export$a57bfe0eb79af278)(this[hueChanID]));
            (0, $6b941f0f0b9965ff$export$4cfdf484c27efa43)(null, this, min, max);
            return this;
        }
        eqDelta(o, eps = (0, $a2ec0bb3243ca28e$export$56469a43a57ad8b6)) {
            return (0, $5db2d16f863dd08e$export$215c4845217d5cf1)(this, o, eps);
        }
        randomize(rnd) {
            return (0, $9c48d435d9d3b7f1$export$a3bd1ea0f114ec36)(this, minR, maxR, rnd);
        }
        toJSON() {
            return this.deref();
        }
        toString() {
            return (0, $47e1f5bee596f8ab$export$6074e20ba5c64bef)(4, 4)(this);
        }
    };
    (0, $d08c29b2a90a41b3$export$372fdd3dd278cc1c)($Color.prototype, order);
    (0, $8f2988c0c6d4a536$export$b07aeb3c205b1fa7)(spec.mode, spec.from);
    (0, $8f2988c0c6d4a536$export$b07aeb3c205b1fa7)("rgb", {
        [spec.mode]: spec.toRgb
    });
    const fromColor = (src, mode, args)=>{
        const res = new $Color(...args);
        return mode !== spec.mode ? (0, $8f2988c0c6d4a536$export$9c68d69a4c5bbcf9)(res, src, spec.mode, mode) : res.set(src);
    };
    const factory = (src, ...args)=>src == null ? new $Color() : (0, $98a0a2b1e7a2e447$export$844ec244b1367d54)(src) ? factory((0, $000723b3b4eef467$export$59ad369bf4938177)(src), ...args) : (0, $db5c4a24e7c9329c$export$1e2f57719e155213)(src) ? (0, $98a0a2b1e7a2e447$export$844ec244b1367d54)(src.mode) ? fromColor(src, src.mode, args) : new $Color(src, ...args) : (0, $b4429ed4e1faf6b1$export$c915e14294a7d06f)(src, "deref") ? fromColor(src.deref(), src.mode, args) : (0, $3fa47dff646d40f0$export$7e4aa119212bc614)(src) ? args.length && args.every((0, $3fa47dff646d40f0$export$7e4aa119212bc614)) ? new $Color(...(0, $fa610d3ec54741e5$export$be435c896a95082)([
            src,
            ...args
        ])) : fromColor((0, $08c29446d85a76d8$export$b9b70ffa6eb909fa)([], src), "srgb", args) : (0, $4a444b4abe5f0f2f$export$85f6a9f917d452ba)(`can't create a ${spec.mode} color from: ${src}`);
    factory.class = $Color;
    factory.range = [
        min,
        max
    ];
    factory.random = (rnd, buf, idx, stride)=>new $Color(buf, idx, stride).randomize(rnd);
    factory.mapBuffer = (buf, num = buf.length / numChannels | 0, start = 0, cstride = 1, estride = numChannels)=>(0, $db79a8db643979a1$export$e9242f670cb20645)($Color, buf, num, start, cstride, estride);
    return factory;
};






const $07ec128cf5c9d676$export$7d15b64cf5a3a4c4 = (out, src, alpha = 1)=>(0, $149947dd2be6e525$export$abee0037e1db715)(out || src, (0, $6fbc282bb2566ed8$export$5c5ee632c52bc4a2)(src[0]), (0, $6fbc282bb2566ed8$export$5c5ee632c52bc4a2)(src[1]), (0, $6fbc282bb2566ed8$export$5c5ee632c52bc4a2)(src[2]), (0, $fa610d3ec54741e5$export$4598496351993abf)(src[3], alpha));
const $07ec128cf5c9d676$export$dd799b5658f51338 = (out, src, alpha = 1)=>(0, $149947dd2be6e525$export$abee0037e1db715)(out || src, (0, $4d3964704e49b256$export$a57bfe0eb79af278)(src[0]), (0, $6fbc282bb2566ed8$export$5c5ee632c52bc4a2)(src[1]), (0, $6fbc282bb2566ed8$export$5c5ee632c52bc4a2)(src[2]), (0, $fa610d3ec54741e5$export$4598496351993abf)(src[3], alpha));


const $63689da83f262ad2$export$61d1db33a18350ee = (out, src)=>{
    out = (0, $07ec128cf5c9d676$export$dd799b5658f51338)(out || src, src);
    const s = out[1];
    const v = out[2];
    const l = (2 - s) * v / 2;
    out[2] = l;
    out[1] = l && l < 1 ? s * v / (l < 0.5 ? l * 2 : 2 - l * 2) : s;
    return out;
};



const $1316361d3442ab41$export$7d5e3328550ce0cd = (theta, n = 1)=>[
        Math.sin(theta) * n,
        Math.cos(theta) * n
    ];
const $1316361d3442ab41$export$5dceb76539a08116 = (theta, n = 1)=>[
        Math.cos(theta) * n,
        Math.sin(theta) * n
    ];
const $1316361d3442ab41$export$8e3badfd6976e5c = (theta)=>(theta %= (0, $a2ec0bb3243ca28e$export$ad5b0b9ab7d48f58), theta < 0 ? (0, $a2ec0bb3243ca28e$export$ad5b0b9ab7d48f58) + theta : theta);
const $1316361d3442ab41$export$bc9a8c093c36a624 = (theta)=>(theta = Math.abs(theta), theta > (0, $a2ec0bb3243ca28e$export$6b5c1ceb16d01dc3) ? (0, $a2ec0bb3243ca28e$export$ad5b0b9ab7d48f58) - theta : theta);
const $1316361d3442ab41$export$28d974ff8f7517ed = (a, b)=>$1316361d3442ab41$export$bc9a8c093c36a624($1316361d3442ab41$export$8e3badfd6976e5c(b % (0, $a2ec0bb3243ca28e$export$ad5b0b9ab7d48f58) - a % (0, $a2ec0bb3243ca28e$export$ad5b0b9ab7d48f58)));
const $1316361d3442ab41$export$64813598e5fb2450 = (y, x)=>$1316361d3442ab41$export$8e3badfd6976e5c(Math.atan2(y, x));
const $1316361d3442ab41$export$2332ba17bcdd284d = (theta)=>$1316361d3442ab41$export$8e3badfd6976e5c(theta) * (0, $a2ec0bb3243ca28e$export$24b096bfbaf849b7) | 0;
const $1316361d3442ab41$export$61ddd819c68acdd = (theta)=>theta * (0, $a2ec0bb3243ca28e$export$914076c8150813e5);
const $1316361d3442ab41$export$29e4e862bebba87f = (theta)=>theta * (0, $a2ec0bb3243ca28e$export$460c4029b1a54a2e);
const $1316361d3442ab41$export$a830b5ed334924be = (theta)=>1 / Math.sin(theta);
const $1316361d3442ab41$export$e17a63917e2ebf0f = (theta)=>1 / Math.cos(theta);
const $1316361d3442ab41$export$ef569ec50496610c = (theta)=>1 / Math.tan(theta);
const $1316361d3442ab41$export$ebcbd32ce8d4cff = (a, b, gamma)=>Math.sqrt(a * a + b * b - 2 * a * b * Math.cos(gamma));
const $1316361d3442ab41$export$c0a907f067762f6e = (x)=>{
    const x2 = x * x;
    return 1 + x2 * (-4 + 2 * x2);
};
const $1316361d3442ab41$var$__fastCos = (x)=>{
    const x2 = x * x;
    return 0.99940307 + x2 * (-0.49558072 + 0.03679168 * x2);
};
const $1316361d3442ab41$export$3c8033b41bb9b535 = (theta)=>{
    theta %= (0, $a2ec0bb3243ca28e$export$ad5b0b9ab7d48f58);
    theta < 0 && (theta = -theta);
    switch(theta * (0, $a2ec0bb3243ca28e$export$24b096bfbaf849b7) | 0){
        case 0:
            return $1316361d3442ab41$var$__fastCos(theta);
        case 1:
            return -$1316361d3442ab41$var$__fastCos((0, $a2ec0bb3243ca28e$export$6b5c1ceb16d01dc3) - theta);
        case 2:
            return -$1316361d3442ab41$var$__fastCos(theta - (0, $a2ec0bb3243ca28e$export$6b5c1ceb16d01dc3));
        default:
            return $1316361d3442ab41$var$__fastCos((0, $a2ec0bb3243ca28e$export$ad5b0b9ab7d48f58) - theta);
    }
};
const $1316361d3442ab41$export$5a59657e318cc2cf = (theta)=>$1316361d3442ab41$export$3c8033b41bb9b535((0, $a2ec0bb3243ca28e$export$f504979d7e0a75c7) - theta);
const $1316361d3442ab41$export$8019a7ebe7afe6d9 = (deg2, min, sec2)=>deg2 + min / 60 + sec2 / 3600;
const $1316361d3442ab41$export$6804273a91971333 = (theta)=>{
    const sign = Math.sign(theta);
    theta = Math.abs(theta);
    const deg2 = Math.trunc(theta);
    theta = (theta - deg2) * 60;
    const min = Math.trunc(theta);
    return [
        deg2 * sign,
        min,
        (theta - min) * 60
    ];
};





const $5b56fdd6e872b875$export$8a87efa82f297c68 = (out, src)=>{
    const { 1: a, 2: b } = src;
    return (0, $149947dd2be6e525$export$abee0037e1db715)(out || src, src[0], Math.hypot(a, b), a === 0 && b === 0 ? 0 : (0, $1316361d3442ab41$export$64813598e5fb2450)(b, a) * (0, $a2ec0bb3243ca28e$export$3a7bf289cac70393), (0, $fa610d3ec54741e5$export$4598496351993abf)(src[3]));
};
const $5b56fdd6e872b875$export$1d9aa1122f81fc3e = (out, src)=>{
    let { 1: c, 2: h } = src;
    h *= (0, $a2ec0bb3243ca28e$export$ad5b0b9ab7d48f58);
    const a = (0, $fa610d3ec54741e5$export$4598496351993abf)(src[3]);
    return c > 0 ? (0, $149947dd2be6e525$export$abee0037e1db715)(out || src, src[0], Math.cos(h) * c, Math.sin(h) * c, a) : (0, $149947dd2be6e525$export$abee0037e1db715)(out || src, src[0], 0, 0, a);
};





const $e4b8746ae6613d2b$var$__transform = (x)=>{
    const y = x ** 3;
    return y > 8856e-6 ? y : (x - 16 / 116) / 7.787;
};
const $e4b8746ae6613d2b$export$e2f27988cc5b3a12 = (out, src, white = (0, $fa10cec494bd22e3$export$eea70998d27a3f6e))=>{
    const y = (src[0] + 0.16) / 1.16;
    return (0, $149947dd2be6e525$export$abee0037e1db715)(out || src, $e4b8746ae6613d2b$var$__transform(src[1] / 5 + y) * white[0], $e4b8746ae6613d2b$var$__transform(y) * white[1], $e4b8746ae6613d2b$var$__transform(y - src[2] / 2) * white[2], (0, $fa610d3ec54741e5$export$4598496351993abf)(src[3]));
};
const $e4b8746ae6613d2b$export$5bbeea95f392b8fe = (out, src)=>$e4b8746ae6613d2b$export$e2f27988cc5b3a12(out, src, (0, $fa10cec494bd22e3$export$5c2abc406650e66e));




const $c0675824074b95fc$export$d1abfbcc2687ddc4 = (a, b, n, ia = 0, ib = 0, sa = 1, sb = 1)=>{
    let sum = 0;
    while(n-- > 0)sum += a[ia + n * sa] * b[ib + n * sb];
    return sum;
};
const $c0675824074b95fc$export$cf66b157879064b6 = (a, b, io = 0, ib = 0, sa = 1, sb = 1)=>a[io] * b[ib] + a[io + sa] * b[ib + sb];
const $c0675824074b95fc$export$78ae608fdbee4899 = (a, b, ia = 0, ib = 0, sa = 1, sb = 1)=>a[ia] * b[ib] + a[ia + sa] * b[ib + sb] + a[ia + 2 * sa] * b[ib + 2 * sb];
const $c0675824074b95fc$export$7cff64c0e2ba076b = (a, b, ia = 0, ib = 0, sa = 1, sb = 1)=>a[ia] * b[ib] + a[ia + sa] * b[ib + sb] + a[ia + 2 * sa] * b[ib + 2 * sb] + a[ia + 3 * sa] * b[ib + 3 * sb];




const $bf5785378a0cb6d0$export$eaa9061711f71897 = (out, mat, src, clampOut = false)=>{
    const x = (0, $c0675824074b95fc$export$78ae608fdbee4899)(mat, src, 0, 0, 3);
    const y = (0, $c0675824074b95fc$export$78ae608fdbee4899)(mat, src, 1, 0, 3);
    const z = (0, $c0675824074b95fc$export$78ae608fdbee4899)(mat, src, 2, 0, 3);
    const a = (0, $fa610d3ec54741e5$export$4598496351993abf)(src[3]);
    return clampOut ? (0, $149947dd2be6e525$export$abee0037e1db715)(out || src, (0, $6fbc282bb2566ed8$export$5c5ee632c52bc4a2)(x), (0, $6fbc282bb2566ed8$export$5c5ee632c52bc4a2)(y), (0, $6fbc282bb2566ed8$export$5c5ee632c52bc4a2)(z), a) : (0, $149947dd2be6e525$export$abee0037e1db715)(out || src, x, y, z, a);
};
const $bf5785378a0cb6d0$export$3c41ca02e903d6c6 = (out, mat, src, clampOut = true)=>{
    out = (0, $149947dd2be6e525$export$abee0037e1db715)(out || src, src[0], src[1], src[2], (0, $fa610d3ec54741e5$export$4598496351993abf)(src[3]));
    const x = (0, $c0675824074b95fc$export$7cff64c0e2ba076b)(out, mat, 0, 0) + mat[4];
    const y = (0, $c0675824074b95fc$export$7cff64c0e2ba076b)(out, mat, 0, 5) + mat[9];
    const z = (0, $c0675824074b95fc$export$7cff64c0e2ba076b)(out, mat, 0, 10) + mat[14];
    const w = (0, $c0675824074b95fc$export$7cff64c0e2ba076b)(out, mat, 0, 15) + mat[19];
    return clampOut ? (0, $149947dd2be6e525$export$abee0037e1db715)(out, (0, $6fbc282bb2566ed8$export$5c5ee632c52bc4a2)(x), (0, $6fbc282bb2566ed8$export$5c5ee632c52bc4a2)(y), (0, $6fbc282bb2566ed8$export$5c5ee632c52bc4a2)(z), (0, $6fbc282bb2566ed8$export$5c5ee632c52bc4a2)(w)) : (0, $149947dd2be6e525$export$abee0037e1db715)(out, x, y, z, w);
};
const $bf5785378a0cb6d0$export$4a53f7863042bc1b = (a, b)=>[
        (0, $c0675824074b95fc$export$7cff64c0e2ba076b)(b, a, 0, 0, 1, 5),
        (0, $c0675824074b95fc$export$7cff64c0e2ba076b)(b, a, 0, 1, 1, 5),
        (0, $c0675824074b95fc$export$7cff64c0e2ba076b)(b, a, 0, 2, 1, 5),
        (0, $c0675824074b95fc$export$7cff64c0e2ba076b)(b, a, 0, 3, 1, 5),
        (0, $c0675824074b95fc$export$7cff64c0e2ba076b)(b, a, 0, 4, 1, 5) + b[4],
        (0, $c0675824074b95fc$export$7cff64c0e2ba076b)(b, a, 5, 0, 1, 5),
        (0, $c0675824074b95fc$export$7cff64c0e2ba076b)(b, a, 5, 1, 1, 5),
        (0, $c0675824074b95fc$export$7cff64c0e2ba076b)(b, a, 5, 2, 1, 5),
        (0, $c0675824074b95fc$export$7cff64c0e2ba076b)(b, a, 5, 3, 1, 5),
        (0, $c0675824074b95fc$export$7cff64c0e2ba076b)(b, a, 5, 4, 1, 5) + b[9],
        (0, $c0675824074b95fc$export$7cff64c0e2ba076b)(b, a, 10, 0, 1, 5),
        (0, $c0675824074b95fc$export$7cff64c0e2ba076b)(b, a, 10, 1, 1, 5),
        (0, $c0675824074b95fc$export$7cff64c0e2ba076b)(b, a, 10, 2, 1, 5),
        (0, $c0675824074b95fc$export$7cff64c0e2ba076b)(b, a, 10, 3, 1, 5),
        (0, $c0675824074b95fc$export$7cff64c0e2ba076b)(b, a, 10, 4, 1, 5) + b[14],
        (0, $c0675824074b95fc$export$7cff64c0e2ba076b)(b, a, 15, 0, 1, 5),
        (0, $c0675824074b95fc$export$7cff64c0e2ba076b)(b, a, 15, 1, 1, 5),
        (0, $c0675824074b95fc$export$7cff64c0e2ba076b)(b, a, 15, 2, 1, 5),
        (0, $c0675824074b95fc$export$7cff64c0e2ba076b)(b, a, 15, 3, 1, 5),
        (0, $c0675824074b95fc$export$7cff64c0e2ba076b)(b, a, 15, 4, 1, 5) + b[19]
    ];


const $00ae0d1cf164b4b2$export$3772e887938e648f = (out, src, mat = (0, $fa10cec494bd22e3$export$5bd959522fbb33fb))=>(0, $bf5785378a0cb6d0$export$eaa9061711f71897)(out, mat, src);
const $00ae0d1cf164b4b2$export$b144c3ea0bb0eb35 = (out, src)=>$00ae0d1cf164b4b2$export$3772e887938e648f(out, src, (0, $fa10cec494bd22e3$export$68ca3d30fbda6075));


const $efc5643149fac624$export$62c4a88ec5f406a7 = (out, src)=>(0, $00ae0d1cf164b4b2$export$3772e887938e648f)(null, (0, $e4b8746ae6613d2b$export$e2f27988cc5b3a12)(out, src));
const $efc5643149fac624$export$9977adf6ced6e7be = (out, src)=>(0, $00ae0d1cf164b4b2$export$b144c3ea0bb0eb35)(null, (0, $e4b8746ae6613d2b$export$5bbeea95f392b8fe)(out, src));







const $7b54ecf11c53b210$export$e6056cb2e71b648d = (out, src)=>{
    out = (0, $07ec128cf5c9d676$export$7d15b64cf5a3a4c4)(out || src, src);
    const p = out[1] < out[2] ? [
        out[2],
        out[1],
        -1,
        2 / 3
    ] : [
        out[1],
        out[2],
        0,
        -1 / 3
    ];
    const q = out[0] < p[0] ? [
        p[0],
        p[1],
        p[3],
        out[0]
    ] : [
        out[0],
        p[1],
        p[2],
        p[0]
    ];
    const c = q[0] - Math.min(q[1], q[3]);
    return (0, $149947dd2be6e525$export$ba8c70ce75474f8d)(out, (0, $6fbc282bb2566ed8$export$5c5ee632c52bc4a2)(Math.abs((q[3] - q[1]) / (6 * c + (0, $a2ec0bb3243ca28e$export$56469a43a57ad8b6)) + q[2])), (0, $6fbc282bb2566ed8$export$5c5ee632c52bc4a2)(c), (0, $6fbc282bb2566ed8$export$5c5ee632c52bc4a2)(q[0]));
};


const $c0f2df91f36e4c3c$export$ebedcdd15cc9bf0a = (out, src)=>{
    out = (0, $7b54ecf11c53b210$export$e6056cb2e71b648d)(out, src);
    out[2] -= out[1] * 0.5;
    out[1] /= 1 + (0, $a2ec0bb3243ca28e$export$56469a43a57ad8b6) - Math.abs(out[2] * 2 - 1);
    return out;
};




const $da19dcc7583f0550$export$5b10bb54545ea67e = (x)=>x <= 31308e-7 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055;
const $da19dcc7583f0550$export$7a3b4878f4bbb062 = (x)=>x <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);


const $6b0f7f1d4b2440a8$export$b06545aaa0d83879 = (out, src)=>(0, $149947dd2be6e525$export$abee0037e1db715)(out || src, (0, $da19dcc7583f0550$export$5b10bb54545ea67e)(src[0]), (0, $da19dcc7583f0550$export$5b10bb54545ea67e)(src[1]), (0, $da19dcc7583f0550$export$5b10bb54545ea67e)(src[2]), (0, $fa610d3ec54741e5$export$4598496351993abf)(src[3]));
const $6b0f7f1d4b2440a8$var$GAMMA = 1 / 2.2;
const $6b0f7f1d4b2440a8$export$6e3e81c16f2688c2 = (out, src)=>(0, $149947dd2be6e525$export$abee0037e1db715)(out || src, src[0] ** $6b0f7f1d4b2440a8$var$GAMMA, src[1] ** $6b0f7f1d4b2440a8$var$GAMMA, src[2] ** $6b0f7f1d4b2440a8$var$GAMMA, (0, $fa610d3ec54741e5$export$4598496351993abf)(src[3]));







const $ffe58a4cf03c8f32$export$3d9bf1c19a0bc433 = (out, hue, alpha = 1)=>{
    hue = (0, $4d3964704e49b256$export$a57bfe0eb79af278)(hue) * 6;
    return (0, $149947dd2be6e525$export$abee0037e1db715)(out || [], (0, $6fbc282bb2566ed8$export$5c5ee632c52bc4a2)(Math.abs(hue - 3) - 1), (0, $6fbc282bb2566ed8$export$5c5ee632c52bc4a2)(2 - Math.abs(hue - 2)), (0, $6fbc282bb2566ed8$export$5c5ee632c52bc4a2)(2 - Math.abs(hue - 4)), alpha);
};
const $ffe58a4cf03c8f32$export$54272290a832ed1e = (out, hue, alpha = 1)=>$ffe58a4cf03c8f32$export$3d9bf1c19a0bc433(out, hue / 12, alpha);



const $51835341b848c29d$export$8b5c95800cbf8ce0 = (out, src)=>{
    const s = (0, $6fbc282bb2566ed8$export$5c5ee632c52bc4a2)(src[1]);
    const l = (0, $6fbc282bb2566ed8$export$5c5ee632c52bc4a2)(src[2]);
    out = (0, $ffe58a4cf03c8f32$export$3d9bf1c19a0bc433)(out || src, src[0], (0, $fa610d3ec54741e5$export$4598496351993abf)(src[3]));
    const c = (1 - Math.abs(2 * l - 1)) * s;
    return (0, $149947dd2be6e525$export$ba8c70ce75474f8d)(out, (out[0] - 0.5) * c + l, (out[1] - 0.5) * c + l, (out[2] - 0.5) * c + l);
};


const $6e6bff3bd160b642$export$8f4a7c0bb78e6ea8 = (0, $8367b6b41e4dac9e$export$dd366fca209b6b9f)({
    mode: "hsl",
    channels: {
        h: {
            hue: true
        }
    },
    order: [
        "h",
        "s",
        "l",
        "alpha"
    ],
    from: {
        rgb: (0, $c0f2df91f36e4c3c$export$ebedcdd15cc9bf0a),
        srgb: (0, $c0f2df91f36e4c3c$export$ebedcdd15cc9bf0a),
        hsv: (0, $63689da83f262ad2$export$61d1db33a18350ee),
        lch: [
            (0, $5b56fdd6e872b875$export$1d9aa1122f81fc3e),
            (0, $efc5643149fac624$export$62c4a88ec5f406a7),
            (0, $6b0f7f1d4b2440a8$export$b06545aaa0d83879),
            (0, $c0f2df91f36e4c3c$export$ebedcdd15cc9bf0a)
        ]
    },
    toRgb: (0, $51835341b848c29d$export$8b5c95800cbf8ce0)
});






const $1fd5f56a1dd50d11$export$fe6a5064d53faf98 = (a, b)=>a[0] * b[0] + a[1] * b[1];
const $1fd5f56a1dd50d11$export$6f9aa2c904053c13 = (a, b)=>a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
const $1fd5f56a1dd50d11$export$2e1971da4e839d07 = (a, b)=>a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
const $1fd5f56a1dd50d11$export$94132a0e348806d4 = (0, $176ac089df32114b$export$c37d18c23b2ea60c)(0, (a, b)=>{
    let sum = 0;
    for(let i = a.length; i-- > 0;)sum += a[i] * b[i];
    return sum;
}, $1fd5f56a1dd50d11$export$fe6a5064d53faf98, $1fd5f56a1dd50d11$export$6f9aa2c904053c13, $1fd5f56a1dd50d11$export$2e1971da4e839d07);



const $0670cf7a9efef22d$export$68855e3505eedafd = (rgb, weights = (0, $fa10cec494bd22e3$export$1a74005704ec0a02))=>(0, $1fd5f56a1dd50d11$export$6f9aa2c904053c13)(rgb, weights);
const $0670cf7a9efef22d$export$7c1804560b24eb96 = (rgb)=>(0, $1fd5f56a1dd50d11$export$6f9aa2c904053c13)(rgb, (0, $fa10cec494bd22e3$export$618666431255d9df));
const $0670cf7a9efef22d$export$e099497bb3d7725d = (rgb)=>((rgb >>> 16 & 255) * 76 + (rgb >>> 8 & 255) * 150 + (rgb & 255) * 29) / 65025;
const $0670cf7a9efef22d$export$6c413272b3075f97 = (rgb)=>((rgb >>> 16 & 255) * 29 + (rgb >>> 8 & 255) * 150 + (rgb & 255) * 76) / 65025;
const $0670cf7a9efef22d$export$d2a617b7a4376295 = (argb)=>$0670cf7a9efef22d$export$e099497bb3d7725d(argb[0]);
const $0670cf7a9efef22d$export$9e732cd69a3d169c = (argb)=>$0670cf7a9efef22d$export$6c413272b3075f97(argb[0]);



const $794faec2855b64f9$export$84dfe7a7188c2429 = (out, src)=>{
    const h = src[0];
    let c = src[1];
    const y = src[2];
    const rgb = (0, $ffe58a4cf03c8f32$export$3d9bf1c19a0bc433)(out || src, h, (0, $fa610d3ec54741e5$export$4598496351993abf)(src[3]));
    const lum = (0, $0670cf7a9efef22d$export$68855e3505eedafd)(rgb);
    if (y < lum) c *= y / lum;
    else if (lum < 1) c *= (1 - y) / (1 - lum);
    return (0, $149947dd2be6e525$export$ba8c70ce75474f8d)(rgb, (0, $6fbc282bb2566ed8$export$5c5ee632c52bc4a2)((rgb[0] - lum) * c + y), (0, $6fbc282bb2566ed8$export$5c5ee632c52bc4a2)((rgb[1] - lum) * c + y), (0, $6fbc282bb2566ed8$export$5c5ee632c52bc4a2)((rgb[2] - lum) * c + y));
};




const $39f2e08130ebf6ae$export$54f13de7f2ebc467 = (out, src)=>{
    out = (0, $07ec128cf5c9d676$export$dd799b5658f51338)(out || src, src);
    const s = out[1];
    const i = out[2];
    if (s < 1e-6) return (0, $149947dd2be6e525$export$ba8c70ce75474f8d)(out, i, i, i);
    const h = out[0] * 6 % 6;
    const m = i * (1 - s);
    const z = 1 - Math.abs(h % 2 - 1);
    let c = 3 * i * s / (1 + z);
    const x = c * z + m;
    c += m;
    switch(h | 0){
        case 0:
            return (0, $149947dd2be6e525$export$ba8c70ce75474f8d)(out, c, x, m);
        case 1:
            return (0, $149947dd2be6e525$export$ba8c70ce75474f8d)(out, x, c, m);
        case 2:
            return (0, $149947dd2be6e525$export$ba8c70ce75474f8d)(out, m, c, x);
        case 3:
            return (0, $149947dd2be6e525$export$ba8c70ce75474f8d)(out, m, x, c);
        case 4:
            return (0, $149947dd2be6e525$export$ba8c70ce75474f8d)(out, x, m, c);
        case 5:
            return (0, $149947dd2be6e525$export$ba8c70ce75474f8d)(out, c, m, x);
        default:
            return (0, $149947dd2be6e525$export$ba8c70ce75474f8d)(out, m, m, m);
    }
};






const $c57eac52e98ba861$export$3056d8eeaa70fa11 = (out, src)=>{
    out = (0, $07ec128cf5c9d676$export$dd799b5658f51338)(out || src, src);
    const s = out[1];
    const v = out[2];
    (0, $ffe58a4cf03c8f32$export$3d9bf1c19a0bc433)(out, src[0], out[3]);
    return (0, $149947dd2be6e525$export$ba8c70ce75474f8d)(out, ((out[0] - 1) * s + 1) * v, ((out[1] - 1) * s + 1) * v, ((out[2] - 1) * s + 1) * v);
};







const $bf2ccda0f63c7de0$export$73738998bb7f180b = (out, src)=>(0, $149947dd2be6e525$export$abee0037e1db715)(out || src, (0, $da19dcc7583f0550$export$7a3b4878f4bbb062)(src[0]), (0, $da19dcc7583f0550$export$7a3b4878f4bbb062)(src[1]), (0, $da19dcc7583f0550$export$7a3b4878f4bbb062)(src[2]), (0, $fa610d3ec54741e5$export$4598496351993abf)(src[3]));
const $bf2ccda0f63c7de0$var$GAMMA = 2.2;
const $bf2ccda0f63c7de0$export$eff5eb400a504f87 = (out, src)=>(0, $149947dd2be6e525$export$abee0037e1db715)(out || src, src[0] ** $bf2ccda0f63c7de0$var$GAMMA, src[1] ** $bf2ccda0f63c7de0$var$GAMMA, src[2] ** $bf2ccda0f63c7de0$var$GAMMA, (0, $fa610d3ec54741e5$export$4598496351993abf)(src[3]));


const $071d5807df0edd8c$export$f772f42bf67d946c = (0, $8367b6b41e4dac9e$export$dd366fca209b6b9f)({
    mode: "srgb",
    order: [
        "r",
        "g",
        "b",
        "alpha"
    ],
    from: {
        abgr32: (out, src)=>(0, $08c29446d85a76d8$export$bb762bbbffb67d5)(out, src[0]),
        argb32: (out, src)=>(0, $08c29446d85a76d8$export$b9b70ffa6eb909fa)(out, src[0]),
        hcy: (0, $794faec2855b64f9$export$84dfe7a7188c2429),
        hsi: (0, $39f2e08130ebf6ae$export$54f13de7f2ebc467),
        hsl: (0, $51835341b848c29d$export$8b5c95800cbf8ce0),
        hsv: (0, $c57eac52e98ba861$export$3056d8eeaa70fa11),
        rgb: (0, $6b0f7f1d4b2440a8$export$b06545aaa0d83879)
    },
    toRgb: (0, $bf2ccda0f63c7de0$export$73738998bb7f180b)
});


var $78ce2a669c6df413$exports = {};
/**
 * @module fps-indicator
 */ "use strict";
var $48d150d77846bea0$exports = {};
var $5614fc581e3b4cfe$exports = {};
var $3d1dc255ff201a7e$exports = {};
// shim for using process in browser
var $3d1dc255ff201a7e$var$process = $3d1dc255ff201a7e$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $3d1dc255ff201a7e$var$cachedSetTimeout;
var $3d1dc255ff201a7e$var$cachedClearTimeout;
function $3d1dc255ff201a7e$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $3d1dc255ff201a7e$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $3d1dc255ff201a7e$var$cachedSetTimeout = setTimeout;
        else $3d1dc255ff201a7e$var$cachedSetTimeout = $3d1dc255ff201a7e$var$defaultSetTimout;
    } catch (e) {
        $3d1dc255ff201a7e$var$cachedSetTimeout = $3d1dc255ff201a7e$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $3d1dc255ff201a7e$var$cachedClearTimeout = clearTimeout;
        else $3d1dc255ff201a7e$var$cachedClearTimeout = $3d1dc255ff201a7e$var$defaultClearTimeout;
    } catch (e) {
        $3d1dc255ff201a7e$var$cachedClearTimeout = $3d1dc255ff201a7e$var$defaultClearTimeout;
    }
})();
function $3d1dc255ff201a7e$var$runTimeout(fun) {
    if ($3d1dc255ff201a7e$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($3d1dc255ff201a7e$var$cachedSetTimeout === $3d1dc255ff201a7e$var$defaultSetTimout || !$3d1dc255ff201a7e$var$cachedSetTimeout) && setTimeout) {
        $3d1dc255ff201a7e$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3d1dc255ff201a7e$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $3d1dc255ff201a7e$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $3d1dc255ff201a7e$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $3d1dc255ff201a7e$var$runClearTimeout(marker) {
    if ($3d1dc255ff201a7e$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($3d1dc255ff201a7e$var$cachedClearTimeout === $3d1dc255ff201a7e$var$defaultClearTimeout || !$3d1dc255ff201a7e$var$cachedClearTimeout) && clearTimeout) {
        $3d1dc255ff201a7e$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3d1dc255ff201a7e$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $3d1dc255ff201a7e$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $3d1dc255ff201a7e$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $3d1dc255ff201a7e$var$queue = [];
var $3d1dc255ff201a7e$var$draining = false;
var $3d1dc255ff201a7e$var$currentQueue;
var $3d1dc255ff201a7e$var$queueIndex = -1;
function $3d1dc255ff201a7e$var$cleanUpNextTick() {
    if (!$3d1dc255ff201a7e$var$draining || !$3d1dc255ff201a7e$var$currentQueue) return;
    $3d1dc255ff201a7e$var$draining = false;
    if ($3d1dc255ff201a7e$var$currentQueue.length) $3d1dc255ff201a7e$var$queue = $3d1dc255ff201a7e$var$currentQueue.concat($3d1dc255ff201a7e$var$queue);
    else $3d1dc255ff201a7e$var$queueIndex = -1;
    if ($3d1dc255ff201a7e$var$queue.length) $3d1dc255ff201a7e$var$drainQueue();
}
function $3d1dc255ff201a7e$var$drainQueue() {
    if ($3d1dc255ff201a7e$var$draining) return;
    var timeout = $3d1dc255ff201a7e$var$runTimeout($3d1dc255ff201a7e$var$cleanUpNextTick);
    $3d1dc255ff201a7e$var$draining = true;
    var len = $3d1dc255ff201a7e$var$queue.length;
    while(len){
        $3d1dc255ff201a7e$var$currentQueue = $3d1dc255ff201a7e$var$queue;
        $3d1dc255ff201a7e$var$queue = [];
        while(++$3d1dc255ff201a7e$var$queueIndex < len)if ($3d1dc255ff201a7e$var$currentQueue) $3d1dc255ff201a7e$var$currentQueue[$3d1dc255ff201a7e$var$queueIndex].run();
        $3d1dc255ff201a7e$var$queueIndex = -1;
        len = $3d1dc255ff201a7e$var$queue.length;
    }
    $3d1dc255ff201a7e$var$currentQueue = null;
    $3d1dc255ff201a7e$var$draining = false;
    $3d1dc255ff201a7e$var$runClearTimeout(timeout);
}
$3d1dc255ff201a7e$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $3d1dc255ff201a7e$var$queue.push(new $3d1dc255ff201a7e$var$Item(fun, args));
    if ($3d1dc255ff201a7e$var$queue.length === 1 && !$3d1dc255ff201a7e$var$draining) $3d1dc255ff201a7e$var$runTimeout($3d1dc255ff201a7e$var$drainQueue);
};
// v8 likes predictible objects
function $3d1dc255ff201a7e$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$3d1dc255ff201a7e$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$3d1dc255ff201a7e$var$process.title = "browser";
$3d1dc255ff201a7e$var$process.browser = true;
$3d1dc255ff201a7e$var$process.env = {};
$3d1dc255ff201a7e$var$process.argv = [];
$3d1dc255ff201a7e$var$process.version = ""; // empty string to avoid regexp issues
$3d1dc255ff201a7e$var$process.versions = {};
function $3d1dc255ff201a7e$var$noop() {}
$3d1dc255ff201a7e$var$process.on = $3d1dc255ff201a7e$var$noop;
$3d1dc255ff201a7e$var$process.addListener = $3d1dc255ff201a7e$var$noop;
$3d1dc255ff201a7e$var$process.once = $3d1dc255ff201a7e$var$noop;
$3d1dc255ff201a7e$var$process.off = $3d1dc255ff201a7e$var$noop;
$3d1dc255ff201a7e$var$process.removeListener = $3d1dc255ff201a7e$var$noop;
$3d1dc255ff201a7e$var$process.removeAllListeners = $3d1dc255ff201a7e$var$noop;
$3d1dc255ff201a7e$var$process.emit = $3d1dc255ff201a7e$var$noop;
$3d1dc255ff201a7e$var$process.prependListener = $3d1dc255ff201a7e$var$noop;
$3d1dc255ff201a7e$var$process.prependOnceListener = $3d1dc255ff201a7e$var$noop;
$3d1dc255ff201a7e$var$process.listeners = function(name) {
    return [];
};
$3d1dc255ff201a7e$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$3d1dc255ff201a7e$var$process.cwd = function() {
    return "/";
};
$3d1dc255ff201a7e$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$3d1dc255ff201a7e$var$process.umask = function() {
    return 0;
};


// Generated by CoffeeScript 1.12.2
(function() {
    var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) $5614fc581e3b4cfe$exports = function() {
        return performance.now();
    };
    else if (typeof $3d1dc255ff201a7e$exports !== "undefined" && $3d1dc255ff201a7e$exports !== null && $3d1dc255ff201a7e$exports.hrtime) {
        $5614fc581e3b4cfe$exports = function() {
            return (getNanoSeconds() - nodeLoadTime) / 1e6;
        };
        hrtime = $3d1dc255ff201a7e$exports.hrtime;
        getNanoSeconds = function() {
            var hr;
            hr = hrtime();
            return hr[0] * 1e9 + hr[1];
        };
        moduleLoadTime = getNanoSeconds();
        upTime = $3d1dc255ff201a7e$exports.uptime() * 1e9;
        nodeLoadTime = moduleLoadTime - upTime;
    } else if (Date.now) {
        $5614fc581e3b4cfe$exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        $5614fc581e3b4cfe$exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call($5614fc581e3b4cfe$exports);


var $48d150d77846bea0$var$root = typeof window === "undefined" ? $parcel$global : window, $48d150d77846bea0$var$vendors = [
    "moz",
    "webkit"
], $48d150d77846bea0$var$suffix = "AnimationFrame", $48d150d77846bea0$var$raf = $48d150d77846bea0$var$root["request" + $48d150d77846bea0$var$suffix], $48d150d77846bea0$var$caf = $48d150d77846bea0$var$root["cancel" + $48d150d77846bea0$var$suffix] || $48d150d77846bea0$var$root["cancelRequest" + $48d150d77846bea0$var$suffix];
for(var $48d150d77846bea0$var$i = 0; !$48d150d77846bea0$var$raf && $48d150d77846bea0$var$i < $48d150d77846bea0$var$vendors.length; $48d150d77846bea0$var$i++){
    $48d150d77846bea0$var$raf = $48d150d77846bea0$var$root[$48d150d77846bea0$var$vendors[$48d150d77846bea0$var$i] + "Request" + $48d150d77846bea0$var$suffix];
    $48d150d77846bea0$var$caf = $48d150d77846bea0$var$root[$48d150d77846bea0$var$vendors[$48d150d77846bea0$var$i] + "Cancel" + $48d150d77846bea0$var$suffix] || $48d150d77846bea0$var$root[$48d150d77846bea0$var$vendors[$48d150d77846bea0$var$i] + "CancelRequest" + $48d150d77846bea0$var$suffix];
}
// Some versions of FF have rAF but not cAF
if (!$48d150d77846bea0$var$raf || !$48d150d77846bea0$var$caf) {
    var $48d150d77846bea0$var$last = 0, $48d150d77846bea0$var$id = 0, $48d150d77846bea0$var$queue = [], $48d150d77846bea0$var$frameDuration = 1000 / 60;
    $48d150d77846bea0$var$raf = function(callback) {
        if ($48d150d77846bea0$var$queue.length === 0) {
            var _now = $5614fc581e3b4cfe$exports(), next = Math.max(0, $48d150d77846bea0$var$frameDuration - (_now - $48d150d77846bea0$var$last));
            $48d150d77846bea0$var$last = next + _now;
            setTimeout(function() {
                var cp = $48d150d77846bea0$var$queue.slice(0);
                // Clear queue here to prevent
                // callbacks from appending listeners
                // to the current frame's queue
                $48d150d77846bea0$var$queue.length = 0;
                for(var i = 0; i < cp.length; i++){
                    if (!cp[i].cancelled) try {
                        cp[i].callback($48d150d77846bea0$var$last);
                    } catch (e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                }
            }, Math.round(next));
        }
        $48d150d77846bea0$var$queue.push({
            handle: ++$48d150d77846bea0$var$id,
            callback: callback,
            cancelled: false
        });
        return $48d150d77846bea0$var$id;
    };
    $48d150d77846bea0$var$caf = function(handle) {
        for(var i = 0; i < $48d150d77846bea0$var$queue.length; i++)if ($48d150d77846bea0$var$queue[i].handle === handle) $48d150d77846bea0$var$queue[i].cancelled = true;
    };
}
$48d150d77846bea0$exports = function(fn) {
    // Wrap in a new function to prevent
    // `cancel` potentially being assigned
    // to the native rAF function
    return $48d150d77846bea0$var$raf.call($48d150d77846bea0$var$root, fn);
};
$48d150d77846bea0$exports.cancel = function() {
    $48d150d77846bea0$var$caf.apply($48d150d77846bea0$var$root, arguments);
};
$48d150d77846bea0$exports.polyfill = function(object) {
    if (!object) object = $48d150d77846bea0$var$root;
    object.requestAnimationFrame = $48d150d77846bea0$var$raf;
    object.cancelAnimationFrame = $48d150d77846bea0$var$caf;
};


var $147b8cd2206d459f$exports = {};
$147b8cd2206d459f$exports = $parcel$global.performance && $parcel$global.performance.now ? function now() {
    return performance.now();
} : Date.now || function now() {
    return +new Date;
};


var $636b8989901872c6$exports = {};
"use strict";
var $2cb80178ba52e8bc$exports = {};
/*!
 * repeat-string <https://github.com/jonschlinkert/repeat-string>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */ "use strict";
/**
 * Results cache
 */ var $2cb80178ba52e8bc$var$res = "";
var $2cb80178ba52e8bc$var$cache;
/**
 * Expose `repeat`
 */ $2cb80178ba52e8bc$exports = $2cb80178ba52e8bc$var$repeat;
/**
 * Repeat the given `string` the specified `number`
 * of times.
 *
 * **Example:**
 *
 * ```js
 * var repeat = require('repeat-string');
 * repeat('A', 5);
 * //=> AAAAA
 * ```
 *
 * @param {String} `string` The string to repeat
 * @param {Number} `number` The number of times to repeat the string
 * @return {String} Repeated string
 * @api public
 */ function $2cb80178ba52e8bc$var$repeat(str, num) {
    if (typeof str !== "string") throw new TypeError("expected a string");
    // cover common, quick use cases
    if (num === 1) return str;
    if (num === 2) return str + str;
    var max = str.length * num;
    if ($2cb80178ba52e8bc$var$cache !== str || typeof $2cb80178ba52e8bc$var$cache === "undefined") {
        $2cb80178ba52e8bc$var$cache = str;
        $2cb80178ba52e8bc$var$res = "";
    } else if ($2cb80178ba52e8bc$var$res.length >= max) return $2cb80178ba52e8bc$var$res.substr(0, max);
    while(max > $2cb80178ba52e8bc$var$res.length && num > 1){
        if (num & 1) $2cb80178ba52e8bc$var$res += str;
        num >>= 1;
        str += str;
    }
    $2cb80178ba52e8bc$var$res += str;
    $2cb80178ba52e8bc$var$res = $2cb80178ba52e8bc$var$res.substr(0, max);
    return $2cb80178ba52e8bc$var$res;
}


var $7643cd356dc0f276$exports = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $7643cd356dc0f276$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $7643cd356dc0f276$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $7643cd356dc0f276$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $7643cd356dc0f276$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $7643cd356dc0f276$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
$7643cd356dc0f276$exports = $7643cd356dc0f276$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $7643cd356dc0f276$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($7643cd356dc0f276$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($7643cd356dc0f276$var$getOwnPropertySymbols) {
            symbols = $7643cd356dc0f276$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($7643cd356dc0f276$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};


var $4713b0a34e87aab5$exports = {};
"use strict";
$4713b0a34e87aab5$exports = function(val) {
    if (val === null || val === undefined) return [];
    return Array.isArray(val) ? val : [
        val
    ];
};


$636b8989901872c6$exports = function toCss(object, opts) {
    opts = $7643cd356dc0f276$exports({
        indent: "",
        property: $636b8989901872c6$var$identity,
        value: $636b8989901872c6$var$identity,
        selector: $636b8989901872c6$var$identity
    }, opts);
    if (typeof opts.indent === "number") opts.indent = $2cb80178ba52e8bc$exports(" ", opts.indent);
    function props(prop, val) {
        return $4713b0a34e87aab5$exports(prop).reduce(function(props, p) {
            return props.concat(opts.property(p, val));
        }, []);
    }
    function values(val, prop) {
        return $4713b0a34e87aab5$exports(val).reduce(function(vals, v) {
            return vals.concat(opts.value(v, prop));
        }, []);
    }
    function selectors(sel, value) {
        return $4713b0a34e87aab5$exports(sel).reduce(function(sels, s) {
            return sels.concat(opts.selector(s, value));
        }, []);
    }
    function _toCss(obj, level) {
        var str = "";
        Object.keys(obj).forEach(function(sel) {
            var value = obj[sel];
            if ($636b8989901872c6$var$isLastLevel(value)) {
                str += $636b8989901872c6$var$rule(props(sel, value), values(value, sel), opts.indent, level - 1);
                return;
            } else if (Array.isArray(value)) {
                value.forEach(function(val) {
                    str += _toCss($636b8989901872c6$var$nest(sel, val), level);
                });
                return;
            }
            selectors(sel, value).forEach(function(selector) {
                str += $636b8989901872c6$var$start(selector, opts.indent, level);
                Object.keys(value).forEach(function(prop) {
                    var value = obj[sel][prop];
                    if ($636b8989901872c6$var$oneMoreLevelExists(value)) str += _toCss($636b8989901872c6$var$nest(prop, value), level + 1);
                    else str += $636b8989901872c6$var$rule(props(prop, value), values(value, prop), opts.indent, level);
                });
                str += $636b8989901872c6$var$end(opts.indent, level);
            });
        });
        return str;
    }
    return $4713b0a34e87aab5$exports(object).map(function(o) {
        return _toCss(o, 0);
    }).join($636b8989901872c6$var$lineEnd(opts.indent));
};
function $636b8989901872c6$var$nest(prop, val) {
    var tmp = {};
    tmp[prop] = val;
    return tmp;
}
function $636b8989901872c6$var$isLastLevel(val) {
    return typeof val === "string" || Array.isArray(val) && val.length && typeof val[0] !== "object";
}
function $636b8989901872c6$var$oneMoreLevelExists(val) {
    return typeof val === "object" && !Array.isArray(val);
}
function $636b8989901872c6$var$identity(v) {
    return v;
}
function $636b8989901872c6$var$lineStart(indent, level) {
    return indent ? $2cb80178ba52e8bc$exports(indent, level) : "";
}
function $636b8989901872c6$var$space(indent) {
    return indent ? " " : "";
}
function $636b8989901872c6$var$lineEnd(indent) {
    return indent ? "\n" : "";
}
function $636b8989901872c6$var$start(sel, indent, level) {
    return $636b8989901872c6$var$lineStart(indent, level) + sel + $636b8989901872c6$var$space(indent) + "{" + $636b8989901872c6$var$lineEnd(indent);
}
function $636b8989901872c6$var$end(indent, level) {
    return $636b8989901872c6$var$lineStart(indent, level) + "}" + $636b8989901872c6$var$lineEnd(indent);
}
function $636b8989901872c6$var$rule(props, values, indent, level) {
    var linestart = $636b8989901872c6$var$lineStart(indent, level + 1);
    var lineend = $636b8989901872c6$var$lineEnd(indent);
    var s = $636b8989901872c6$var$space(indent);
    var str = "";
    for(var i = 0, propLength = props.length; i < propLength; i++)for(var j = 0, valueLength = values.length; j < valueLength; j++)str += linestart + props[i] + ($636b8989901872c6$var$isAtRule(props[i]) ? " " : ":") + s + values[j] + ";" + lineend;
    return str;
}
function $636b8989901872c6$var$isAtRule(prop) {
    return prop.indexOf("@") === 0;
}


$78ce2a669c6df413$exports = $78ce2a669c6df413$var$fps;
function $78ce2a669c6df413$var$fps(opts) {
    if (!(this instanceof $78ce2a669c6df413$var$fps)) return new $78ce2a669c6df413$var$fps(opts);
    if (typeof opts === "string") {
        if ($78ce2a669c6df413$var$positions[opts]) opts = {
            position: opts
        };
        else opts = {
            container: opts
        };
    }
    opts = opts || {};
    if (opts.container) {
        if (typeof opts.container === "string") this.container = document.querySelector(opts.container);
        else this.container = opts.container;
    } else this.container = document.body || document.documentElement;
    //init fps
    this.element = document.createElement("div");
    this.element.className = "fps";
    this.element.innerHTML = [
        '<div class="fps-bg"></div>',
        '<canvas class="fps-canvas"></canvas>',
        '<span class="fps-text">fps <span class="fps-value">60.0</span></span>'
    ].join("");
    this.container.appendChild(this.element);
    this.canvas = this.element.querySelector(".fps-canvas");
    this.textEl = this.element.querySelector(".fps-text");
    this.valueEl = this.element.querySelector(".fps-value");
    this.bgEl = this.element.querySelector(".fps-bg");
    var style = opts.css || opts.style || "";
    if (typeof style === "object") style = $636b8989901872c6$exports(style);
    var posCss = "";
    posCss = $78ce2a669c6df413$var$positions[opts.position] || $78ce2a669c6df413$var$positions["top-left"];
    this.element.style.cssText = [
        "line-height: 1;",
        "position: fixed;",
        "font-family: Roboto, sans-serif;",
        "z-index: 1;",
        "font-weight: 300;",
        "font-size: small;",
        "padding: 1rem;",
        posCss,
        opts.color ? "color:" + opts.color : "",
        style
    ].join("");
    this.canvas.style.cssText = [
        "position: relative;",
        "width: 2em;",
        "height: 1em;",
        "display: block;",
        "float: left;",
        "margin-right: .333em;"
    ].join("");
    this.bgEl.style.cssText = [
        "position: absolute;",
        "height: 1em;",
        "width: 2em;",
        "background: currentcolor;",
        "opacity: .1;"
    ].join("");
    this.canvas.width = parseInt(getComputedStyle(this.canvas).width) || 1;
    this.canvas.height = parseInt(getComputedStyle(this.canvas).height) || 1;
    this.context = this.canvas.getContext("2d");
    var ctx = this.context;
    var w = this.canvas.width;
    var h = this.canvas.height;
    var count = 0;
    var lastTime = 0;
    var values = opts.values || Array(this.canvas.width);
    var period = opts.period || 1000;
    var max = opts.max || 100;
    //enable update routine
    var that = this;
    $48d150d77846bea0$exports(function measure() {
        count++;
        var t = $147b8cd2206d459f$exports();
        if (t - lastTime > period) {
            lastTime = t;
            values.push(count / (max * period * 0.001));
            values = values.slice(-w);
            count = 0;
            ctx.clearRect(0, 0, w, h);
            ctx.fillStyle = getComputedStyle(that.canvas).color;
            for(var i = w; i--;){
                var value = values[i];
                if (value == null) break;
                ctx.fillRect(i, h - h * value, 1, h * value);
            }
            that.valueEl.innerHTML = (values[values.length - 1] * max).toFixed(1);
        }
        $48d150d77846bea0$exports(measure);
    });
}
var $78ce2a669c6df413$var$positions = {
    "top-left": "left: 0; top: 0;",
    "top-right": "right: 0; top: 0;",
    "bottom-right": "right: 0; bottom: 0;",
    "bottom-left": "left: 0; bottom: 0;"
};


const $a0fef7c841dcaa76$var$r = Array.prototype.reduce;
const $a0fef7c841dcaa76$export$533b26079ad0b4b = (f, a, to)=>// Needs separate `call` because native detects even `undefined` parameter.
    to === undefined ? $a0fef7c841dcaa76$var$r.call(a, f) : $a0fef7c841dcaa76$var$r.call(a, f, to);
var $a0fef7c841dcaa76$export$2e2bcd8739ae039 = $a0fef7c841dcaa76$export$533b26079ad0b4b;


const $a8bd34883e6c6917$export$871de8747c9eaa88 = (f, a, to = [])=>(0, $a0fef7c841dcaa76$export$533b26079ad0b4b)((to, v, i)=>{
        to[i] = f(v, i, a, to);
        return to;
    }, a, to || a);
var $a8bd34883e6c6917$export$2e2bcd8739ae039 = $a8bd34883e6c6917$export$871de8747c9eaa88;



const $33f17267bd9f0c05$var$e = Array.prototype.forEach;
const $33f17267bd9f0c05$export$79b2f7037acddd43 = (f, a)=>{
    $33f17267bd9f0c05$var$e.call(a, f);
    return a;
};
var $33f17267bd9f0c05$export$2e2bcd8739ae039 = $33f17267bd9f0c05$export$79b2f7037acddd43;


/**
 * Wraps an index over a given length, so that indexes greater than the length
 * loop back past `0`, and indexes less than `0` loop backward from the length.
 * Similar to the indexing behaviour of `Array`'s `slice`.
 * Indexing is the equivalent of a true _modulo_ operator, where JavaScript's
 * `%` operator is actually a _remainder_ operator.
 *
 * @see Array.prototpye.slice
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Remainder
 *
 * @param {number} i Index to wrap.
 * @param {number} l Length to wrap the index over.
 *
 * @returns {number} The index wrapped over the length.
 */ const $e90571c48d90ff65$export$acb6ab09ed1b7b8b = (i, l)=>(i % l + l) % l;
var $e90571c48d90ff65$export$2e2bcd8739ae039 = $e90571c48d90ff65$export$acb6ab09ed1b7b8b;


const $118b47bfc49fdb1b$export$4997ffc0176396a6 = (i, l, end = l.length)=>end || end === 0 ? l[(0, $e90571c48d90ff65$export$2e2bcd8739ae039)(i, end)] : (0, $e90571c48d90ff65$export$2e2bcd8739ae039)(i, l);
var $118b47bfc49fdb1b$export$2e2bcd8739ae039 = $118b47bfc49fdb1b$export$4997ffc0176396a6;


const { fill: $a17f2cccfa5f5eb1$var$fill } = Array.prototype;
const { isFinite: $a17f2cccfa5f5eb1$var$isFinite } = Number;
const { floor: $a17f2cccfa5f5eb1$var$floor } = Math;
const $a17f2cccfa5f5eb1$export$d02631cccf789723 = (l = 0, value, start, end)=>$a17f2cccfa5f5eb1$var$fill.call($a17f2cccfa5f5eb1$var$isFinite(l) ? Array($a17f2cccfa5f5eb1$var$floor(l)) : l, value, start, end);
var $a17f2cccfa5f5eb1$export$2e2bcd8739ae039 = $a17f2cccfa5f5eb1$export$d02631cccf789723;


/**
 * **Main `index.js` - see [`readme`](..)**
 *
 * [![`gl-gpgpu` particles demo](media://demo-particles-regl-frames.png)](..)
 *
 * [GPGPU](https://en.wikipedia.org/wiki/General-purpose_computing_on_graphics_processing_units)
 * state-stepping - declaratively maps optimal draw passes, shaders, `GL`
 * resources, inputs, outputs - lets you focus on your logic, BYO-renderer.
 *
 * Decouples logic from rendering approach/engine.
 * Each module and hook may be used as given, or piecemeal, or overridden.
 *
 * @module (root)
 * @category Root
 * @category JS
 *
 * @todo Add a way to look up values from previous passes in the current step:
 *   - We have `past` state inputs and the `next` state outputs, so adjacent
 *     states in the current pass can be called `got` states.
 *   - All states are already accessible in the shader, just need a way to
 *     declare the lookup is desired; maybe a negative index in `derives` should
 *     signify that, and be handled in the `tapStates` macros?
 * @todo Add a way to resize all `gpgpu` resources in one convenient function.
 * @todo Handle values with more channels than `channelsMax`...
 */ /**
 * Description of the `api` hooks for `gpgpu`, to interact with `GL` resources.
 *
 * Not implemented within the `gpgpu` library.
 *
 * Based on [`regl`](https://github.com/regl-project/regl/)'s API; but can be
 * use any `GL` renderer, given hooks matching these implementations.
 *
 * @module
 * @category API Hooks
 *
 * @todo [Fix `@callback`/`@typedef`](https://github.com/TypeStrong/typedoc/issues/1896):
 *   nested `@param`; omits `@return`/`@see`/`@this`
 */ /**
 * @callback getFramebuffer
 * A `function` to create or update a `GL` `framebuffer`; via a `GL` `api`.
 *
 * **See**
 *
 * - {@link framebuffer}
 * - {@link data.toData}
 *
 * **This**
 *
 * Updates any `this` value's `framebuffer` in-place (or similar handling);
 * otherwise if `null`ish, returns a new `framebuffer`.
 *
 * **Returns**
 *
 * A `GL` `framebuffer` created or updated by any given `options`, or an
 * `object` serving that purpose.
 *
 * @param {{
 *     depth?:object,
 *     stencil?:object,
 *     width?:number,
 *     height?:number,
 *     color?:texture[]
 *   }} options Options to create or update a `GL` `framebuffer`; with:
 *   - `depth`: Any `framebuffer` depth attachment, or a flag for whether it
 *     should be created.
 *   - `stencil`: Any `framebuffer` stencil attachment, or a flag for whether it
 *     should be created.
 *   - `width`: The width of the `framebuffer`.
 *   - `height`: The height of the `framebuffer`.
 *   - `color`: The `texture` attachments to use.
 *
 * @returns {framebuffer}
 */ /**
 * @callback useFramebuffer
 * Bind a `GL` `framebuffer` while calling a given `function`; via a `GL` `api`.
 *
 * **See**
 *
 * - {@link framebuffer}
 * - {@link step.toStep}
 *
 * **This**
 *
 * Uses any `this` value's `framebuffer` (or similar handling).
 *
 * @param {()=>void} hook A `function` to call while the `framebuffer` is bound.
 */ /**
 * @typedef {object} framebuffer
 * A `GL` `framebuffer`, or an `object` serving that purpose; via a `GL` `api`.
 *
 * **See**
 *
 * - {@link getFramebuffer}
 * - {@link data.toData}
 *
 * @prop {getFramebuffer} call Update this `framebuffer` in-place.
 * @prop {useFramebuffer} use Bind this `framebuffer` for the given `function`.
 */ /**
 * @callback getTexture
 * A `function` hook to create or update a `GL` `texture`; via a `GL` `api`.
 *
 * **See**
 *
 * - {@link api}
 * - {@link texture}
 * - {@link data.toData}
 *
 * **Returns**
 *
 * A `GL` `texture`, or an `object` serving that purpose.
 *
 * @param {string} type Any `texture` data type value.
 * @param {string} min Any `texture` minification filter value.
 * @param {string} mag Any `texture` magnification filter value.
 * @param {string} wrap Any `texture` wrap mode value.
 * @param {number} width The width of the `texture`.
 * @param {number} height The height of the `texture`.
 * @param {number} channels The number of channels of the `texture`.
 *
 * @returns {texture}
 */ /**
 * @callback subimage
 * Copy from a given source `texture` to part of `this` output `texture`; via
 * a `GL` `api`.
 *
 * **See**
 *
 * - {@link api}
 * - {@link texture}
 * - {@link getTexture}
 * - {@link step.toStep}
 *
 * **Returns**
 *
 * The output `texture`, `this`; the source `texture` copied to part of it.
 *
 * **This**
 *
 * Uses any `this` value's `texture` as the output to copy into.
 *
 * @param {texture} source A `texture` to copy to part of the output `texture`.
 * @param {number} [x=0] Offset along the output `texture`'s x-axis.
 * @param {number} [y=0] Offset along the output `texture`'s y-axis.
 *
 * @returns {texture}
 */ /**
 * @typedef {object} texture
 * A `GL` `texture`, or an `object` serving that purpose; via a `GL` `api`.
 *
 * **See**
 *
 * - {@link getTexture}
 * - {@link data.toData}
 *
 * @prop {getTexture} call Update this `texture` in-place.
 * @prop {subimage} subimage Copy from a source `texture` into part of `this`
 *   destination `texture`.
 */ /**
 * @callback getBuffer
 * A `function` to set up a `GL` buffer; via a `GL` `api`.
 *
 * **See**
 *
 * - {@link buffer}
 * - {@link attributes.getAttributes}
 *
 * @param {number[]|{[k:string|number]:number}|buffer} data Data to create a new
 *   `buffer`; or an existing `buffer` to use as-is.
 *
 * @returns {buffer}
 */ /**
 * @typedef {object} buffer
 * A `GL` `buffer` for vertex `attribute`s, or an `object` serving that purpose;
 * via a `GL` `api`.
 */ /**
 * @callback clear
 * A `function` to clear `GL` output view or `framebuffer`; via a `GL` `api`.
 *
 * **See**
 *
 * - {@link framebuffer}
 * - {@link step.toStep}
 *
 * @param {{
 *     color?:number[],
 *     depth?:number,
 *     stencil?:number,
 *     framebuffer?:framebuffer
 *   }} options Options to clear `GL`; with:
 *   - `color`: The values to clear any color buffers with.
 *   - `depth`: The value to clear any depth buffer with.
 *   - `stencil`: The value to clear any stencil buffer with.
 *   - `framebuffer`: Any `framebuffer` to clear; if not given, clears any
 *     `framebuffer` already bound, or the view if none are bound.
 */ /**
 * @callback command
 * A `function` to create a `GL` render pass execution `function`, to be called
 * later, given options, for a render pass; via a `GL` `api`.
 *
 * **See**
 *
 * - {@link buffer}
 * - {@link attributes}
 * - {@link framebuffer}
 * - {@link step.toStep}
 * - {@link uniforms.toUniforms}
 * - {@link uniforms.getUniform}
 *
 * **Returns**
 *
 * A `function` to execute a `GL` render pass, given options.
 *
 * @param {{
 *     vert?:(context,state)=>string,
 *     frag?:(context,state)=>string,
 *     count?:number,
 *     attributes?:{[k:string]:buffer},
 *     uniforms?:{[k:string]:getUniform},
 *     depth?:{[k:string]:boolean|{}},
 *     framebuffer?:(context,state)=>framebuffer
 *   }} options Options to create a `GL` render pass `function`; with:
 *   - `vert`: Hook to get any `GLSL` vertex shader `string`.
 *   - `frag`: Hook to get any `GLSL` fragment shader `string`.
 *   - `count`: Any `number` of elements to render.
 *   - `attributes`: Map of any `GL` `attribute` `buffer`s.
 *     See `attributes`, `buffer`, `toStep`.
 *   - `uniforms`: Map of any `GL` `uniform` hooks.
 *     See `uniforms`, `toUniforms`, and `getUniform`.
 *   - `depth`: Any `GL` depth settings (e.g: `options.depth.enable`).
 *   - `framebuffer`: Hook to get any `framebuffer` to render into.
 *     See `framebuffer`.
 *
 * @returns {(context,state)=>void}
 */ /**
 * @typedef {{
 *     framebuffer:getFramebuffer,
 *     texture:getTexture,
 *     buffer:getBuffer,
 *     clear:clear,
 *     command:command,
 *     call:command
 *   }} api
 * An API `object` given to `gpgpu`, to interact with `GL` resources.
 *
 * Based on [`regl`](https://github.com/regl-project/regl/)'s API; but can be
 * use any `GL` renderer, given hooks matching these implementations.
 */ /** @ignore */ var $347b3f28ba8ab7b1$export$2e2bcd8739ae039 = null;


/**
 * Default properties for `gpgpu` and `GL` capabilities and resources.
 *
 * @module
 * @category JS
 */ const $0ae4a8af2230f72b$export$ba60520149d1328e = [
    [
        -1,
        -1
    ],
    [
        -1,
        4
    ],
    [
        4,
        -1
    ]
];
const $0ae4a8af2230f72b$export$85b9a36db797e02b = $0ae4a8af2230f72b$export$ba60520149d1328e.length;
const $0ae4a8af2230f72b$export$c96e90b4bcb7d4ca = 2;
const $0ae4a8af2230f72b$export$878041e1e4cd4218 = $0ae4a8af2230f72b$export$ba60520149d1328e.flat();
var $0ae4a8af2230f72b$export$2e2bcd8739ae039 = $0ae4a8af2230f72b$export$878041e1e4cd4218;


var $caa017c225f896af$exports = {};
$caa017c225f896af$exports = "/**\n * Default `gpgpu` vertex shader.\n *\n * @see [@epok.tech/gl-screen-triangle/uv-texture.vert.glsl](https://github.com/keeffEoghan/gl-screen-triangle/tree/master/uv-texture.vert.glsl)\n */\n\nprecision highp float;\n#define GLSLIFY 1\n\n/**\n * Uses the default prefix namespace; replaced with any given prefix if this\n * shader's used during `toStep`.\n *\n * @see {@link const.preDef}\n * @see {@link step.toStep}\n */\nattribute vec2 gpgpu_position;\n\nvarying vec2 gpgpu_uv;\n\nvoid main() {\n  // Texture coordinates, range `[0, 1]`, y-axis points upwards.\n  gpgpu_uv = (gpgpu_position*0.5)+0.5;\n  gl_Position = vec4(gpgpu_position, 0, 1);\n}\n";


const $c3a4c4b89537eec0$export$dc207adda608f979 = (0, (/*@__PURE__*/$parcel$interopDefault($caa017c225f896af$exports)));
const $c3a4c4b89537eec0$export$cfdc3a7c4cb854c6 = ()=>[
        ...(0, $0ae4a8af2230f72b$export$878041e1e4cd4218)
    ];
const $c3a4c4b89537eec0$export$832d88422d279bbc = (0, $0ae4a8af2230f72b$export$85b9a36db797e02b);
const $c3a4c4b89537eec0$export$ac0cd3cc21f80dfc = ()=>[
        "oes_texture_float",
        "webgl_color_buffer_float"
    ];
const $c3a4c4b89537eec0$export$5d97924d29f48e83 = ()=>[
        "oes_texture_half_float",
        "ext_color_buffer_half_float"
    ];
const $c3a4c4b89537eec0$export$fdb75c5ac32869de = ()=>[
        "webgl_draw_buffers"
    ];
const $c3a4c4b89537eec0$export$cc3e2d3244e01b7f = ()=>[];
const $c3a4c4b89537eec0$export$4bceda1224fc5ab8 = $c3a4c4b89537eec0$export$fdb75c5ac32869de;
const $c3a4c4b89537eec0$export$918e5821fc7288cd = $c3a4c4b89537eec0$export$4bceda1224fc5ab8;
const $c3a4c4b89537eec0$export$b4781c2237bde956 = "gpgpu_";
const $c3a4c4b89537eec0$export$26945b8c914b7fc = 4;
const $c3a4c4b89537eec0$export$154f256b9eac9103 = 4;
const $c3a4c4b89537eec0$export$b6267c3f91c57c78 = 1;
const $c3a4c4b89537eec0$export$b029aceb5666f022 = 1;
const $c3a4c4b89537eec0$export$71c6d8e332d66a75 = 0;
const $c3a4c4b89537eec0$export$c4175b5828221aa7 = 2 ** $c3a4c4b89537eec0$export$71c6d8e332d66a75;
const $c3a4c4b89537eec0$export$bffb644e7dc52e91 = 2 ** $c3a4c4b89537eec0$export$71c6d8e332d66a75;
const $c3a4c4b89537eec0$export$617a37502ff8853 = 2;
const $c3a4c4b89537eec0$export$ff01eb58fe4e69 = ()=>[
        $c3a4c4b89537eec0$export$154f256b9eac9103
    ];
const $c3a4c4b89537eec0$export$27fb0dad99ae5dd2 = "float";
const $c3a4c4b89537eec0$export$47b10f415de592b1 = "nearest";
const $c3a4c4b89537eec0$export$1fb689c67b965bff = "nearest";
const $c3a4c4b89537eec0$export$8d7f4a48e1f2b2a = "clamp";
const $c3a4c4b89537eec0$export$a211ab2c8ecded9a = false;
const $c3a4c4b89537eec0$export$a1b7c201e9365814 = false;
const $c3a4c4b89537eec0$export$5544d416ac8224f1 = /[0-9\.]+/;
const $c3a4c4b89537eec0$export$2902d6d00b7c2bce = 8192;
const $c3a4c4b89537eec0$export$2fcc13103217f9a3 = ()=>({
        color: [
            0,
            0,
            0,
            0
        ],
        depth: 1,
        stencil: 0
    });
const $c3a4c4b89537eec0$export$72e520e6a70b780c = ()=>({
        copy: true
    });


/**
 * The `gpgpu` maps of data for optimal inputs/outputs on a platform.
 *
 * These maps show how to make optimal use of a platform's supported features,
 * how to pack/unpack their data from `framebuffer`s/`texture`s, perform minimal
 * needed samples to retrieve any past values they must derive from, etc.
 *
 * Shaders may declare values they output, values they derive from, groupings of
 * in/dependent values - without handling how these concerns map to the
 * particular platform resources they're using.
 *
 * Platform limits/features/extensions are accounted for, to produce the most
 * efficient mappings available with the least I/O when it comes to drawing
 * (draw passes, `texture` samples, etc).
 *
 * @module
 * @category JS
 *
 * @todo Allow passes within/across `texture`s; separate data/`texture` shapes.
 */ 



const { isInteger: $9ca80cadf3eaf758$var$isInteger } = Number;
const { isArray: $9ca80cadf3eaf758$var$isArray } = Array;
const $9ca80cadf3eaf758$export$5ca26c99531348ec = (value, channelsMax = (0, $c3a4c4b89537eec0$export$154f256b9eac9103))=>1 <= value || value <= channelsMax || !!console.error(`\`gl-gpgpu\`: the given value (${value}) exceeds the ` + `range of channels available, \`[1, ${channelsMax}]\` inclusive.`, value, channelsMax);
const $9ca80cadf3eaf758$export$f5edbc631dafdbf = (buffersMax)=>$9ca80cadf3eaf758$var$isInteger(buffersMax) && 0 < buffersMax && buffersMax < Infinity;
function $9ca80cadf3eaf758$export$9d1d9285bd6d8c57(values, channelsMax = (0, $c3a4c4b89537eec0$export$154f256b9eac9103), to = []) {
    // Fill `to` with indexes of `values`, and ensure it's the same length.
    (0, $a8bd34883e6c6917$export$2e2bcd8739ae039)((_, i)=>i, values, to).length = values.length;
    /** Counts the number of empty channels in the current group. */ let channels = channelsMax;
    /** How many values have already been packed. */ let packed = 0;
    /** Tracks the value that best fits the free channels (fills it tightest). */ let fitIndex = 0;
    let fitSize = Infinity;
    for(let i = 0; packed < values.length;){
        const v = packed + i;
        const value = values[to[v]];
        if (!$9ca80cadf3eaf758$export$5ca26c99531348ec(value, channelsMax)) return to;
        // Check how value fits the channels - valid is >= 0, perfect is 0.
        const fit = channels - value;
        if (fit >= 0 && fit < fitSize) {
            fitSize = fit;
            fitIndex = v;
        }
        // Not a perfect fit and can keep searching for better fits - continue.
        if (fitSize !== 0 && v < values.length - 1) ++i;
        else {
            // Got a perfect fit or the search ended - swap in best fit value.
            const pack = to[fitIndex];
            to[fitIndex] = to[packed];
            to[packed] = pack;
            (channels -= values[pack]) > 0 || (channels = channelsMax);
            // Start the search again over the remaining unpacked entries.
            fitIndex = ++packed;
            fitSize = Infinity;
            i = 0;
        }
    }
    return to;
}
function $9ca80cadf3eaf758$export$96707a1f51900f3d(maps = {}, to = maps) {
    const { values: values = (0, $c3a4c4b89537eec0$export$ff01eb58fe4e69)(), buffersMax: buffersMax = (0, $c3a4c4b89537eec0$export$b6267c3f91c57c78), channelsMax: channelsMax = (0, $c3a4c4b89537eec0$export$154f256b9eac9103), packed: // Pack `values` into blocks of `channelsMax` to minimise resources.
    packed = $9ca80cadf3eaf758$export$9d1d9285bd6d8c57(values, channelsMax) } = maps;
    // Ensure any properties changed are included.
    to.values = values;
    to.buffersMax = buffersMax;
    to.channelsMax = channelsMax;
    to.packed = packed;
    const passes = to.passes = [
        []
    ];
    const textures = to.textures = [
        []
    ];
    const valueToTexture = to.valueToTexture = [];
    const valueToPass = to.valueToPass = [];
    const textureToPass = to.textureToPass = [];
    /** Whether to use output buffers in passes, or no buffers in one pass. */ const output = !!buffersMax;
    /** Counts the number of channels written in a single draw pass. */ let channels = 0;
    /** Get the index, via any `packed`, from `values`. */ const getIndex = packed ? (i)=>packed[i] : (i)=>i;
    /** Get the value, via any `packed`, from `values`. */ const getValue = packed ? (_, i)=>values[i] : (v)=>v;
    return (0, $a0fef7c841dcaa76$export$2e2bcd8739ae039)((to, v, i)=>{
        const index = getIndex(i);
        const value = getValue(v, index);
        if (!$9ca80cadf3eaf758$export$5ca26c99531348ec(value, channelsMax)) return to;
        let p = passes.length - 1;
        let pass = passes[p];
        let t = textures.length - 1;
        let texture = textures[t];
        if ((channels += value) > channelsMax) {
            channels = value;
            t = textures.push(texture = []) - 1;
            output && pass.length >= buffersMax && (p = passes.push(pass = []) - 1);
            pass.push(t);
            textureToPass.push(p);
        } else if (pass.length === 0) {
            pass.push(t);
            textureToPass.push(p);
        }
        texture.push(index);
        valueToTexture[index] = t;
        valueToPass[index] = p;
        return to;
    }, values, to);
}
function $9ca80cadf3eaf758$export$574963e692b662ec(maps = {}, to = maps) {
    const { derives: derives, passes: passes, textures: textures, valueToTexture: valueToTexture } = maps;
    if (!derives && derives !== 0) return to;
    const reads = to.reads = [];
    const readsToValue = to.readsToValue = [];
    const cache = {};
    const allStepSamples = (step)=>cache[step] ??= (0, $a8bd34883e6c6917$export$2e2bcd8739ae039)((t, value)=>({
                step: step,
                value: value
            }), valueToTexture);
    const getAddSample = (pass, valueNext)=>function add(set, derive, d) {
            /** The past step to derive from. */ let step = 0;
            /** The past value to derive from. */ let dp = derive;
            // Derive from any specified `value` and `step` nested properties.
            derives !== true && !$9ca80cadf3eaf758$var$isInteger(derives) && ({ value: dp = dp, step: step = step } = derive);
            // Derive from all samples at the given or most recent step if given `true`.
            if (dp === true) return (0, $a0fef7c841dcaa76$export$2e2bcd8739ae039)(add, allStepSamples(step), set);
            // Derive from the given sample.
            const texture = valueToTexture[dp];
            if (!($9ca80cadf3eaf758$var$isInteger(step) && $9ca80cadf3eaf758$var$isInteger(texture))) return console.error("`mapSamples`: invalid map for sample", derives, maps, pass, valueNext, derive, d, step, texture, dp);
            // Create the set if not already created.
            const to = set || [];
            // Check for any existing matching step/texture read in the set.
            const i = to.findIndex(([s, t])=>s === step && t === texture);
            // Add the read for this next value in this pass; creating any needed maps.
            ((reads[pass] ??= [])[valueNext] ??= [])// A new read as needed, or any existing matching read.
            .push(i < 0 ? to.push([
                step,
                texture
            ]) - 1 : i);
            // Add a reverse lookup from read index to value index.
            ((readsToValue[pass] ??= [])[valueNext] ??= []).push(dp);
            return to;
        };
    const getAddSamples = (pass)=>(set, valueNext)=>{
            /** Derive next output value from any given past input values. */ const dn = $9ca80cadf3eaf758$var$isArray(derives) ? derives[valueNext] : derives;
            return !dn && dn !== 0 ? set : dn !== derives && $9ca80cadf3eaf758$var$isArray(dn) ? (0, $a0fef7c841dcaa76$export$2e2bcd8739ae039)(getAddSample(pass, valueNext), dn, set) : getAddSample(pass, valueNext)(set, dn);
        };
    to.samples = (0, $a8bd34883e6c6917$export$2e2bcd8739ae039)((pass, p)=>(0, $a0fef7c841dcaa76$export$2e2bcd8739ae039)((set, texture)=>(0, $a0fef7c841dcaa76$export$2e2bcd8739ae039)(getAddSamples(p), textures[texture], set), pass, null), passes, []);
    return to;
}
const $9ca80cadf3eaf758$export$798cdecdcbbf9755 = (maps, to = maps)=>$9ca80cadf3eaf758$export$574963e692b662ec($9ca80cadf3eaf758$export$96707a1f51900f3d(maps, to), to);
var /**
 * @typedef {derive|array.<derive|array.<derive>>>} derives
 * Denotes how next output `values` derive from any past input `values`.
 *
 * A nested hierarchy of the form
 * `all-next-from-past[any-next-from-past[any-next-from-any-past]]`; each
 * nesting level denotes how to derive:
 * 0. `all-next-from-past`: to all next `values`, from one/all past `value`/s.
 * 1. `any-next-from-past`: to any given next `values` (by sparse `array`
 *   indexes in `values` order), from one/all past `value`/s.
 * 2. `any-next-from-any-past`: to any given next `values` (by its `array` index
 *   in parent level 1), from any past `value`/s in this level 2 `array`.
 *
 * The `array`s are sparse, with empty or `false`y-non-integer entries ignored.
 *
 * See `derive` for how to denote past input `values`.
 *
 * **See**
 *
 * - {@link derive}
 */ /**
 * @typedef {true|number|{value:true|number,step?:number}} derive
 * Denotes any past input `values` (and optional past `step`), that next output
 * `values` derive from.
 *
 * A nested hierarchy of the form `any-value-past[any-value-step-past]`,
 * indexing `values`, each nesting level denotes how to derive from:
 * 0. `any-value-past`: any/all past input `value`/s, at 1st `step` past.
 * 1. `any-value-step-past`: any/all past input `value`/s, at any given `step`
 *   past.
 *
 * The `value`/s to derive from may be given as:
 * - `true`: derives from all `values`.
 * - `number`: derives from the given `values` index.
 *
 * If given a `true` or `number` (denoting `value`/s but no `step`), the next
 * output `value` derives from the given `values` at the 1st `step` past.
 *
 * To specify a different `step`, pass an `object` denoting both the `value` (as
 * above) along with a `step`; in the form `{value:true|number,step?:number}`,
 * to derive from the `value` at any given `step` past (or the 1st `step` past
 * if not given).
 *
 * Any omitted `values` are ignored.
 *
 * See `derives` for more on how these are derived by the next output `values`.
 *
 * **See**
 *
 * - {@link derives}
 */ $9ca80cadf3eaf758$export$2e2bcd8739ae039 = $9ca80cadf3eaf758$export$798cdecdcbbf9755;


/**
 * The `gpgpu` state and `GL` data resources.
 *
 * Handles `framebuffer`s, `texture`s; and the main meta info.
 *
 * @module
 * @category JS
 *
 * @todo Allow passes into or across `texture`s; separate shapes of data and
 *   `texture`s.
 * @todo In-place updates of complex resources and meta info.
 */ 



/**
 * @module
 * @category JS
 */ 


const { floor: $827d5157c38742eb$var$floor } = Math;
const { isFinite: $827d5157c38742eb$var$isFinite, isInteger: $827d5157c38742eb$var$isInteger } = Number;
function $827d5157c38742eb$export$3c49c185de0c2bfc(value) {
    const { width: width, w: w, x: x, shape: shape, size: size, side: side, 0: v0 } = value;
    return (size && $827d5157c38742eb$export$3c49c185de0c2bfc(size)) ?? width ?? w ?? x ?? (shape && $827d5157c38742eb$export$3c49c185de0c2bfc(shape)) ?? side ?? v0 ?? ($827d5157c38742eb$var$isFinite(value) ? value : null);
}
function $827d5157c38742eb$export$c08559766941f856(value) {
    const { height: height, h: h, y: y, shape: shape, size: size, side: side, 1: v1 } = value;
    return (size && $827d5157c38742eb$export$c08559766941f856(size)) ?? height ?? h ?? y ?? (shape && $827d5157c38742eb$export$c08559766941f856(shape)) ?? side ?? v1 ?? ($827d5157c38742eb$var$isFinite(value) ? value : null);
}
const $827d5157c38742eb$export$2815acae70277c92 = (size = 1, height = 1)=>size?.entries ?? ($827d5157c38742eb$export$3c49c185de0c2bfc(size) ?? 1) * ($827d5157c38742eb$export$c08559766941f856(height) ?? 1);
const $827d5157c38742eb$export$87ed20f81f3c66ff = (size)=>(0, $a8bd34883e6c6917$export$2e2bcd8739ae039)((_, i)=>i, (0, $a17f2cccfa5f5eb1$export$2e2bcd8739ae039)($827d5157c38742eb$var$isInteger(size) ? size : $827d5157c38742eb$export$2815acae70277c92(size)), 0);
const $827d5157c38742eb$export$19cc39c76123d7db = (scale)=>$827d5157c38742eb$var$isFinite(scale) ? 2 ** scale : null;
function $827d5157c38742eb$export$6574bcda6112260a(value, to = []) {
    let s;
    to[0] = $827d5157c38742eb$var$floor($827d5157c38742eb$export$3c49c185de0c2bfc(value) ?? (s ??= $827d5157c38742eb$export$19cc39c76123d7db(value.scale)) ?? (0, $c3a4c4b89537eec0$export$c4175b5828221aa7));
    to[1] = $827d5157c38742eb$var$floor($827d5157c38742eb$export$c08559766941f856(value) ?? (s ??= $827d5157c38742eb$export$19cc39c76123d7db(value.scale)) ?? (0, $c3a4c4b89537eec0$export$bffb644e7dc52e91));
    return to;
}



const { max: $815579669ce8de85$var$max } = Math;
const { isInteger: $815579669ce8de85$var$isInteger } = Number;
/**
 * Whether all states merge into one data-`texture` or remain separate by
 * default, according to the number of `steps` and `textures` to be tracked.
 *
 * Uses separate data-`texture`s when the `steps` and `textures` are few enough
 * to allow it without issue on all platforms; otherwise merges data-`texture`s.
 *
 * @param {number} [steps] How many `steps` of state to track.
 * @param {number} [textures] How many data-`textures` to track per-step.
 *
 * @returns {boolean} Whether to merge states to one data-`texture` by default.
 */ const $815579669ce8de85$var$mergeDef = (steps, textures)=>steps > 2 && textures > 1;
function $815579669ce8de85$export$24a6b176bdc41ce5({ texture: texture, framebuffer: framebuffer }, state = {}, to = state) {
    const { maps: maps, steps: steps = (0, $c3a4c4b89537eec0$export$617a37502ff8853), type: // Resource format settings.
    type = (0, $c3a4c4b89537eec0$export$27fb0dad99ae5dd2), min: min = (0, $c3a4c4b89537eec0$export$47b10f415de592b1), mag: mag = (0, $c3a4c4b89537eec0$export$1fb689c67b965bff), wrap: wrap = (0, $c3a4c4b89537eec0$export$8d7f4a48e1f2b2a), depth: depth = (0, $c3a4c4b89537eec0$export$a211ab2c8ecded9a), stencil: stencil = (0, $c3a4c4b89537eec0$export$a1b7c201e9365814) } = state;
    const shape = (0, $827d5157c38742eb$export$6574bcda6112260a)(state);
    const [width, height] = shape;
    const { values: values = maps.values = (0, $c3a4c4b89537eec0$export$ff01eb58fe4e69)(), channelsMin: channelsMin = maps.channelsMin = (0, $c3a4c4b89537eec0$export$26945b8c914b7fc), buffersMax: buffersMax = maps.buffersMax = (0, $c3a4c4b89537eec0$export$b6267c3f91c57c78), textures: texturesMap, passes: passesMap } = maps;
    const stepsL = steps.length ?? steps;
    const { merge: merge = $815579669ce8de85$var$mergeDef(stepsL, texturesMap.length) } = state;
    // Ensure any properties changed are included.
    to.steps = steps;
    to.merge = merge;
    to.type = type;
    to.min = min;
    to.mag = mag;
    to.wrap = wrap;
    to.depth = depth;
    to.stencil = stencil;
    to.width = width;
    to.height = height;
    /** Whether to use output buffers in passes, or no buffers in one pass. */ const output = buffersMax || null;
    /**
   * All `framebuffer` attachments need the same number of channels; enough to
   * hold all values a pass holds, or all passes hold if merging and reusing.
   */ const passChannels = (pass, min)=>(0, $a0fef7c841dcaa76$export$2e2bcd8739ae039)((min, t)=>$815579669ce8de85$var$max(min, (0, $a0fef7c841dcaa76$export$2e2bcd8739ae039)((sum, v)=>sum + values[v], texturesMap[t], 0)), pass, min);
    /**
   * If merging past `texture`s and reusing `texture` attachments in each pass's
   * `framebuffer`, pre-compute the minimum channels for a reusable pool of
   * `texture` attachments that can hold any pass's values; since all a
   * `framebuffer`'s attachments also need the same number of channels, this is
   * also the same number of channels across all passes.
   */ const mergeChannels = !merge ? null : (0, $a0fef7c841dcaa76$export$2e2bcd8739ae039)((min, p)=>passChannels(p, min), passesMap, channelsMin);
    /** Size of the created resources. */ const size = to.size ??= {};
    size.shape ??= shape;
    size.entries ??= (size.width ??= width) * (size.height ??= height);
    size.type ??= type;
    size.channelsMin ??= mergeChannels ?? channelsMin;
    size.steps ??= stepsL;
    size.passes ??= 0;
    size.framebuffers ??= 0;
    size.textures ??= 0;
    size.colors ??= 0;
    /** The `texture`s created for the `step`/`pass` render flow. */ const textures = to.textures = [];
    /** The passes created for the `step`/`pass` render flow. */ const passes = to.passes = [];
    /** The `texture`s bound to the next pass; reused if merging. */ let colorPool;
    /**
   * Add a `texture` attachment and meta info to `texture`s if applicable; to
   * return its new `texture` or a reused one to bind to a pass in `passes`.
   */ const addTexture = (channels, w, h, step, pass)=>(index, c, _, color)=>{
            /** Properties passed for `texture` creation, then meta info. */ const to = {
                channels: channels,
                width: w,
                height: h,
                type: type,
                min: min,
                mag: mag,
                wrap: wrap
            };
            // Resources.
            /**
     * Add/reuse `texture` color attachments as needed; add minimal `texture`s.
     * If merging, passes may reuse any pass's existing `texture` attachments;
     * otherwise, each pass has its own dedicated `texture` attachments.
     */ let entry = c;
            let t = color?.[entry];
            // Only create new `texture`s if existing ones can't be reused.
            if (!t) {
                t = texture?.(to);
                entry = size.textures++;
            }
            // Add meta info.
            /** Check if this is bound to a pass. */ const s = $815579669ce8de85$var$isInteger(step);
            const p = $815579669ce8de85$var$isInteger(pass);
            const i = $815579669ce8de85$var$isInteger(index);
            /** Denotes attached `texture`; if merging, `texture`s are reused. */ to.texture = t;
            /** Denotes attached `texture` entry; if merging, `texture`s are reused. */ to.entry = entry;
            s && (to.step = step);
            if (p) {
                /** Denotes `framebuffer` attachments; may reuse underlying `texture`s. */ to.color = size.colors++;
                to.pass = pass;
            }
            i && (to.map = texturesMap[to.index = index]);
            // Check whether this `texture` is part of the `step`/`pass` render flow.
            // If so, add to `textures`, return its `texture` to bind to a pass.
            // If not, return the entire object.
            return s && p && i ? ((textures[step] ??= [])[index] = to).texture : to;
        };
    /**
   * Add a pass to `passes`, with its `texture`s bound; to return its
   * `framebuffer` to one of `steps`.
   */ const addPass = (step, color)=>(pass, index)=>{
            /**
     * All a `framebuffer`'s attachments need the same number of channels;
     * superseded by any given `color`'s value.
     */ const channels = color != null ? 0 : mergeChannels ?? (pass ? passChannels(pass, channelsMin) : channelsMin);
            // Resources.
            /** Properties passed for `framebuffer` creation, then meta info. */ const to = {
                depth: depth,
                stencil: stencil,
                width: width,
                height: height,
                /** Map the pass's `texture` color attachments and their meta info. */ color: color ?? (pass ? (0, $a8bd34883e6c6917$export$2e2bcd8739ae039)(addTexture(channels, width, height, step, index), pass, // Reuse any existing color attachments if merging; otherwise make
                // dedicated color attachments for each pass.
                merge ? colorPool ??= [] : []) : [])
            };
            /**
     * The `framebuffer` for this pass; don't create or bind if `buffersMax`
     * is `false`y.
     */ to.framebuffer = output && framebuffer?.(to);
            // Add meta info.
            /** Denotes any attached `framebuffer` entry. */ to.entry = output && size.framebuffers++;
            if (pass) {
                to.map = pass;
                to.pass = size.passes++;
            }
            const s = $815579669ce8de85$var$isInteger(step);
            const i = $815579669ce8de85$var$isInteger(index);
            s && (to.step = step);
            i && (to.index = index);
            // Check whether this pass is part of the `step`/`pass` render flow.
            // If so, add to `passes`, return its `framebuffer` for its step.
            return pass && s && i ? ((passes[step] ??= [])[index] = to).framebuffer : to;
        };
    /**
   * Set up resources needed to store data per-`texture` per-pass per-step.
   * Use any given steps/passes or create new ones.
   */ to.steps = (0, $a8bd34883e6c6917$export$2e2bcd8739ae039)((passes, step)=>passes || (0, $a8bd34883e6c6917$export$2e2bcd8739ae039)(addPass(step), passesMap), $815579669ce8de85$var$isInteger(steps) ? (0, $a17f2cccfa5f5eb1$export$2e2bcd8739ae039)(steps) : steps, 0);
    /** Resize `texture`s, `framebuffer`s, and update `size`. */ to.resize = (value = to, state = to)=>{
        const { size: size, passes: passes, textures: textures, merge: merge } = state;
        const [w, h] = (0, $827d5157c38742eb$export$6574bcda6112260a)(value ?? state, size.shape ??= []);
        size.entries = (size.width = w) * (size.height = h);
        (0, $33f17267bd9f0c05$export$2e2bcd8739ae039)((s)=>(0, $33f17267bd9f0c05$export$2e2bcd8739ae039)((p)=>p.framebuffer.resize(p.width = w, p.height = h), s), passes);
        (0, $33f17267bd9f0c05$export$2e2bcd8739ae039)((p)=>(0, $33f17267bd9f0c05$export$2e2bcd8739ae039)((t)=>t.texture.resize(t.width = w, t.height = h), p), textures);
        return merge?.resize?.(value, state) ?? state;
    };
    // Finish here if merge is disabled.
    if (!merge) return to;
    // Set up the `texture` for states to be merged into.
    const m = to.merge = {
        ...merge
    };
    const { all: mAll, next: mNext } = m;
    const ms = size.merge = m.size ??= {};
    /** Use any given size info, or merge along `[texture, step]` axes. */ ms.width ??= texturesMap.length * width;
    ms.height ??= stepsL * height;
    const [mw, mh] = (0, $827d5157c38742eb$export$6574bcda6112260a)(m, ms.shape ??= []);
    ms.entries ??= (ms.width = mw) * (ms.height = mh);
    /** New merge `texture` and info, or use any given merge `texture`. */ m.all = mAll ?? addTexture(mergeChannels, mw, mh)();
    /** Empty `framebuffer`, to copy data from each `texture` of each pass. */ m.next = mNext ?? addPass(null, colorPool[0])();
    /** Resize `texture`s, `framebuffer`s, and update `size`. */ m.resize = (value = to, state = to)=>{
        const { merge: merge, size: size, maps: maps } = state;
        const { size: ms = size.merge = {}, all: all, next: next } = merge;
        const { textures: texturesMap } = maps;
        const shape = (0, $827d5157c38742eb$export$6574bcda6112260a)(value ?? state, ms.shape ??= []);
        const [w, h] = shape;
        next.framebuffer.resize(next.width = w, next.height = h);
        ms.width = texturesMap.length * w;
        ms.height = size.steps * h;
        const [mw, mh] = (0, $827d5157c38742eb$export$6574bcda6112260a)(ms, shape);
        ms.entries = (ms.width = mw) * (ms.height = mh);
        all.texture.resize(all.width = mw, all.height = mh);
        return state;
    };
    return to;
}
var $815579669ce8de85$export$2e2bcd8739ae039 = $815579669ce8de85$export$24a6b176bdc41ce5;


/**
 * The `gpgpu` inputs for `GL` `uniform`s.
 *
 * @module
 * @category JS
 */ 



function $dd6bfc0fd00c82d9$export$1aad3af825e3305b(state = {}, to = state.uniforms ??= {}) {
    const { steps: steps, maps: maps, pre: n = (0, $c3a4c4b89537eec0$export$b4781c2237bde956), bound: bound = (0, $c3a4c4b89537eec0$export$b029aceb5666f022) } = state;
    const { textures: textures } = maps;
    const stepsL = steps.length ?? steps;
    const texturesL = textures.length;
    // Local caches.
    const stateShape = [];
    const viewShape = [];
    /** Gives any current step. */ to[n + "stepNow"] = (_, s)=>s.stepNow;
    /** Gives any shape of `state` and any merged `states` data-`texture`s. */ to[n + "stateShape"] = (_, { size: { shape: s, merge: m } })=>s ? (0, $7b6dab4ddb729928$export$abee0037e1db715)(stateShape, ...s, ...m?.shape ?? s) : (0, $7b6dab4ddb729928$export$abee0037e1db715)(stateShape);
    /** Gives the shape of the `GL` viewport. */ to[n + "viewShape"] = ({ drawingBufferWidth: w, drawingBufferHeight: h })=>(0, $7b6dab4ddb729928$export$dcfbb7940cfb3a48)(viewShape, w, h);
    /**
   * Gives all `states` merged in one `texture`, if using `merge`;
   * otherwise gives `null`.
   */ to[n + "states"] = (_, s)=>s.merge?.all?.texture ?? null;
    /**
   * Past steps, each some steps `ago`, from the current active step at `0`, as
   * `[0,... stepsL-1-bound]`.
   */ const addTextures = (ago)=>/**
     * Hooks to pull a given `texture` by the active pass `state`; lets `GLSL`
     * access the `array` of `texture`s by constant index (steps ago).
     * Only returns a value if not using a `merge`d `texture`; otherwise `null`.
     */ (0, $33f17267bd9f0c05$export$2e2bcd8739ae039)((_, t)=>to[n + `states[${ago * texturesL + t}]`] = (_, { merge: m, stepNow: s = 0, bound: b = bound, textures: ts })=>m ? null : (0, $118b47bfc49fdb1b$export$2e2bcd8739ae039)(s - b - ago, ts)?.[t]?.texture, textures);
    /** Flatten all input `texture`s, as `uniform`s are kept in flat `array`s. */ for(let ago = 0, pl = stepsL - bound; ago < pl; ++ago)addTextures(ago);
    return to;
} /**
 * @todo [Fix `@callback`/`@typedef`](https://github.com/TypeStrong/typedoc/issues/1896):
 *   nested `@param`; omits `@return`/`@see`/`@this`
 *
 * @callback getUniform
 * A `function` hook to update a `GL` `uniform` value for a render pass.
 *
 * **See**
 * - {@link toUniforms}
 * - {@link data.toData}
 * - {@link api.texture}
 *
 * **Returns**
 * A `GL` uniform to be bound via a `GL` API.
 *
 * @param {{
 *     drawingBufferWidth:number,
 *     drawingBufferHeight:number
 *   }} context General or global properties; with:
 *   - `drawingBufferWidth`: Current `GL` viewport width in pixels.
 *   - `drawingBufferHeight`: Current `GL` viewport height in pixels.
 *
 * @param {{
 *     stepNow?:number,
 *     bound?:number,
 *     merge?:{texture:object},
 *     textures:{texture:object}[][]
 *   }} state Local properties (the `gpgpu` state); with:
 *   - `stepNow`: The current step of the `gpgpu` state.
 *   - `bound`: Number of steps bound to output; can't be bound as inputs.
 *   - `merge`: Any `object` containing merged data-`texture`.
 *     - `texture`: Any merged data-`texture`.
 *   - `textures`: Textures per-step, as `array`s of `object`s with a `texture`
 *     property. See `toData`.
 *
 * @returns {number|number[]|texture|object}
 */ 


/**
 * The `gpgpu` update step.
 *
 * Connects inputs to the `GL` state and renders an update step.
 *
 * @module
 * @category JS
 *
 * @todo [Fix `@callback`/`@typedef`](https://github.com/TypeStrong/typedoc/issues/1896):
 *   nested `@param`; omits `@return`/`@see`/`@this`
 */ 

/**
 * The `GLSL` preprocessor macros for working with the `gpgpu` state and maps.
 *
 * Each set of different macros will result in new shader compilations - for
 * optimal performance, the fewest macros possible should be created, one per
 * each given set of inputs, ideally; caches here can be used for efficiency.
 *
 * @module
 * @category JS
 *
 * @todo Redo examples, especially `macroTaps` and `macroPass`.
 * @todo Ensure the `output_N` in `macroOutput` can work with `WebGL2`; look at
 *   using `layout(location=attach_N) out data_N`, not `gl_FragData[attach_N]`.
 *   - [SO: Multiple output textures from the same program](https://stackoverflow.com/questions/51793336/multiple-output-textures-from-the-same-program)
 *   - [SO: GL FragData must be constant zero](https://stackoverflow.com/questions/46740817/gl-fragdata-must-be-constant-zero)
 *   - [SO: How are layout qualifiers better than getAttribLocation in WebGL2](https://stackoverflow.com/questions/50258822/how-are-layout-qualifiers-better-than-getattriblocation-in-webgl2)
 */ 

const [{ length: $0d6927602641c70e$var$start }, { length: $0d6927602641c70e$var$end }] = "[object {type}]".split("{type}");
const $0d6927602641c70e$export$bf9fb029d174d554 = (x)=>toString.call(x).slice($0d6927602641c70e$var$start, -$0d6927602641c70e$var$end);
var $0d6927602641c70e$export$2e2bcd8739ae039 = $0d6927602641c70e$export$bf9fb029d174d554;



const $51b9e91bc370f51d$export$36a518e2013de1bd = " \\\n";
const $51b9e91bc370f51d$var$lf = $51b9e91bc370f51d$export$36a518e2013de1bd;
const $51b9e91bc370f51d$export$4e46ac54fc82cf3b = "rgba";
const $51b9e91bc370f51d$export$497faa7f0daf9da = {};
/** Gives cache keys from simple plain `object` inputs. */ const $51b9e91bc370f51d$var$id = JSON.stringify;
const $51b9e91bc370f51d$export$11949c6f5fba7dcd = {
    /** The full set of macros. */ macroPass: "",
    /** Each part of the set of macros. */ macroValues: "values",
    macroOutput: "output",
    macroSamples: "samples",
    macroTaps: "taps"
};
function $51b9e91bc370f51d$export$feaf5ffc92c2af94(state, key, on = "", macros = state?.macros) {
    if ((macros ?? true) === true) return null;
    else if (!macros) return "";
    const t = (0, $0d6927602641c70e$export$bf9fb029d174d554)(macros);
    return t === "String" ? macros : t === "Function" ? $51b9e91bc370f51d$export$feaf5ffc92c2af94(state, key, on, macros(state, key, on, macros)) : macros instanceof Object && key in macros ? $51b9e91bc370f51d$export$feaf5ffc92c2af94(state, key, on, macros[key]) : on ? $51b9e91bc370f51d$export$feaf5ffc92c2af94(state, key ? key + "_" + on : on, "", macros) : null;
}
const $51b9e91bc370f51d$export$83d01c7b88bc16d5 = (type, name, a, qualify = "", init = type)=>`const int ${name}_l = ${a.length};` + (0, $a0fef7c841dcaa76$export$2e2bcd8739ae039)((s, v, i)=>s + $51b9e91bc370f51d$var$lf + (qualify && qualify + " ") + type + ` ${name}_${i} = ${init}(${v.join?.(", ") ?? v});`, a, "");
const $51b9e91bc370f51d$export$45db4de6da38aa8d = (type, name, a, qualify = "", init = type)=>$51b9e91bc370f51d$export$83d01c7b88bc16d5(type, name, a, qualify, init) + "\n\n" + // @todo Would ideally use the concatenation macro, but can't in GLSL 1.
    // `#define ${name}_i(i) ${name}_##i`;
    `/**\n` + ` * Index function \`${name}_i\` (e.g: \`${name}_i(0)\`) may be slow.\n` + ` * Use name (e.g: \`${name}_0\`) if possible.\n` + ` */\n` + `#define ${name}_i(i) ${(0, $a0fef7c841dcaa76$export$2e2bcd8739ae039)((s, v, i)=>i ? `((i == ${i})? ${name}_${i} : ${s})` : `${name}_${i}`, a, "")}\n`;
const $51b9e91bc370f51d$export$3df19e70a88cb8cd = (type, name, a, qualify = "", init = type)=>$51b9e91bc370f51d$export$83d01c7b88bc16d5(type, name, a, qualify, init) + $51b9e91bc370f51d$var$lf + (qualify && qualify + " ") + type + ` ${name}[${name}_l];` + (0, $a0fef7c841dcaa76$export$2e2bcd8739ae039)((s, _, i)=>s + $51b9e91bc370f51d$var$lf + name + `[${i}] = ${name}_${i};`, a, "") + "\n" + `#define ${name}_i(i) ${name}[i]\n`;
const $51b9e91bc370f51d$export$1c7039c93eddfba = (type, name, a, qualify = "", init = type)=>$51b9e91bc370f51d$export$83d01c7b88bc16d5(type, name, a, qualify, init) + $51b9e91bc370f51d$var$lf + (qualify && qualify + " ") + type + ` ${name}[${name}_l] = ${init}[${name}_l](${(0, $a0fef7c841dcaa76$export$2e2bcd8739ae039)((s, _, i)=>(s && s + ", ") + name + "_" + i, a, "")});\n` + `#define ${name}_i(i) ${name}[i]\n`;
const $51b9e91bc370f51d$export$c346962e7dd3191 = (type, name, a, qualify = "", glsl = 1, init)=>(glsl >= 3 ? $51b9e91bc370f51d$export$1c7039c93eddfba : qualify.trim() === "const" ? $51b9e91bc370f51d$export$45db4de6da38aa8d : $51b9e91bc370f51d$export$3df19e70a88cb8cd)(type, name, a, qualify, init);
function $51b9e91bc370f51d$export$84186522bf5a7d4d(state, on) {
    const key = $51b9e91bc370f51d$export$11949c6f5fba7dcd.macroValues;
    let to = $51b9e91bc370f51d$export$feaf5ffc92c2af94(state, key, on);
    if (to != null) return to;
    const { maps: maps, steps: steps, bound: bound = (0, $c3a4c4b89537eec0$export$b029aceb5666f022), merge: merge, size: size, pre: n = (0, $c3a4c4b89537eec0$export$b4781c2237bde956), cache: cache = $51b9e91bc370f51d$export$497faa7f0daf9da } = state;
    const { values: values, textures: textures, passes: { length: passesL }, alias: alias } = maps;
    const stepsL = steps.length ?? steps;
    const entries = size?.entries;
    const split = !merge;
    const c = cache && `macro@${key}@${n}|${bound}|${$51b9e91bc370f51d$var$id(values)}|${$51b9e91bc370f51d$var$id(textures)}|${stepsL}|${passesL}|${entries}|${split}|${$51b9e91bc370f51d$var$id(alias)}`;
    if ((to = cache?.[c]) != null) return to;
    const texturesL = textures.length;
    const stepsPast = stepsL - bound;
    to = (0, $a0fef7c841dcaa76$export$2e2bcd8739ae039)((s, texture, t, _, i = 0)=>(0, $a0fef7c841dcaa76$export$2e2bcd8739ae039)((s, v)=>{
            const to = s + `#define ${n}texture_${v} ${t}\n` + `#define ${n}channels_${v} ${$51b9e91bc370f51d$export$4e46ac54fc82cf3b.slice(i, i += values[v])}\n\n`;
            if (!alias) return to;
            const a = alias[v];
            return to + `#define ${n}texture_${a} ${n}texture_${v}\n` + `#define ${n}channels_${a} ${n}channels_${v}\n\n`;
        }, texture, s), textures, "") + (entries || entries === 0 ? `#define ${n}entries ${entries}\n` : "") + `#define ${n}textures ${texturesL}\n` + `#define ${n}passes ${passesL}\n` + `#define ${n}bound ${bound}\n` + `#define ${n}steps ${stepsL}\n` + `#define ${n}stepsPast ${stepsPast}\n` + `#define ${n}${split ? `splits` : `merged`} ${texturesL * stepsPast}\n\n`;
    return cache ? cache[c] = to : to;
}
function $51b9e91bc370f51d$export$49873e279ff642c0(state, on) {
    const key = $51b9e91bc370f51d$export$11949c6f5fba7dcd.macroOutput;
    let to = $51b9e91bc370f51d$export$feaf5ffc92c2af94(state, key, on);
    if (to != null) return to;
    const { passNow: p, maps: maps, pre: n = (0, $c3a4c4b89537eec0$export$b4781c2237bde956), cache: cache = $51b9e91bc370f51d$export$497faa7f0daf9da } = state;
    const { values: values, textures: textures, passes: passes, alias: alias } = maps;
    const pass = passes[p];
    const c = cache && `macro@${key}@${n}|${p}|${$51b9e91bc370f51d$var$id(values)}|${$51b9e91bc370f51d$var$id(textures)}|${$51b9e91bc370f51d$var$id(passes)}|${$51b9e91bc370f51d$var$id(alias)}`;
    to = cache?.[c] ?? `#define ${n}passNow ${p}\n${(0, $a0fef7c841dcaa76$export$2e2bcd8739ae039)((s, texture, bound, _, i = 0)=>(0, $a0fef7c841dcaa76$export$2e2bcd8739ae039)((s, v)=>{
            const to = s + "\n" + `#define ${n}bound_${v} ${texture}\n` + `#define ${n}attach_${v} ${bound}\n` + `#define ${n}output_${v} gl_FragData[${n}attach_${v}].${$51b9e91bc370f51d$export$4e46ac54fc82cf3b.slice(i, i += values[v])}\n`;
            if (!alias) return to;
            const a = alias[v];
            return to + "\n" + `#define ${n}bound_${a} ${n}bound_${v}\n` + `#define ${n}attach_${a} ${n}attach_${v}\n` + `#define ${n}output_${a} ${n}output_${v}\n`;
        }, textures[texture], s), pass, "")}\n`;
    return cache ? cache[c] = to : to;
}
function $51b9e91bc370f51d$export$9cb6037fa2a40c2e(state, on) {
    const key = $51b9e91bc370f51d$export$11949c6f5fba7dcd.macroSamples;
    let to = $51b9e91bc370f51d$export$feaf5ffc92c2af94(state, key, on);
    if (to != null) return to;
    const { passNow: p = 0, maps: maps, steps: steps, bound: bound = (0, $c3a4c4b89537eec0$export$b029aceb5666f022), glsl: glsl, pre: n = (0, $c3a4c4b89537eec0$export$b4781c2237bde956), cache: cache = $51b9e91bc370f51d$export$497faa7f0daf9da } = state;
    const { samples: samples, reads: reads, readsToValue: readsToValue, alias: alias } = maps;
    const passSamples = samples?.[p];
    const passReads = reads?.[p];
    const passReadsToValue = readsToValue?.[p];
    const stepsPast = alias ? (steps.length ?? steps) - bound : null;
    const c = cache && `macro@${key}@${n}|${p}|${$51b9e91bc370f51d$var$id(passSamples)}|${$51b9e91bc370f51d$var$id(passReads)}|${$51b9e91bc370f51d$var$id(passReadsToValue)}|${$51b9e91bc370f51d$var$id(alias)}|${stepsPast}|${glsl}`;
    to = cache?.[c] ?? (!passSamples ? "" : `#define ${n}useSamples${$51b9e91bc370f51d$var$lf + $51b9e91bc370f51d$export$c346962e7dd3191("ivec2", n + "samples", passSamples, "const", glsl)}\n`) + (!passReads ? "" : (0, $a0fef7c841dcaa76$export$2e2bcd8739ae039)((s, reads, v)=>{
        const to = `${s}#define ${n}useReads_${v}${$51b9e91bc370f51d$var$lf + $51b9e91bc370f51d$export$c346962e7dd3191("int", n + "reads_" + v, reads, "const", glsl)}\n`;
        if (!alias) return to;
        const valueReadsToValue = passReadsToValue[v];
        const aliasAt = alias[v];
        const readAlias = `${n}reads_${aliasAt}`;
        const readIndex = `${n}reads_${v}`;
        return to + `/**\n` + ` * Alias reads, depends on index reads \`${n}useReads_${v}\`.\n` + ` * If using both alias and index reads, only use this not both.\n` + ` */\n` + `#define ${n}useReads_${aliasAt}${$51b9e91bc370f51d$var$lf}${n}useReads_${v}${(0, $a0fef7c841dcaa76$export$2e2bcd8739ae039)((s, read, r)=>{
            const aliasTo = alias[valueReadsToValue[r]];
            /** How many steps into the past is the sample being read. */ const past = passSamples[read][0];
            /** How many steps from the last is the sample being read. */ const last = stepsPast - past - 1;
            const note = `Alias for \`${aliasAt}\` reads \`${aliasTo}\` at `;
            const noteNew = `${note + past} step${past === 1 ? "" : "s"} into the past; `;
            const noteOld = `${note + last} step${last === 1 ? "" : "s"} from the last; `;
            /** Base of assignment. */ const base = `${$51b9e91bc370f51d$var$lf}const int ${readAlias}_${aliasTo}`;
            /** Right side of assignment. */ const right = `${readIndex}_${r};${$51b9e91bc370f51d$var$lf}`;
            /** Left side of assignment. */ let left;
            return s + $51b9e91bc370f51d$var$lf + (past || s.indexOf(left = `${base} = `) >= 0 ? "" : `/** ${noteNew}implied newest, bare. */${left + right}`) + (past || s.indexOf(left = `${base}_new = `) >= 0 ? "" : `/** ${noteNew}implied newest. */${left + right}`) + (last || s.indexOf(left = `${base}_old = `) >= 0 ? "" : `/** ${noteOld}implied oldest. */${left + right}`) + (s.indexOf(left = `${base}_new_${past} = `) >= 0 ? "" : `/** ${noteNew}counted newest-to-oldest. */${left + right}`) + (s.indexOf(left = `${base}_old_${last} = `) >= 0 ? "" : `/** ${noteOld}counted oldest-to-newest. */${left + right}`);
        }, reads, reads.length ? $51b9e91bc370f51d$var$lf : "")}${$51b9e91bc370f51d$var$lf}const int ${readAlias}_l = ${readIndex}_l;${$51b9e91bc370f51d$var$lf}int ${readAlias}_i(int i) { return ${readIndex}_i(i); }\n\n`;
    }, passReads, ""));
    return cache ? cache[c] = to : to;
}
function $51b9e91bc370f51d$export$562ddd36066ad650(state, on) {
    const key = $51b9e91bc370f51d$export$11949c6f5fba7dcd.macroTaps;
    let to = $51b9e91bc370f51d$export$feaf5ffc92c2af94(state, key, on);
    if (to != null) return to;
    const { passNow: p = 0, maps: maps, merge: merge, glsl: glsl, pre: n = (0, $c3a4c4b89537eec0$export$b4781c2237bde956), cache: cache = $51b9e91bc370f51d$export$497faa7f0daf9da } = state;
    const passSamples = maps.samples?.[p];
    const split = !merge;
    const c = cache && `macro@${key}@${n}|${p}|${$51b9e91bc370f51d$var$id(passSamples)}|${split}|${glsl}`;
    if ((to = cache?.[c]) != null) return to;
    const glsl3 = glsl >= 3;
    /** Which texture sampling function is available. */ const texture = "texture" + (glsl3 ? "" : "2D");
    /** Short and common names for functions and parameters. */ const f = n + "tapState";
    const def = "#define " + f;
    /** Common parameters, passed as `(..., stepBy, textureBy)` */ const bs = "stepBy";
    const bt = "textureBy";
    const by = `${bs}, ${bt}`;
    /** Aliases default names for brevity, main functions offer more control. */ const aka = `#define ${f}(uv)` + $51b9e91bc370f51d$var$lf + f;
    const akaBy = `#define ${f}By(uv, ${by})` + $51b9e91bc370f51d$var$lf + f;
    /** The current `sample`, as `[step, texture]`. */ const st = n + "samples_";
    /** Prefix for private temporary variables. */ const t = "_" + n;
    /** A temporary `array` to pass to `getGLSLList`. */ const tapsSamples = cache[key + ":tapsSamples"] ??= [];
    const tapsL = tapsSamples.length = passSamples?.length ?? 0;
    /** The main `texture`-sampling logic. */ to = !tapsL ? "" : (split ? /** Split un-merged `texture`s accessed by constant index. */ `/**\n` + ` * States in a \`sampler2D[]\`; looks up 1D index and 2D \`uv\`.\n` + ` * Past steps go later in the list.\n` + ` * States may also be sampled by shifted step/texture.\n` + ` * Pass constant array index values; \`textures, ${by}\`.\n` + ` * Use \`${n}data\` list; ignore temporary \`${t}\` names.\n` + ` */\n` + def + `sBy(uv, states, textures, ${by})` + $51b9e91bc370f51d$var$lf + // Compute before the loop for lighter work.
    `const int ${t}tl = int(textures);` + $51b9e91bc370f51d$var$lf + `vec2 ${t}uv = vec2(uv);` + $51b9e91bc370f51d$var$lf + // Sample into the `data` output list.
    $51b9e91bc370f51d$export$c346962e7dd3191("vec4", n + "data", (0, $a8bd34883e6c6917$export$2e2bcd8739ae039)((_, i)=>texture + "(states[" + // Offset step.
        `((int(${st + i}.s)+int(${bs}))*${t}tl)+` + // Offset `texture`.
        `int(${st + i}.t)+int(${bt})` + `], ${t}uv)`, passSamples, tapsSamples), "", glsl) + "\n" + `/** Sample the states as given without shifting by any offsets. */\n` + def + `s(uv, states, textures)` + $51b9e91bc370f51d$var$lf + f + `sBy(uv, states, textures, 0, 0)\n\n` + `/** Preferred aliases: index suits states array constant access. */\n` + aka + `s(uv, ${n}states, ${n}textures)\n` + akaBy + `sBy(uv, ${n}states, ${n}textures, ${by})\n` : /** Merged 2D `texture`. */ `/**\n` + ` * States merged in a \`sampler2D\`.\n` + ` * Scales the 2D \`uv\` lookup over \`[textures, steps]\`.\n` + ` * Step from now into the past going upwards in the texture.\n` + ` * States may also be sampled by shifted step/texture.\n` + ` * Use \`${n}data\` list; ignore temporary \`${t}\` names.\n` + ` */\n` + def + `2By(uv, states, stepNow, steps, textures, ${by})` + $51b9e91bc370f51d$var$lf + // Compute before the loop for lighter work.
    `vec2 ${t}l = vec2(textures, steps);` + $51b9e91bc370f51d$var$lf + `vec2 ${t}uv = vec2(uv)/${t}l;` + $51b9e91bc370f51d$var$lf + // Steps advance in reverse, top-to-bottom.
    `vec2 ${t}s = vec2(1, -1)/${t}l;` + $51b9e91bc370f51d$var$lf + // Offset `texture`, step.
    // Each step stored in `texture` top downward at `-stepNow`.
    // Most recent step to look up is at `-stepNow+1`.
    `vec2 ${t}i = (vec2(${by}).ts+vec2(0, 1))-vec2(0, stepNow);` + $51b9e91bc370f51d$var$lf + // Sample into the `data` output list.
    $51b9e91bc370f51d$export$c346962e7dd3191("vec4", n + "data", // Would repeat wrap; but `WebGL1` needs power-of-2.
    (0, $a8bd34883e6c6917$export$2e2bcd8739ae039)((_, i)=>texture + `(states, ` + // Offset `texture`, step.
        `fract(${t}uv+fract((vec2(${st + i}).ts+${t}i)*${t}s)))`, passSamples, tapsSamples), "", glsl) + "\n" + `/** Sample the states as given without shifting by any offsets. */\n` + def + `2(uv, states, stepNow, steps, textures)` + $51b9e91bc370f51d$var$lf + f + `2By(uv, states, stepNow, steps, textures, 0, 0)\n\n` + (!glsl3 ? `/** Preferred aliases: 2D suits merged texture in \`GLSL\` < 1. */\n` + aka + `2(uv, ${n}states, ${n}stepNow, ${n}steps, ${n}textures)\n` + akaBy + `2By(uv, ${n}states, ${n}stepNow, ${n}steps, ${n}textures, ${by})\n` : /**
         * Merged 3D `texture` types, supported from `GLSL3`.
         * @todo Check and finish this.
         */ `/**\n` + ` * States merged to \`sampler3D\` or \`sampler2DArray\`.\n` + ` * 2D \`uv\` to 3D.\n` + ` * Scales \`x\` over \`textures\`, \`z\` over \`steps\` as:\n` + ` * - \`sampler3D\`: the number of steps; depth, \`[0, 1]\`.\n` + ` * - \`sampler2DArray\`: \`1\` or less; layer, \`[0, steps-1]\`.\n` + ` * States may also be sampled by shifted step/texture.\n` + ` * Use \`${n}data\` list; ignore temporary \`${t}\` names.\n` + ` */\n` + def + `3By(uv, states, stepNow, steps, textures, ${by})` + $51b9e91bc370f51d$var$lf + /** @see `...2By()` above. */ // Compute before the loop for lighter work.
    `vec2 ${t}l = vec2(textures, steps);` + $51b9e91bc370f51d$var$lf + `vec2 ${t}uv = (vec2(uv)+vec2(textureBy, 0))/${t}l;` + $51b9e91bc370f51d$var$lf + // Offset `texture`.
    `float ${t}sx = 1.0/${t}l.x;` + $51b9e91bc370f51d$var$lf + // Offset step.
    `float ${t}s = float(stepBy)-float(stepNow);` + $51b9e91bc370f51d$var$lf + `float ${t}sz = -1.0/${t}l;` + $51b9e91bc370f51d$var$lf + // Sample into the `data` output list.
    $51b9e91bc370f51d$export$c346962e7dd3191("vec4", n + "data", // Would repeat wrap; but `sampler2DArray` layer can't.
    (0, $a8bd34883e6c6917$export$2e2bcd8739ae039)((_, i)=>texture + "(states, fract(vec3(" + // Offset `texture`.
        `${t}uv.x+(float(${st + i}.t)*${t}sx), ${t}uv.y, ` + // Offset step: `sampler3D` depth, `[0, 1]`;
        // `sampler2DArray` layer, `[0, steps-1]`.
        `(float(${st + i}.s)+${t}s)*${t}sz)))`, passSamples, tapsSamples), "", glsl) + "\n" + `/** Sample the states as given without shifting by any offsets. */\n` + def + `3(uv, states, stepNow, steps, textures)` + $51b9e91bc370f51d$var$lf + f + `3(uv, states, stepNow, steps, textures)\n\n` + `/** Preferred aliases: 3D suits merged texture in \`GLSL\` 3+. */\n` + aka + `3(uv, ${n}states, ${n}stepNow, ${n}steps, ${n}textures)\n` + akaBy + `3By(uv, ${n}states, ${n}stepNow, ${n}steps, ${n}textures, ${by})\n`)) + "\n";
    return cache ? cache[c] = to : to;
}
const $51b9e91bc370f51d$export$d38b14fb9031108e = (state, on)=>$51b9e91bc370f51d$export$feaf5ffc92c2af94(state, $51b9e91bc370f51d$export$11949c6f5fba7dcd.macroPass, on) ?? $51b9e91bc370f51d$export$84186522bf5a7d4d(state, on) + $51b9e91bc370f51d$export$49873e279ff642c0(state, on) + $51b9e91bc370f51d$export$9cb6037fa2a40c2e(state, on) + $51b9e91bc370f51d$export$562ddd36066ad650(state, on);
var $51b9e91bc370f51d$export$2e2bcd8739ae039 = $51b9e91bc370f51d$export$d38b14fb9031108e;



const { call: $23462767626c8c72$var$call } = Function;
const $23462767626c8c72$export$d86e3abd7686c23f = ({ passes: ps, stepNow: s, passNow: p })=>(0, $118b47bfc49fdb1b$export$2e2bcd8739ae039)(s, ps)?.[p];
const $23462767626c8c72$export$95b2c9ea2de43ebb = (shader, context, state)=>shader.call === $23462767626c8c72$var$call ? shader(context, state) : shader;
function $23462767626c8c72$export$12661000d11a17d2(state) {
    const { merge: merge, stepNow: s, size: size, copyImage: ci = state.copyImage = (0, $c3a4c4b89537eec0$export$72e520e6a70b780c)() } = state;
    const { color: cs, map: pass } = $23462767626c8c72$export$d86e3abd7686c23f(state);
    const { all: { texture: t }, next: next } = merge;
    const sub = t?.subimage;
    const { color: nc } = next;
    let f = next.framebuffer;
    /** Handle `object`s or `regl`-like extended `function`s. */ f?.call !== Function.call && (f = f?.call);
    // Silent exit if there's not enough info ready now to perform the update.
    if (!(sub && f && cs && pass && (s || s === 0))) return t;
    const { steps: sl, width: w, height: h } = size;
    /** Start at the top of the `texture`, move down row-per-step and wrap. */ const y = (0, $118b47bfc49fdb1b$export$2e2bcd8739ae039)(s, sl) * h;
    /**
   * Reusable `framebuffer` binds and copies each of the pass `texture`s along
   * the merged `texture`.
   */ (0, $33f17267bd9f0c05$export$2e2bcd8739ae039)((c, i)=>(next.color = c) && f.call(f, next).use.call(f, ()=>sub.call(t, ci, pass[i] * w, y)), cs);
    /** Reset any changed properties. */ next.color = nc;
    f.call(f, next);
    return t;
}
function $23462767626c8c72$export$ca14b6cb1bf101d2(state) {
    const { merge: merge, clearPass: c = state.clearPass = (0, $c3a4c4b89537eec0$export$2fcc13103217f9a3)() } = state;
    const { all: { texture: t }, next: next } = merge;
    const { color: nc } = next;
    let f = next.framebuffer;
    /** Handle `object`s or `regl`-like extended `function`s. */ f?.call !== Function.call && (f = f?.call);
    if (!c || !f) return t;
    const cf = c.framebuffer;
    (next.color = t) && (c.framebuffer = f.call(f, next)) && clear(c);
    /** Reset any changed properties. */ c.framebuffer = cf;
    next.color = nc;
    f.call(f, next);
    return t;
}
function $23462767626c8c72$export$d89197afac86b993(api, state = {}, to = state) {
    /** Handle `object`s or `regl`-like extended `function`s, for `command`. */ const { buffer: buffer, clear: clear1, command: command = api } = api;
    const { merge: merge, pipeline: pipeline, verts: verts, frag: frag, frags: frags, uniforms: uniforms, attributes: attributes, maps: maps, // Update any default vertex `shader` to use the given `pre`.
    pre: n = (0, $c3a4c4b89537eec0$export$b4781c2237bde956), vert: vert = (0, $c3a4c4b89537eec0$export$dc207adda608f979).replaceAll((0, $c3a4c4b89537eec0$export$b4781c2237bde956), n || ""), count: // Any vertex `count`, and `positions` to be passed to `buffer`.
    count = (0, $c3a4c4b89537eec0$export$832d88422d279bbc), positions: positions = (0, $c3a4c4b89537eec0$export$cfdc3a7c4cb854c6)() } = state;
    let { clearPass: clearPass = null } = state;
    // Ensure any properties changed are included.
    to.pre = n;
    to.vert = vert;
    to.count = count;
    to.positions = buffer(positions);
    to.clearPass = clearPass === true ? clearPass = undefined : clearPass;
    // May pre-process and keep the `shader`s for all passes in advance.
    if (verts || frags) {
        // Keep the current pass.
        const { passNow: passNow } = state;
        verts && (to.verts = verts);
        frags && (to.frags = frags);
        (0, $33f17267bd9f0c05$export$2e2bcd8739ae039)((pass, p)=>{
            // Create `macro`s for this pass in advance.
            state.passNow = p;
            // Specify a `'vert'` type `shader` for any per-`shader` `macro` hooks.
            verts && (verts[p] ??= (0, $51b9e91bc370f51d$export$d38b14fb9031108e)(state, "vert") + $23462767626c8c72$export$95b2c9ea2de43ebb(vert, null, state));
            // Specify a `'frag'` type `shader` for any per-`shader` `macro` hooks.
            frags && (frags[p] ??= (0, $51b9e91bc370f51d$export$d38b14fb9031108e)(state, "frag") + $23462767626c8c72$export$95b2c9ea2de43ebb(frag, null, state));
        }, maps.passes);
        // Set the pass back to what it was.
        state.passNow = passNow;
    }
    /** A `command` to render `pass` updates via a `GL` `pipeline` description. */ to.pass = command(to.pipeline = {
        // Uses the full-screen vertex `shader` state by default.
        vert (c, s) {
            const { passNow: p, step: { vert: v = vert, verts: vs = verts } } = state;
            // Specify a `'vert'` type `shader` for any per-`shader` `macro` hooks.
            return vs?.[p] ?? (0, $51b9e91bc370f51d$export$d38b14fb9031108e)(s, "vert") + $23462767626c8c72$export$95b2c9ea2de43ebb(v, c, s);
        },
        frag (c, s) {
            const { passNow: p, step: { frag: f = frag, frags: fs = frags } } = state;
            // Specify a `'frag'` type `shader` for any per-`shader` `macro` hooks.
            return fs?.[p] ?? (0, $51b9e91bc370f51d$export$d38b14fb9031108e)(s, "frag") + $23462767626c8c72$export$95b2c9ea2de43ebb(f, c, s);
        },
        /** Need an active `pass` with `framebuffer`, or may draw to the screen. */ framebuffer: (_, s)=>$23462767626c8c72$export$d86e3abd7686c23f(s)?.framebuffer,
        count: count,
        uniforms: uniforms,
        attributes: {
            [n + "position"]: (_, s)=>s.positions,
            ...attributes
        },
        depth: {
            enable: false
        },
        blend: {
            enable: false
        },
        /** Any `pipeline` properties shallow-override others of the same name. */ ...pipeline
    });
    if (merge && (to.merge = merge)) {
        /** Any merged `texture`'s update, set up if not already given. */ merge.update ??= $23462767626c8c72$export$12661000d11a17d2;
        /** Any merged `texture`'s clear, set up if not already given. */ merge.clear ??= $23462767626c8c72$export$ca14b6cb1bf101d2;
    }
    /** Guard for number overflow; set to `0` to ignore or handle in `GLSL`. */ to.stepBy = (state = to, by = 1)=>{
        const { stepNow: stepNow = 0, stepMax: stepMax = (0, $c3a4c4b89537eec0$export$2902d6d00b7c2bce) } = state;
        state.stepNow = (0, $118b47bfc49fdb1b$export$2e2bcd8739ae039)(stepNow + by, stepMax || Infinity);
        return state;
    };
    /** Executes the next step and all its passes. */ to.step = (state = to)=>{
        const stepState = state.onStep?.(state) ?? state;
        const { maps: maps, merge: merge, pass: pass, onPass: onPass, stepBy: stepBy, clearPass: clearPass = stepState.clearPass = (0, $c3a4c4b89537eec0$export$2fcc13103217f9a3)() } = stepState;
        const clearFramebuffer = clearPass && clearPass.framebuffer;
        const mergeUpdate = merge?.update;
        stepBy(stepState);
        (0, $33f17267bd9f0c05$export$2e2bcd8739ae039)((p, i)=>{
            stepState.passNow = i;
            const passState = onPass?.(stepState, p) ?? stepState;
            /** Only call `clear` if specified, can just use blending otherwise. */ clearPass && (clearPass.framebuffer = $23462767626c8c72$export$d86e3abd7686c23f(passState)?.framebuffer) && clear1(clearPass);
            pass(passState);
            // Update any merged `texture` upon each pass.
            mergeUpdate?.(passState);
        }, maps.passes);
        /** Reset any changed properties. */ clearPass && (clearPass.framebuffer = clearFramebuffer);
        return stepState;
    };
    /** Clears all passes and merged data. */ to.clear = (state = to)=>{
        const s = state.onClear?.(state) ?? state;
        const { maps: maps, merge: merge, clearPass: c = s.clearPass = (0, $c3a4c4b89537eec0$export$2fcc13103217f9a3)() } = s;
        if (!c) return s;
        const cf = c.framebuffer;
        (0, $33f17267bd9f0c05$export$2e2bcd8739ae039)((p, i)=>{
            s.passNow = i;
            (c.framebuffer = $23462767626c8c72$export$d86e3abd7686c23f(s)?.framebuffer) && clear1(c);
        }, maps.passes);
        /** Reset any changed properties. */ c.framebuffer = cf;
        merge?.clear?.(s);
        return s;
    };
    return to;
}
/**
 * @todo [Fix `@callback`/`@typedef`](https://github.com/TypeStrong/typedoc/issues/1896):
 *   nested `@param`; omits `@return`/`@see`/`@this`
 *
 * @callback onStep
 * Callback upon each step.
 *
 * **See**
 * - {@link toStep}
 * - {@link data.toData}
 * - {@link state.framebuffer}
 *
 * **Returns**
 * - A `stepState` object to use for each of the step's next passes; or
 *   `null`ish to use the given `props`.
 *
 * @param {object} [props] The `props` passed to `run`.
 * @param {framebuffer[]} step The `framebuffer`s for `props.stepNow` from
 *   `props.steps`, where the next state step will be drawn. See `toData`.
 *
 * @returns {object}
 */ /**
 * @todo [Fix `@callback`/`@typedef`](https://github.com/TypeStrong/typedoc/issues/1896):
 *   nested `@param`; omits `@return`/`@see`/`@this`
 *
 * @callback onPass
 * Callback upon each pass.
 *
 * **See**
 * - {@link toStep}
 * - {@link maps.mapGroups}
 *
 * **Returns**
 * - A `passState` object to use for the render `command` call; or `null`ish to
 *   use the given `stepState`.
 *
 * @param {object} [stepState] The `props` passed to `run` via any `onStep`.
 * @param {number[]} pass The maps for the next pass. See `mapGroups`.
 *
 * @returns {object}
 */ /** A wrapper around `updateMerge`, handy for testing. */ function $23462767626c8c72$var$updateMergeTest(state, update = $23462767626c8c72$export$12661000d11a17d2, after = 2) {
    const { color: color, map: pass } = $23462767626c8c72$export$d86e3abd7686c23f(state);
    const { merge: { all: all, next: next }, stepNow: s, passNow: p, size: size, maps: maps } = state;
    const { channels: channels } = all;
    const { steps: sl, shape: [w, h], merge: { shape: [wl, hl] } } = size;
    const tl = maps.textures.length;
    const y = s % sl * h;
    const lc = y * tl * w;
    const to = update(state);
    let f = next?.framebuffer;
    /** Handle `object`s or `regl`-like extended `function`s. */ f.call !== $23462767626c8c72$var$call && (f = f?.call);
    console.warn(s, p, pass, ":");
    console.warn("- l", 0, "r", tl * w, "w", w, "wl", wl);
    console.warn("- t", y, "b", y + h, "h", h, "hl", hl);
    console.warn("- c", channels, "lc", lc * channels, "rc", (lc + w * h) * channels, "sc", w * h * channels, "slc", wl * hl * channels);
    f.call(f, {
        color: to
    }).use.call(f, ()=>console.warn(Array.prototype.reduce.call(regl.read(), (o, v, i)=>o + (i ? ",	" : "") + (!i ? "" : i % (tl * w * h * channels) === 0 ? `\n${"=".repeat(100)}step${"=".repeat(100)}\n` : i % (tl * w * channels) === 0 ? "\n" : i % (w * channels) === 0 ? " || 	" : i % channels === 0 ? " / 	" : "") + (i * 1e-3).toFixed(3).slice(2) + ": " + (v ? v.toFixed(2) : "___"), "\n")));
    if (s && after && s % (sl * after) === 0) debugger;
    return to;
}
var $23462767626c8c72$export$2e2bcd8739ae039 = $23462767626c8c72$export$d89197afac86b993;


const { isFinite: $112a804b6949d908$var$isFinite } = Number;
const $112a804b6949d908$export$658d3265ca8f5f4e = (version)=>$112a804b6949d908$var$isFinite(version) ? version : parseFloat(version?.match?.((0, $c3a4c4b89537eec0$export$5544d416ac8224f1))?.[0] ?? version, 10);
function $112a804b6949d908$export$a8489f67fe30ef76(api, state = {}, to = state) {
    const { maxDrawbuffers: maxDrawbuffers, glsl: apiGLSL } = api.limits ?? api;
    const { maps: maps = {}, glsl: glsl = apiGLSL } = state;
    const { buffersMax: buffersMax } = maps;
    /** The parsed `GLSL` version. */ to.glsl = $112a804b6949d908$export$658d3265ca8f5f4e(glsl);
    /** Any `maps.buffersMax` supersedes any `maxDrawbuffers` from the `api`. */ maps.buffersMax ??= maxDrawbuffers;
    state.maps = (0, $9ca80cadf3eaf758$export$798cdecdcbbf9755)(maps, to.maps ??= {});
    (0, $815579669ce8de85$export$24a6b176bdc41ce5)(api, state, to);
    (0, $dd6bfc0fd00c82d9$export$1aad3af825e3305b)(state, to.uniforms ??= {});
    (0, $23462767626c8c72$export$d89197afac86b993)(api, state, to);
    return to;
}
var $112a804b6949d908$export$2e2bcd8739ae039 = $112a804b6949d908$export$a8489f67fe30ef76;





/**
 * @todo Move most properties up to the `to` level, it's not very relevant from
 *   outside which step of the internal MPM process they belong to.
 */ 




const $beb29002c2450874$export$be3f796aed065412 = {
    diff: "-",
    dt: "-",
    "\u23F3": "-",
    pause: 0,
    "\u23F8": 0,
    add: "+",
    "\u23ED": "+"
};
const $beb29002c2450874$export$7548f4bc1b09ff22 = $beb29002c2450874$export$be3f796aed065412.diff;
const $beb29002c2450874$export$85b884786400d38f = 0;
const $beb29002c2450874$export$eb8a9b7a1ebec59a = {
    [$beb29002c2450874$export$be3f796aed065412.diff]: Date.now,
    [$beb29002c2450874$export$be3f796aed065412.add]: 1000 / 60
};
function $beb29002c2450874$export$9dc4ecf953986f04(state, now, out = state) {
    // Get the initial time and step-step.
    const { time: t0 = $beb29002c2450874$export$85b884786400d38f, step: step = $beb29002c2450874$export$7548f4bc1b09ff22, now: n } = state;
    var _step;
    // Get the step mode - from a key into `steps` or a numerical value.
    const s = (_step = $beb29002c2450874$export$be3f796aed065412[step]) !== null && _step !== void 0 ? _step : step;
    const diff = s === $beb29002c2450874$export$be3f796aed065412.diff;
    var ref, ref1;
    const t = (ref1 = (ref = now !== null && now !== void 0 ? now : n) !== null && ref !== void 0 ? ref : $beb29002c2450874$export$eb8a9b7a1ebec59a[s]) !== null && ref1 !== void 0 ? ref1 : s;
    // Step by `s`:
    // - `0` or falsey to `pause`
    // - `steps.diff` for difference since last `time`
    // - `steps.add` or a number to add a `time` step
    const t1 = !s ? t0 : (diff ? 0 : t0) + (isNaN(t) ? t() : t);
    const dt = t1 - t0;
    // If only returning a value, return the relevant calculated unknown.
    if (!out) return diff ? dt : t1;
    out.time = t1;
    out.dt = dt;
    out.step = step;
    return out;
}
var $beb29002c2450874$export$2e2bcd8739ae039 = $beb29002c2450874$export$9dc4ecf953986f04;






const [$9afb1b0a564300b3$export$37b75d0026f96b8d, $9afb1b0a564300b3$export$dc78d1181d20ae9d, $9afb1b0a564300b3$export$3566317347873a0b, $9afb1b0a564300b3$export$49c94a8647bf28c0] = (0, $79c5830c48753a63$export$24ecd06eea36a882)("+");




var $3b170edb4d456798$exports = {};
var $3b170edb4d456798$var$gsl_const = {};
$3b170edb4d456798$var$gsl_const.CGS = {};
$3b170edb4d456798$var$gsl_const.CGS.SPEED_OF_LIGHT = 2.99792458e+10; /* cm / s */ 
$3b170edb4d456798$var$gsl_const.CGS.GRAVITATIONAL_CONSTANT = 6.673e-8; /* cm^3 / g s^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.PLANCKS_CONSTANT_H = 6.62606896e-27; /* g cm^2 / s */ 
$3b170edb4d456798$var$gsl_const.CGS.PLANCKS_CONSTANT_HBAR = 1.05457162825e-27; /* g cm^2 / s */ 
$3b170edb4d456798$var$gsl_const.CGS.ASTRONOMICAL_UNIT = 1.49597870691e+13; /* cm */ 
$3b170edb4d456798$var$gsl_const.CGS.LIGHT_YEAR = 9.46053620707e+17; /* cm */ 
$3b170edb4d456798$var$gsl_const.CGS.PARSEC = 3.08567758135e+18; /* cm */ 
$3b170edb4d456798$var$gsl_const.CGS.GRAV_ACCEL = 9.80665e+2; /* cm / s^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.ELECTRON_VOLT = 1.602176487e-12; /* g cm^2 / s^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.MASS_ELECTRON = 9.10938188e-28; /* g */ 
$3b170edb4d456798$var$gsl_const.CGS.MASS_MUON = 1.88353109e-25; /* g */ 
$3b170edb4d456798$var$gsl_const.CGS.MASS_PROTON = 1.67262158e-24; /* g */ 
$3b170edb4d456798$var$gsl_const.CGS.MASS_NEUTRON = 1.67492716e-24; /* g */ 
$3b170edb4d456798$var$gsl_const.CGS.RYDBERG = 2.17987196968e-11; /* g cm^2 / s^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.BOLTZMANN = 1.3806504e-16; /* g cm^2 / K s^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.MOLAR_GAS = 8.314472e7; /* g cm^2 / K mol s^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.STANDARD_GAS_VOLUME = 2.2710981e4; /* cm^3 / mol */ 
$3b170edb4d456798$var$gsl_const.CGS.MINUTE = 6e1; /* s */ 
$3b170edb4d456798$var$gsl_const.CGS.HOUR = 3.6e3; /* s */ 
$3b170edb4d456798$var$gsl_const.CGS.DAY = 8.64e4; /* s */ 
$3b170edb4d456798$var$gsl_const.CGS.WEEK = 6.048e5; /* s */ 
$3b170edb4d456798$var$gsl_const.CGS.INCH = 2.54e0; /* cm */ 
$3b170edb4d456798$var$gsl_const.CGS.FOOT = 3.048e1; /* cm */ 
$3b170edb4d456798$var$gsl_const.CGS.YARD = 9.144e1; /* cm */ 
$3b170edb4d456798$var$gsl_const.CGS.MILE = 1.609344e5; /* cm */ 
$3b170edb4d456798$var$gsl_const.CGS.NAUTICAL_MILE = 1.852e5; /* cm */ 
$3b170edb4d456798$var$gsl_const.CGS.FATHOM = 1.8288e2; /* cm */ 
$3b170edb4d456798$var$gsl_const.CGS.MIL = 2.54e-3; /* cm */ 
$3b170edb4d456798$var$gsl_const.CGS.POINT = 3.52777777778e-2; /* cm */ 
$3b170edb4d456798$var$gsl_const.CGS.TEXPOINT = 3.51459803515e-2; /* cm */ 
$3b170edb4d456798$var$gsl_const.CGS.MICRON = 1e-4; /* cm */ 
$3b170edb4d456798$var$gsl_const.CGS.ANGSTROM = 1e-8; /* cm */ 
$3b170edb4d456798$var$gsl_const.CGS.HECTARE = 1e8; /* cm^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.ACRE = 4.04685642241e7; /* cm^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.BARN = 1e-24; /* cm^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.LITER = 1e3; /* cm^3 */ 
$3b170edb4d456798$var$gsl_const.CGS.US_GALLON = 3.78541178402e3; /* cm^3 */ 
$3b170edb4d456798$var$gsl_const.CGS.QUART = 9.46352946004e2; /* cm^3 */ 
$3b170edb4d456798$var$gsl_const.CGS.PINT = 4.73176473002e2; /* cm^3 */ 
$3b170edb4d456798$var$gsl_const.CGS.CUP = 2.36588236501e2; /* cm^3 */ 
$3b170edb4d456798$var$gsl_const.CGS.FLUID_OUNCE = 2.95735295626e1; /* cm^3 */ 
$3b170edb4d456798$var$gsl_const.CGS.TABLESPOON = 1.47867647813e1; /* cm^3 */ 
$3b170edb4d456798$var$gsl_const.CGS.TEASPOON = 4.92892159375e0; /* cm^3 */ 
$3b170edb4d456798$var$gsl_const.CGS.CANADIAN_GALLON = 4.54609e3; /* cm^3 */ 
$3b170edb4d456798$var$gsl_const.CGS.UK_GALLON = 4.546092e3; /* cm^3 */ 
$3b170edb4d456798$var$gsl_const.CGS.MILES_PER_HOUR = 4.4704e1; /* cm / s */ 
$3b170edb4d456798$var$gsl_const.CGS.KILOMETERS_PER_HOUR = 2.77777777778e1; /* cm / s */ 
$3b170edb4d456798$var$gsl_const.CGS.KNOT = 5.14444444444e1; /* cm / s */ 
$3b170edb4d456798$var$gsl_const.CGS.POUND_MASS = 4.5359237e2; /* g */ 
$3b170edb4d456798$var$gsl_const.CGS.OUNCE_MASS = 2.8349523125e1; /* g */ 
$3b170edb4d456798$var$gsl_const.CGS.TON = 9.0718474e5; /* g */ 
$3b170edb4d456798$var$gsl_const.CGS.METRIC_TON = 1e6; /* g */ 
$3b170edb4d456798$var$gsl_const.CGS.UK_TON = 1.0160469088e6; /* g */ 
$3b170edb4d456798$var$gsl_const.CGS.TROY_OUNCE = 3.1103475e1; /* g */ 
$3b170edb4d456798$var$gsl_const.CGS.CARAT = 2e-1; /* g */ 
$3b170edb4d456798$var$gsl_const.CGS.UNIFIED_ATOMIC_MASS = 1.660538782e-24; /* g */ 
$3b170edb4d456798$var$gsl_const.CGS.GRAM_FORCE = 9.80665e2; /* cm g / s^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.POUND_FORCE = 4.44822161526e5; /* cm g / s^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.KILOPOUND_FORCE = 4.44822161526e8; /* cm g / s^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.POUNDAL = 1.38255e4; /* cm g / s^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.CALORIE = 4.1868e7; /* g cm^2 / s^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.BTU = 1.05505585262e10; /* g cm^2 / s^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.THERM = 1.05506e15; /* g cm^2 / s^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.HORSEPOWER = 7.457e9; /* g cm^2 / s^3 */ 
$3b170edb4d456798$var$gsl_const.CGS.BAR = 1e6; /* g / cm s^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.STD_ATMOSPHERE = 1.01325e6; /* g / cm s^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.TORR = 1.33322368421e3; /* g / cm s^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.METER_OF_MERCURY = 1.33322368421e6; /* g / cm s^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.INCH_OF_MERCURY = 3.38638815789e4; /* g / cm s^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.INCH_OF_WATER = 2.490889e3; /* g / cm s^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.PSI = 6.89475729317e4; /* g / cm s^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.POISE = 1e0; /* g / cm s */ 
$3b170edb4d456798$var$gsl_const.CGS.STOKES = 1e0; /* cm^2 / s */ 
$3b170edb4d456798$var$gsl_const.CGS.STILB = 1e0; /* cd / cm^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.LUMEN = 1e0; /* cd sr */ 
$3b170edb4d456798$var$gsl_const.CGS.LUX = 1e-4; /* cd sr / cm^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.PHOT = 1e0; /* cd sr / cm^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.FOOTCANDLE = 1.076e-3; /* cd sr / cm^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.LAMBERT = 1e0; /* cd sr / cm^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.FOOTLAMBERT = 1.07639104e-3; /* cd sr / cm^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.CURIE = 3.7e10; /* 1 / s */ 
$3b170edb4d456798$var$gsl_const.CGS.ROENTGEN = 2.58e-7; /* A s / g */ 
$3b170edb4d456798$var$gsl_const.CGS.RAD = 1e2; /* cm^2 / s^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.SOLAR_MASS = 1.98892e33; /* g */ 
$3b170edb4d456798$var$gsl_const.CGS.BOHR_RADIUS = 5.291772083e-9; /* cm */ 
$3b170edb4d456798$var$gsl_const.CGS.NEWTON = 1e5; /* cm g / s^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.DYNE = 1e0; /* cm g / s^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.JOULE = 1e7; /* g cm^2 / s^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.ERG = 1e0; /* g cm^2 / s^2 */ 
$3b170edb4d456798$var$gsl_const.CGS.STEFAN_BOLTZMANN_CONSTANT = 5.67040047374e-5; /* g / K^4 s^3 */ 
$3b170edb4d456798$var$gsl_const.CGS.THOMSON_CROSS_SECTION = 6.65245893699e-25; /* cm^2 */ 
$3b170edb4d456798$var$gsl_const.CGSM = {};
$3b170edb4d456798$var$gsl_const.CGSM.SPEED_OF_LIGHT = 2.99792458e10 /* cm / s */ ;
$3b170edb4d456798$var$gsl_const.CGSM.GRAVITATIONAL_CONSTANT = 6.673e-8 /* cm^3 / g s^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.PLANCKS_CONSTANT_H = 6.62606896e-27 /* g cm^2 / s */ ;
$3b170edb4d456798$var$gsl_const.CGSM.PLANCKS_CONSTANT_HBAR = 1.05457162825e-27 /* g cm^2 / s */ ;
$3b170edb4d456798$var$gsl_const.CGSM.ASTRONOMICAL_UNIT = 1.49597870691e13 /* cm */ ;
$3b170edb4d456798$var$gsl_const.CGSM.LIGHT_YEAR = 9.46053620707e17 /* cm */ ;
$3b170edb4d456798$var$gsl_const.CGSM.PARSEC = 3.08567758135e18 /* cm */ ;
$3b170edb4d456798$var$gsl_const.CGSM.GRAV_ACCEL = 9.80665e2 /* cm / s^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.ELECTRON_VOLT = 1.602176487e-12 /* g cm^2 / s^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.MASS_ELECTRON = 9.10938188e-28 /* g */ ;
$3b170edb4d456798$var$gsl_const.CGSM.MASS_MUON = 1.88353109e-25 /* g */ ;
$3b170edb4d456798$var$gsl_const.CGSM.MASS_PROTON = 1.67262158e-24 /* g */ ;
$3b170edb4d456798$var$gsl_const.CGSM.MASS_NEUTRON = 1.67492716e-24 /* g */ ;
$3b170edb4d456798$var$gsl_const.CGSM.RYDBERG = 2.17987196968e-11 /* g cm^2 / s^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.BOLTZMANN = 1.3806504e-16 /* g cm^2 / K s^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.MOLAR_GAS = 8.314472e7 /* g cm^2 / K mol s^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.STANDARD_GAS_VOLUME = 2.2710981e4 /* cm^3 / mol */ ;
$3b170edb4d456798$var$gsl_const.CGSM.MINUTE = 6e1 /* s */ ;
$3b170edb4d456798$var$gsl_const.CGSM.HOUR = 3.6e3 /* s */ ;
$3b170edb4d456798$var$gsl_const.CGSM.DAY = 8.64e4 /* s */ ;
$3b170edb4d456798$var$gsl_const.CGSM.WEEK = 6.048e5 /* s */ ;
$3b170edb4d456798$var$gsl_const.CGSM.INCH = 2.54e0 /* cm */ ;
$3b170edb4d456798$var$gsl_const.CGSM.FOOT = 3.048e1 /* cm */ ;
$3b170edb4d456798$var$gsl_const.CGSM.YARD = 9.144e1 /* cm */ ;
$3b170edb4d456798$var$gsl_const.CGSM.MILE = 1.609344e5 /* cm */ ;
$3b170edb4d456798$var$gsl_const.CGSM.NAUTICAL_MILE = 1.852e5 /* cm */ ;
$3b170edb4d456798$var$gsl_const.CGSM.FATHOM = 1.8288e2 /* cm */ ;
$3b170edb4d456798$var$gsl_const.CGSM.MIL = 2.54e-3 /* cm */ ;
$3b170edb4d456798$var$gsl_const.CGSM.POINT = 3.52777777778e-2 /* cm */ ;
$3b170edb4d456798$var$gsl_const.CGSM.TEXPOINT = 3.51459803515e-2 /* cm */ ;
$3b170edb4d456798$var$gsl_const.CGSM.MICRON = 1e-4 /* cm */ ;
$3b170edb4d456798$var$gsl_const.CGSM.ANGSTROM = 1e-8 /* cm */ ;
$3b170edb4d456798$var$gsl_const.CGSM.HECTARE = 1e8 /* cm^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.ACRE = 4.04685642241e7 /* cm^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.BARN = 1e-24 /* cm^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.LITER = 1e3 /* cm^3 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.US_GALLON = 3.78541178402e3 /* cm^3 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.QUART = 9.46352946004e2 /* cm^3 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.PINT = 4.73176473002e2 /* cm^3 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.CUP = 2.36588236501e2 /* cm^3 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.FLUID_OUNCE = 2.95735295626e1 /* cm^3 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.TABLESPOON = 1.47867647813e1 /* cm^3 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.TEASPOON = 4.92892159375e0 /* cm^3 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.CANADIAN_GALLON = 4.54609e3 /* cm^3 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.UK_GALLON = 4.546092e3 /* cm^3 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.MILES_PER_HOUR = 4.4704e1 /* cm / s */ ;
$3b170edb4d456798$var$gsl_const.CGSM.KILOMETERS_PER_HOUR = 2.77777777778e1 /* cm / s */ ;
$3b170edb4d456798$var$gsl_const.CGSM.KNOT = 5.14444444444e1 /* cm / s */ ;
$3b170edb4d456798$var$gsl_const.CGSM.POUND_MASS = 4.5359237e2 /* g */ ;
$3b170edb4d456798$var$gsl_const.CGSM.OUNCE_MASS = 2.8349523125e1 /* g */ ;
$3b170edb4d456798$var$gsl_const.CGSM.TON = 9.0718474e5 /* g */ ;
$3b170edb4d456798$var$gsl_const.CGSM.METRIC_TON = 1e6 /* g */ ;
$3b170edb4d456798$var$gsl_const.CGSM.UK_TON = 1.0160469088e6 /* g */ ;
$3b170edb4d456798$var$gsl_const.CGSM.TROY_OUNCE = 3.1103475e1 /* g */ ;
$3b170edb4d456798$var$gsl_const.CGSM.CARAT = 2e-1 /* g */ ;
$3b170edb4d456798$var$gsl_const.CGSM.UNIFIED_ATOMIC_MASS = 1.660538782e-24 /* g */ ;
$3b170edb4d456798$var$gsl_const.CGSM.GRAM_FORCE = 9.80665e2 /* cm g / s^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.POUND_FORCE = 4.44822161526e5 /* cm g / s^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.KILOPOUND_FORCE = 4.44822161526e8 /* cm g / s^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.POUNDAL = 1.38255e4 /* cm g / s^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.CALORIE = 4.1868e7 /* g cm^2 / s^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.BTU = 1.05505585262e10; /* g cm^2 / s^2 */ 
$3b170edb4d456798$var$gsl_const.CGSM.THERM = 1.05506e15 /* g cm^2 / s^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.HORSEPOWER = 7.457e9 /* g cm^2 / s^3 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.BAR = 1e6 /* g / cm s^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.STD_ATMOSPHERE = 1.01325e6 /* g / cm s^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.TORR = 1.33322368421e3 /* g / cm s^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.METER_OF_MERCURY = 1.33322368421e6 /* g / cm s^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.INCH_OF_MERCURY = 3.38638815789e4 /* g / cm s^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.INCH_OF_WATER = 2.490889e3 /* g / cm s^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.PSI = 6.89475729317e4 /* g / cm s^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.POISE = 1e0 /* g / cm s */ ;
$3b170edb4d456798$var$gsl_const.CGSM.STOKES = 1e0 /* cm^2 / s */ ;
$3b170edb4d456798$var$gsl_const.CGSM.STILB = 1e0 /* cd / cm^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.LUMEN = 1e0 /* cd sr */ ;
$3b170edb4d456798$var$gsl_const.CGSM.LUX = 1e-4 /* cd sr / cm^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.PHOT = 1e0 /* cd sr / cm^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.FOOTCANDLE = 1.076e-3 /* cd sr / cm^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.LAMBERT = 1e0 /* cd sr / cm^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.FOOTLAMBERT = 1.07639104e-3 /* cd sr / cm^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.CURIE = 3.7e10; /* 1 / s */ 
$3b170edb4d456798$var$gsl_const.CGSM.ROENTGEN = 2.58e-8 /* abamp s / g */ ;
$3b170edb4d456798$var$gsl_const.CGSM.RAD = 1e2 /* cm^2 / s^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.SOLAR_MASS = 1.98892e33 /* g */ ;
$3b170edb4d456798$var$gsl_const.CGSM.BOHR_RADIUS = 5.291772083e-9 /* cm */ ;
$3b170edb4d456798$var$gsl_const.CGSM.NEWTON = 1e5 /* cm g / s^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.DYNE = 1e0 /* cm g / s^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.JOULE = 1e7 /* g cm^2 / s^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.ERG = 1e0 /* g cm^2 / s^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.STEFAN_BOLTZMANN_CONSTANT = 5.67040047374e-5 /* g / K^4 s^3 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.THOMSON_CROSS_SECTION = 6.65245893699e-25 /* cm^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.BOHR_MAGNETON = 9.27400899e-21 /* abamp cm^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.NUCLEAR_MAGNETON = 5.05078317e-24 /* abamp cm^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.ELECTRON_MAGNETIC_MOMENT = 9.28476362e-21 /* abamp cm^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.PROTON_MAGNETIC_MOMENT = 1.410606633e-23 /* abamp cm^2 */ ;
$3b170edb4d456798$var$gsl_const.CGSM.FARADAY = 9.64853429775e3 /* abamp s / mol */ ;
$3b170edb4d456798$var$gsl_const.CGSM.ELECTRON_CHARGE = 1.602176487e-20 /* abamp s */ ;
$3b170edb4d456798$var$gsl_const.MKS = {};
$3b170edb4d456798$var$gsl_const.MKS.SPEED_OF_LIGHT = 2.99792458e8 /* m / s */ ;
$3b170edb4d456798$var$gsl_const.MKS.GRAVITATIONAL_CONSTANT = 6.673e-11 /* m^3 / kg s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.PLANCKS_CONSTANT_H = 6.62606896e-34 /* kg m^2 / s */ ;
$3b170edb4d456798$var$gsl_const.MKS.PLANCKS_CONSTANT_HBAR = 1.05457162825e-34 /* kg m^2 / s */ ;
$3b170edb4d456798$var$gsl_const.MKS.ASTRONOMICAL_UNIT = 1.49597870691e11 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKS.LIGHT_YEAR = 9.46053620707e15 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKS.PARSEC = 3.08567758135e16 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKS.GRAV_ACCEL = 9.80665e0 /* m / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.ELECTRON_VOLT = 1.602176487e-19 /* kg m^2 / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.MASS_ELECTRON = 9.10938188e-31 /* kg */ ;
$3b170edb4d456798$var$gsl_const.MKS.MASS_MUON = 1.88353109e-28 /* kg */ ;
$3b170edb4d456798$var$gsl_const.MKS.MASS_PROTON = 1.67262158e-27 /* kg */ ;
$3b170edb4d456798$var$gsl_const.MKS.MASS_NEUTRON = 1.67492716e-27 /* kg */ ;
$3b170edb4d456798$var$gsl_const.MKS.RYDBERG = 2.17987196968e-18 /* kg m^2 / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.BOLTZMANN = 1.3806504e-23 /* kg m^2 / K s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.MOLAR_GAS = 8.314472e0 /* kg m^2 / K mol s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.STANDARD_GAS_VOLUME = 2.2710981e-2 /* m^3 / mol */ ;
$3b170edb4d456798$var$gsl_const.MKS.MINUTE = 6e1 /* s */ ;
$3b170edb4d456798$var$gsl_const.MKS.HOUR = 3.6e3 /* s */ ;
$3b170edb4d456798$var$gsl_const.MKS.DAY = 8.64e4 /* s */ ;
$3b170edb4d456798$var$gsl_const.MKS.WEEK = 6.048e5 /* s */ ;
$3b170edb4d456798$var$gsl_const.MKS.INCH = 2.54e-2 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKS.FOOT = 3.048e-1 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKS.YARD = 9.144e-1 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKS.MILE = 1.609344e3 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKS.NAUTICAL_MILE = 1.852e3 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKS.FATHOM = 1.8288e0 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKS.MIL = 2.54e-5 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKS.POINT = 3.52777777778e-4 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKS.TEXPOINT = 3.51459803515e-4 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKS.MICRON = 1e-6 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKS.ANGSTROM = 1e-10 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKS.HECTARE = 1e4 /* m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.ACRE = 4.04685642241e3 /* m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.BARN = 1e-28 /* m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.LITER = 1e-3 /* m^3 */ ;
$3b170edb4d456798$var$gsl_const.MKS.US_GALLON = 3.78541178402e-3 /* m^3 */ ;
$3b170edb4d456798$var$gsl_const.MKS.QUART = 9.46352946004e-4 /* m^3 */ ;
$3b170edb4d456798$var$gsl_const.MKS.PINT = 4.73176473002e-4 /* m^3 */ ;
$3b170edb4d456798$var$gsl_const.MKS.CUP = 2.36588236501e-4 /* m^3 */ ;
$3b170edb4d456798$var$gsl_const.MKS.FLUID_OUNCE = 2.95735295626e-5 /* m^3 */ ;
$3b170edb4d456798$var$gsl_const.MKS.TABLESPOON = 1.47867647813e-5 /* m^3 */ ;
$3b170edb4d456798$var$gsl_const.MKS.TEASPOON = 4.92892159375e-6 /* m^3 */ ;
$3b170edb4d456798$var$gsl_const.MKS.CANADIAN_GALLON = 4.54609e-3 /* m^3 */ ;
$3b170edb4d456798$var$gsl_const.MKS.UK_GALLON = 4.546092e-3 /* m^3 */ ;
$3b170edb4d456798$var$gsl_const.MKS.MILES_PER_HOUR = 4.4704e-1 /* m / s */ ;
$3b170edb4d456798$var$gsl_const.MKS.KILOMETERS_PER_HOUR = 2.77777777778e-1 /* m / s */ ;
$3b170edb4d456798$var$gsl_const.MKS.KNOT = 5.14444444444e-1 /* m / s */ ;
$3b170edb4d456798$var$gsl_const.MKS.POUND_MASS = 4.5359237e-1 /* kg */ ;
$3b170edb4d456798$var$gsl_const.MKS.OUNCE_MASS = 2.8349523125e-2 /* kg */ ;
$3b170edb4d456798$var$gsl_const.MKS.TON = 9.0718474e2 /* kg */ ;
$3b170edb4d456798$var$gsl_const.MKS.METRIC_TON = 1e3 /* kg */ ;
$3b170edb4d456798$var$gsl_const.MKS.UK_TON = 1.0160469088e3 /* kg */ ;
$3b170edb4d456798$var$gsl_const.MKS.TROY_OUNCE = 3.1103475e-2 /* kg */ ;
$3b170edb4d456798$var$gsl_const.MKS.CARAT = 2e-4 /* kg */ ;
$3b170edb4d456798$var$gsl_const.MKS.UNIFIED_ATOMIC_MASS = 1.660538782e-27 /* kg */ ;
$3b170edb4d456798$var$gsl_const.MKS.GRAM_FORCE = 9.80665e-3 /* kg m / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.POUND_FORCE = 4.44822161526e0 /* kg m / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.KILOPOUND_FORCE = 4.44822161526e3 /* kg m / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.POUNDAL = 1.38255e-1 /* kg m / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.CALORIE = 4.1868e0 /* kg m^2 / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.BTU = 1.05505585262e3 /* kg m^2 / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.THERM = 1.05506e8 /* kg m^2 / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.HORSEPOWER = 7.457e2 /* kg m^2 / s^3 */ ;
$3b170edb4d456798$var$gsl_const.MKS.BAR = 1e5 /* kg / m s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.STD_ATMOSPHERE = 1.01325e5 /* kg / m s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.TORR = 1.33322368421e2 /* kg / m s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.METER_OF_MERCURY = 1.33322368421e5 /* kg / m s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.INCH_OF_MERCURY = 3.38638815789e3 /* kg / m s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.INCH_OF_WATER = 2.490889e2 /* kg / m s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.PSI = 6.89475729317e3 /* kg / m s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.POISE = 1e-1 /* kg m^-1 s^-1 */ ;
$3b170edb4d456798$var$gsl_const.MKS.STOKES = 1e-4 /* m^2 / s */ ;
$3b170edb4d456798$var$gsl_const.MKS.STILB = 1e4 /* cd / m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.LUMEN = 1e0 /* cd sr */ ;
$3b170edb4d456798$var$gsl_const.MKS.LUX = 1e0 /* cd sr / m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.PHOT = 1e4 /* cd sr / m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.FOOTCANDLE = 1.076e1 /* cd sr / m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.LAMBERT = 1e4 /* cd sr / m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.FOOTLAMBERT = 1.07639104e1 /* cd sr / m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.CURIE = 3.7e10 /* 1 / s */ ;
$3b170edb4d456798$var$gsl_const.MKS.ROENTGEN = 2.58e-4 /* A s / kg */ ;
$3b170edb4d456798$var$gsl_const.MKS.RAD = 1e-2 /* m^2 / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.SOLAR_MASS = 1.98892e30 /* kg */ ;
$3b170edb4d456798$var$gsl_const.MKS.BOHR_RADIUS = 5.291772083e-11 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKS.NEWTON = 1e0 /* kg m / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.DYNE = 1e-5 /* kg m / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.JOULE = 1e0 /* kg m^2 / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.ERG = 1e-7 /* kg m^2 / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.STEFAN_BOLTZMANN_CONSTANT = 5.67040047374e-8 /* kg / K^4 s^3 */ ;
$3b170edb4d456798$var$gsl_const.MKS.THOMSON_CROSS_SECTION = 6.65245893699e-29 /* m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.BOHR_MAGNETON = 9.27400899e-24 /* A m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.NUCLEAR_MAGNETON = 5.05078317e-27 /* A m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.ELECTRON_MAGNETIC_MOMENT = 9.28476362e-24 /* A m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.PROTON_MAGNETIC_MOMENT = 1.410606633e-26 /* A m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.FARADAY = 9.64853429775e4 /* A s / mol */ ;
$3b170edb4d456798$var$gsl_const.MKS.ELECTRON_CHARGE = 1.602176487e-19 /* A s */ ;
$3b170edb4d456798$var$gsl_const.MKS.VACUUM_PERMITTIVITY = 8.854187817e-12 /* A^2 s^4 / kg m^3 */ ;
$3b170edb4d456798$var$gsl_const.MKS.VACUUM_PERMEABILITY = 1.25663706144e-6 /* kg m / A^2 s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.DEBYE = 3.33564095198e-30 /* A s^2 / m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKS.GAUSS = 1e-4 /* kg / A s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA = {};
$3b170edb4d456798$var$gsl_const.MKSA.SPEED_OF_LIGHT = 2.99792458e8 /* m / s */ ;
$3b170edb4d456798$var$gsl_const.MKSA.GRAVITATIONAL_CONSTANT = 6.673e-11 /* m^3 / kg s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.PLANCKS_CONSTANT_H = 6.62606896e-34 /* kg m^2 / s */ ;
$3b170edb4d456798$var$gsl_const.MKSA.PLANCKS_CONSTANT_HBAR = 1.05457162825e-34 /* kg m^2 / s */ ;
$3b170edb4d456798$var$gsl_const.MKSA.ASTRONOMICAL_UNIT = 1.49597870691e11 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKSA.LIGHT_YEAR = 9.46053620707e15 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKSA.PARSEC = 3.08567758135e16 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKSA.GRAV_ACCEL = 9.80665e0 /* m / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.ELECTRON_VOLT = 1.602176487e-19 /* kg m^2 / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.MASS_ELECTRON = 9.10938188e-31 /* kg */ ;
$3b170edb4d456798$var$gsl_const.MKSA.MASS_MUON = 1.88353109e-28 /* kg */ ;
$3b170edb4d456798$var$gsl_const.MKSA.MASS_PROTON = 1.67262158e-27 /* kg */ ;
$3b170edb4d456798$var$gsl_const.MKSA.MASS_NEUTRON = 1.67492716e-27 /* kg */ ;
$3b170edb4d456798$var$gsl_const.MKSA.RYDBERG = 2.17987196968e-18 /* kg m^2 / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.BOLTZMANN = 1.3806504e-23 /* kg m^2 / K s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.MOLAR_GAS = 8.314472e0 /* kg m^2 / K mol s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.STANDARD_GAS_VOLUME = 2.2710981e-2 /* m^3 / mol */ ;
$3b170edb4d456798$var$gsl_const.MKSA.MINUTE = 6e1 /* s */ ;
$3b170edb4d456798$var$gsl_const.MKSA.HOUR = 3.6e3 /* s */ ;
$3b170edb4d456798$var$gsl_const.MKSA.DAY = 8.64e4 /* s */ ;
$3b170edb4d456798$var$gsl_const.MKSA.WEEK = 6.048e5 /* s */ ;
$3b170edb4d456798$var$gsl_const.MKSA.INCH = 2.54e-2 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKSA.FOOT = 3.048e-1 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKSA.YARD = 9.144e-1 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKSA.MILE = 1.609344e3 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKSA.NAUTICAL_MILE = 1.852e3 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKSA.FATHOM = 1.8288e0 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKSA.MIL = 2.54e-5 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKSA.POINT = 3.52777777778e-4 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKSA.TEXPOINT = 3.51459803515e-4 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKSA.MICRON = 1e-6 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKSA.ANGSTROM = 1e-10 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKSA.HECTARE = 1e4 /* m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.ACRE = 4.04685642241e3 /* m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.BARN = 1e-28 /* m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.LITER = 1e-3 /* m^3 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.US_GALLON = 3.78541178402e-3 /* m^3 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.QUART = 9.46352946004e-4 /* m^3 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.PINT = 4.73176473002e-4 /* m^3 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.CUP = 2.36588236501e-4 /* m^3 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.FLUID_OUNCE = 2.95735295626e-5 /* m^3 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.TABLESPOON = 1.47867647813e-5 /* m^3 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.TEASPOON = 4.92892159375e-6 /* m^3 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.CANADIAN_GALLON = 4.54609e-3 /* m^3 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.UK_GALLON = 4.546092e-3 /* m^3 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.MILES_PER_HOUR = 4.4704e-1 /* m / s */ ;
$3b170edb4d456798$var$gsl_const.MKSA.KILOMETERS_PER_HOUR = 2.77777777778e-1 /* m / s */ ;
$3b170edb4d456798$var$gsl_const.MKSA.KNOT = 5.14444444444e-1 /* m / s */ ;
$3b170edb4d456798$var$gsl_const.MKSA.POUND_MASS = 4.5359237e-1 /* kg */ ;
$3b170edb4d456798$var$gsl_const.MKSA.OUNCE_MASS = 2.8349523125e-2 /* kg */ ;
$3b170edb4d456798$var$gsl_const.MKSA.TON = 9.0718474e2 /* kg */ ;
$3b170edb4d456798$var$gsl_const.MKSA.METRIC_TON = 1e3 /* kg */ ;
$3b170edb4d456798$var$gsl_const.MKSA.UK_TON = 1.0160469088e3 /* kg */ ;
$3b170edb4d456798$var$gsl_const.MKSA.TROY_OUNCE = 3.1103475e-2 /* kg */ ;
$3b170edb4d456798$var$gsl_const.MKSA.CARAT = 2e-4 /* kg */ ;
$3b170edb4d456798$var$gsl_const.MKSA.UNIFIED_ATOMIC_MASS = 1.660538782e-27 /* kg */ ;
$3b170edb4d456798$var$gsl_const.MKSA.GRAM_FORCE = 9.80665e-3 /* kg m / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.POUND_FORCE = 4.44822161526e0 /* kg m / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.KILOPOUND_FORCE = 4.44822161526e3 /* kg m / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.POUNDAL = 1.38255e-1 /* kg m / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.CALORIE = 4.1868e0 /* kg m^2 / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.BTU = 1.05505585262e3 /* kg m^2 / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.THERM = 1.05506e8 /* kg m^2 / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.HORSEPOWER = 7.457e2 /* kg m^2 / s^3 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.BAR = 1e5 /* kg / m s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.STD_ATMOSPHERE = 1.01325e5 /* kg / m s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.TORR = 1.33322368421e2 /* kg / m s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.METER_OF_MERCURY = 1.33322368421e5 /* kg / m s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.INCH_OF_MERCURY = 3.38638815789e3 /* kg / m s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.INCH_OF_WATER = 2.490889e2 /* kg / m s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.PSI = 6.89475729317e3 /* kg / m s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.POISE = 1e-1 /* kg m^-1 s^-1 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.STOKES = 1e-4 /* m^2 / s */ ;
$3b170edb4d456798$var$gsl_const.MKSA.STILB = 1e4 /* cd / m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.LUMEN = 1e0 /* cd sr */ ;
$3b170edb4d456798$var$gsl_const.MKSA.LUX = 1e0 /* cd sr / m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.PHOT = 1e4 /* cd sr / m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.FOOTCANDLE = 1.076e1 /* cd sr / m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.LAMBERT = 1e4 /* cd sr / m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.FOOTLAMBERT = 1.07639104e1 /* cd sr / m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.CURIE = 3.7e10 /* 1 / s */ ;
$3b170edb4d456798$var$gsl_const.MKSA.ROENTGEN = 2.58e-4 /* A s / kg */ ;
$3b170edb4d456798$var$gsl_const.MKSA.RAD = 1e-2 /* m^2 / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.SOLAR_MASS = 1.98892e30 /* kg */ ;
$3b170edb4d456798$var$gsl_const.MKSA.BOHR_RADIUS = 5.291772083e-11 /* m */ ;
$3b170edb4d456798$var$gsl_const.MKSA.NEWTON = 1e0 /* kg m / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.DYNE = 1e-5 /* kg m / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.JOULE = 1e0 /* kg m^2 / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.ERG = 1e-7 /* kg m^2 / s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.STEFAN_BOLTZMANN_CONSTANT = 5.67040047374e-8 /* kg / K^4 s^3 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.THOMSON_CROSS_SECTION = 6.65245893699e-29 /* m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.BOHR_MAGNETON = 9.27400899e-24 /* A m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.NUCLEAR_MAGNETON = 5.05078317e-27 /* A m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.ELECTRON_MAGNETIC_MOMENT = 9.28476362e-24 /* A m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.PROTON_MAGNETIC_MOMENT = 1.410606633e-26 /* A m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.FARADAY = 9.64853429775e4 /* A s / mol */ ;
$3b170edb4d456798$var$gsl_const.MKSA.ELECTRON_CHARGE = 1.602176487e-19 /* A s */ ;
$3b170edb4d456798$var$gsl_const.MKSA.VACUUM_PERMITTIVITY = 8.854187817e-12 /* A^2 s^4 / kg m^3 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.VACUUM_PERMEABILITY = 1.25663706144e-6 /* kg m / A^2 s^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.DEBYE = 3.33564095198e-30 /* A s^2 / m^2 */ ;
$3b170edb4d456798$var$gsl_const.MKSA.GAUSS = 1e-4 /* kg / A s^2 */ ;
$3b170edb4d456798$var$gsl_const.NUM = {};
$3b170edb4d456798$var$gsl_const.NUM.FINE_STRUCTURE = 7.297352533e-3 /* 1 */ ;
$3b170edb4d456798$var$gsl_const.NUM.AVOGADRO = 6.02214199e23 /* 1 / mol */ ;
$3b170edb4d456798$var$gsl_const.NUM.YOTTA = 1e24 /* 1 */ ;
$3b170edb4d456798$var$gsl_const.NUM.ZETTA = 1e21 /* 1 */ ;
$3b170edb4d456798$var$gsl_const.NUM.EXA = 1e18 /* 1 */ ;
$3b170edb4d456798$var$gsl_const.NUM.PETA = 1e15 /* 1 */ ;
$3b170edb4d456798$var$gsl_const.NUM.TERA = 1e12 /* 1 */ ;
$3b170edb4d456798$var$gsl_const.NUM.GIGA = 1e9 /* 1 */ ;
$3b170edb4d456798$var$gsl_const.NUM.MEGA = 1e6 /* 1 */ ;
$3b170edb4d456798$var$gsl_const.NUM.KILO = 1e3 /* 1 */ ;
$3b170edb4d456798$var$gsl_const.NUM.MILLI = 1e-3 /* 1 */ ;
$3b170edb4d456798$var$gsl_const.NUM.MICRO = 1e-6 /* 1 */ ;
$3b170edb4d456798$var$gsl_const.NUM.NANO = 1e-9 /* 1 */ ;
$3b170edb4d456798$var$gsl_const.NUM.PICO = 1e-12 /* 1 */ ;
$3b170edb4d456798$var$gsl_const.NUM.FEMTO = 1e-15 /* 1 */ ;
$3b170edb4d456798$var$gsl_const.NUM.ATTO = 1e-18 /* 1 */ ;
$3b170edb4d456798$var$gsl_const.NUM.ZEPTO = 1e-21 /* 1 */ ;
$3b170edb4d456798$var$gsl_const.NUM.YOCTO = 1e-24 /* 1 */ ;
$3b170edb4d456798$exports = $3b170edb4d456798$var$gsl_const;








const { max: $8d37ed4696fd96a4$var$max } = Math;
const $8d37ed4696fd96a4$export$d538e2b459c01d7 = (states = 1, form = 2, count = 1)=>$8d37ed4696fd96a4$var$max(1, states - form + 1) * form * count;
var $8d37ed4696fd96a4$export$2e2bcd8739ae039 = $8d37ed4696fd96a4$export$d538e2b459c01d7;



var $fb5fbe3afe5e76bf$exports = {};
$fb5fbe3afe5e76bf$exports = "/** Grid fragment shader. */\n\n/** @todo Use a better setup than this, for tidier ongoing mapping tests. */\n#define test_off 0\n#define test_p2g 1\n#define test_draw 2\n#ifndef test\n  #define test test_off\n#endif\n\n#ifdef GL_EXT_draw_buffers\n  #extension GL_EXT_draw_buffers : require\n#endif\n\nprecision highp float;\n#define GLSLIFY 1\n\ngrid_useSamples\n\n#ifdef grid_output_motionFull\n  grid_useReads_motionFull\n#endif\n#ifdef grid_output_motionBase\n  grid_useReads_motionBase\n#endif\n\n/** @todo `gl-gpgpu` should skip passes with no output; here for mass. */\n#if defined(grid_output_motionFull) || defined(grid_output_motionBase)\n  #ifdef grid_splits\n    uniform sampler2D grid_states[grid_splits];\n  #else\n    uniform sampler2D grid_states;\n  #endif\n\n  uniform float grid_stepNow;\n#endif\n#if defined(grid_output_motionFull)\n  uniform vec4 grid_stateShape;\n#endif\n\n#if defined(grid_output_motionFull) || defined(grid_output_motionBase)\n  uniform vec3 g;\n  uniform float dt;\n\n  #ifdef rescale_mass\n    uniform vec2 rescaleMass;\n  #else\n    const float rescaledMass = 1.0;\n  #endif\n  #ifdef rescale_motion\n    uniform vec2 rescaleMotion;\n  #else\n    const float rescaledMotion = 1.0;\n  #endif\n\n  float when_gt_1540259130(float x, float y) {\n  return max(sign(x - y), 0.0);\n}\n\nvec2 when_gt_1540259130(vec2 x, vec2 y) {\n  return max(sign(x - y), 0.0);\n}\n\nvec3 when_gt_1540259130(vec3 x, vec3 y) {\n  return max(sign(x - y), 0.0);\n}\n\nvec4 when_gt_1540259130(vec4 x, vec4 y) {\n  return max(sign(x - y), 0.0);\n}\n\n  /**\n * Convenience to sample entries safely at their texel center.\n * Where `spreadUV` is for lookup ranges, `offsetUV` is for lookup queries.\n *\n * @see [`spreadUV`](./spread-uv.glsl)\n *\n * @param {vec2} `uv` UV texture sample coordinate, expect range `[0, 1]`.\n * @param {float|int|vec2|ivec2} `[size=1.0]` Texture's size, expect\n *   `[width, height]`, or if given a scalar interpret both as `side`.\n * @param {float|vec2} `[pad=0.5]` Texel `pad` to offset, expect range `[0, 1]`.\n *\n * @returns {vec2} The `uv` offset by `pad` to texel center, expect range\n *   `[0+pad, 1-pad]`.\n */\n\nvec2 offsetUV(vec2 uv, float size, float pad) {\n  return ((uv*(size-1.0))+pad)/size;\n}\n\nvec2 offsetUV(vec2 uv, vec2 size, float pad) {\n  return ((uv*(size-1.0))+pad)/size;\n}\n\nvec2 offsetUV(vec2 uv, vec2 size, vec2 pad) {\n  return ((uv*(size-1.0))+pad)/size;\n}\n\nvec2 offsetUV(vec2 uv, int size, float pad) {\n  return offsetUV(uv, float(size), pad);\n}\n\nvec2 offsetUV(vec2 uv, ivec2 size, float pad) {\n  return offsetUV(uv, vec2(size), pad);\n}\n\nvec2 offsetUV(vec2 uv, ivec2 size, vec2 pad) {\n  return offsetUV(uv, vec2(size), pad);\n}\n\nvec2 offsetUV(vec2 uv, float size) { return offsetUV(uv, size, 0.5); }\nvec2 offsetUV(vec2 uv, vec2 size) { return offsetUV(uv, size, 0.5); }\nvec2 offsetUV(vec2 uv, int size) { return offsetUV(uv, size, 0.5); }\nvec2 offsetUV(vec2 uv, ivec2 size) { return offsetUV(uv, size, 0.5); }\nvec2 offsetUV(vec2 uv) { return offsetUV(uv, 1.0, 0.5); }\n\n  #if defined(rescale_mass) || defined(rescale_motion)\n    /** Exponential notation packed into a vector. */\nfloat exponent(vec2 basePower) { return basePower.s*pow(1e1, basePower.t); }\n\n  #endif\n#endif\n#if defined(grid_output_motionFull)\n  uniform vec4 boundsIn;\n  uniform float boundsHit;\n\n  float when_lt_2281831123(float x, float y) {\n  return max(sign(y - x), 0.0);\n}\n\nvec2 when_lt_2281831123(vec2 x, vec2 y) {\n  return max(sign(y - x), 0.0);\n}\n\nvec3 when_lt_2281831123(vec3 x, vec3 y) {\n  return max(sign(y - x), 0.0);\n}\n\nvec4 when_lt_2281831123(vec4 x, vec4 y) {\n  return max(sign(y - x), 0.0);\n}\n\n  \n\nfloat when_ge_529295689(float x, float y) {\n  return 1.0 - when_lt_2281831123(x, y);\n}\n\nvec2 when_ge_529295689(vec2 x, vec2 y) {\n  return 1.0 - when_lt_2281831123(x, y);\n}\n\nvec3 when_ge_529295689(vec3 x, vec3 y) {\n  return 1.0 - when_lt_2281831123(x, y);\n}\n\nvec4 when_ge_529295689(vec4 x, vec4 y) {\n  return 1.0 - when_lt_2281831123(x, y);\n}\n\n#endif\n\nvarying vec2 grid_uv;\n\nconst vec2 v1 = vec2(1);\nconst vec2 v0 = v1*0.0;\n\n#if defined(grid_output_motionFull)\n  const float hitStop = 0.0;\n  const float hitBack = 1.0;\n  const float hitBounce = 2.0;\n#endif\n\nvoid main() {\n  #if defined(grid_output_motionFull) || defined(grid_output_motionBase)\n    #ifdef readMass\n    #elif defined(grid_output_motionFull)\n      #define readMass grid_reads_motionFull_mass\n    #elif defined(grid_output_motionBase)\n      #define readMass grid_reads_motionBase_mass\n    #endif\n\n    grid_tapState(offsetUV(grid_uv, grid_stateShape.xy));\n    // grid_tapState(grid_uv);\n\n    #if test == test_p2g\n      // for(int t = 0; t < grid_textures; ++t) { gl_FragData[t] = grid_data[t]; }\n      gl_FragData[0] = grid_data[0];\n      return;\n    #endif\n\n    #ifdef rescale_mass\n      float rescaledMass = exponent(rescaleMass);\n    #endif\n    #ifdef rescale_motion\n      float rescaledMotion = exponent(rescaleMotion);\n    #endif\n\n    float mass = rescaledMass*grid_data[readMass].grid_channels_mass;\n    float on = when_gt_1540259130(mass, 0.0);\n    float massScale = 1.0/mix(1.0, mass, on);\n  #endif\n\n  #ifdef grid_output_motionFull\n    vec2 motionFull = rescaledMotion*\n      grid_data[grid_reads_motionFull_motionFull].grid_channels_motionFull;\n\n    motionFull *= massScale;\n\n    /** External forces. */\n    motionFull += normalize(g.xy-mix(-v1, v1, grid_uv))*g.z*dt;\n\n    /** Boundaries. */\n\n    vec2 at = grid_uv*grid_stateShape.xy;\n\n    vec4 boundsTo = vec4(boundsIn.xy, boundsIn.zw+grid_stateShape.xy)-at.xyxy;\n\n    vec4 boundsOut = vec4(when_gt_1540259130(boundsTo.xy, v0)*when_lt_2281831123(motionFull, v0),\n      when_lt_2281831123(boundsTo.zw, v0)*when_gt_1540259130(motionFull, v0));\n\n    vec2 moveStop = v0;\n    vec2 moveBack = (boundsTo.xy*boundsOut.xy)+(boundsTo.zw*boundsOut.zw);\n    vec2 moveBounce = -motionFull;\n    float geStop = when_ge_529295689(boundsHit, hitStop);\n    float geBack = when_ge_529295689(boundsHit, hitBack);\n    float geBounce = when_ge_529295689(boundsHit, hitBounce);\n    vec2 moveHit = motionFull;\n\n    moveHit = mix(moveHit, moveStop, geStop);\n    moveHit = mix(moveHit, moveBack, geBack);\n    moveHit = mix(moveHit, moveBounce, geBounce);\n    motionFull = mix(motionFull, moveHit, boundsOut.xy+boundsOut.zw);\n\n    // grid_output_motionFull = (on*motionFull)/rescaledMotion;\n    grid_output_motionFull = motionFull/rescaledMotion;\n  #endif\n  #ifdef grid_output_motionBase\n    vec2 motionBase = rescaledMotion*\n      grid_data[grid_reads_motionBase_motionBase].grid_channels_motionBase;\n\n    // grid_output_motionBase = (on*motionBase*massScale)/rescaledMotion;\n    grid_output_motionBase = (motionBase*massScale)/rescaledMotion;\n  #endif\n}\n";


var $201ff48dc55802cd$exports = {};
$201ff48dc55802cd$exports = "/** Grid-to-points fragment shader. */\n\n#ifdef GL_EXT_draw_buffers\n  #extension GL_EXT_draw_buffers : require\n#endif\n\nprecision highp float;\n#define GLSLIFY 1\n\nstruct Kernel2 {\n  vec2 base;\n  vec2 diff;\n  // Only using `[i].xy` channels of each layer `i`; `vec2[3]` is tricky.\n  mat3 weights;\n};\n\nstruct UP2 {\n  mat2 u;\n  mat2 p;\n};\n\nstruct SVD2 {\n  mat2 u;\n  mat2 sigma;\n  mat2 v;\n};\n\npoints_useSamples\ngrid_useSamples\n\n#ifdef points_useReads_position\n  points_useReads_position\n#endif\n#ifdef points_useReads_motion\n  points_useReads_motion\n#endif\n#ifdef points_useReads_mass\n  points_useReads_mass\n#endif\n#ifdef points_useReads_affine\n  points_useReads_affine\n#endif\n#ifdef points_useReads_deform\n  points_useReads_deform\n#endif\n#ifdef points_useReads_stress\n  points_useReads_stress\n#endif\n\n#if defined(points_output_position) || defined(points_output_motion) || \\\n    defined(points_output_affine)\n  grid_useReads_mass\n#endif\n\n#if defined(points_output_position) || defined(points_output_motion) || \\\n    defined(points_output_affine) || defined(points_output_deform)\n  #ifdef points_splits\n    uniform sampler2D points_states[points_splits];\n  #else\n    uniform sampler2D points_states;\n  #endif\n\n  uniform float points_stepNow;\n  uniform vec4 points_stateShape;\n#endif\n\n#if defined(points_output_position) || defined(points_output_motion) || \\\n    defined(points_output_affine)\n  #ifdef grid_splits\n    uniform sampler2D grid_states[grid_splits];\n  #else\n    uniform sampler2D grid_states;\n  #endif\n\n  uniform float grid_stepNow;\n  uniform vec4 grid_stateShape;\n#endif\n\n#if defined(points_output_mass)\n  /** @todo Move to looking up material types? */\n  uniform float mass;\n#endif\n#if defined(points_output_stress)\n  /** @todo Move to looking up material types? */\n  uniform float volume;\n#endif\n#if defined(points_output_motion)\n  uniform float speedClamp;\n#endif\n#if defined(points_output_position) || defined(points_output_motion)\n  /** Volume change threshold comparison. */\n  uniform vec2 volumeSplit;\n  /** ASFLIP motion adjustment. */\n  uniform float motionAdjust;\n  /** ASFLIP position adjustment range. */\n  uniform vec2 positionAdjusts;\n#endif\n#if defined(points_output_deform) || defined(points_output_stress)\n  /**\n  * Mechanics parameters.\n  *\n  * @todo Move to individual particles looking up material types?\n  */\n\n  /** Bulk modulus. */\n  uniform float bulkMod;\n  /** Shear modulus. */\n  uniform float shearMod;\n#endif\n#if defined(points_output_deform)\n  /**\n  * Plasticity parameters.\n  *\n  * @todo Move to individual particles looking up material types?\n  */\n  uniform float materialFriction;\n#endif\n#if defined(points_output_position)\n  uniform float boundsClamp;\n#endif\n#if defined(points_output_position) || defined(points_output_motion) || \\\n    defined(points_output_affine) || defined(points_output_deform) || \\\n    defined(points_output_stress)\n  uniform float spawnOnAny;\n  uniform float spawnOnOut;\n  uniform float spawnOnSlow;\n  uniform float spawnOnCentre;\n#endif\n#if defined(points_output_motion) || defined(points_output_position)\n  uniform vec3 wander;\n#endif\n\nuniform float dt;\n\nuniform vec4 bounds;\nuniform float chaos;\n\n#ifdef rescale_mass\n  uniform vec2 rescaleMass;\n#else\n  const float rescaledMass = 1.0;\n#endif\n#ifdef rescale_position\n  uniform vec2 rescalePosition;\n#else\n  const float rescaledPosition = 1.0;\n#endif\n#ifdef rescale_motion\n  uniform vec2 rescaleMotion;\n#else\n  const float rescaledMotion = 1.0;\n#endif\n#ifdef rescale_affine\n  uniform vec2 rescaleAffine;\n#else\n  const float rescaledAffine = 1.0;\n#endif\n#ifdef rescale_deform\n  uniform vec2 rescaleDeform;\n#else\n  const float rescaledDeform = 1.0;\n#endif\n#ifdef rescale_stress\n  uniform vec2 rescaleStress;\n#else\n  const float rescaledStress = 1.0;\n#endif\n\nvarying vec2 points_uv;\n\nconst vec2 v1 = vec2(1);\nconst vec2 v0 = v1*0.0;\nconst mat2 m1 = mat2(1);\nconst mat2 m0 = m1*0.0;\nconst vec4 mv0 = vec4(m0);\nconst vec4 mv1 = vec4(m1);\nconst float eps = 1e-6;\n\nfloat when_lt_2281831123(float x, float y) {\n  return max(sign(y - x), 0.0);\n}\n\nvec2 when_lt_2281831123(vec2 x, vec2 y) {\n  return max(sign(y - x), 0.0);\n}\n\nvec3 when_lt_2281831123(vec3 x, vec3 y) {\n  return max(sign(y - x), 0.0);\n}\n\nvec4 when_lt_2281831123(vec4 x, vec4 y) {\n  return max(sign(y - x), 0.0);\n}\n\nfloat when_gt_529295689(float x, float y) {\n  return max(sign(x - y), 0.0);\n}\n\nvec2 when_gt_529295689(vec2 x, vec2 y) {\n  return max(sign(x - y), 0.0);\n}\n\nvec3 when_gt_529295689(vec3 x, vec3 y) {\n  return max(sign(x - y), 0.0);\n}\n\nvec4 when_gt_529295689(vec4 x, vec4 y) {\n  return max(sign(x - y), 0.0);\n}\n\nfloat when_le_3028842562(float x, float y) {\n  return 1.0 - when_gt_529295689(x, y);\n}\n\nvec2 when_le_3028842562(vec2 x, vec2 y) {\n  return 1.0 - when_gt_529295689(x, y);\n}\n\nvec3 when_le_3028842562(vec3 x, vec3 y) {\n  return 1.0 - when_gt_529295689(x, y);\n}\n\nvec4 when_le_3028842562(vec4 x, vec4 y) {\n  return 1.0 - when_gt_529295689(x, y);\n}\n\nfloat when_ge_2658629798(float x, float y) {\n  return 1.0 - when_lt_2281831123(x, y);\n}\n\nvec2 when_ge_2658629798(vec2 x, vec2 y) {\n  return 1.0 - when_lt_2281831123(x, y);\n}\n\nvec3 when_ge_2658629798(vec3 x, vec3 y) {\n  return 1.0 - when_lt_2281831123(x, y);\n}\n\nvec4 when_ge_2658629798(vec4 x, vec4 y) {\n  return 1.0 - when_lt_2281831123(x, y);\n}\n\nfloat when_eq_1062606552(float x, float y) {\n  return 1.0 - abs(sign(x - y));\n}\n\nvec2 when_eq_1062606552(vec2 x, vec2 y) {\n  return 1.0 - abs(sign(x - y));\n}\n\nvec3 when_eq_1062606552(vec3 x, vec3 y) {\n  return 1.0 - abs(sign(x - y));\n}\n\nvec4 when_eq_1062606552(vec4 x, vec4 y) {\n  return 1.0 - abs(sign(x - y));\n}\n\n// Math.PI * 2\nconst float TAU = 6.28318530718;\n\nfloat map(float value, float inMin, float inMax, float outMin, float outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\nvec2 map(vec2 value, vec2 inMin, vec2 inMax, vec2 outMin, vec2 outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\nvec3 map(vec3 value, vec3 inMin, vec3 inMax, vec3 outMin, vec3 outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\nvec4 map(vec4 value, vec4 inMin, vec4 inMax, vec4 outMin, vec4 outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\nfloat determinant(float m) {\n  return m;\n}\n\nfloat determinant(mat2 m) {\n  return m[0][0] * m[1][1] - m[0][1] * m[1][0]; \n}\n\nfloat determinant(mat3 m) {\n  return m[0][0] * (m[2][2]*m[1][1] - m[1][2]*m[2][1])\n       + m[0][1] * (m[1][2]*m[2][0] - m[2][2]*m[1][0])\n       + m[0][2] * (m[2][1]*m[1][0] - m[1][1]*m[2][0]);\n}\n\nfloat determinant(mat4 m) {\n  float\n      b00 = m[0][0] * m[1][1] - m[0][1] * m[1][0],\n      b01 = m[0][0] * m[1][2] - m[0][2] * m[1][0],\n      b02 = m[0][0] * m[1][3] - m[0][3] * m[1][0],\n      b03 = m[0][1] * m[1][2] - m[0][2] * m[1][1],\n      b04 = m[0][1] * m[1][3] - m[0][3] * m[1][1],\n      b05 = m[0][2] * m[1][3] - m[0][3] * m[1][2],\n      b06 = m[2][0] * m[3][1] - m[2][1] * m[3][0],\n      b07 = m[2][0] * m[3][2] - m[2][2] * m[3][0],\n      b08 = m[2][0] * m[3][3] - m[2][3] * m[3][0],\n      b09 = m[2][1] * m[3][2] - m[2][2] * m[3][1],\n      b10 = m[2][1] * m[3][3] - m[2][3] * m[3][1],\n      b11 = m[2][2] * m[3][3] - m[2][3] * m[3][2];\n  return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;\n}\n\nfloat transpose(float m) {\n  return m;\n}\n\nmat2 transpose(mat2 m) {\n  return mat2(m[0][0], m[1][0],\n              m[0][1], m[1][1]);\n}\n\nmat3 transpose(mat3 m) {\n  return mat3(m[0][0], m[1][0], m[2][0],\n              m[0][1], m[1][1], m[2][1],\n              m[0][2], m[1][2], m[2][2]);\n}\n\nmat4 transpose(mat4 m) {\n  return mat4(m[0][0], m[1][0], m[2][0], m[3][0],\n              m[0][1], m[1][1], m[2][1], m[3][1],\n              m[0][2], m[1][2], m[2][2], m[3][2],\n              m[0][3], m[1][3], m[2][3], m[3][3]);\n}\n\n/**\n * Convenience to sample entries safely at their texel center.\n * Where `spreadUV` is for lookup ranges, `offsetUV` is for lookup queries.\n *\n * @see [`spreadUV`](./spread-uv.glsl)\n *\n * @param {vec2} `uv` UV texture sample coordinate, expect range `[0, 1]`.\n * @param {float|int|vec2|ivec2} `[size=1.0]` Texture's size, expect\n *   `[width, height]`, or if given a scalar interpret both as `side`.\n * @param {float|vec2} `[pad=0.5]` Texel `pad` to offset, expect range `[0, 1]`.\n *\n * @returns {vec2} The `uv` offset by `pad` to texel center, expect range\n *   `[0+pad, 1-pad]`.\n */\n\nvec2 offsetUV(vec2 uv, float size, float pad) {\n  return ((uv*(size-1.0))+pad)/size;\n}\n\nvec2 offsetUV(vec2 uv, vec2 size, float pad) {\n  return ((uv*(size-1.0))+pad)/size;\n}\n\nvec2 offsetUV(vec2 uv, vec2 size, vec2 pad) {\n  return ((uv*(size-1.0))+pad)/size;\n}\n\nvec2 offsetUV(vec2 uv, int size, float pad) {\n  return offsetUV(uv, float(size), pad);\n}\n\nvec2 offsetUV(vec2 uv, ivec2 size, float pad) {\n  return offsetUV(uv, vec2(size), pad);\n}\n\nvec2 offsetUV(vec2 uv, ivec2 size, vec2 pad) {\n  return offsetUV(uv, vec2(size), pad);\n}\n\nvec2 offsetUV(vec2 uv, float size) { return offsetUV(uv, size, 0.5); }\nvec2 offsetUV(vec2 uv, vec2 size) { return offsetUV(uv, size, 0.5); }\nvec2 offsetUV(vec2 uv, int size) { return offsetUV(uv, size, 0.5); }\nvec2 offsetUV(vec2 uv, ivec2 size) { return offsetUV(uv, size, 0.5); }\nvec2 offsetUV(vec2 uv) { return offsetUV(uv, 1.0, 0.5); }\n\n// float trace(mat2 m) { return m[0][0]+m[1][1]; }\n\n#define createTrace(f, mat, n) \\\nfloat f(mat m) { \\\n  float t = 0.0; \\\n   \\\n  for(int d = 0; d < n; ++d) { t += m[d][d]; } \\\n   \\\n  return t; \\\n}\n\ncreateTrace(trace, mat2, 2)\ncreateTrace(trace, mat3, 3)\ncreateTrace(trace, mat4, 4)\n\n// mat2 outerProduct(vec2 v0, vec2 v1) { return mat2(v0*v1[0], v0*v1[1]); }\n\n#define createOuterProduct(f, vec, mat, n) \\\nmat f(vec v0, vec v1) { \\\n  mat m; \\\n   \\\n  for(int d = 0; d < n; ++d) { m[d] = v0*v1[d]; } \\\n   \\\n  return m; \\\n}\n\ncreateOuterProduct(outerProduct, vec2, mat2, 2)\ncreateOuterProduct(outerProduct, vec3, mat3, 3)\ncreateOuterProduct(outerProduct, vec4, mat4, 4)\n\n// float area(vec2 v) { return v.x*v.y; }\n\n#define createArea(f, vec, n) \\\nfloat f(vec v) { \\\n  float a = 1.0; \\\n   \\\n  for(int d = 0; d < n; ++d) { a *= v[d]; } \\\n   \\\n  return a; \\\n}\n\ncreateArea(area, vec2, 2)\ncreateArea(area, vec3, 3)\ncreateArea(area, vec4, 4)\n\nfloat length2(float v) { return v*v; }\nfloat length2(vec2 v) { return dot(v, v); }\nfloat length2(vec3 v) { return dot(v, v); }\nfloat length2(vec4 v) { return dot(v, v); }\n\n#if defined(rescale_mass) || defined(rescale_position) || \\\n    defined(rescale_motion) || defined(rescale_affine) || \\\n    defined(rescale_deform) || defined(rescale_stress)\n  /** Exponential notation packed into a vector. */\nfloat exponent(vec2 basePower) { return basePower.s*pow(1e1, basePower.t); }\n\n#endif\n\n#if defined(points_output_position) || defined(points_output_motion) || \\\n    defined(points_output_affine)\n  /**\n * Quadratic weight kernel.\n *\n * @see [Equation 123, The Material Point Method for Simulating Continuum\n *   Materials (mpm.graphics)](https://drive.google.com/open?id=1rI4gsBH3BstH7EYQA451Pb56MrJ7hVsu&usp=drive_fs)\n * @see [Incremental MPM](https://github.com/nialltl/incremental_mpm/blob/master/Assets/3.%20MLS_MPM_Fluid_Multithreaded/MLS_MPM_Fluid_Multithreaded.cs#L337-L344)\n * @see [MLS-MPM-88](https://github.com/yuanming-hu/taichi_mpm/blob/master/mls-mpm88-explained.cpp#L151-L158)\n *\n * @todo Test more and ensure this is the equivalent lookup.\n */\n\nstruct Kernel3 {\n  vec3 base;\n  vec3 diff;\n  mat3 weights;\n};\n\n/**\n * The cell base for each kernel type.\n *\n * @note Tried implementing the same `int(at)` cast-based truncation logic as\n *   the original, but it led to the simulation exploding, probably because an\n *   array-based grid can't handle negative indices but a texture-based one can,\n *   and truncation must've led to a division by 0 somewhere.\n */\n\n#define createToBaseShort(f, vec) \\\nvec f(vec at) { \\\n  vec base; \\\n   \\\n  return f(at, base); \\\n}\n\n#ifdef kernelTypeCentre\n  #ifdef kernelBaseCast\n    #define createToBase(f, vec, ivec) \\\n    vec f(vec at, out vec base) { return (base = vec(ivec(at))); } \\\n    createToBaseShort(f, vec)\n  #else\n    #define createToBase(f, vec) \\\n    vec f(vec at, out vec base) { return (base = floor(at)); } \\\n    createToBaseShort(f, vec)\n  #endif\n#else\n  /**\n   * @todo Test if this is correct for negative numbers, seems to create gaps\n   *   between positive and negative quadrants.\n   */\n  #ifdef kernelBaseCast\n    #define createToBase(f, vec, ivec) \\\n    vec f(vec at, out vec base) { return (base = vec(ivec(at-0.5))); } \\\n    createToBaseShort(f, vec)\n  #else\n    #define createToBase(f, vec) \\\n    vec f(vec at, out vec base) { return (base = floor(at-0.5)); } \\\n    createToBaseShort(f, vec)\n  #endif\n#endif\n\n#ifdef kernelBaseCast\n  createToBase(toBase, float, int)\n  createToBase(toBase, vec2, ivec2)\n  createToBase(toBase, vec3, ivec3)\n#else\n  createToBase(toBase, float)\n  createToBase(toBase, vec2)\n  createToBase(toBase, vec3)\n#endif\n\n/** The cell base for each kernel type. */\n#define createToDiffShort(f, vec) \\\nvec f(vec at, vec base) { \\\n  vec diff; \\\n   \\\n  return f(at, base, diff); \\\n}\n\n#ifdef kernelTypeCentre\n  #define createToDiff(f, vec) \\\n  vec f(vec at, vec base, out vec diff) { return (diff = (at-base)-0.5); } \\\n  createToDiffShort(f, vec)\n#else\n  #define createToDiff(f, vec) \\\n  vec f(vec at, vec base, out vec diff) { return (diff = at-base); } \\\n  createToDiffShort(f, vec)\n#endif\n\ncreateToDiff(toDiff, float)\ncreateToDiff(toDiff, vec2)\ncreateToDiff(toDiff, vec3)\n\nvec2 toWeight(inout vec2 w, vec2 v) { return w = v; }\nvec2 toWeight(inout vec3 w, vec2 v) { return w.xy = v; }\nvec3 toWeight(inout vec3 w, vec3 v) { return w = v; }\n\n#ifdef kernelTypeCentre\n  #define createToWeightsMain(vec, diff) \\\n    vec w0 = 0.5-diff; \\\n    vec w1 = diff; \\\n    vec w2 = 0.5+diff;\n#else\n  #define createToWeightsMain(vec, diff) \\\n    vec w0 = 1.5-diff; \\\n    vec w1 = diff-1.0; \\\n    vec w2 = diff-0.5;\n#endif\n\n#define createToWeights(f, vec, mat) \\\n \\\nmat f(vec diff, out mat weights) { \\\n  createToWeightsMain(vec, diff) \\\n   \\\n  toWeight(weights[0], 0.5*(w0*w0)); \\\n  toWeight(weights[1], 0.75-(w1*w1)); \\\n  toWeight(weights[2], 0.5*(w2*w2)); \\\n   \\\n  return weights; \\\n} \\\n \\\nmat f(vec diff) { \\\n  mat weights; \\\n   \\\n  return f(diff, weights); \\\n}\n\ncreateToWeights(toWeights, vec2, mat3)\ncreateToWeights(toWeights, vec3, mat3)\n\n#define createToKernel(f, vec, mat, Kernel) \\\n \\\nKernel f(vec at, out vec base, out vec diff, out mat weights) { \\\n  return Kernel(base = toBase(at, base), \\\n    diff = toDiff(at, base, diff), \\\n    weights = toWeights(diff, weights)); \\\n} \\\n \\\nKernel f(vec at, out vec base, out vec diff) { \\\n  mat weights; \\\n   \\\n  return f(at, base, diff, weights); \\\n} \\\n \\\nKernel f(vec at, out vec base) { \\\n  vec diff; \\\n   \\\n  return f(at, base, diff); \\\n} \\\n \\\nKernel f(vec at, out vec base, out mat weights) { \\\n  vec diff; \\\n   \\\n  return f(at, base, diff, weights); \\\n} \\\n \\\nKernel f(vec at, out mat weights) { \\\n  vec base; \\\n   \\\n  return f(at, base, weights); \\\n} \\\n \\\nKernel f(vec at) { \\\n  vec base; \\\n   \\\n  return f(at, base); \\\n}\n\ncreateToKernel(toKernel, vec2, mat3, Kernel2)\ncreateToKernel(toKernel, vec3, mat3, Kernel3)\n\n  /** The cell offset for each kernel type. */\n#define createToOffsetShort(f, vec) \\\nvec f(vec offset) { \\\n  vec to; \\\n   \\\n  return f(offset, to); \\\n}\n\n#ifdef kernelTypeCentre\n  #define createToOffset(f, vec) \\\n  vec f(in vec offset, out vec to) { return (to = offset-1.0); } \\\n  createToOffsetShort(f, vec)\n#else\n  #define createToOffset(f, vec) \\\n  vec f(in vec offset, out vec to) { return (to = offset); } \\\n  createToOffsetShort(f, vec)\n#endif\n\ncreateToOffset(toOffset, float)\ncreateToOffset(toOffset, vec2)\ncreateToOffset(toOffset, vec3)\n\n  /**\n * The distance function for each kernel type.\n *\n * @see [Incremental MPM cell distance](https://github.com/nialltl/incremental_mpm/blob/master/Assets/3.%20MLS_MPM_Fluid_Multithreaded/MLS_MPM_Fluid_Multithreaded.cs#L187-L201)\n * @see [PyASFLIP cell distance](https://github.com/nepluno/pyasflip/blob/master/pyasflip.py#L320-L339)\n * @todo Not sure this is right, the scales might be off.\n * @todo Work out the algebra more nicely in terms of `offset` and `diff`.\n */\n\n#ifdef kernelTypeCentre\n  /**\n   * @example ```\n   * // Goal:\n   * dist(offset, base, at) = ((base+offset-1)-at)+0.5\n   * // From offset:\n   * offset = offset-1\n   * // Thus:\n   * dist(offset = offset-1, base, at) = ((base+offset)-at)+0.5\n   * // From weights:\n   * diff(base, at) = (at-base)-0.5\n   * // And:\n   * base(at) = floor(at)\n   * // @todo The rest\n   * ```\n   *\n   * @todo Derive the form `toDistance(offset, diff)`.\n   */\n  #define createToDistance(f, vec) \\\n   \\\n  vec f(vec offset, vec at, vec base) { return ((base+offset)-at)+0.5; } \\\n   \\\n  vec f(vec offset, vec diff);\n#else\n  \n\n  /**\n   * @example ```\n   * // Goal:\n   * dist(offset, diff) = offset-diff\n   * // From weights:\n   * diff(base, at) = at-base\n   * // Thus:\n   * dist(offset, base, at) = offset-diff(base, at) = offset-(at-base)\n   * ```\n   */\n  #define createToDistance(f, vec) \\\n   \\\n  vec f(vec offset, vec diff) { return offset-diff; } \\\n   \\\n  vec f(vec offset, vec at, vec base) { return f(offset, toDiff(at, base)); }\n#endif\n\ncreateToDistance(toDistance, float)\ncreateToDistance(toDistance, vec2)\ncreateToDistance(toDistance, vec3)\n\n#endif\n#if defined(points_output_deform) || defined(points_output_stress)\n  \n\n/**\n * Perform polar decomposition `(a = up)` for a 2D matrix.\n *\n * @param {mat2} a An input 2D matrix.\n *\n * @returns {struct} `to` Decomposed 2D matrices `u`, `p`.\n * @returns {mat2} `to.u` A 2D orthogonal matrix.\n * @returns {mat2} `to.p` A 2D positive or semi-positive definite matrix.\n *\n * @see [Taichi implementation of 2D matrix polar decomposition](https://github.com/taichi-dev/taichi/blob/e9f19b831c8a7b04a94ff5b06179bbe21f80a783/python/taichi/_funcs.py#L53-L96)\n * @see [Mathematical concept](https://en.wikipedia.org/wiki/Polar_decomposition)\n */\nUP2 toPolar(in mat2 a, out mat2 u, out mat2 p) {\n  UP2 to = UP2(mat2(1), a);\n  vec2 a0 = a[0];\n  vec2 a1 = a[1];\n  float a00 = a0[0];\n  float a01 = a0[1];\n  float a10 = a1[0];\n  float a11 = a1[1];\n\n  // If `a` is a zero matrix we simply return the pair `identity, a`.\n  if(abs(a00)+abs(a01)+abs(a10)+abs(a11) == 0.0) { return to; }\n\n  float aDet = determinant(a);\n  float flip = sign(aDet);\n  mat2 b = mat2(a00+(a11*flip), a01-(a10*flip), a10-(a01*flip), a11+(a00*flip));\n  // Here `det(b) != 0` if `a` is not the zero matrix.\n  float k = 1.0/sqrt(abs(determinant(b)));\n\n  to.u = b*k;\n  to.p = ((transpose(a)*a)+(abs(aDet)*mat2(1)))*k;\n\n  return to;\n}\n\nUP2 toPolar(in mat2 a) {\n  mat2 u;\n  mat2 p;\n\n  return toPolar(a, u, p);\n}\n\nconst float eps_0 = 1e-5;\n\n/**\n * Perform singular value decomposition `(a = us*transpose(v))` for a 2D matrix.\n *\n * @param {mat2} a An input 2D matrix.\n *\n * @returns {struct} `to` Decomposed 2D matrixes `u`, `s`, `v`.\n * @returns {mat2} `to.u` A 2D matrix.\n * @returns {mat2} `to.s` A 2D matrix.\n * @returns {mat2} `to.v` A 2D matrix.\n *\n * @see [Taichi Python code](https://github.com/taichi-dev/taichi/blob/e9f19b831c8a7b04a94ff5b06179bbe21f80a783/python/taichi/_funcs.py#L118-L157)\n * @see [Paper](https://www.seas.upenn.edu/~cffjiang/research/svd/svd.pdf)\n * @see [Mathematical concept](https://en.wikipedia.org/wiki/Singular_value_decomposition)\n */\nSVD2 toSVD(in mat2 a, out mat2 u, out mat2 sigma, out mat2 v) {\n  mat2 r;\n  mat2 s;\n\n  toPolar(a, r, s);\n\n  float vc = 1.0;\n  float vs = 0.0;\n  vec2 s0 = s[0];\n  float s01 = s0[1];\n  float s00 = s0[0];\n  float s11 = s[1][1];\n\n  if(abs(s01) >= eps_0) {\n    float tao = 0.5*(s00-s11);\n    float t = s01/(tao+(sqrt((tao*tao)+(s01*s01))*sign(tao)));\n\n    vs = -t*(vc = 1.0/sqrt((t*t)+1.0));\n\n    float vc2 = vc*vc;\n    float vs2 = vs*vs;\n    float term = 2.0*vc*vs*s01;\n\n    s00 = (vc2*s00)-term+(vs2*s11);\n    s11 = (vs2*s00)+term+(vc2*s11);\n  }\n\n  float f = when_lt_2281831123(s00, s11);\n\n  sigma = mat2(mix(s00, s11, f), 0, 0, mix(s11, s00, f));\n  v = mat2(mix(vc, -vs, f), mix(vs, vc, f), mix(-vs, -vc, f), mix(vc, -vs, f));\n\n  return SVD2(u = r*v, sigma, v);\n}\n\nSVD2 toSVD(in mat2 a) {\n  mat2 u;\n  mat2 sigma;\n  mat2 v;\n\n  return toSVD(a, u, sigma, v);\n}\n\n#endif\n#if defined(points_output_position) || defined(points_output_motion)\n  highp float random(vec2 co)\n{\n    highp float a = 12.9898;\n    highp float b = 78.233;\n    highp float c = 43758.5453;\n    highp float dt= dot(co.xy ,vec2(a,b));\n    highp float sn= mod(dt,3.14);\n    return fract(sin(sn) * c);\n}\n\n  /**\n * @param {float} angle An angle, in radians, expects range `[0, 2*pi]`.\n * @param {float} depth A depth, expects range `[-1, 1]`.\n *\n * @see [Spherical distribution](https://observablehq.com/@rreusser/equally-distributing-points-on-a-sphere)\n */\nvec2 onSphere(float angle) { return vec2(cos(angle), sin(angle)); }\n\nvec3 onSphere(float angle, float depth) {\n  return vec3(sqrt(1.0-(depth*depth))*vec2(cos(angle), sin(angle)), depth);\n}\n\n#endif\n#if defined(points_output_position)\n  \n\nconst vec4 seed = vec4(0.34238, -0.86761, 0.69201, 0.57872);\nconst vec2 off = vec2(-1, 1)*0.49;\n\nvec2 by(vec2 v) { return vec2(random(v.xy+seed.xy), random(v.yx+seed.zw)); }\n\nvec3 by(vec3 v) {\n  return vec3(random(v.xy+seed.xy), random(v.zx+seed.zw), random(v.xz+seed.zx));\n}\n\n#define createSpawn(f, vec, off0, off1) \\\n \\\nvec f(vec at, vec lo, vec hi) { return mix(lo, hi, by(at)); } \\\n \\\nvec f(vec at, vec lo, vec hi, vec scale) { \\\n  return mix(lo, hi, at+(mix(off0, off1, by(at))*scale)); \\\n}\n\ncreateSpawn(spawn_0, vec2, off.xx, off.yy)\ncreateSpawn(spawn_0, vec3, off.xxx, off.yyy)\n\n#endif\n#if defined(points_output_deform)\n  /**\n * Project the singular values of the deformation gradient with Drucker-Prager\n * model. Determines the yield surface.\n *\n * @see [Yue et al. 2018]\n * @see [Taichi PyASFLIP](https://github.com/nepluno/pyasflip/blob/master/pyasflip.py#L206-L244)\n */\n\nconst float eps_1 = 1e-6;\n\nmat2 projectDruckerPrager(inout mat2 sigma,\n    float bulkMod, float shearMod, float friction) {\n  /**\n   * @todo Apply volume recovery, similar to damping.\n   *   Multiply the recorded volume with a rate below one for better stability.\n   *   Needs new material-point property `logSigma` and inputs `volumeRecovery`\n   *   and `volumeRecordLimit`.\n   */\n  // float jse = sigma[0][0]*sigma[1][1];\n  //\n  // for(int c = 0; c < 2; ++c) {\n  //   sigma[c][c] = max(eps, abs(sigma[c][c]*exp(logSigma*volumeRecovery)));\n  // }\n\n  float s00 = sigma[0][0];\n  float s11 = sigma[1][1];\n  float je = max(eps_1, s00*s11);\n\n  if(je >= 1.0) {\n    sigma[0][0] = sigma[1][1] = 1.0;\n\n    /**\n     * @todo Record the geometric mean of per-dimension expansions for later\n     *   volume recovery during compression, refer to [Gao et al. 2018].\n     *   Perform this operation in the log-space for better numerical stability.\n     *   For the same reason, set a limit on the recorded volume expansion.\n     */\n    // logSigma = min(volumeRecordLimit, logSigma+(log(max(eps, jse))*0.5));\n\n    return sigma;\n  }\n\n  /** Check if the stress is inside the feasible region. */\n  // logSigma = 0.0;\n\n  float je2 = je*je;\n  float s00p2 = s00*s00;\n  float s11p2 = s11*s11;\n  float traceB2 = (s00p2+s11p2)*0.5;\n  float yieldLimit = -friction*bulkMod*0.5*(je2-1.0);\n  vec2 bDev = vec2(s00p2, s11p2)-traceB2;\n  float yieldAt = shearMod*sqrt(((bDev[0]*bDev[0])+(bDev[1]*bDev[1]))/je);\n\n  if(yieldAt <= yieldLimit) { return sigma; }\n\n  /** Project to the yield surface. */\n  float bDet = s00p2*s11p2;\n  float bDetDev = bDev[0]*bDev[1];\n  float lambda1 = yieldLimit/max(eps_1, yieldAt);\n  float lambda0 = sqrt(max(0.0, bDet-(lambda1*lambda1*bDetDev)));\n\n  sigma[0][0] = sqrt(abs(lambda0+(lambda1*bDev[0])));\n  sigma[1][1] = sqrt(abs(lambda0+(lambda1*bDev[1])));\n\n  return sigma;\n}\n\n#endif\n#if defined(points_output_stress)\n  /**\n * Compute stress with Simo's [1988] neo-Hookean elasticity.\n *\n * @see [Taichi PyASFLIP](https://github.com/nepluno/pyasflip/blob/master/pyasflip.py#L247-L260)\n */\n\nmat2 neoHookeanElastic(mat2 u, mat2 sigma, float bulkMod, float shearMod) {\n  float s00 = sigma[0][0];\n  float s11 = sigma[1][1];\n  float j = s00*s11;\n  float shear = shearMod*sqrt(j);\n  float bulk = bulkMod*0.5*((j*j)-1.0);\n  float s00p2 = s00*s00;\n  float s11p2 = s11*s11;\n  float s2 = (s00p2+s11p2)*0.5;\n  mat2 stress = mat2(1);\n\n  stress[0][0] = (s00p2-s2)*shear;\n  stress[1][1] = (s11p2-s2)*shear;\n  stress = u*stress*transpose(u);\n  stress[0][0] += bulk;\n  stress[1][1] += bulk;\n\n  return stress;\n}\n\n#endif\n\nvoid main() {\n  #ifdef pReadPosition\n  #elif defined(points_output_position)\n    #define pReadPosition points_reads_position_position\n  #elif defined(points_output_motion)\n    #define pReadPosition points_reads_motion_position\n  #elif defined(points_output_affine)\n    #define pReadPosition points_reads_affine_position\n  #endif\n\n  #ifdef pReadMotion\n  #elif defined(points_output_position)\n    #define pReadMotion points_reads_position_motion\n  #elif defined(points_output_motion)\n    #define pReadMotion points_reads_motion_motion\n  #endif\n\n  #ifdef pReadMass\n  #elif defined(points_output_position)\n    #define pReadMass points_reads_position_mass\n  #elif defined(points_output_motion)\n    #define pReadMass points_reads_motion_mass\n  #elif defined(points_output_mass)\n    #define pReadMass points_reads_mass_mass\n  #elif defined(points_output_affine)\n    #define pReadMass points_reads_affine_mass\n  #elif defined(points_output_deform)\n    #define pReadMass points_reads_deform_mass\n  #elif defined(points_output_stress)\n    #define pReadMass points_reads_stress_mass\n  #endif\n\n  #ifdef pReadDeform\n  #elif defined(points_output_deform)\n    #define pReadDeform points_reads_deform_deform\n  #endif\n\n  #if defined(points_output_position) || defined(points_output_motion) || \\\n      defined(points_output_affine) || defined(points_output_deform)\n    points_tapState(offsetUV(points_uv, points_stateShape.xy));\n    // points_tapState(points_uv);\n  #endif\n\n  #if defined(points_output_position) || defined(points_output_motion) || \\\n      defined(points_output_affine)\n    #ifdef rescale_position\n      float rescaledPosition = exponent(rescalePosition);\n    #endif\n    #ifdef rescale_motion\n      float rescaledMotion = exponent(rescaleMotion);\n    #endif\n    #ifdef rescale_affine\n      float rescaledAffine = exponent(rescaleAffine);\n    #endif\n\n    vec2 pPosition = rescaledPosition*\n      points_data[pReadPosition].points_channels_position;\n\n    vec2 boundsSize = abs(bounds.zw-bounds.xy);\n    float boundsSide = min(boundsSize.x, boundsSize.y);\n\n    /** Read grid material properties on 3 nodes in each axis. */\n    vec2 gMotionFull = v0;\n    vec2 gMotionBase = v0;\n    mat2 gAffine = m0;\n    /** Seems the right range, by trial, versus `[0, grid_stateShape.xy-1]`. */\n    vec2 cellAt = map(pPosition, bounds.xy, bounds.zw, v0, grid_stateShape.xy);\n    Kernel2 kernel = toKernel(cellAt);\n    /** Scale from bounds-space to grid-scale; motions differ from positions. */\n    /**\n     * @todo Verify if this is the real solution or just masking; seems to\n     *   differ from just changing `volumeSplit` values, and offer:\n     *   - Remove jitter at low numbers of particles.\n     *   - Keep close to the reference `volumeSplit` values... reasons unknown.\n     *   - Make some intuitive sense.\n     */\n    // Original.\n    // vec2 scaleBoundsToGrid = grid_stateShape.xy;\n    // Fix or mask?\n    vec2 scaleBoundsToGrid = grid_stateShape.xy/boundsSize;\n    // vec2 scaleBoundsToGrid = grid_stateShape.xy/boundsSide;\n    // Seems to have the same effect as the fix or mask...\n    // vec2 scaleBoundsToGrid = v0;\n\n    for(int gx = 0; gx < kernelSize; ++gx) {\n      for(int gy = 0; gy < kernelSize; ++gy) {\n        vec2 offset = toOffset(vec2(gx, gy));\n        /** Range: `base` is `[0, grid_stateShape.xy-1.0]`, `st` is `[0, 1]`. */\n        vec2 st = (kernel.base+offset)/(grid_stateShape.xy-1.0);\n        float weight = kernel.weights[gx].x*kernel.weights[gy].y;\n\n        grid_tapState(offsetUV(st, grid_stateShape.xy));\n        // grid_tapState(st);\n\n        vec2 cMotionFull = rescaledMotion*\n          grid_data[grid_reads_mass_motionFull].grid_channels_motionFull;\n\n        vec2 cMotionBase = rescaledMotion*\n          grid_data[grid_reads_mass_motionBase].grid_channels_motionBase;\n\n        vec2 wmf = weight*cMotionFull;\n        vec2 wmb = weight*cMotionBase;\n\n        gMotionFull += wmf;\n        gMotionBase += wmb;\n\n        vec2 cellDist = toDistance(offset, cellAt, kernel.base);\n\n        gAffine += rescaledAffine*4.0*weight*\n          outerProduct(cMotionFull*scaleBoundsToGrid, cellDist);\n      }\n    }\n  #endif\n\n  #if defined(points_output_position) || defined(points_output_motion)\n    /**\n    * Mix grid and point velocities for ASFLIP, according to whether the\n    * material is separating.\n    * Mix full-grid-motion with particle-motion minus base-grid-motion - same\n    * as full-grid-motion but without stress or other effects applied, leaving\n    * only those effects when subtracted.\n    *\n    * @see [The ASFLIP paper](https://drive.google.com/open?id=1-3XumWRY5oFtWJdjrpzK9wjY19ukhJxQ&usp=drive_fs)\n    * @see [Taichi PyASFLIP implementation mixing old nodal motion](https://github.com/nepluno/pyasflip/blob/master/pyasflip.py#L410-L415)\n    */\n    vec2 pMotion = rescaledMotion*\n      points_data[pReadMotion].points_channels_motion;\n\n    vec2 motionSplit = motionAdjust*(pMotion-gMotionBase);\n    vec2 wandered = onSphere(map(random(points_uv*chaos), 0.0, 1.0, -TAU, TAU));\n  #endif\n\n  #if defined(points_output_motion)\n    vec2 motionTo = gMotionFull+motionSplit;\n\n    /** Avoid slow spots, wander motion. */\n    float wanderOn = when_ge_2658629798(wander.s, 0.0);\n    float wanderSlow = 1.0-clamp(dot(motionTo, motionTo)*wander.s, 0.0, 1.0);\n\n    motionTo += wanderOn*wanderSlow*wander.t*boundsSide*wandered;\n\n    float speed = length(motionTo);\n    float moving = when_gt_529295689(speed, eps);\n\n    motionTo *= mix(1.0,\n      mix(1.0, min(speed, speedClamp), moving)/mix(1.0, speed, moving),\n      when_ge_2658629798(speedClamp, 0.0));\n  #endif\n\n  #if defined(points_output_affine) || \\\n      defined(points_output_position) || defined(points_output_deform)\n    mat2 affineTo = gAffine;\n  #endif\n\n  #if defined(points_output_deform) || defined(points_output_position)\n    /**\n     * @todo Deformation and stress should ideally be calculated at the start of\n     *   the time-step not the end. Unsure if it matters much in practice, but\n     *   the output is used to calculate the position (deformation calculates\n     *   the volume which affects ASFLIP positional adjustment), it may be\n     *   better to move the deformation update to a separate step at the start\n     *   of each time-step.\n     *\n     * @see [Taichi PyASFLIP DruckerPrager plasticity, Neo-Hookean Elasticity](https://github.com/nepluno/pyasflip/blob/master/pyasflip.py#L324-L336)\n     */\n\n    #ifdef rescale_deform\n      float rescaledDeform = exponent(rescaleDeform);\n    #endif\n\n    mat2 pDeform = rescaledDeform*\n      mat2(points_data[pReadDeform].points_channels_deform);\n\n    mat2 deformTo = (mat2(1)+(dt*affineTo))*pDeform;\n\n    SVD2 deformSVD = toSVD(deformTo);\n\n    // Plasticity flow.\n    deformSVD.sigma = projectDruckerPrager(deformSVD.sigma,\n      bulkMod, shearMod, materialFriction);\n\n    // Reconstruct elastic deformation gradient after plasticity flow.\n    deformTo = deformSVD.u*deformSVD.sigma*transpose(deformSVD.v);\n  #endif\n\n  #if defined(points_output_position)\n    /**\n     * @todo Try alternative volume ratio for materials where the stress depends\n     *   only on the volume ratio (e.g: weakly-compressible liquid), with large\n     *   timestep.\n     * @see [Equation 6 in ASFLIP paper](https://drive.google.com/open?id=1-3XumWRY5oFtWJdjrpzK9wjY19ukhJxQ&usp=drive_fs)\n     */\n    float volumeRatio = determinant(deformTo);\n\n    /**\n     * @todo Check again if scaling `affine` is fixing or masking the grid\n     *   artefact issue:\n     *   - It seems to help reduce jitter with few points, as well as address\n     *     the grid artefact issue; does this indicate it works, or just reduce\n     *     another artefact with `deform` coincidentally?\n     *   - It seems like the large-scale effect looks little-to-no different to\n     *     setting `positionAdjusts[1]=0`; is it simply doing that, in effect?\n     *   - The key difference in this part of the process is `stress` (and the\n     *     `deform` it relies on): does the issue simply lie in how these are\n     *     calculated, or in them being calculated at the step's end not start?\n     */\n    float dilation = log(max(volumeSplit.s, volumeRatio))+(trace(affineTo)*dt);\n    float dilating = when_ge_2658629798(dilation, volumeSplit.t);\n    float positionAdjust = mix(positionAdjusts.x, positionAdjusts.y, dilating);\n    vec2 positionSplit = positionAdjust*motionSplit;\n    vec2 positionTo = pPosition+((gMotionFull+positionSplit)*dt);\n\n    /** Like fractal Brownian motion to help any stuck clumps separate. */\n    positionTo += wander.p*boundsSide*wandered;\n\n    // Boundaries.\n    positionTo = mix(positionTo,\n      clamp(positionTo, bounds.xy, bounds.zw), boundsClamp);\n  #endif\n\n  /**\n   * @todo This stress update is in grid-to-points just to avoid another\n   *   `toSVD(pDeform)` in the points-to-grid step; reconsider this?\n   */\n  #if defined(points_output_stress)\n    #ifdef rescale_stress\n      float rescaledStress = exponent(rescaleStress);\n    #endif\n\n    /**\n     * `D**-1` term for APIC transfers.\n     *\n     * @see [APIC transfer `D**-1` in paragraph after Eqn. 176](file:///Users/eoghanokeeffe/Library/CloudStorage/GoogleDrive-keeffeoghan@gmail.com/My%20Drive/Read/Fluid%20Continuum%20Physics/Material%20Point%20Method/The%20Material%20Point%20Method%20for%20Simulating%20Continuum%20Materials%20(mpm.graphics).pdf)\n     *\n     * @todo `D**-1` seems to be for points-to-grid transfers, not for\n     *   grid-to-points; should this use the inverse in grid-to-points, or does\n     *   it not matter, or does an issue arise from moving this stress step from\n     *   points-to-grid to grid-to-points?\n     */\n    float dInv = 4.0*area(grid_stateShape.xy);\n    // float dInv = 1.0/(4.0*area(grid_stateShape.xy));\n    // float dInv = 1.0;\n\n    /**\n     * Neo-Hookean elasticity stress to Cauchy stress.\n     *\n     * @see [MLS-MPM-88](https://github.com/yuanming-hu/taichi_mpm/blob/master/mls-mpm88-explained.cpp#L100)\n     * @see [Taichi PyASFLIP](https://github.com/nepluno/pyasflip/blob/master/pyasflip.py#L334)\n     * @see [Incremental MPM](https://github.com/nialltl/incremental_mpm/blob/master/Assets/2.%20MLS_MPM_NeoHookean_Multithreaded/MLS_MPM_NeoHookean_Multithreaded.cs#L262)\n     */\n    // mat2 stressTo = -dt*volume*volumeRatio*dInv*\n    mat2 stressTo = -dt*volume*dInv*\n      neoHookeanElastic(deformSVD.u, deformSVD.sigma, bulkMod, shearMod);\n  #endif\n\n  /** @todo Better to move spawning into another pass for external control? */\n  #if defined(points_output_position) || defined(points_output_motion) || \\\n      defined(points_output_mass) || defined(points_output_affine) || \\\n      defined(points_output_deform) || defined(points_output_stress)\n    #ifdef rescale_mass\n      float rescaledMass = exponent(rescaleMass);\n    #endif\n\n    float pMass = rescaledMass*points_data[pReadMass].points_channels_mass;\n\n    vec2 spawnOut = spawnOnOut*\n      (when_lt_2281831123(positionTo, bounds.xy)+when_lt_2281831123(bounds.zw, positionTo));\n\n    // Avoid slow spots, respawn.\n    float spawnSlow = spawnOnSlow*when_lt_2281831123(dot(motionTo, motionTo), spawnOnSlow);\n\n    // Avoid dead centre.\n    float spawnCentre = when_gt_529295689(spawnOnCentre, 0.0)*\n      when_lt_2281831123(length2(positionTo/boundsSide), spawnOnCentre*spawnOnCentre);\n\n    float spawn =\n      spawnOnAny*when_gt_529295689(spawnOut.x+spawnOut.y+spawnSlow+spawnCentre, 0.0);\n  #endif\n  #if defined(points_output_position) || defined(points_output_motion)\n    float hold = when_le_3028842562(pMass, 0.0);\n    float spawnOrHold = max(spawn, hold);\n  #endif\n  #if defined(points_output_mass) || defined(points_output_affine) || \\\n      defined(points_output_deform) || defined(points_output_stress)\n    float empty = when_eq_1062606552(pMass, 0.0);\n  #endif\n  #if defined(points_output_affine) || \\\n      defined(points_output_deform) || defined(points_output_stress)\n    float spawnOrEmpty = max(spawn, empty);\n  #endif\n\n  #ifdef points_output_position\n    points_output_position = mix(positionTo,\n        spawn_0(points_uv, bounds.xy, bounds.zw, 1.0/points_stateShape.xy),\n        spawnOrHold)/\n      rescaledPosition;\n  #endif\n  #ifdef points_output_motion\n    points_output_motion =\n      mix(motionTo, v0, spawnOrHold)/rescaledMotion;\n  #endif\n  #ifdef points_output_mass\n    points_output_mass = mix(pMass, mass, empty)/rescaledMass;\n  #endif\n  #ifdef points_output_affine\n    points_output_affine =\n      mix(vec4(affineTo), mv0, spawnOrEmpty)/rescaledAffine;\n  #endif\n  #ifdef points_output_deform\n    points_output_deform =\n      mix(vec4(deformTo), mv1, spawnOrEmpty)/rescaledDeform;\n  #endif\n  #ifdef points_output_stress\n    points_output_stress =\n      mix(vec4(stressTo), mv1, spawnOrEmpty)/rescaledStress;\n  #endif\n}\n";


var $ccea03e8b69b2e19$exports = {};
$ccea03e8b69b2e19$exports = "/** Points-to-grid vertex shader. */\n\n/** @todo Use a better setup than this, for tidier ongoing mapping tests. */\n#define test_off 0\n#define test_p2g 1\n#define test_draw 2\n#ifndef test\n  #define test test_off\n#endif\n\nprecision highp float;\n#define GLSLIFY 1\n\npoints_useSamples\npoints_useReads_position\n\n/** @todo Draw to all the needed grid passes. */\n\n#ifdef points_splits\n  uniform sampler2D points_states[points_splits];\n#else\n  uniform sampler2D points_states;\n#endif\n\nuniform float points_stepNow;\nuniform vec4 points_stateShape;\n\nuniform vec4 grid_stateShape;\n\nattribute vec2 vertex;\nattribute float index;\nattribute float splat;\n\n#if defined(grid_output_motionFull) || defined(grid_output_motionBase)\n  /** Advection scheme parameters. */\n  uniform float stretch;\n  uniform float turn;\n#endif\n\nuniform vec4 bounds;\nuniform vec2 widths;\n\n#ifdef rescale_mass\n  uniform vec2 rescaleMass;\n#else\n  const float rescaledMass = 1.0;\n#endif\n\n#ifdef rescale_affine\n  uniform vec2 rescaleAffine;\n#else\n  const float rescaledAffine = 1.0;\n#endif\n\n#if test == test_p2g\n  uniform float loop;\n\n  varying vec4 color;\n#endif\n\nvarying vec2 cellAt;\nvarying vec2 cellBase;\nvarying mat3 cellWeights;\n\n#ifdef points_grid_quads\n  varying vec2 cellIndex;\n#else\n  varying vec3 point;\n#endif\n\n#if defined(grid_output_mass) || defined(grid_output_motionFull) || \\\n    defined(grid_output_motionBase)\n  varying float mass;\n#endif\n#if defined(grid_output_motionFull) || defined(grid_output_motionBase)\n  varying mat2 affine;\n  varying vec2 motion;\n#endif\n#if defined(grid_output_motionFull)\n  varying mat2 stress;\n#endif\n\nconst vec2 v1 = vec2(1);\nconst vec2 v0 = v1*0.0;\n\nfloat map(float value, float inMin, float inMax, float outMin, float outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\nvec2 map(vec2 value, vec2 inMin, vec2 inMax, vec2 outMin, vec2 outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\nvec3 map(vec3 value, vec3 inMin, vec3 inMax, vec3 outMin, vec3 outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\nvec4 map(vec4 value, vec4 inMin, vec4 inMax, vec4 outMin, vec4 outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\n#if defined(grid_output_motionFull) || defined(grid_output_motionBase)\n  float transpose(float m) {\n  return m;\n}\n\nmat2 transpose(mat2 m) {\n  return mat2(m[0][0], m[1][0],\n              m[0][1], m[1][1]);\n}\n\nmat3 transpose(mat3 m) {\n  return mat3(m[0][0], m[1][0], m[2][0],\n              m[0][1], m[1][1], m[2][1],\n              m[0][2], m[1][2], m[2][2]);\n}\n\nmat4 transpose(mat4 m) {\n  return mat4(m[0][0], m[1][0], m[2][0], m[3][0],\n              m[0][1], m[1][1], m[2][1], m[3][1],\n              m[0][2], m[1][2], m[2][2], m[3][2],\n              m[0][3], m[1][3], m[2][3], m[3][3]);\n}\n\n#endif\n\n/**\n * Convenience to turn a 1D entry index into a 2D texture `UV` for sampling.\n * Note that this does not wrap the y-axis, so if the `index` exceeds the range\n * `[0, (size.x*size.y)-1]`, the result y-axis will exceed the range `[0, 1]`.\n *\n * @see {@link util/remain-div.glsl!}\n *\n * @param {float|int} `index` 1D index, expect range `[0, (size.x*size.y)-1]`.\n * @param {float|int|vec2|ivec2} `size` Texture's size, expect\n *   `[width, height]`, or if given a scalar interpret both as `side`.\n *\n * @returns {vec2} 2D `UV` texture sample coordinate, expect range `[0, 1]`.\n */\n\n/**\n * Equivalent to a _remainder_ operator; same as `mod` for same-signed operands,\n * but different for differently-signed operands, like JavaScript's `%`\n * operator.\n * Reuses the truncated division, and returns both; as both are useful in\n * various places, e.g: index conversion.\n *\n * @see [GLSL modulo](https://www.shaderific.com/glsl-functions#modulo)\n * @see [JS modulo/remainder](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Remainder)\n *\n * @param {float|int} `x` The first remainder/divide operand, expect `x >= 0`.\n * @param {float|int} `y` The second remainder/divide operand, expect `y >= 0`.\n *\n * @returns {vec2|ivec2} The result as `[(remainder), (truncated division)]`;\n *   always a `vec2` if any operand is a `float`.\n */\n\nivec2 remainDiv(int x, int y) {\n  // Careful handling integer maths; decimals truncated, works like a\n  // _remainder_ operator, rather than `mod`.\n  int d = x/y;\n\n  return ivec2(x-(y*d), d);\n}\n\nvec2 remainDiv(float x, int y) {\n  int d = int(x)/y;\n\n  // Remainder; like `mod` but with truncated `d` not floored, reuses `d`.\n  // return vec2(mod(x, y), d);\n  return vec2(x-float(y*d), d);\n}\n\n/**\n * Assume higher accuracy is desired; if less computation with `int` is desired,\n * use `remainDiv(int(x), int(y))` or `vec2(remainDiv(int(x), int(y)))` instead.\n */\nvec2 remainDiv(float x, float y) { return remainDiv(x, int(y)); }\n\n/**\n * Assume higher accuracy is desired; if less computation with `int` is desired,\n * use `remainDiv(x, int(y))` or `vec2(remainDiv(x, int(y)))` instead.\n */\nvec2 remainDiv(int x, float y) { return remainDiv(float(x), y); }\n\nvec2 indexUV(float index, vec2 size) {\n  return remainDiv(index, size.x)/max(size-1.0, 1.0);\n}\n\nvec2 indexUV(int index, ivec2 size) {\n  return vec2(remainDiv(index, size.x))/max(vec2(size-1), 1.0);\n}\n\nvec2 indexUV(float index, ivec2 size) {\n  return remainDiv(index, size.x)/max(vec2(size-1), 1.0);\n}\n\nvec2 indexUV(int index, vec2 size) {\n  return remainDiv(index, size.x)/max(size-1.0, 1.0);\n}\n\nvec2 indexUV(float index, float size) {\n  return remainDiv(index, size)/max(size-1.0, 1.0);\n}\n\nvec2 indexUV(int index, float size) {\n  return remainDiv(index, size)/max(size-1.0, 1.0);\n}\n\nvec2 indexUV(float index, int size) {\n  return remainDiv(index, size)/max(float(size-1), 1.0);\n}\n\nvec2 indexUV(int index, int size) {\n  return vec2(remainDiv(index, size))/max(float(size-1), 1.0);\n}\n\n/**\n * Convenience to sample entries safely at their texel center.\n * Where `spreadUV` is for lookup ranges, `offsetUV` is for lookup queries.\n *\n * @see [`spreadUV`](./spread-uv.glsl)\n *\n * @param {vec2} `uv` UV texture sample coordinate, expect range `[0, 1]`.\n * @param {float|int|vec2|ivec2} `[size=1.0]` Texture's size, expect\n *   `[width, height]`, or if given a scalar interpret both as `side`.\n * @param {float|vec2} `[pad=0.5]` Texel `pad` to offset, expect range `[0, 1]`.\n *\n * @returns {vec2} The `uv` offset by `pad` to texel center, expect range\n *   `[0+pad, 1-pad]`.\n */\n\nvec2 offsetUV(vec2 uv, float size, float pad) {\n  return ((uv*(size-1.0))+pad)/size;\n}\n\nvec2 offsetUV(vec2 uv, vec2 size, float pad) {\n  return ((uv*(size-1.0))+pad)/size;\n}\n\nvec2 offsetUV(vec2 uv, vec2 size, vec2 pad) {\n  return ((uv*(size-1.0))+pad)/size;\n}\n\nvec2 offsetUV(vec2 uv, int size, float pad) {\n  return offsetUV(uv, float(size), pad);\n}\n\nvec2 offsetUV(vec2 uv, ivec2 size, float pad) {\n  return offsetUV(uv, vec2(size), pad);\n}\n\nvec2 offsetUV(vec2 uv, ivec2 size, vec2 pad) {\n  return offsetUV(uv, vec2(size), pad);\n}\n\nvec2 offsetUV(vec2 uv, float size) { return offsetUV(uv, size, 0.5); }\nvec2 offsetUV(vec2 uv, vec2 size) { return offsetUV(uv, size, 0.5); }\nvec2 offsetUV(vec2 uv, int size) { return offsetUV(uv, size, 0.5); }\nvec2 offsetUV(vec2 uv, ivec2 size) { return offsetUV(uv, size, 0.5); }\nvec2 offsetUV(vec2 uv) { return offsetUV(uv, 1.0, 0.5); }\n\n#ifdef points_grid_quads\n  /**\n * Convenience to spread entries safely to their texel edges range.\n * Where `offsetUV` is for lookup queries, `spreadUV` is for lookup ranges.\n *\n * @see [`offsetUV`](./offset-uv.glsl)\n *\n * @param {vec2} `uv` UV texture sample coordinate, expect range `[0, 1]`.\n * @param {float|int|vec2|ivec2} `[size=1.0]` Texture's size, expect\n *   `[width, height]`, or if given a scalar interpret both as `side`.\n * @param {float|vec2} `[pad=0.5]` Texel `pad` to spread, expect range `[0, 1]`.\n *\n * @returns {vec2} The UV with spread to texel edges, expect range\n *   `[0-pad, size+pad]`.\n */\n\nvec2 spreadUV(vec2 uv, float size, float pad) { return (uv*size)-pad; }\nvec2 spreadUV(vec2 uv, float size, vec2 pad) { return (uv*size)-pad; }\nvec2 spreadUV(vec2 uv, vec2 size, float pad) { return (uv*size)-pad; }\nvec2 spreadUV(vec2 uv, vec2 size, vec2 pad) { return (uv*size)-pad; }\n\nvec2 spreadUV(vec2 uv, int size, float pad) {\n  return spreadUV(uv, float(size), pad);\n}\n\nvec2 spreadUV(vec2 uv, int size, vec2 pad) {\n  return spreadUV(uv, float(size), pad);\n}\n\nvec2 spreadUV(vec2 uv, ivec2 size, float pad) {\n  return spreadUV(uv, vec2(size), pad);\n}\n\nvec2 spreadUV(vec2 uv, ivec2 size, vec2 pad) {\n  return spreadUV(uv, vec2(size), pad);\n}\n\nvec2 spreadUV(vec2 uv, float size) { return spreadUV(uv, size, 0.5); }\nvec2 spreadUV(vec2 uv, vec2 size) { return spreadUV(uv, size, 0.5); }\nvec2 spreadUV(vec2 uv, int size) { return spreadUV(uv, size, 0.5); }\nvec2 spreadUV(vec2 uv, ivec2 size) { return spreadUV(uv, size, 0.5); }\nvec2 spreadUV(vec2 uv) { return spreadUV(uv, 1.0, 0.5); }\n\n#endif\n\n/**\n * Quadratic weight kernel.\n *\n * @see [Equation 123, The Material Point Method for Simulating Continuum\n *   Materials (mpm.graphics)](https://drive.google.com/open?id=1rI4gsBH3BstH7EYQA451Pb56MrJ7hVsu&usp=drive_fs)\n * @see [Incremental MPM](https://github.com/nialltl/incremental_mpm/blob/master/Assets/3.%20MLS_MPM_Fluid_Multithreaded/MLS_MPM_Fluid_Multithreaded.cs#L337-L344)\n * @see [MLS-MPM-88](https://github.com/yuanming-hu/taichi_mpm/blob/master/mls-mpm88-explained.cpp#L151-L158)\n *\n * @todo Test more and ensure this is the equivalent lookup.\n */\n\nstruct Kernel2 {\n  vec2 base;\n  vec2 diff;\n  // Only using `[i].xy` channels of each layer `i`; `vec2[3]` is tricky.\n  mat3 weights;\n};\n\nstruct Kernel3 {\n  vec3 base;\n  vec3 diff;\n  mat3 weights;\n};\n\n/**\n * The cell base for each kernel type.\n *\n * @note Tried implementing the same `int(at)` cast-based truncation logic as\n *   the original, but it led to the simulation exploding, probably because an\n *   array-based grid can't handle negative indices but a texture-based one can,\n *   and truncation must've led to a division by 0 somewhere.\n */\n\n#define createToBaseShort(f, vec) \\\nvec f(vec at) { \\\n  vec base; \\\n   \\\n  return f(at, base); \\\n}\n\n#ifdef kernelTypeCentre\n  #ifdef kernelBaseCast\n    #define createToBase(f, vec, ivec) \\\n    vec f(vec at, out vec base) { return (base = vec(ivec(at))); } \\\n    createToBaseShort(f, vec)\n  #else\n    #define createToBase(f, vec) \\\n    vec f(vec at, out vec base) { return (base = floor(at)); } \\\n    createToBaseShort(f, vec)\n  #endif\n#else\n  /**\n   * @todo Test if this is correct for negative numbers, seems to create gaps\n   *   between positive and negative quadrants.\n   */\n  #ifdef kernelBaseCast\n    #define createToBase(f, vec, ivec) \\\n    vec f(vec at, out vec base) { return (base = vec(ivec(at-0.5))); } \\\n    createToBaseShort(f, vec)\n  #else\n    #define createToBase(f, vec) \\\n    vec f(vec at, out vec base) { return (base = floor(at-0.5)); } \\\n    createToBaseShort(f, vec)\n  #endif\n#endif\n\n#ifdef kernelBaseCast\n  createToBase(toBase, float, int)\n  createToBase(toBase, vec2, ivec2)\n  createToBase(toBase, vec3, ivec3)\n#else\n  createToBase(toBase, float)\n  createToBase(toBase, vec2)\n  createToBase(toBase, vec3)\n#endif\n\n/** The cell base for each kernel type. */\n#define createToDiffShort(f, vec) \\\nvec f(vec at, vec base) { \\\n  vec diff; \\\n   \\\n  return f(at, base, diff); \\\n}\n\n#ifdef kernelTypeCentre\n  #define createToDiff(f, vec) \\\n  vec f(vec at, vec base, out vec diff) { return (diff = (at-base)-0.5); } \\\n  createToDiffShort(f, vec)\n#else\n  #define createToDiff(f, vec) \\\n  vec f(vec at, vec base, out vec diff) { return (diff = at-base); } \\\n  createToDiffShort(f, vec)\n#endif\n\ncreateToDiff(toDiff, float)\ncreateToDiff(toDiff, vec2)\ncreateToDiff(toDiff, vec3)\n\nvec2 toWeight(inout vec2 w, vec2 v) { return w = v; }\nvec2 toWeight(inout vec3 w, vec2 v) { return w.xy = v; }\nvec3 toWeight(inout vec3 w, vec3 v) { return w = v; }\n\n#ifdef kernelTypeCentre\n  #define createToWeightsMain(vec, diff) \\\n    vec w0 = 0.5-diff; \\\n    vec w1 = diff; \\\n    vec w2 = 0.5+diff;\n#else\n  #define createToWeightsMain(vec, diff) \\\n    vec w0 = 1.5-diff; \\\n    vec w1 = diff-1.0; \\\n    vec w2 = diff-0.5;\n#endif\n\n#define createToWeights(f, vec, mat) \\\n \\\nmat f(vec diff, out mat weights) { \\\n  createToWeightsMain(vec, diff) \\\n   \\\n  toWeight(weights[0], 0.5*(w0*w0)); \\\n  toWeight(weights[1], 0.75-(w1*w1)); \\\n  toWeight(weights[2], 0.5*(w2*w2)); \\\n   \\\n  return weights; \\\n} \\\n \\\nmat f(vec diff) { \\\n  mat weights; \\\n   \\\n  return f(diff, weights); \\\n}\n\ncreateToWeights(toWeights, vec2, mat3)\ncreateToWeights(toWeights, vec3, mat3)\n\n#define createToKernel(f, vec, mat, Kernel) \\\n \\\nKernel f(vec at, out vec base, out vec diff, out mat weights) { \\\n  return Kernel(base = toBase(at, base), \\\n    diff = toDiff(at, base, diff), \\\n    weights = toWeights(diff, weights)); \\\n} \\\n \\\nKernel f(vec at, out vec base, out vec diff) { \\\n  mat weights; \\\n   \\\n  return f(at, base, diff, weights); \\\n} \\\n \\\nKernel f(vec at, out vec base) { \\\n  vec diff; \\\n   \\\n  return f(at, base, diff); \\\n} \\\n \\\nKernel f(vec at, out vec base, out mat weights) { \\\n  vec diff; \\\n   \\\n  return f(at, base, diff, weights); \\\n} \\\n \\\nKernel f(vec at, out mat weights) { \\\n  vec base; \\\n   \\\n  return f(at, base, weights); \\\n} \\\n \\\nKernel f(vec at) { \\\n  vec base; \\\n   \\\n  return f(at, base); \\\n}\n\ncreateToKernel(toKernel, vec2, mat3, Kernel2)\ncreateToKernel(toKernel, vec3, mat3, Kernel3)\n\n/** The cell offset for each kernel type. */\n#define createToOffsetShort(f, vec) \\\nvec f(vec offset) { \\\n  vec to; \\\n   \\\n  return f(offset, to); \\\n}\n\n#ifdef kernelTypeCentre\n  #define createToOffset(f, vec) \\\n  vec f(in vec offset, out vec to) { return (to = offset-1.0); } \\\n  createToOffsetShort(f, vec)\n#else\n  #define createToOffset(f, vec) \\\n  vec f(in vec offset, out vec to) { return (to = offset); } \\\n  createToOffsetShort(f, vec)\n#endif\n\ncreateToOffset(toOffset, float)\ncreateToOffset(toOffset, vec2)\ncreateToOffset(toOffset, vec3)\n\n#if defined(rescale_affine)\n  /** Exponential notation packed into a vector. */\nfloat exponent(vec2 basePower) { return basePower.s*pow(1e1, basePower.t); }\n\n#endif\n\n/**\n * @todo Handle separate splats, by how many buffers can be drawn to.\n * @todo Separate processes according to active outputs.\n */\nvoid main() {\n  vec2 uv = indexUV(index, points_stateShape.xy);\n\n  uv = offsetUV(uv, points_stateShape.xy);\n  points_tapState(uv);\n\n  vec2 position = points_data[points_reads_position_position]\n    .points_channels_position;\n\n  #if defined(grid_output_mass) || defined(grid_output_motionFull) || \\\n      defined(grid_output_motionBase)\n    // Negative `mass` can indicate points spawning that still affect physics.\n    mass = abs(points_data[points_reads_position_mass].points_channels_mass);\n  #endif\n  #if defined(grid_output_motionFull) || defined(grid_output_motionBase)\n    #ifdef rescale_affine\n      float rescaledAffine = exponent(rescaleAffine);\n    #endif\n    #ifdef rescale_mass\n      float rescaledMass = exponent(rescaleMass);\n    #endif\n\n    vec2 advection = (stretch+vec2(turn, -turn))*0.5;\n\n    affine = rescaledAffine*\n      mat2(points_data[points_reads_position_affine].points_channels_affine);\n\n    affine = (mass*rescaledMass)*\n      ((affine*advection.x)+(transpose(affine)*advection.y));\n\n    affine /= rescaledAffine;\n\n    motion = points_data[points_reads_position_motion].points_channels_motion;\n  #endif\n  #if defined(grid_output_motionFull)\n    stress = mat2(points_data[points_reads_position_stress]\n      .points_channels_stress);\n  #endif\n\n  /** Map the position into the correct range with the proper offset. */\n  #if test == test_p2g\n    color = vec4(uv, 0.5, 1);\n    // cellAt = mod((uv+(loop*9e-5))*grid_stateShape.xy, grid_stateShape.xy);\n    cellAt = uv*grid_stateShape.xy;\n    // gl_Position = vec4(map(uv+(vertex/grid_stateShape.xy), v0, v1, -v1, v1), 0, 1);\n    // return;\n  #else\n    /** Seems the right range, by trial, versus `[0, grid_stateShape.xy-1]`. */\n    cellAt = map(position, bounds.xy, bounds.zw, v0, grid_stateShape.xy);\n  #endif\n\n  /** Kernel weights and positions, to scale the values per-fragment. */\n  toKernel(cellAt, cellBase, cellWeights);\n\n  vec2 to = cellBase+toOffset(vertex*float(kernelSize));\n\n  gl_Position = vec4(map(to, v0, grid_stateShape.xy, -v1, v1), 0, 1);\n\n  #ifdef points_grid_quads\n    /**\n     * Mask the weights by the distance from these indexes per-fragment.\n     * Account for the half-pixel offset at the fragment centre.\n     * @see [Pixel coordinates on WebGL Fundamentals](https://webglfundamentals.org/webgl/lessons/webgl-shadertoy.html#pixel-coords)\n     */\n    cellIndex = spreadUV(vertex, kernelSize);\n  #else\n    /**\n     * Convert vertex position to `gl_FragCoord` window-space.\n     * @see [SO](https://stackoverflow.com/a/7158573)\n     * @see [SO](https://stackoverflow.com/a/54237532/716898)\n     */\n    point = vec3(to, 0.5*(gl_PointSize = float(kernelSize)));\n  #endif\n}\n";


var $6fc836b8d7da46eb$exports = {};
$6fc836b8d7da46eb$exports = "/** Points-to-grid fragment shader. */\n\n/** @todo Use a better setup than this, for tidier ongoing mapping tests. */\n#define test_off 0\n#define test_p2g 1\n#define test_draw 2\n#ifndef test\n  #define test test_off\n#endif\n\n#ifdef GL_EXT_draw_buffers\n  #extension GL_EXT_draw_buffers : require\n#endif\n\nprecision highp float;\n#define GLSLIFY 1\n\n/** @todo Draw to all the needed grid passes. */\n\n#if defined(grid_output_motionFull) || defined(grid_output_motionBase)\n  uniform vec4 grid_stateShape;\n#endif\n\n#ifdef rescale_motion\n  uniform vec2 rescaleMotion;\n#else\n  const float rescaledMotion = 1.0;\n#endif\n#ifdef rescale_mass\n  uniform vec2 rescaleMass;\n#else\n  const float rescaledMass = 1.0;\n#endif\n#ifdef rescale_affine\n  uniform vec2 rescaleAffine;\n#else\n  const float rescaledAffine = 1.0;\n#endif\n#ifdef rescale_stress\n  uniform vec2 rescaleStress;\n#else\n  const float rescaledStress = 1.0;\n#endif\n\n#if test == test_p2g\n  varying vec4 color;\n#endif\n\nvarying vec2 cellAt;\nvarying vec2 cellBase;\nvarying mat3 cellWeights;\n\n#ifdef points_grid_quads\n  varying vec2 cellIndex;\n#else\n  varying vec3 point;\n#endif\n\n#if defined(grid_output_mass) || defined(grid_output_motionFull) || \\\n    defined(grid_output_motionBase)\n  varying float mass;\n#endif\n#if defined(grid_output_motionFull) || defined(grid_output_motionBase)\n  varying mat2 affine;\n  varying vec2 motion;\n#endif\n#if defined(grid_output_motionFull)\n  varying mat2 stress;\n#endif\n\nconst mat3 mask = mat3(vec3(0), vec3(1), vec3(2));\n\nconst vec2 v1 = vec2(1);\nconst vec2 v0 = v1*0.0;\nconst vec2 cellNear = v1*0.5;\n\n#ifndef points_grid_quads\n  /**\n * Convenience to spread entries safely to their texel edges range.\n * Where `offsetUV` is for lookup queries, `spreadUV` is for lookup ranges.\n *\n * @see [`offsetUV`](./offset-uv.glsl)\n *\n * @param {vec2} `uv` UV texture sample coordinate, expect range `[0, 1]`.\n * @param {float|int|vec2|ivec2} `[size=1.0]` Texture's size, expect\n *   `[width, height]`, or if given a scalar interpret both as `side`.\n * @param {float|vec2} `[pad=0.5]` Texel `pad` to spread, expect range `[0, 1]`.\n *\n * @returns {vec2} The UV with spread to texel edges, expect range\n *   `[0-pad, size+pad]`.\n */\n\nvec2 spreadUV(vec2 uv, float size, float pad) { return (uv*size)-pad; }\nvec2 spreadUV(vec2 uv, float size, vec2 pad) { return (uv*size)-pad; }\nvec2 spreadUV(vec2 uv, vec2 size, float pad) { return (uv*size)-pad; }\nvec2 spreadUV(vec2 uv, vec2 size, vec2 pad) { return (uv*size)-pad; }\n\nvec2 spreadUV(vec2 uv, int size, float pad) {\n  return spreadUV(uv, float(size), pad);\n}\n\nvec2 spreadUV(vec2 uv, int size, vec2 pad) {\n  return spreadUV(uv, float(size), pad);\n}\n\nvec2 spreadUV(vec2 uv, ivec2 size, float pad) {\n  return spreadUV(uv, vec2(size), pad);\n}\n\nvec2 spreadUV(vec2 uv, ivec2 size, vec2 pad) {\n  return spreadUV(uv, vec2(size), pad);\n}\n\nvec2 spreadUV(vec2 uv, float size) { return spreadUV(uv, size, 0.5); }\nvec2 spreadUV(vec2 uv, vec2 size) { return spreadUV(uv, size, 0.5); }\nvec2 spreadUV(vec2 uv, int size) { return spreadUV(uv, size, 0.5); }\nvec2 spreadUV(vec2 uv, ivec2 size) { return spreadUV(uv, size, 0.5); }\nvec2 spreadUV(vec2 uv) { return spreadUV(uv, 1.0, 0.5); }\n\n#endif\n\n#if defined(grid_output_motionFull) || defined(grid_output_motionBase)\n  /** The cell offset for each kernel type. */\n#define createToOffsetShort(f, vec) \\\nvec f(vec offset) { \\\n  vec to; \\\n   \\\n  return f(offset, to); \\\n}\n\n#ifdef kernelTypeCentre\n  #define createToOffset(f, vec) \\\n  vec f(in vec offset, out vec to) { return (to = offset-1.0); } \\\n  createToOffsetShort(f, vec)\n#else\n  #define createToOffset(f, vec) \\\n  vec f(in vec offset, out vec to) { return (to = offset); } \\\n  createToOffsetShort(f, vec)\n#endif\n\ncreateToOffset(toOffset, float)\ncreateToOffset(toOffset, vec2)\ncreateToOffset(toOffset, vec3)\n\n  /**\n * The distance function for each kernel type.\n *\n * @see [Incremental MPM cell distance](https://github.com/nialltl/incremental_mpm/blob/master/Assets/3.%20MLS_MPM_Fluid_Multithreaded/MLS_MPM_Fluid_Multithreaded.cs#L187-L201)\n * @see [PyASFLIP cell distance](https://github.com/nepluno/pyasflip/blob/master/pyasflip.py#L320-L339)\n * @todo Not sure this is right, the scales might be off.\n * @todo Work out the algebra more nicely in terms of `offset` and `diff`.\n */\n\n#ifdef kernelTypeCentre\n  /**\n   * @example ```\n   * // Goal:\n   * dist(offset, base, at) = ((base+offset-1)-at)+0.5\n   * // From offset:\n   * offset = offset-1\n   * // Thus:\n   * dist(offset = offset-1, base, at) = ((base+offset)-at)+0.5\n   * // From weights:\n   * diff(base, at) = (at-base)-0.5\n   * // And:\n   * base(at) = floor(at)\n   * // @todo The rest\n   * ```\n   *\n   * @todo Derive the form `toDistance(offset, diff)`.\n   */\n  #define createToDistance(f, vec) \\\n   \\\n  vec f(vec offset, vec at, vec base) { return ((base+offset)-at)+0.5; } \\\n   \\\n  vec f(vec offset, vec diff);\n#else\n  /** The cell base for each kernel type. */\n#define createToDiffShort(f, vec) \\\nvec f(vec at, vec base) { \\\n  vec diff; \\\n   \\\n  return f(at, base, diff); \\\n}\n\n#ifdef kernelTypeCentre\n  #define createToDiff(f, vec) \\\n  vec f(vec at, vec base, out vec diff) { return (diff = (at-base)-0.5); } \\\n  createToDiffShort(f, vec)\n#else\n  #define createToDiff(f, vec) \\\n  vec f(vec at, vec base, out vec diff) { return (diff = at-base); } \\\n  createToDiffShort(f, vec)\n#endif\n\ncreateToDiff(toDiff, float)\ncreateToDiff(toDiff, vec2)\ncreateToDiff(toDiff, vec3)\n\n  /**\n   * @example ```\n   * // Goal:\n   * dist(offset, diff) = offset-diff\n   * // From weights:\n   * diff(base, at) = at-base\n   * // Thus:\n   * dist(offset, base, at) = offset-diff(base, at) = offset-(at-base)\n   * ```\n   */\n  #define createToDistance(f, vec) \\\n   \\\n  vec f(vec offset, vec diff) { return offset-diff; } \\\n   \\\n  vec f(vec offset, vec at, vec base) { return f(offset, toDiff(at, base)); }\n#endif\n\ncreateToDistance(toDistance, float)\ncreateToDistance(toDistance, vec2)\ncreateToDistance(toDistance, vec3)\n\n#endif\n\nfloat when_lt_1117569599(float x, float y) {\n  return max(sign(y - x), 0.0);\n}\n\nvec2 when_lt_1117569599(vec2 x, vec2 y) {\n  return max(sign(y - x), 0.0);\n}\n\nvec3 when_lt_1117569599(vec3 x, vec3 y) {\n  return max(sign(y - x), 0.0);\n}\n\nvec4 when_lt_1117569599(vec4 x, vec4 y) {\n  return max(sign(y - x), 0.0);\n}\n\nfloat map(float value, float inMin, float inMax, float outMin, float outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\nvec2 map(vec2 value, vec2 inMin, vec2 inMax, vec2 outMin, vec2 outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\nvec3 map(vec3 value, vec3 inMin, vec3 inMax, vec3 outMin, vec3 outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\nvec4 map(vec4 value, vec4 inMin, vec4 inMax, vec4 outMin, vec4 outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\n#if defined(rescale_motion) || defined(rescale_mass) || \\\n  defined(rescale_affine) || defined(rescale_stress)\n  /** Exponential notation packed into a vector. */\nfloat exponent(vec2 basePower) { return basePower.s*pow(1e1, basePower.t); }\n\n#endif\n\nvoid main() {\n  #if test == test_p2g\n    // for(int t = 0; t < grid_textures; ++t) { gl_FragData[t] = color; }\n    gl_FragData[0] = color;\n    return;\n  #endif\n\n  #ifndef points_grid_quads\n    /**\n     * Convert vertex position to `gl_FragCoord` window-space.\n     * Mask the weights by the distance from these indexes per-fragment.\n     * Account for the half-pixel offset at the fragment centre.\n     * @see [Pixel coordinates on WebGL Fundamentals](https://webglfundamentals.org/webgl/lessons/webgl-shadertoy.html#pixel-coords)\n     * @see [SO](https://stackoverflow.com/a/7158573)\n     * @see [SO](https://stackoverflow.com/a/54237532/716898)\n     */\n    vec2 cellIndex = map(gl_FragCoord.xy-point.xy, -point.bb, point.bb, v0, v1);\n\n    cellIndex = spreadUV(cellIndex, kernelSize);\n  #endif\n\n  /** Work around the need for constant index by looping and masking. */\n  // float weight = cellWeights[int(cellIndex.x)].x*cellWeights[int(cellIndex.y)].y;\n  vec2 maskWeight = v0;\n\n  for(int i = 0; i < kernelSize; ++i) {\n    maskWeight += cellWeights[i].xy*when_lt_1117569599(abs((cellIndex)-mask[i].xy), cellNear);\n  }\n\n  float weight = maskWeight.x*maskWeight.y;\n\n  /** @todo Handle multiple passes properly. */\n  #if defined(grid_output_mass) || defined(grid_output_motionFull) || \\\n      defined(grid_output_motionBase)\n    #ifdef rescale_mass\n      float rescaledMass = exponent(rescaleMass);\n    #endif\n\n    float massTo = rescaledMass*mass;\n  #endif\n  #if defined(grid_output_motionFull) || defined(grid_output_motionBase)\n    #ifdef rescale_motion\n      float rescaledMotion = exponent(rescaleMotion);\n    #endif\n    #ifdef rescale_affine\n      float rescaledAffine = exponent(rescaleAffine);\n    #endif\n\n    vec2 motionTo = rescaledMotion*motion;\n    mat2 affineTo = rescaledAffine*affine;\n    vec2 massMotion = massTo*motionTo;\n    vec2 offset = toOffset(cellIndex);\n\n    vec2 cellDist =\n      toDistance(offset, cellAt, cellBase)/grid_stateShape.xy;\n  #endif\n  #if defined(grid_output_motionFull)\n    #ifdef rescale_stress\n      float rescaledStress = exponent(rescaleStress);\n    #endif\n\n    mat2 stressTo = rescaledStress*stress;\n  #endif\n\n  #ifdef grid_output_mass\n    grid_output_mass = (weight*massTo)/rescaledMass;\n  #endif\n  #ifdef grid_output_motionFull\n    grid_output_motionFull =\n      (weight*(massMotion+((stressTo+affineTo)*cellDist)))/rescaledMotion;\n  #endif\n  #ifdef grid_output_motionBase\n    grid_output_motionBase =\n      (weight*(massMotion+(affineTo*cellDist)))/rescaledMotion;\n  #endif\n}\n";


var $432370b25c6a4871$exports = {};
$432370b25c6a4871$exports = "/** Grid-to-screen fragment shader. */\n\n/** @todo Use a better setup than this, for tidier ongoing mapping tests. */\n#define test_off 0\n#define test_p2g 1\n#define test_draw 2\n#ifndef test\n  #define test test_off\n#endif\n\nprecision highp float;\n#define GLSLIFY 1\n\nstruct Kernel2 {\n  vec2 base;\n  vec2 diff;\n  // Only using `[i].xy` channels of each layer `i`; `vec2[3]` is tricky.\n  mat3 weights;\n};\n\ngrid_useSamples\ngrid_useReads_mass\n\n#ifdef grid_splits\n  uniform sampler2D grid_states[grid_splits];\n#else\n  uniform sampler2D grid_states;\n#endif\n\nuniform float grid_stepNow;\nuniform vec4 grid_stateShape;\n\nuniform vec2 range;\nuniform vec2 curve[4];\nuniform vec4 colorLo;\nuniform vec4 colorHi;\n\n#ifdef angleHSLA\n  uniform vec4 angleHSLA;\n#endif\n\nuniform vec2 aspect;\n\n#ifdef rescale_motion\n  uniform vec2 rescaleMotion;\n#else\n  const float rescaledMotion = 1.0;\n#endif\n\nvarying vec2 grid_uv;\n\nconst vec2 v1 = vec2(1);\nconst vec2 v0 = v1*0.0;\n\nfloat when_lt_1604150559(float x, float y) {\n  return max(sign(y - x), 0.0);\n}\n\nvec2 when_lt_1604150559(vec2 x, vec2 y) {\n  return max(sign(y - x), 0.0);\n}\n\nvec3 when_lt_1604150559(vec3 x, vec3 y) {\n  return max(sign(y - x), 0.0);\n}\n\nvec4 when_lt_1604150559(vec4 x, vec4 y) {\n  return max(sign(y - x), 0.0);\n}\n\nfloat map(float value, float inMin, float inMax, float outMin, float outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\nvec2 map(vec2 value, vec2 inMin, vec2 inMax, vec2 outMin, vec2 outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\nvec3 map(vec3 value, vec3 inMin, vec3 inMax, vec3 outMin, vec3 outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\nvec4 map(vec4 value, vec4 inMin, vec4 inMax, vec4 outMin, vec4 outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\n#ifdef angleHSLA\n  float hue2rgb(float f1, float f2, float hue) {\n    if (hue < 0.0)\n        hue += 1.0;\n    else if (hue > 1.0)\n        hue -= 1.0;\n    float res;\n    if ((6.0 * hue) < 1.0)\n        res = f1 + (f2 - f1) * 6.0 * hue;\n    else if ((2.0 * hue) < 1.0)\n        res = f2;\n    else if ((3.0 * hue) < 2.0)\n        res = f1 + (f2 - f1) * ((2.0 / 3.0) - hue) * 6.0;\n    else\n        res = f1;\n    return res;\n}\n\nvec3 hsl2rgb(vec3 hsl) {\n    vec3 rgb;\n    \n    if (hsl.y == 0.0) {\n        rgb = vec3(hsl.z); // Luminance\n    } else {\n        float f2;\n        \n        if (hsl.z < 0.5)\n            f2 = hsl.z * (1.0 + hsl.y);\n        else\n            f2 = hsl.z + hsl.y - hsl.y * hsl.z;\n            \n        float f1 = 2.0 * hsl.z - f2;\n        \n        rgb.r = hue2rgb(f1, f2, hsl.x + (1.0/3.0));\n        rgb.g = hue2rgb(f1, f2, hsl.x);\n        rgb.b = hue2rgb(f1, f2, hsl.x - (1.0/3.0));\n    }   \n    return rgb;\n}\n\nvec3 hsl2rgb(float h, float s, float l) {\n    return hsl2rgb(vec3(h, s, l));\n}\n\n  const float PI = 3.14159265359;\n\n#endif\n\n/**\n * Convenience to sample entries safely at their texel center.\n * Where `spreadUV` is for lookup ranges, `offsetUV` is for lookup queries.\n *\n * @see [`spreadUV`](./spread-uv.glsl)\n *\n * @param {vec2} `uv` UV texture sample coordinate, expect range `[0, 1]`.\n * @param {float|int|vec2|ivec2} `[size=1.0]` Texture's size, expect\n *   `[width, height]`, or if given a scalar interpret both as `side`.\n * @param {float|vec2} `[pad=0.5]` Texel `pad` to offset, expect range `[0, 1]`.\n *\n * @returns {vec2} The `uv` offset by `pad` to texel center, expect range\n *   `[0+pad, 1-pad]`.\n */\n\nvec2 offsetUV(vec2 uv, float size, float pad) {\n  return ((uv*(size-1.0))+pad)/size;\n}\n\nvec2 offsetUV(vec2 uv, vec2 size, float pad) {\n  return ((uv*(size-1.0))+pad)/size;\n}\n\nvec2 offsetUV(vec2 uv, vec2 size, vec2 pad) {\n  return ((uv*(size-1.0))+pad)/size;\n}\n\nvec2 offsetUV(vec2 uv, int size, float pad) {\n  return offsetUV(uv, float(size), pad);\n}\n\nvec2 offsetUV(vec2 uv, ivec2 size, float pad) {\n  return offsetUV(uv, vec2(size), pad);\n}\n\nvec2 offsetUV(vec2 uv, ivec2 size, vec2 pad) {\n  return offsetUV(uv, vec2(size), pad);\n}\n\nvec2 offsetUV(vec2 uv, float size) { return offsetUV(uv, size, 0.5); }\nvec2 offsetUV(vec2 uv, vec2 size) { return offsetUV(uv, size, 0.5); }\nvec2 offsetUV(vec2 uv, int size) { return offsetUV(uv, size, 0.5); }\nvec2 offsetUV(vec2 uv, ivec2 size) { return offsetUV(uv, size, 0.5); }\nvec2 offsetUV(vec2 uv) { return offsetUV(uv, 1.0, 0.5); }\n\n/**\n * Quadratic weight kernel.\n *\n * @see [Equation 123, The Material Point Method for Simulating Continuum\n *   Materials (mpm.graphics)](https://drive.google.com/open?id=1rI4gsBH3BstH7EYQA451Pb56MrJ7hVsu&usp=drive_fs)\n * @see [Incremental MPM](https://github.com/nialltl/incremental_mpm/blob/master/Assets/3.%20MLS_MPM_Fluid_Multithreaded/MLS_MPM_Fluid_Multithreaded.cs#L337-L344)\n * @see [MLS-MPM-88](https://github.com/yuanming-hu/taichi_mpm/blob/master/mls-mpm88-explained.cpp#L151-L158)\n *\n * @todo Test more and ensure this is the equivalent lookup.\n */\n\nstruct Kernel3 {\n  vec3 base;\n  vec3 diff;\n  mat3 weights;\n};\n\n/**\n * The cell base for each kernel type.\n *\n * @note Tried implementing the same `int(at)` cast-based truncation logic as\n *   the original, but it led to the simulation exploding, probably because an\n *   array-based grid can't handle negative indices but a texture-based one can,\n *   and truncation must've led to a division by 0 somewhere.\n */\n\n#define createToBaseShort(f, vec) \\\nvec f(vec at) { \\\n  vec base; \\\n   \\\n  return f(at, base); \\\n}\n\n#ifdef kernelTypeCentre\n  #ifdef kernelBaseCast\n    #define createToBase(f, vec, ivec) \\\n    vec f(vec at, out vec base) { return (base = vec(ivec(at))); } \\\n    createToBaseShort(f, vec)\n  #else\n    #define createToBase(f, vec) \\\n    vec f(vec at, out vec base) { return (base = floor(at)); } \\\n    createToBaseShort(f, vec)\n  #endif\n#else\n  /**\n   * @todo Test if this is correct for negative numbers, seems to create gaps\n   *   between positive and negative quadrants.\n   */\n  #ifdef kernelBaseCast\n    #define createToBase(f, vec, ivec) \\\n    vec f(vec at, out vec base) { return (base = vec(ivec(at-0.5))); } \\\n    createToBaseShort(f, vec)\n  #else\n    #define createToBase(f, vec) \\\n    vec f(vec at, out vec base) { return (base = floor(at-0.5)); } \\\n    createToBaseShort(f, vec)\n  #endif\n#endif\n\n#ifdef kernelBaseCast\n  createToBase(toBase, float, int)\n  createToBase(toBase, vec2, ivec2)\n  createToBase(toBase, vec3, ivec3)\n#else\n  createToBase(toBase, float)\n  createToBase(toBase, vec2)\n  createToBase(toBase, vec3)\n#endif\n\n/** The cell base for each kernel type. */\n#define createToDiffShort(f, vec) \\\nvec f(vec at, vec base) { \\\n  vec diff; \\\n   \\\n  return f(at, base, diff); \\\n}\n\n#ifdef kernelTypeCentre\n  #define createToDiff(f, vec) \\\n  vec f(vec at, vec base, out vec diff) { return (diff = (at-base)-0.5); } \\\n  createToDiffShort(f, vec)\n#else\n  #define createToDiff(f, vec) \\\n  vec f(vec at, vec base, out vec diff) { return (diff = at-base); } \\\n  createToDiffShort(f, vec)\n#endif\n\ncreateToDiff(toDiff, float)\ncreateToDiff(toDiff, vec2)\ncreateToDiff(toDiff, vec3)\n\nvec2 toWeight(inout vec2 w, vec2 v) { return w = v; }\nvec2 toWeight(inout vec3 w, vec2 v) { return w.xy = v; }\nvec3 toWeight(inout vec3 w, vec3 v) { return w = v; }\n\n#ifdef kernelTypeCentre\n  #define createToWeightsMain(vec, diff) \\\n    vec w0 = 0.5-diff; \\\n    vec w1 = diff; \\\n    vec w2 = 0.5+diff;\n#else\n  #define createToWeightsMain(vec, diff) \\\n    vec w0 = 1.5-diff; \\\n    vec w1 = diff-1.0; \\\n    vec w2 = diff-0.5;\n#endif\n\n#define createToWeights(f, vec, mat) \\\n \\\nmat f(vec diff, out mat weights) { \\\n  createToWeightsMain(vec, diff) \\\n   \\\n  toWeight(weights[0], 0.5*(w0*w0)); \\\n  toWeight(weights[1], 0.75-(w1*w1)); \\\n  toWeight(weights[2], 0.5*(w2*w2)); \\\n   \\\n  return weights; \\\n} \\\n \\\nmat f(vec diff) { \\\n  mat weights; \\\n   \\\n  return f(diff, weights); \\\n}\n\ncreateToWeights(toWeights, vec2, mat3)\ncreateToWeights(toWeights, vec3, mat3)\n\n#define createToKernel(f, vec, mat, Kernel) \\\n \\\nKernel f(vec at, out vec base, out vec diff, out mat weights) { \\\n  return Kernel(base = toBase(at, base), \\\n    diff = toDiff(at, base, diff), \\\n    weights = toWeights(diff, weights)); \\\n} \\\n \\\nKernel f(vec at, out vec base, out vec diff) { \\\n  mat weights; \\\n   \\\n  return f(at, base, diff, weights); \\\n} \\\n \\\nKernel f(vec at, out vec base) { \\\n  vec diff; \\\n   \\\n  return f(at, base, diff); \\\n} \\\n \\\nKernel f(vec at, out vec base, out mat weights) { \\\n  vec diff; \\\n   \\\n  return f(at, base, diff, weights); \\\n} \\\n \\\nKernel f(vec at, out mat weights) { \\\n  vec base; \\\n   \\\n  return f(at, base, weights); \\\n} \\\n \\\nKernel f(vec at) { \\\n  vec base; \\\n   \\\n  return f(at, base); \\\n}\n\ncreateToKernel(toKernel, vec2, mat3, Kernel2)\ncreateToKernel(toKernel, vec3, mat3, Kernel3)\n\n/** The cell offset for each kernel type. */\n#define createToOffsetShort(f, vec) \\\nvec f(vec offset) { \\\n  vec to; \\\n   \\\n  return f(offset, to); \\\n}\n\n#ifdef kernelTypeCentre\n  #define createToOffset(f, vec) \\\n  vec f(in vec offset, out vec to) { return (to = offset-1.0); } \\\n  createToOffsetShort(f, vec)\n#else\n  #define createToOffset(f, vec) \\\n  vec f(in vec offset, out vec to) { return (to = offset); } \\\n  createToOffsetShort(f, vec)\n#endif\n\ncreateToOffset(toOffset, float)\ncreateToOffset(toOffset, vec2)\ncreateToOffset(toOffset, vec3)\n\n/**\n * Cubic B\xe9zier interpolation, CSS-style.\n * Given p0, p1, p2, p3 as control points, and an input `x` value, find the\n * corresponding `y` value using the B\xe9zier curve; note that this doesn't\n * directly use the usual `t` value as input for interpolation.\n *\n * @todo Split up and generalise, add to `bezier-gen` or other package.\n *\n * @see [Y-for-X in Pomax's guide](https://pomax.github.io/bezierinfo/#yforx)\n * @see [Finding B\xe9zier roots and Newton-Raphson method in Pomax's guide](https://pomax.github.io/bezierinfo/#extremities)\n */\n\n// Code generated by `bezier-gen` - start:\n\nfloat bezier(float cp0, float cp1, float cp2, float t) {\n    float p0 = mix(cp0, cp1, t);\n    float p1 = mix(cp1, cp2, t);\n\n    return mix(p0, p1, t);\n}\n\nfloat bezier(float cp0, float cp1, float cp2, float cp3, float t) {\n    float p0 = mix(cp0, cp1, t);\n    float p1 = mix(cp1, cp2, t);\n    float p2 = mix(cp2, cp3, t);\n\n    p0 = mix(p0, p1, t);\n    p1 = mix(p1, p2, t);\n\n    return mix(p0, p1, t);\n}\n\nfloat bezier(float cp0, float cp1, float cp2, float cp3, float cp4, float t) {\n    float p0 = mix(cp0, cp1, t);\n    float p1 = mix(cp1, cp2, t);\n    float p2 = mix(cp2, cp3, t);\n    float p3 = mix(cp3, cp4, t);\n\n    p0 = mix(p0, p1, t);\n    p1 = mix(p1, p2, t);\n    p2 = mix(p2, p3, t);\n\n    p0 = mix(p0, p1, t);\n    p1 = mix(p1, p2, t);\n\n    return mix(p0, p1, t);\n}\n\n// Code generated by `bezier-gen` - end.\n\n// float bezier(float p0, float p1, float p2, float p3, float t) {\n//   float u = 1.0-t;\n\n//   return (3.0*u*u*t*p1)+(3.0*u*t*t*p2)+(t*t*t*p3);\n// }\n\n/** @todo Generalise to other orders. */\nfloat derivativeCubic(float p0, float p1, float p2, float p3, float t) {\n  float u = 1.0-t;\n\n  return (9.0*p1*u*u)+(6.0*(p2-p1)*u*t)+(3.0*p3*t*t);\n}\n\nfloat xToY(vec2 p0, vec2 p1, vec2 p2, vec2 p3, float x) {\n  float t = x;\n\n  // Netwon's method iteration.\n  for(int i = 0; i < 4; ++i) {\n    float xt = bezier(p0.x, p1.x, p2.x, p3.x, t);\n    float dtx = derivativeCubic(p0.x, p1.x, p2.x, p3.x, t);\n    float error = xt-x;\n\n    // Newton's iteration.\n    t = clamp(t-(error/dtx), 0.0, 1.0);\n  }\n\n  // Now that we have `t`, compute the corresponding `y` value.\n  return bezier(p0.y, p1.y, p2.y, p3.y, t);\n}\n\nfloat xToY(vec2 ps[4], float x) { return xToY(ps[0], ps[1], ps[2], ps[3], x); }\n\n#if defined(rescale_motion)\n  /** Exponential notation packed into a vector. */\nfloat exponent(vec2 basePower) { return basePower.s*pow(1e1, basePower.t); }\n\n#endif\n\nvoid main() {\n  #ifdef rescale_motion\n    float rescaledMotion = exponent(rescaleMotion);\n  #endif\n\n  vec2 motion = v0;\n  /** Seems the right range, by trial, versus `[0, grid_stateShape.xy-1]`. */\n  Kernel2 kernel = toKernel(grid_uv*grid_stateShape.xy);\n\n  for(int gx = 0; gx < kernelSize; ++gx) {\n    for(int gy = 0; gy < kernelSize; ++gy) {\n      #if test == test_p2g\n        // vec2 offset = toKernelOffset(vec2(gx, gy));\n        // vec2 offset = toKernelOffset(vec2(kernelSize)*0.5);\n        /** Range: `base` is `[0, grid_stateShape.xy-1.0]`, `st` is `[0, 1]`. */\n        // vec2 st = (kernel.base+offset)/(grid_stateShape.xy-1.0);\n        // vec2 st = kernel.base/(grid_stateShape.xy-1.0);\n        // vec2 st = kernel.base/grid_stateShape.xy;\n        // vec2 st = grid_uv;\n        vec2 st = floor((grid_uv*grid_stateShape.xy)-0.5)/grid_stateShape.xy;\n\n        // st = offsetUV(st, grid_stateShape.xy);\n        // gl_FragColor.rgba = vec4(st, 0, 1);\n        // return;\n        grid_tapState(st);\n        gl_FragColor.rgba = grid_data[0];\n\n        // vec4 dc = grid_data[0]-vec4(st, 0.5, 1);\n\n        // /** @todo With high scaling this is less accurate near axes cross. */\n        // gl_FragColor.rgba = mix(vec4(0, 1, 0, 1), vec4(1, 0, 0, 1),\n        //   clamp(dot(dc, dc)*1e3, 0.0, 1.0));\n        return;\n      #else\n        float weight = kernel.weights[gx].x*kernel.weights[gy].y;\n        vec2 offset = toOffset(vec2(gx, gy));\n        /** Range: `base` is `[0, grid_stateShape.xy-1.0]`, `st` is `[0, 1]`. */\n        vec2 st = (kernel.base+offset)/(grid_stateShape.xy-1.0);\n\n        st = offsetUV(st, grid_stateShape.xy);\n\n        #if grid_stepsPast > 1\n          for(int stepPast = 0; stepPast < grid_stepsPast; ++stepPast) {\n            float ago = float(stepPast)/float(grid_stepsPast);\n\n            grid_tapStateBy(offsetUV(st, grid_stateShape.xy), stepPast, 0);\n            // grid_tapStateBy(st, stepPast, 0);\n\n            motion += rescaledMotion*(1.0-ago)*weight*\n              grid_data[grid_reads_mass_motionFull].grid_channels_motionFull;\n              // grid_data[grid_reads_mass_motionFull].grid_channels_motionFull*\n              // grid_data[grid_reads_mass_mass].grid_channels_mass;\n              // vec2(grid_data[grid_reads_mass_mass].grid_channels_mass);\n          }\n        #else\n          grid_tapState(offsetUV(st, grid_stateShape.xy));\n          // grid_tapState(st);\n\n          motion += rescaledMotion*weight*\n            grid_data[grid_reads_mass_motionFull].grid_channels_motionFull;\n            // grid_data[grid_reads_mass_motionFull].grid_channels_motionFull*\n            // grid_data[grid_reads_mass_mass].grid_channels_mass;\n            // vec2(grid_data[grid_reads_mass_mass].grid_channels_mass);\n        #endif\n      #endif\n    }\n  }\n\n  // motion *= 1e9;\n\n  #ifdef paceLinear\n    float pace = length(motion);\n  #else\n    float pace = dot(motion, motion);\n  #endif\n\n  float at = clamp(map(pace, range.x, range.y, 0.0, 1.0), 0.0, 1.0);\n  float to = xToY(curve[0], curve[1], curve[2], curve[3], at);\n  // float to = at;\n  vec2 outside = when_lt_1604150559(grid_uv, v0)+when_lt_1604150559(v1, grid_uv);\n  float on = when_lt_1604150559(outside.x+outside.y, 0.5);\n  vec4 color = mix(colorLo, colorHi, clamp(to, 0.0, on));\n\n  #ifdef angleHSLA\n    float hue = map(atan(motion.y, motion.x), -PI, PI, 0.0, 1.0);\n    vec3 angleColor = hsl2rgb(fract(hue+angleHSLA.x), angleHSLA.y, angleHSLA.z);\n\n    color.rgb = mix(color.rgb, angleColor, angleHSLA.a*on);\n  #endif\n\n  // #if test != test_off\n  //   vec2 line = fract(grid_uv*grid_stateShape.xy);\n\n  //   // color = mix(color, 1.0-color, lt(min(line.x, line.y), 5e-2));\n  //   color = mix(color, vec4(1, 0, 0, 1), lt(min(line.x, line.y), 0.1));\n  // #endif\n\n  gl_FragColor = clamp(color, 0.0, 1.0);\n  gl_FragColor.rgb *= gl_FragColor.a;\n}\n";


var $dd5fdb0d9b74b9e3$exports = {};
$dd5fdb0d9b74b9e3$exports = "/** Points-to-screen vertex shader. */\n\nprecision highp float;\n#define GLSLIFY 1\n\n#define positionChannels points_channels_0\n#define massChannels points_channels_2\n\npoints_useSamples\npoints_useReads_position\n\nattribute float index;\n\n#ifdef points_splits\n  uniform sampler2D points_states[points_splits];\n#else\n  uniform sampler2D points_states;\n#endif\n\nuniform float points_stepNow;\nuniform vec4 points_stateShape;\n\nuniform float wideHi;\nuniform float wideLo;\nuniform vec2 widths;\nuniform vec4 colorHi;\nuniform vec4 colorLo;\n\n#ifdef colorImage\n  uniform sampler2D colorImage;\n  uniform vec2 colorBy;\n  uniform vec2 flip;\n  uniform vec4 offset;\n  uniform vec2 aspectImage;\n#endif\n\nuniform float dt;\nuniform vec2 size;\nuniform vec2 aspectScreen;\nuniform vec4 bounds;\nuniform float form;\n\n#ifdef rescale_mass\n  uniform vec2 rescaleMass;\n#else\n  const float rescaledMass = 1.0;\n#endif\n#ifdef rescale_position\n  uniform vec2 rescalePosition;\n#else\n  const float rescaledPosition = 1.0;\n#endif\n\nvarying float wide;\nvarying vec3 sphere;\nvarying vec4 color;\n\nfloat map(float value, float inMin, float inMax, float outMin, float outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\nvec2 map(vec2 value, vec2 inMin, vec2 inMax, vec2 outMin, vec2 outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\nvec3 map(vec3 value, vec3 inMin, vec3 inMax, vec3 outMin, vec3 outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\nvec4 map(vec4 value, vec4 inMin, vec4 inMax, vec4 outMin, vec4 outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\nfloat when_neq_1604150559(float x, float y) {\n  return abs(sign(x - y));\n}\n\nvec2 when_neq_1604150559(vec2 x, vec2 y) {\n  return abs(sign(x - y));\n}\n\nvec3 when_neq_1604150559(vec3 x, vec3 y) {\n  return abs(sign(x - y));\n}\n\nvec4 when_neq_1604150559(vec4 x, vec4 y) {\n  return abs(sign(x - y));\n}\n\n#ifdef colorImage\n  float when_lt_529295689(float x, float y) {\n  return max(sign(y - x), 0.0);\n}\n\nvec2 when_lt_529295689(vec2 x, vec2 y) {\n  return max(sign(y - x), 0.0);\n}\n\nvec3 when_lt_529295689(vec3 x, vec3 y) {\n  return max(sign(y - x), 0.0);\n}\n\nvec4 when_lt_529295689(vec4 x, vec4 y) {\n  return max(sign(y - x), 0.0);\n}\n\nfloat when_ge_2315452051(float x, float y) {\n  return 1.0 - when_lt_529295689(x, y);\n}\n\nvec2 when_ge_2315452051(vec2 x, vec2 y) {\n  return 1.0 - when_lt_529295689(x, y);\n}\n\nvec3 when_ge_2315452051(vec3 x, vec3 y) {\n  return 1.0 - when_lt_529295689(x, y);\n}\n\nvec4 when_ge_2315452051(vec4 x, vec4 y) {\n  return 1.0 - when_lt_529295689(x, y);\n}\n\n#endif\n\n/**\n * Convenience to turn a 1D entry index into a 2D texture `UV` for sampling.\n * Note that this does not wrap the y-axis, so if the `index` exceeds the range\n * `[0, (size.x*size.y)-1]`, the result y-axis will exceed the range `[0, 1]`.\n *\n * @see {@link util/remain-div.glsl!}\n *\n * @param {float|int} `index` 1D index, expect range `[0, (size.x*size.y)-1]`.\n * @param {float|int|vec2|ivec2} `size` Texture's size, expect\n *   `[width, height]`, or if given a scalar interpret both as `side`.\n *\n * @returns {vec2} 2D `UV` texture sample coordinate, expect range `[0, 1]`.\n */\n\n/**\n * Equivalent to a _remainder_ operator; same as `mod` for same-signed operands,\n * but different for differently-signed operands, like JavaScript's `%`\n * operator.\n * Reuses the truncated division, and returns both; as both are useful in\n * various places, e.g: index conversion.\n *\n * @see [GLSL modulo](https://www.shaderific.com/glsl-functions#modulo)\n * @see [JS modulo/remainder](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Remainder)\n *\n * @param {float|int} `x` The first remainder/divide operand, expect `x >= 0`.\n * @param {float|int} `y` The second remainder/divide operand, expect `y >= 0`.\n *\n * @returns {vec2|ivec2} The result as `[(remainder), (truncated division)]`;\n *   always a `vec2` if any operand is a `float`.\n */\n\nivec2 remainDiv(int x, int y) {\n  // Careful handling integer maths; decimals truncated, works like a\n  // _remainder_ operator, rather than `mod`.\n  int d = x/y;\n\n  return ivec2(x-(y*d), d);\n}\n\nvec2 remainDiv(float x, int y) {\n  int d = int(x)/y;\n\n  // Remainder; like `mod` but with truncated `d` not floored, reuses `d`.\n  // return vec2(mod(x, y), d);\n  return vec2(x-float(y*d), d);\n}\n\n/**\n * Assume higher accuracy is desired; if less computation with `int` is desired,\n * use `remainDiv(int(x), int(y))` or `vec2(remainDiv(int(x), int(y)))` instead.\n */\nvec2 remainDiv(float x, float y) { return remainDiv(x, int(y)); }\n\n/**\n * Assume higher accuracy is desired; if less computation with `int` is desired,\n * use `remainDiv(x, int(y))` or `vec2(remainDiv(x, int(y)))` instead.\n */\nvec2 remainDiv(int x, float y) { return remainDiv(float(x), y); }\n\nvec2 indexUV(float index, vec2 size) {\n  return remainDiv(index, size.x)/max(size-1.0, 1.0);\n}\n\nvec2 indexUV(int index, ivec2 size) {\n  return vec2(remainDiv(index, size.x))/max(vec2(size-1), 1.0);\n}\n\nvec2 indexUV(float index, ivec2 size) {\n  return remainDiv(index, size.x)/max(vec2(size-1), 1.0);\n}\n\nvec2 indexUV(int index, vec2 size) {\n  return remainDiv(index, size.x)/max(size-1.0, 1.0);\n}\n\nvec2 indexUV(float index, float size) {\n  return remainDiv(index, size)/max(size-1.0, 1.0);\n}\n\nvec2 indexUV(int index, float size) {\n  return remainDiv(index, size)/max(size-1.0, 1.0);\n}\n\nvec2 indexUV(float index, int size) {\n  return remainDiv(index, size)/max(float(size-1), 1.0);\n}\n\nvec2 indexUV(int index, int size) {\n  return vec2(remainDiv(index, size))/max(float(size-1), 1.0);\n}\n\n/**\n * Convenience to sample entries safely at their texel center.\n * Where `spreadUV` is for lookup ranges, `offsetUV` is for lookup queries.\n *\n * @see [`spreadUV`](./spread-uv.glsl)\n *\n * @param {vec2} `uv` UV texture sample coordinate, expect range `[0, 1]`.\n * @param {float|int|vec2|ivec2} `[size=1.0]` Texture's size, expect\n *   `[width, height]`, or if given a scalar interpret both as `side`.\n * @param {float|vec2} `[pad=0.5]` Texel `pad` to offset, expect range `[0, 1]`.\n *\n * @returns {vec2} The `uv` offset by `pad` to texel center, expect range\n *   `[0+pad, 1-pad]`.\n */\n\nvec2 offsetUV(vec2 uv, float size, float pad) {\n  return ((uv*(size-1.0))+pad)/size;\n}\n\nvec2 offsetUV(vec2 uv, vec2 size, float pad) {\n  return ((uv*(size-1.0))+pad)/size;\n}\n\nvec2 offsetUV(vec2 uv, vec2 size, vec2 pad) {\n  return ((uv*(size-1.0))+pad)/size;\n}\n\nvec2 offsetUV(vec2 uv, int size, float pad) {\n  return offsetUV(uv, float(size), pad);\n}\n\nvec2 offsetUV(vec2 uv, ivec2 size, float pad) {\n  return offsetUV(uv, vec2(size), pad);\n}\n\nvec2 offsetUV(vec2 uv, ivec2 size, vec2 pad) {\n  return offsetUV(uv, vec2(size), pad);\n}\n\nvec2 offsetUV(vec2 uv, float size) { return offsetUV(uv, size, 0.5); }\nvec2 offsetUV(vec2 uv, vec2 size) { return offsetUV(uv, size, 0.5); }\nvec2 offsetUV(vec2 uv, int size) { return offsetUV(uv, size, 0.5); }\nvec2 offsetUV(vec2 uv, ivec2 size) { return offsetUV(uv, size, 0.5); }\nvec2 offsetUV(vec2 uv) { return offsetUV(uv, 1.0, 0.5); }\n\n#if defined(rescale_mass) || defined(rescale_position)\n  /** Exponential notation packed into a vector. */\nfloat exponent(vec2 basePower) { return basePower.s*pow(1e1, basePower.t); }\n\n#endif\n\n#if points_stepsPast > 1\n  #define indexFormsStates\n  #ifdef indexFormsStates\n    /**\n * The step and entry indexes corresponding to the number of entries and steps\n * for pairs of elements (e.g: lines linking each index's steps); as detailed in\n * the `indexForms` `JS` `function`.\n * Given the vertex index and number of steps; iterates entries-then-steps.\n *\n * @see {@link index-forms}\n * @see {@link util/remain-div.glsl!}\n *\n * @param {float|int} `index` The index of a vertex; expects simple sequential\n *   index attribute.\n * @param {float|int} `states` How many steps of state each entry has.\n * @param {float|int} [`form`] How many steps of state each form covers.\n *\n * @returns {vec2|ivec2} The step and entry index, respectively, to look up the\n *   correct data to draw the given `form` along each entry's steps of state;\n *   always a `vec2` if any operand is a `float`, an `ivec2` if all are `int`;\n *   iterates with `index` by entries-then-steps.\n */\n\n// Careful handling integer maths - decimals truncated.\nivec2 indexForms_1(int index, int states, int form) {\n  int f = form-1;\n  ivec2 stepEntry = remainDiv(index, (states-f)*form);\n\n  stepEntry.s = (stepEntry.s+f)/form;\n\n  return stepEntry;\n}\n\nvec2 indexForms_1(float index, float states, float form) {\n  vec2 stepEntry = remainDiv(index/form, states-form+1.0);\n\n  stepEntry.s = ceil(stepEntry.s);\n\n  return stepEntry;\n}\n\n// Mixed-type overloads assume higher accuracy is desired; if less computation\n// with `int` is desired, use `indexForms(int(index), int(states), int(form))`\n// or `vec2(indexForms(int(index), int(states), int(form)))` instead.\n\nvec2 indexForms_1(int index, float states, float form) {\n  return indexForms_1(float(index), states, form);\n}\n\nvec2 indexForms_1(float index, int states, float form) {\n  return indexForms_1(index, float(states), form);\n}\n\nvec2 indexForms_1(float index, float states, int form) {\n  return indexForms_1(index, states, float(form));\n}\n\nvec2 indexForms_1(float index, int states, int form) {\n  return indexForms_1(index, float(states), float(form));\n}\n\nvec2 indexForms_1(int index, float states, int form) {\n  return indexForms_1(float(index), states, float(form));\n}\n\nvec2 indexForms_1(int index, int states, float form) {\n  return indexForms_1(float(index), float(states), form);\n}\n\n// Expects pairs by default, though also works for single points and possibly\n// useful for other forms.\n// Mixed-type overloads assume higher accuracy is desired; if less computation\n// with `int` is desired, use `indexForms(int(index), int(states))` or\n// `vec2(indexForms(int(index), int(states)))` instead.\n\nivec2 indexForms_1(int index, int states) {\n  return indexForms_1(index, states, 2);\n}\n\nvec2 indexForms_1(float index, float states) {\n  return indexForms_1(index, states, 2.0);\n}\n\nvec2 indexForms_1(int index, float states) {\n  return indexForms_1(float(index), states, 2.0);\n}\n\nvec2 indexForms_1(float index, int states) {\n  return indexForms_1(index, float(states), 2.0);\n}\n\n  #else\n    /**\n * The step and entry indexes corresponding to the number of entries and steps\n * for pairs of elements (e.g: lines linking each index's steps); as detailed in\n * the `indexForms` `JS` `function`.\n * Given the vertex index and number of entries; iterates steps-then-entries.\n *\n * Works out as 2 `remainDiv`:\n * `[(index%form)+floor(floor(index/form)/count), floor(index/form)%count]`\n * `[indexForm.s+floor(indexForm.t/count), indexForm.t%count]`\n * `[indexForm.s+stepEntry.t, stepEntry.s]`\n *\n * @see {@link index-forms}\n * @see {@link util/remain-div.glsl!}\n *\n * @param {float|int} `index` The index of a vertex; expects simple sequential\n *   index attribute.\n * @param {float|int} `count` How many entries are in each step of state.\n * @param {float|int} [`form`] How many steps of state each form covers.\n *\n * @returns {vec2|ivec2} The step and entry index, respectively, to look up the\n *   correct data to draw the given `form` along each entry's steps of state;\n *   always a `vec2` if any operand is a `float`, an `ivec2` if all are `int`;\n *   iterates with `index` by steps-then-entries.\n */\n\n// Careful handling integer maths - decimals truncated.\nivec2 indexForms_0(int index, int count, int form) {\n  ivec2 indexForm = remainDiv(index, form);\n  ivec2 stepEntry = remainDiv(indexForm.t, count).ts;\n\n  stepEntry.s += indexForm.s;\n\n  return stepEntry;\n}\n\nvec2 indexForms_0(float index, float count, float form) {\n  vec2 indexForm = remainDiv(index, form);\n  vec2 stepEntry = remainDiv(indexForm.t, count).ts;\n\n  stepEntry.s += indexForm.s;\n\n  return stepEntry;\n}\n\n// Mixed-type overloads assume higher accuracy is desired; if less computation\n// with `int` is desired, use `indexForms(int(index), int(count), int(form))` or\n// `vec2(indexForms(int(index), int(count), int(form)))` instead.\n\nvec2 indexForms_0(int index, float count, float form) {\n  return indexForms_0(float(index), count, form);\n}\n\nvec2 indexForms_0(float index, int count, float form) {\n  return indexForms_0(index, float(count), form);\n}\n\nvec2 indexForms_0(float index, float count, int form) {\n  return indexForms_0(index, count, float(form));\n}\n\nvec2 indexForms_0(float index, int count, int form) {\n  return indexForms_0(index, float(count), float(form));\n}\n\nvec2 indexForms_0(int index, float count, int form) {\n  return indexForms_0(float(index), count, float(form));\n}\n\nvec2 indexForms_0(int index, int count, float form) {\n  return indexForms_0(float(index), float(count), form);\n}\n\n// Expects pairs by default, though also works for single points and possibly\n// useful for other forms.\n// Mixed-type overloads assume higher accuracy is desired; if less computation\n// with `int` is desired, use `indexForms(int(index), int(count))` or\n// `vec2(indexForms(int(index), int(count)))` instead.\n\nivec2 indexForms_0(int index, int count) {\n  return indexForms_0(index, count, 2);\n}\n\nvec2 indexForms_0(float index, float count) {\n  return indexForms_0(index, count, 2.0);\n}\n\nvec2 indexForms_0(int index, float count) {\n  return indexForms_0(float(index), count, 2.0);\n}\n\nvec2 indexForms_0(float index, int count) {\n  return indexForms_0(index, float(count), 2.0);\n}\n\n  #endif\n#endif\n\nconst vec2 v1 = vec2(1);\nconst vec2 v0 = v1*0.0;\nconst vec4 hidden = vec4(0, 0, 0, -1);\n\n#ifdef colorImage\n  const float colorByBase = 1.0;\n  const float colorByImage = 2.0;\n#endif\n\nvoid main() {\n  #if points_stepsPast > 1\n    // If multiple steps are given, find past step and entry.\n    // Lookups mostly equivalent; input and result iteration order differ.\n    #ifdef indexFormsStates\n      vec2 stepEntry = indexForms_1(index, points_stepsPast, form);\n    #else\n      vec2 stepEntry = indexForms_0(index, points_entries, form);\n    #endif\n\n    float stepPast = stepEntry.s;\n    float entry = stepEntry.t;\n  #else\n    // If only 1 step is given, past step and entry are known.\n    float stepPast = 0.0;\n    float entry = index;\n  #endif\n\n  vec2 st =\n    offsetUV(indexUV(entry, points_stateShape.xy), points_stateShape.xy);\n  // vec2 st = indexUV(entry, points_stateShape.xy);\n\n  #if points_stepsPast > 1\n    points_tapStateBy(st, stepPast, 0);\n  #else\n    points_tapState(st);\n  #endif\n\n  #ifdef rescale_mass\n    float rescaledMass = exponent(rescaleMass);\n  #endif\n  #ifdef rescale_position\n    float rescaledPosition = exponent(rescalePosition);\n  #endif\n\n  float mass = rescaledMass*\n    points_data[points_reads_position_mass].massChannels;\n\n  vec2 position = rescaledPosition*\n    points_data[points_reads_position_position].positionChannels;\n\n  float show = when_neq_1604150559(mass, 0.0);\n  vec2 boundSize = bounds.zw-bounds.xy;\n  vec2 to = (position/max(boundSize.x, boundSize.y))*2.0;\n  vec4 screen = mix(hidden, vec4(to, 0, 1), show);\n\n  screen.xy *= aspectScreen;\n  gl_Position = screen;\n\n  float ago = stepPast/max(float(points_stepsPast-1), 1.0);\n\n  color = mix(colorHi, colorLo, ago);\n\n  #ifdef colorImage\n    vec2 pq = ((fract(st*flip)*(aspectImage/aspectScreen))/offset.zw)-offset.xy;\n    vec4 colorPixel = texture2D(colorImage, pq);\n    float colorAt = colorBy.x;\n\n    colorAt = mix(colorAt, (1.0-color.a)+colorBy.x, when_ge_2315452051(colorBy.y, colorByBase));\n    colorAt = mix(colorAt, colorPixel.a+colorBy.x, when_ge_2315452051(colorBy.y, colorByImage));\n    color = mix(color, colorPixel, clamp(colorAt, 0.0, 1.0));\n  #endif\n\n  color *= show;\n\n  wide = mix(wideHi, wideLo, ago)*show;\n\n  float pointSize = gl_PointSize = 0.5*clamp(wide/screen.w, widths.s, widths.t);\n\n  /**\n   * Convert vertex position to `gl_FragCoord` window-space.\n   * @see [SO](https://stackoverflow.com/a/7158573)\n   * @see [SO](https://stackoverflow.com/a/54237532/716898)\n   * @todo Why does the correct size here seem to be half the radius?\n   */\n  sphere = vec3(size*map(screen.xy/screen.w, -v1, v1, v0, v1), pointSize*0.5);\n}\n";


var $e361475d76f22da0$exports = {};
$e361475d76f22da0$exports = "/** Points-to-screen fragment shader. */\n\nprecision highp float;\n#define GLSLIFY 1\n\nvarying float wide;\nvarying vec3 sphere;\nvarying vec4 color;\n\nfloat when_gt_1540259130(float x, float y) {\n  return max(sign(x - y), 0.0);\n}\n\nvec2 when_gt_1540259130(vec2 x, vec2 y) {\n  return max(sign(x - y), 0.0);\n}\n\nvec3 when_gt_1540259130(vec3 x, vec3 y) {\n  return max(sign(x - y), 0.0);\n}\n\nvec4 when_gt_1540259130(vec4 x, vec4 y) {\n  return max(sign(x - y), 0.0);\n}\n\nvoid main() {\n  float r = sphere.p;\n  float r2 = r*r;\n  vec2 cf = gl_FragCoord.xy-sphere.xy;\n  float cfl2 = dot(cf, cf);\n  float isWide = when_gt_1540259130(wide, 1.0);\n\n  #ifdef useDiscard\n    if(isWide*cfl2 > r2) { discard; }\n  #endif\n\n  float fade = max(r2-(isWide*cfl2), 0.0);\n\n  #ifdef lengthLinear\n    fade = sqrt(fade)/r;\n  #else\n    fade = fade/r2;\n  #endif\n\n  gl_FragColor = color*fade;\n  gl_FragColor.rgb *= gl_FragColor.a;\n}\n";


const { keys: $df94745e835b5ca5$var$keys, assign: $df94745e835b5ca5$var$assign } = Object;
const { floor: $df94745e835b5ca5$var$floor, min: $df94745e835b5ca5$var$min, max: $df94745e835b5ca5$var$max, abs: $df94745e835b5ca5$var$abs, random: $df94745e835b5ca5$var$random, sign: $df94745e835b5ca5$var$sign, sin: $df94745e835b5ca5$var$sin } = Math;
const { GRAV_ACCEL: $df94745e835b5ca5$var$g } = (0, $3b170edb4d456798$exports.MKS);
const $df94745e835b5ca5$var$cache = {};
const $df94745e835b5ca5$export$5d97924d29f48e83 = (0, $c3a4c4b89537eec0$export$5d97924d29f48e83);
const $df94745e835b5ca5$export$ac0cd3cc21f80dfc = (0, $c3a4c4b89537eec0$export$ac0cd3cc21f80dfc);
const $df94745e835b5ca5$export$fdb75c5ac32869de = (0, $c3a4c4b89537eec0$export$fdb75c5ac32869de);
const $df94745e835b5ca5$export$bc4be2352d4c92cc = ()=>[
        "angle_instanced_arrays"
    ];
const $df94745e835b5ca5$export$cc3e2d3244e01b7f = $df94745e835b5ca5$export$5d97924d29f48e83;
const $df94745e835b5ca5$export$918e5821fc7288cd = ()=>[
        ...$df94745e835b5ca5$var$cache.extensionsFloat ??= $df94745e835b5ca5$export$ac0cd3cc21f80dfc(),
        ...$df94745e835b5ca5$var$cache.extensionsDrawBuffers ??= $df94745e835b5ca5$export$fdb75c5ac32869de(),
        ...$df94745e835b5ca5$var$cache.extensionsInstances ??= $df94745e835b5ca5$export$bc4be2352d4c92cc()
    ];
const $df94745e835b5ca5$export$4bceda1224fc5ab8 = $df94745e835b5ca5$export$918e5821fc7288cd;
function $df94745e835b5ca5$export$1c8f61c1db5300d2(to, f) {
    const { onStatus: onStatus, status: status, api: { _gl: _gl, gl: gl = _gl } } = to;
    let error;
    to.status = "wait";
    try {
        f(to);
        const e = gl?.getError();
        if (e) throw e;
        else to.status = "done";
    } catch (e) {
        to.status = "fail", error = e;
    }
    to.status !== "done" && onStatus?.(to, error);
    to.status = status;
}
function $df94745e835b5ca5$export$82ee245e4549d21(fields, to = {}) {
    const vs = to.values = [];
    const index = to.index = {};
    const alias = to.alias = [];
    (to.fields = fields).forEach((v, k)=>alias[index[k] = vs.push(v) - 1] = k);
    return to;
}
function $df94745e835b5ca5$export$bd2891254e1e5b30(state, at, to = {}) {
    const uniforms = (0, $dd6bfc0fd00c82d9$export$1aad3af825e3305b)(to.state = state);
    to.macros ??= (0, $51b9e91bc370f51d$export$d38b14fb9031108e)(state);
    if (!at) return to;
    /** Override uniforms to prefix the right property paths. */ for(let k in uniforms){
        const u = uniforms[k];
        uniforms[k] = (c, p, b)=>u(c, at(c, p, b), b);
    }
    return to;
}
const $df94745e835b5ca5$export$47b243153dce5032 = {
    stepNow: 0,
    passNow: 0,
    bound: 1
};
const $df94745e835b5ca5$export$9f9ef40fe2e7f9e0 = {
    stepNow: 0,
    passNow: 0,
    bound: 0,
    maps: {
        buffersMax: 0
    }
};
function $df94745e835b5ca5$export$48f580ce092b95a(api, to = {}) {
    console.log("mpm:setup", to);
    to.onStatus ??= (state, error)=>console.warn("mpm:status", to.status, to, error);
    const { command: command = api, buffer: buffer, elements: elements, clear: clear, hasExtension: hasExtension, now: now, limits: limits } = to.api = api;
    const { pointSizeDims: pointSizeDims, lineWidthDims: lineWidthDims } = limits;
    const hasInstances = ($df94745e835b5ca5$var$cache.extensionsInstances ??= $df94745e835b5ca5$export$bc4be2352d4c92cc()).every(hasExtension);
    to.support = {
        hasInstances: hasInstances
    };
    const vertex = to.vertex = [
        [
            1,
            1
        ],
        [
            1,
            0
        ],
        [
            0,
            0
        ],
        [
            0,
            1
        ]
    ];
    const quad = to.quad = [
        [
            0,
            1,
            2
        ],
        [
            2,
            3,
            0
        ]
    ];
    // const timestep = to.timer?.step ?? 1e3/120;
    // const timestep = to.timer?.step ?? 1e3/60;
    const timestep = to.timer?.step ?? 1e3 / 30;
    // const timestep = to.timer?.step ?? 0;
    /** Time control and state. */ to.timer = (0, $beb29002c2450874$export$9dc4ecf953986f04)({
        to: to,
        now: timestep ? undefined : ()=>now() * 1e3,
        period: 1e6,
        ...to.timer,
        // Fixed-step (add-step), or real-time (variable delta-time).
        step: timestep || "-"
    });
    /** Target offset position `x` and `y`, magnitude `z`. */ // to.g = assign([0, 0, g*1e2], to.g);
    // to.g = assign([0, 0, 0], to.g);
    to.g = $df94745e835b5ca5$var$assign([
        0,
        -1000000000,
        $df94745e835b5ca5$var$g * 1e2
    ], to.g);
    /** Exponential-notation scaling for storage spatial numerical accuracy. */ const rescale = to.rescale = {
        // mass: [1, 0],
        mass: [
            1,
            0
        ],
        // position: [1, 0],
        position: [
            1,
            0
        ],
        // motion: [1, -6],
        motion: [
            1,
            0
        ],
        // affine: [1, -6],
        affine: [
            1,
            0
        ],
        // deform: [1, -6],
        deform: [
            1,
            0
        ],
        // stress: [1, -6],
        stress: [
            1,
            0
        ],
        ...to.rescale
    };
    /** Header of common settings prepended to each shader. */ to.head = {
        to: to,
        test: "",
        kernelSize: 3,
        kernelType: "",
        // kernelType: 'Centre',
        kernelBase: "",
        // kernelBase: 'Cast',
        rescales: $df94745e835b5ca5$var$keys(rescale),
        glsl (head = to.head) {
            const { test: test, kernelType: kernelType, kernelSize: kernelSize, kernelBase: kernelBase, rescales: rescales, to: to1 } = head;
            const { rescale: rescale } = to1;
            return (test ? `#define test ${test}\n` : "") + (kernelSize ? `#define kernelSize ${kernelSize}\n` : "") + (kernelType ? `#define kernelType${kernelType}\n` : "") + (kernelBase ? `#define kernelBase${kernelBase}\n` : "") + (0, $a0fef7c841dcaa76$export$533b26079ad0b4b)((rs, r)=>{
                const [b, p] = rescale[r];
                return rs + (b * 10 ** p === 1 ? "" : `#define rescale_${r}\n`);
            }, rescales, "") + `\n`;
        },
        ...to.head
    };
    /** Grid data. */ const grid = to.grid = {
        to: to,
        frag: (0, (/*@__PURE__*/$parcel$interopDefault($fb5fbe3afe5e76bf$exports))),
        detail: 90,
        limit: 1e9,
        /**
     * Remove this ambiguity between `bounds` and `boundsIn`, which are in
     * different reference frames; rename this to `space` or `region`.
     */ bounds: [
            -1,
            -1,
            1,
            1
        ],
        boundsIn: [
            1,
            1,
            -1,
            -1
        ],
        boundsHit: 1,
        on: true,
        ...to.grid
    };
    const { detail: gDetail, limit: gLimit, bounds: gBounds } = grid;
    (0, $3920c9be8d12f64a$export$1f214a01989f466a)(null, gBounds, gLimit);
    const gFields = grid.fields = $df94745e835b5ca5$export$82ee245e4549d21(new Map()/** @todo Use inverse mass to allow for infinite mass objects? */ .set("mass", 1)/** Using the term `motion` since it's variously velocity or momentum. */ // .set('motionFull', 3)
    .set("motionFull", 2)/** Using the term `motion` since it's variously velocity or momentum. */ // .set('motionBase', 3)
    .set("motionBase", 2));
    const gPre = "grid_";
    const gDerives = [];
    const { index: gIndex, values: gValues, alias: gAlias } = gFields;
    const { mass: gMass, motionFull: gMotionFull, motionBase: gMotionBase } = gIndex;
    gDerives[gMotionFull] = [
        gMotionFull,
        gMass
    ];
    gDerives[gMotionBase] = [
        gMotionBase,
        gMass
    ];
    const gMaps = {
        values: gValues,
        alias: gAlias,
        derives: gDerives
    };
    const gSteps = grid.gpgpu?.steps ?? 2;
    const gGPGPU = grid.gpgpu = (0, $112a804b6949d908$export$2e2bcd8739ae039)(api, {
        to: to,
        pre: gPre,
        maps: gMaps,
        stepNow: 0,
        steps: gSteps,
        stepMax: gSteps,
        side: gDetail,
        clearPass: true,
        macros: {
            vert: 0
        },
        frag: (c, { to: { grid: g, head: h } })=>h.glsl(h) + g.frag,
        uniforms: {
            boundsIn: (c, p)=>p.to.grid.boundsIn,
            boundsHit: (c, p)=>p.to.grid.boundsHit,
            dt: (c, p)=>p.to.timer.dt,
            g: (c, p)=>p.to.g,
            rescaleMass: (c, p)=>p.to.rescale.mass,
            rescaleMotion: (c, p)=>p.to.rescale.motion
        },
        ...grid.gpgpu
    });
    const gMerge = gGPGPU.merge;
    grid.step = (state = grid)=>{
        const s = state.onStep?.(state) ?? state;
        const { on: on, gpgpu: gpgpu } = s;
        on && gpgpu.step(gpgpu);
        return s;
    };
    /** Material points data. */ const points = to.points = {
        to: to
    };
    const pFields = points.fields = $df94745e835b5ca5$export$82ee245e4549d21(new Map()// .set('position', 3)
    .set("position", 2)/** Using the term `motion` since it's variously velocity or momentum. */ // .set('motion', 3)
    .set("motion", 2).set("mass", 1)/**
     * Affine momentum matrix.
     *
     * @todo Need to pack a 3*3 matrix into fewer channels or across texels.
     */ // .set('affine', 3*3)
    .set("affine", 4)/**
     * Deformation gradient, its determinant is the volume change.
     *
     * @todo Need to pack a 3*3 matrix into fewer channels or across texels.
     */ // .set('deform', 3*3)
    .set("deform", 4)/**
     * Stress gradient, derived from deformation, cached to use across steps.
     *
     * @todo Need to pack a 3*3 matrix into fewer channels or across texels.
     */ // .set('stress', 3*3)
    .set("stress", 4));
    /**
   * The `motion` and `affine` values derive from shared grid data.
   * Other values derive from the next `motion` and `affine` values.
   *
   * @todo In `gl-gpgpu`, add a way to group passes in order if needed, so a
   *   next pass can read values from the past pass if reliant on current
   *   values it `got` from the past pass in the current step.
   * @todo For now, add 2 `gl-gpgpu` processes here if needed:
   *   - If there aren't enough output data channels to do it in one pass,
   *     split the grid-to-points step into 2 parts: update the next values,
   *     then update the values that derive from those in the same step.
   *   - If there are enough output data channels, the step can be combined.
   */ const gridToPoints = to.gridToPoints = {
        to: to,
        frag: (0, (/*@__PURE__*/$parcel$interopDefault($201ff48dc55802cd$exports))),
        /**
     * @todo Are mass or volume responsible for particle collision?
     * @todo Move to looking up material types?
     */ mass: 1,
        // volume: null,
        volume: 5e-4,
        /** Thresholds used to test if the material is separating. */ volumeSplit: [
            1e-6,
            -0.001
        ],
        /** ASFLIP motion adjustment. */ motionAdjust: 0.97,
        /** ASFLIP position adjustment range. */ positionAdjusts: [
            0,
            1
        ],
        /**
     * Mechanics parameters.
     *
     * @todo Move to individual particles looking up material types?
     */ /** Young's modulus */ youngMod: 5e5,
        // youngMod: 1e6,
        /** Poisson's ratio. */ poissonRatio: 0.3,
        // poissonRatio: 0.4,
        /** Bulk modulus. */ bulkMod: null,
        /** Shear modulus. */ shearMod: null,
        /**
     * Plasticity parameters.
     *
     * @todo Move to individual particles looking up material types?
     */ frictionAngle: (0, $1316361d3442ab41$export$29e4e862bebba87f)(40),
        // frictionAngle: rad(80),
        // frictionAngle: rad(10),
        materialFriction: null,
        speedClamp: 1e9,
        boundsClamp: true,
        wander: [
            -0.00001,
            1e-2,
            1e-6
        ],
        // wander: [1e-5, 1e-2, 1e-6],
        on: true,
        ...to.gridToPoints,
        spawnOn: {
            any: true,
            out: true,
            slow: false,
            centre: 0,
            ...to.gridToPoints.spawnOn
        }
    };
    gridToPoints.volume ??= (()=>{
        /** @todo Better volume estimate based on number of particles and size. */ const { volume: v, volumeScale: vs } = gridToPoints;
        if (v != null) return v;
        const [gw, gh] = grid.gpgpu.size.shape;
        // const [pw, ph] = gridToPoints.gpgpu.size.shape;
        return vs / gw * (vs / gh);
    // return (vs/(gw/pw))*(vs/(gh/ph));
    })();
    const { index: pIndex, values: pValues, alias: pAlias } = pFields;
    const { position: pPosition, motion: pMotion, mass: pMass, affine: pAffine, deform: pDeform, stress: pStress } = pIndex;
    const pDerives = [];
    /** @todo Move peer-extensions from `derives` to `extends`, avoid redoing. */ // const pExtends = [];
    pDerives[pPosition] = [
        pPosition,
        pMotion,
        pMass
    ];
    // pExtends[pPosition] = [pAffine, pDeform];
    pDerives[pMotion] = [
        pMotion,
        pPosition,
        pMass
    ];
    pDerives[pMass] = [
        pMass
    ];
    pDerives[pAffine] = [
        pPosition,
        pMass
    ];
    pDerives[pDeform] = [
        pDeform,
        pMass
    ];
    // pExtends[pDeform] = [pAffine];
    pDerives[pStress] = [
        pMass
    ];
    // pExtends[pStress] = [pDeform];
    const pMaps = {
        values: pValues,
        derives: pDerives,
        alias: pAlias
    };
    const pPre = "points_";
    /** Inputs to map points data correctly. */ const gpLinkG = $df94745e835b5ca5$export$bd2891254e1e5b30({
        ...$df94745e835b5ca5$export$47b243153dce5032,
        pre: gPre,
        steps: gSteps,
        merge: gMerge,
        macros: {
            output: 0
        },
        maps: (0, $9ca80cadf3eaf758$export$798cdecdcbbf9755)({
            ...gMaps,
            ...$df94745e835b5ca5$export$47b243153dce5032.maps,
            derives: [
                [
                    gMotionFull,
                    gMotionBase
                ]
            ]
        })
    }, (c, p)=>p.to.grid.gpgpu);
    gridToPoints.link = {
        grid: gpLinkG
    };
    /**
   * @todo Broke this somehow, only 2 steps works, may be a `gpgpu` index issue.
   * @todo Lines don't work for 2 steps but work for 3.
   */ const pSteps = gridToPoints.gpgpu?.steps ?? 2;
    // const pSteps = gridToPoints.gpgpu?.steps ?? 3;
    /**
   * Grid-to-points `gpgpu` step, gather from `grid` data, render to step
   * `points` data.
   */ const gpGPGPU = gridToPoints.gpgpu = (0, $112a804b6949d908$export$2e2bcd8739ae039)(api, {
        to: to,
        pre: pPre,
        maps: pMaps,
        stepNow: 0,
        steps: pSteps,
        stepMax: pSteps,
        scale: 8,
        macros: {
            vert: 0
        },
        frag: (c, { to: { gridToPoints: { frag: f, link: l }, head: h } })=>h.glsl(h) + l.grid.macros + f,
        uniforms: {
            ...gpLinkG.state.uniforms,
            mass: (c, p)=>p.to.gridToPoints.mass,
            volume: (c, p)=>p.to.gridToPoints.volume,
            volumeSplit: (c, p)=>p.to.gridToPoints.volumeSplit,
            motionAdjust: (c, p)=>p.to.gridToPoints.motionAdjust,
            positionAdjusts: (c, p)=>p.to.gridToPoints.positionAdjusts,
            bulkMod (c, { to: { gridToPoints: gp } }) {
                const { bulkMod: bm, youngMod: ym, poissonRatio: pr } = gp;
                return bm ?? ym / (3 * (1 - pr * 2));
            },
            shearMod (c, { to: { gridToPoints: gp } }) {
                const { shearMod: sm, youngMod: ym, poissonRatio: pr } = gp;
                return sm ?? ym / (2 * (1 + pr));
            },
            materialFriction (c, { to: { gridToPoints: gp } }) {
                const { materialFriction: mf, frictionAngle: fa } = gp;
                if (mf != null) return mf;
                const sfa = $df94745e835b5ca5$var$sin(fa);
                return 1.633 * sfa / (3 - sfa);
            },
            speedClamp: (c, p)=>p.to.gridToPoints.speedClamp,
            boundsClamp: (c, p)=>+(p.to.gridToPoints.boundsClamp || 0),
            spawnOnAny: (c, p)=>+(p.to.gridToPoints.spawnOn.any || 0),
            spawnOnOut: (c, p)=>+(p.to.gridToPoints.spawnOn.out || 0),
            spawnOnSlow: (c, p)=>+(p.to.gridToPoints.spawnOn.slow || 0),
            spawnOnCentre: (c, p)=>+(p.to.gridToPoints.spawnOn.centre || 0),
            wander: (c, p)=>p.to.gridToPoints.wander,
            dt: (c, p)=>p.to.timer.dt,
            bounds: (c, p)=>p.to.grid.bounds,
            chaos: (c, p)=>p.to.chaos,
            rescaleMass: (c, p)=>p.to.rescale.mass,
            rescalePosition: (c, p)=>p.to.rescale.position,
            rescaleMotion: (c, p)=>p.to.rescale.motion,
            rescaleAffine: (c, p)=>p.to.rescale.affine,
            rescaleDeform: (c, p)=>p.to.rescale.deform,
            rescaleStress: (c, p)=>p.to.rescale.stress
        },
        ...gridToPoints.gpgpu
    });
    const { size: gpSize, merge: pMerge, bound: pBound } = gpGPGPU;
    const { entries: pl } = gpSize;
    gridToPoints.step = (state = gridToPoints)=>{
        const s = state.onStep?.(state) ?? state;
        const { on: on, gpgpu: gpgpu } = s;
        on && gpgpu.step(gpgpu);
        return s;
    };
    /**
   * Points-to-grid render, splat from `points` data to render `grid` data.
   * @todo How to map `grid` textures correctly in 3x3 quads?
   */ const pointsToGrid = to.pointsToGrid = {
        to: to,
        vert: (0, (/*@__PURE__*/$parcel$interopDefault($ccea03e8b69b2e19$exports))),
        frag: (0, (/*@__PURE__*/$parcel$interopDefault($6fc836b8d7da46eb$exports))),
        stretch: 1,
        turn: 1,
        on: true,
        /** Straight-alpha additive blending with no multiplying channels. */ blend: {
            enable: true,
            func: {
                src: 1,
                dst: 1
            }
        },
        depth: {
            enable: false
        },
        ...to.pointsToGrid
    };
    const { [gMass]: gMassPass, [gMotionFull]: gMotionFullPass, [gMotionBase]: gMotionBasePass } = gMaps.valueToPass;
    const pgSize = pointsToGrid.size = {};
    const pgSplats = pointsToGrid.splats = new Set().add(gMassPass).add(gMotionFullPass).add(gMotionBasePass);
    const pgSplatsL = pgSize.splats = pgSplats.size;
    /**
   * Splats per point, in the shader center on the point and scale to extend
   * as far as the neighbouring 3 nodes.
   *
   * @todo Draw to all the needed grid passes, framebuffer-per-splat.
   */ const pgInstancesL = pgSize.instances = pl * pgSplatsL;
    /**
   * Inputs to map points data correctly.
   *
   * @todo Handle vertex and fragment shaders.
   * @todo Handle passes.
   */ const pgLinkP = $df94745e835b5ca5$export$bd2891254e1e5b30({
        ...$df94745e835b5ca5$export$47b243153dce5032,
        pre: pPre,
        steps: pSteps,
        merge: pMerge,
        macros: {
            output: 0
        },
        maps: (0, $9ca80cadf3eaf758$export$798cdecdcbbf9755)({
            ...pMaps,
            ...$df94745e835b5ca5$export$47b243153dce5032.maps,
            derives: [
                [
                    pPosition,
                    pMotion,
                    pMass,
                    pAffine,
                    pStress
                ]
            ]
        })
    }, (c, p)=>p.to.gridToPoints.gpgpu);
    const pgLinkG = $df94745e835b5ca5$export$bd2891254e1e5b30({
        ...$df94745e835b5ca5$export$47b243153dce5032,
        pre: gPre,
        steps: gSteps,
        merge: gMerge,
        macros: {
            samples: 0,
            taps: 0
        },
        maps: (0, $9ca80cadf3eaf758$export$798cdecdcbbf9755)({
            ...gMaps,
            ...$df94745e835b5ca5$export$47b243153dce5032.maps,
            derives: null
        })
    }, (c, p)=>p.to.grid.gpgpu);
    pointsToGrid.link = {
        points: pgLinkP,
        grid: pgLinkG
    };
    /** If using points, they're square and seem small, seems just big render? */ // pointsToGrid.quads = true;
    // pointsToGrid.quads = false;
    // pointsToGrid.instanced = false;
    // pointsToGrid.instanced = true;
    // pointsToGrid.batch = true;
    // pointsToGrid.batch = false;
    // pointsToGrid.order = 'point-splat';
    // pointsToGrid.order = 'splat-point';
    /** Whether to draw using quads or points. */ const pgQuads = pointsToGrid.quads ??= pointSizeDims[1] < 3;
    /** Whether to draw using instancing. */ const pgInstanced = pointsToGrid.instanced ??= hasInstances && pgQuads;
    /** Iterate, whether to batch-draw. */ const pgBatch = pointsToGrid.batch ??= !pgInstanced && pgSplatsL > 1;
    /** Iterate, splats-then-points or points-then-splats. */ const pgOrder = pointsToGrid.order ??= pgInstanced ? "point-splat" : "splat-point";
    /** The form to use, suitable for `elements`. */ const pgForm = pointsToGrid.form ??= pgQuads ? quad : null;
    /** The number of parts per-form. */ const pgFormsL = pgSize.forms = pgForm?.length ?? 1;
    /** The number of vertexes per-form. */ const pgFormVertexesL = pgSize.formVertexes = pgForm?.[0]?.length ?? 1;
    /** The form vertex source to use. */ const pgFormSource = pointsToGrid.formSource ??= pgQuads ? vertex : [
        [
            0.5,
            0.5
        ]
    ];
    /** The number of vertexes per-source. */ const pgFormSourcesL = pgSize.formSources = pgFormSource.length;
    /** The number of vertexes per-point. */ pgSize.pointVertexes = pgFormsL * pgFormVertexesL;
    /** The number of sources overall. */ const pgFormSourcesSplatsL = pgSize.formSourcesSplats = pgFormSourcesL * pgSplatsL;
    /** The number of sources overall. */ const pgInstancesSourceL = pgSize.instancesSources = pgInstancesL * pgFormSourcesL;
    /**
   * @todo Change this to a grid `gpgpu`, overriding all the attributes and
   *   both shaders, but reusing the framebuffer passes logic to draw all the
   *   needed grid passes correctly.
   */ pointsToGrid.pass = command(pointsToGrid.pipeline = {
        vert: (c, { vert: v, quads: q, link: { points: points, grid: grid }, to: { head: h } })=>h.glsl(h) + (q ? "#define points_grid_quads\n\n" : "") + points.macros + grid.macros + v,
        frag: (c, { frag: f, quads: q, link: l, to: { head: h } })=>h.glsl(h) + (q ? "#define points_grid_quads\n\n" : "") + l.grid.macros + f,
        primitive: (c, p)=>p.quads ? "triangles" : "points",
        attributes: {
            /** Vertex only for drawing quads. */ vertex: !pgQuads ? pointsToGrid.vertex = {
                constant: pgFormSource
            } : buffer(pointsToGrid.vertex = pgInstanced || pgBatch ? pgFormSource : (0, $a8bd34883e6c6917$export$871de8747c9eaa88)((v, i)=>(0, $118b47bfc49fdb1b$export$4997ffc0176396a6)(i, pgFormSource), (0, $a17f2cccfa5f5eb1$export$d02631cccf789723)(pgInstancesSourceL), 0)),
            /** Index of each point. */ index: pgInstanced ? {
                ...pointsToGrid.index = pgOrder === "splat-point" ? // Splats-then-points, more data overall.
                {
                    buffer: (0, $a8bd34883e6c6917$export$871de8747c9eaa88)((v, i)=>i, (0, $a17f2cccfa5f5eb1$export$d02631cccf789723)(pl), 0),
                    divisor: pgSplatsL
                } : {
                    buffer: (0, $a8bd34883e6c6917$export$871de8747c9eaa88)((v, i)=>i % pl, (0, $a17f2cccfa5f5eb1$export$d02631cccf789723)(pgInstancesL), 0),
                    divisor: 1
                },
                buffer: buffer(pointsToGrid.index.buffer)
            } : pgBatch ? pgOrder === "splat-point" && // Splats-then-points, batches.
            ((c, p, b)=>(pointsToGrid.index ??= [])[b] ??= {
                    constant: $df94745e835b5ca5$var$floor(b / p.splats.size)
                }) : pgOrder === "splat-point" && // Splats-then-points, once, more data overall.
            buffer(pointsToGrid.index = (0, $a8bd34883e6c6917$export$871de8747c9eaa88)((v, i)=>$df94745e835b5ca5$var$floor(i / pgFormSourcesSplatsL), (0, $a17f2cccfa5f5eb1$export$d02631cccf789723)(pgInstancesSourceL), 0)),
            /** Index of each splat. */ splat: pgInstanced ? {
                ...pointsToGrid.splat = pgOrder === "splat-point" ? // Splats-then-points, more data overall.
                {
                    buffer: (0, $a8bd34883e6c6917$export$871de8747c9eaa88)((v, i)=>i % pgSplatsL, (0, $a17f2cccfa5f5eb1$export$d02631cccf789723)(pgInstancesL), 0),
                    divisor: 1
                } : {
                    buffer: (0, $a8bd34883e6c6917$export$871de8747c9eaa88)((v, i)=>i, (0, $a17f2cccfa5f5eb1$export$d02631cccf789723)(pgSplatsL), 0),
                    divisor: pl
                },
                buffer: buffer(pointsToGrid.splat.buffer)
            } : pgBatch ? pgOrder === "splat-point" && // Splats-then-points, batches, less data overall.
            ((c, p, b)=>(pointsToGrid.splat ??= [])[b] ??= {
                    constant: b % p.splats.size
                }) : pgOrder === "splat-point" && // Splats-then-points, once, more data overall.
            buffer(pointsToGrid.splat = (0, $a8bd34883e6c6917$export$871de8747c9eaa88)((v, i)=>i % pgFormSourcesSplatsL, (0, $a17f2cccfa5f5eb1$export$d02631cccf789723)(pgInstancesSourceL), 0))
        },
        uniforms: {
            ...pgLinkP.state.uniforms,
            ...pgLinkG.state.uniforms,
            stretch: (c, p)=>p.stretch,
            turn: (c, p)=>p.turn,
            bounds: (c, p)=>p.to.grid.bounds,
            rescaleMotion: (c, p)=>p.to.rescale.motion,
            rescaleMass: (c, p)=>p.to.rescale.mass,
            rescaleAffine: (c, p)=>p.to.rescale.affine,
            rescaleStress: (c, p)=>p.to.rescale.stress,
            // Test
            loop: (c, p)=>p.to.timer.loop
        },
        blend: {
            enable: (c, p)=>p.blend.enable,
            func: {
                srcRGB: (c, { blend: { func: { src: o, srcRGB: s } } })=>s ?? o,
                srcAlpha: (c, { blend: { func: { src: o, srcAlpha: s } } })=>s ?? o,
                dstRGB: (c, { blend: { func: { dst: o, dstRGB: s } } })=>s ?? o,
                dstAlpha: (c, { blend: { func: { dst: o, dstAlpha: s } } })=>s ?? o
            }
        },
        depth: {
            enable: (c, p)=>p.depth.enable
        },
        /** A form at a time; or all forms together. */ elements: !pgForm ? pointsToGrid.elements = null : elements(pointsToGrid.elements = pgInstanced || pgBatch ? pgForm : (0, $a8bd34883e6c6917$export$871de8747c9eaa88)((v, i)=>(0, $9afb1b0a564300b3$export$37b75d0026f96b8d)([], (0, $118b47bfc49fdb1b$export$4997ffc0176396a6)(i, pgForm), $df94745e835b5ca5$var$floor(i / pgFormsL) * pgFormSourcesL), (0, $a17f2cccfa5f5eb1$export$d02631cccf789723)(pgInstancesL * pgFormsL), 0)),
        count: (c, { instanced: instanced, batch: batch, size: { pointVertexes: pointVertexes, instances: instances } })=>pointVertexes * (instanced || batch ? 1 : instances),
        instances: (c, { instanced: i, size: s })=>i ? s.instances : 1,
        framebuffer: (c, { to: to, framebuffer: f = (0, $23462767626c8c72$export$d86e3abd7686c23f)(to.grid.gpgpu) })=>f?.framebuffer
    });
    /** @todo Draw to all the needed grid passes, framebuffer-per-splat. */ pointsToGrid.step = (state = pointsToGrid)=>{
        const s = state.onStep?.(state) ?? state;
        const { on: on, batch: b, pass: pass, size: size, to: to } = s;
        if (!on) return s;
        const { gpgpu: gGPGPU, fields: gf } = to.grid;
        let p = s;
        b && (0, $a17f2cccfa5f5eb1$export$d02631cccf789723)(p = s.batchStates ??= [], s, 0, p.length = size.instances);
        pass(p);
        gGPGPU.merge?.update?.(gGPGPU);
        return s;
    };
    /** Render to the screen. */ const screen = to.screen = {
        to: to,
        size: [
            1,
            1
        ],
        aspect: [
            1,
            1
        ],
        clears: {
            color: [
                0,
                0,
                0,
                0
            ],
            depth: 1
        },
        clear: (s = screen)=>clear(s.clears)
    };
    /** Render the grid to the screen. */ const gridToScreen = to.gridToScreen = {
        to: to,
        frag: (0, (/*@__PURE__*/$parcel$interopDefault($432370b25c6a4871$exports))),
        paceLinear: false,
        /** Squared or linear pace, picked by `paceLinear`. */ ranges: [
            // [0, 9e12],
            [
                0,
                1e10
            ],
            // [0, 9e6]
            [
                0,
                1e5
            ]
        ],
        /**
     * Squared or linear pace, picked by `paceLinear`.
     *
     * @see [Y-for-X in Pomax's guide](https://pomax.github.io/bezierinfo/#yforx)
     * @see [Finding Bézier roots and Newton-Raphson method in Pomax's guide](https://pomax.github.io/bezierinfo/#extremities)
     */ curves: [
            // [[0, 0], [0.2, 0.8], [1, 1], [1, 1]],
            (0, $a8bd34883e6c6917$export$871de8747c9eaa88)((v, i, a)=>(0, $a17f2cccfa5f5eb1$export$d02631cccf789723)(2, i / (a.length - 1)), (0, $a17f2cccfa5f5eb1$export$d02631cccf789723)(4), 0),
            // [[0, 0], [0.5, 0.2], [0.9, 0.9], [1, 1]]
            (0, $a8bd34883e6c6917$export$871de8747c9eaa88)((v, i, a)=>(0, $a17f2cccfa5f5eb1$export$d02631cccf789723)(2, i / (a.length - 1)), (0, $a17f2cccfa5f5eb1$export$d02631cccf789723)(4), 0)
        ],
        // colorHi: srgb('#0055ff55').buf,
        colorHi: [
            1,
            1,
            1,
            0.15
        ],
        colorLo: [
            0,
            0,
            0,
            0
        ],
        angleHSLA: (0, $6e6bff3bd160b642$export$8f4a7c0bb78e6ea8)("hsla(0deg, 80%, 70%, 0.5)").buf,
        // angleHSLA: [0, 0, 0, 0],
        on: true,
        ...to.gridToScreen
    };
    /** Inputs to map grid data correctly. */ const gsLinkG = $df94745e835b5ca5$export$bd2891254e1e5b30({
        ...$df94745e835b5ca5$export$9f9ef40fe2e7f9e0,
        /**
       * Draw all states with none bound as outputs.
       * @todo Errors without `merge`; why, if the framebuffer isn't bound?
       */ bound: +!gMerge,
        pre: gPre,
        steps: gSteps,
        merge: gMerge,
        macros: {
            output: 0
        },
        // maps: mapStep({ ...gMaps, ...linkFull.maps, derives: [[gMotionFull]] })
        maps: (0, $9ca80cadf3eaf758$export$798cdecdcbbf9755)({
            ...gMaps,
            ...$df94745e835b5ca5$export$9f9ef40fe2e7f9e0.maps,
            derives: [
                [
                    gMotionFull,
                    gMass
                ]
            ]
        })
    }, (c, p)=>p.to.grid.gpgpu);
    gridToScreen.link = {
        grid: gsLinkG
    };
    gridToScreen.pass = command(gridToScreen.pipeline = {
        vert: (c, { link: l, to: { head: h, grid: g } })=>h.glsl(h) + l.grid.macros + g.gpgpu.vert,
        frag: (c, { frag: f, link: l, to: { head: h }, angleHSLA: angleHSLA, paceLinear: paceLinear })=>h.glsl(h) + l.grid.macros + (angleHSLA?.[3] ? "#define angleHSLA angleHSLA\n\n" : "") + (paceLinear ? "#define paceLinear\n\n" : "") + f,
        attributes: {
            [gPre + "position"]: gGPGPU.positions
        },
        uniforms: {
            ...gsLinkG.state.uniforms,
            angleHSLA: (c, p)=>p.angleHSLA,
            range: (c, { ranges: rs, paceLinear: p })=>rs[+p],
            ...(0, $a0fef7c841dcaa76$export$533b26079ad0b4b)((to, _, i)=>{
                to[`curve[${i}]`] = (c, { curves: cs, paceLinear: p })=>cs[+p][i];
                return to;
            }, gridToScreen.curves[0], {}),
            colorHi: (c, p)=>p.colorHi,
            colorLo: (c, p)=>p.colorLo,
            aspect: (c, p)=>p.to.screen.aspect,
            rescaleMotion: (c, p)=>p.to.rescale.motion
        },
        /** @see [Premultiplied vs straight-alpha blending](https://limnu.com/webgl-blending-youre-probably-wrong/) */ blend: {
            enable: true,
            func: {
                src: 1,
                dst: "one minus src alpha"
            }
        },
        depth: {
            enable: false
        },
        count: gGPGPU.count,
        framebuffer: (c, p)=>p.framebuffer
    });
    gridToScreen.draw = (state = gridToScreen)=>{
        const s = state.onDraw?.(state) ?? state;
        const { on: on, pass: pass } = s;
        on && pass(s);
        return s;
    };
    /**
   * Render the points to the screen.
   *
   * @todo Set up a separate `gpgpu` with its own steps, to copy point position
   *   and/or advect from the grid while staying close to source point, to track
   *   many steps of state  without using loads of extra data.
   */ const pointsToScreen = to.pointsToScreen = {
        to: to,
        vert: (0, (/*@__PURE__*/$parcel$interopDefault($dd5fdb0d9b74b9e3$exports))),
        frag: (0, (/*@__PURE__*/$parcel$interopDefault($e361475d76f22da0$exports))),
        form: 1,
        // form: 2,
        // colorHi: srgb('#ff4400cc').buf,
        colorHi: [
            1,
            1,
            1,
            0.5
        ],
        // colorLo: srgb('#75000066').buf,
        colorLo: [
            0,
            0,
            0,
            0
        ],
        colorImage: null,
        colorBy: [
            0,
            0
        ],
        flip: [
            1,
            -1
        ],
        offset: [
            0,
            0,
            0,
            0
        ],
        aspectImage: [
            1,
            1
        ],
        useDiscard: false,
        lengthLinear: false,
        wideHi: [
            4e-3,
            4e-6
        ],
        // wideHi: [6e-3, 6e-6],
        // wideHi: [6e-2, 6e-4],
        // wideHi: [511, 255],
        // wideHi: [pointSizeDims[1], pointSizeDims[1]],
        wideLo: [
            2e-3,
            2e-6
        ],
        // wideLo: [2e-3, 2e-6],
        // wideLo: [2e-2, 2e-4],
        // wideLo: [1, 1e-1],
        // wideLo: [pointSizeDims[0], pointSizeDims[0]],
        widths: [
            ,
            pointSizeDims,
            lineWidthDims
        ],
        primitives: [
            ,
            "points",
            "lines"
        ],
        /** @see [Premultiplied vs straight-alpha blending](https://limnu.com/webgl-blending-youre-probably-wrong/) */ // blend: { enable: true, func: { src: 1, dst: 'one minus src alpha' } },
        blend: {
            enable: true,
            func: {
                src: 1,
                dst: 1
            }
        },
        depth: {
            enable: false
        },
        count: null,
        on: true,
        ...to.pointsToScreen
    };
    /** Inputs to map points data correctly. */ /**
   * Draw all states with none bound as outputs.
   *
   * @todo Errors without `merge`; why, if the framebuffer isn't bound?
   * @todo Lines don't work for 2 steps but work for 3.
   */ const psLinkPBound = +!pMerge;
    const psDrawSteps = pSteps - psLinkPBound;
    const psLinkP = $df94745e835b5ca5$export$bd2891254e1e5b30({
        ...$df94745e835b5ca5$export$9f9ef40fe2e7f9e0,
        bound: psLinkPBound,
        pre: pPre,
        steps: pSteps,
        merge: pMerge,
        macros: {
            output: 0
        },
        maps: (0, $9ca80cadf3eaf758$export$798cdecdcbbf9755)({
            ...pMaps,
            ...$df94745e835b5ca5$export$9f9ef40fe2e7f9e0.maps,
            derives: [
                [
                    pPosition,
                    pMass
                ]
            ]
        })
    }, (c, p)=>p.to.gridToPoints.gpgpu);
    pointsToScreen.link = {
        points: psLinkP
    };
    /** @todo Lines don't work for 2 steps but work for 3. */ const psCounts = pointsToScreen.counts = (0, $a8bd34883e6c6917$export$871de8747c9eaa88)((_, f)=>f && (0, $8d37ed4696fd96a4$export$2e2bcd8739ae039)(psDrawSteps, f, pl), (0, $a17f2cccfa5f5eb1$export$d02631cccf789723)(3), 0);
    pointsToScreen.pass = command(pointsToScreen.pipeline = {
        vert: (c, { vert: v, colorImage: ci, link: l, to: { head: h } })=>h.glsl(h) + (ci ? "#define colorImage colorImage\n\n" : "") + l.points.macros + v,
        frag: (c, { frag: f, link: link, to: { head: h }, useDiscard: useDiscard, lengthLinear: lengthLinear })=>h.glsl(h) + link.points.macros + (useDiscard ? "#define useDiscard\n\n" : "") + (lengthLinear ? "#define lengthLinear\n\n" : "") + f,
        primitive: (c, { form: f, primitives: ps })=>ps[f],
        attributes: {
            index: (0, $827d5157c38742eb$export$87ed20f81f3c66ff)($df94745e835b5ca5$var$max(...psCounts))
        },
        uniforms: {
            ...psLinkP.state.uniforms,
            form: (c, p)=>p.form,
            colorHi: (c, p)=>p.colorHi,
            colorLo: (c, p)=>p.colorLo,
            colorImage: (c, p)=>p.colorImage,
            colorBy: (c, p)=>p.colorBy,
            flip: (c, p)=>p.flip,
            offset: (c, p)=>p.offset,
            aspectImage: (c, p)=>p.aspectImage,
            wideHi: (c, { wideHi: wls, lengthLinear: l, widths: wfs, form: f, to: to })=>(0, $6fbc282bb2566ed8$export$7d15b64cf5a3a4c4)(wls[+l] * $df94745e835b5ca5$var$min(...to.screen.size), ...wfs[f]),
            wideLo: (c, { wideLo: wls, lengthLinear: l, widths: wfs, form: f, to: to })=>(0, $6fbc282bb2566ed8$export$7d15b64cf5a3a4c4)(wls[+l] * $df94745e835b5ca5$var$min(...to.screen.size), ...wfs[f]),
            widths: (c, { widths: wfs, form: f })=>wfs[f],
            size: (c, p)=>p.to.screen.size,
            aspectScreen: (c, p)=>p.to.screen.aspect,
            dt: (c, p)=>p.to.timer.dt,
            bounds: (c, p)=>p.to.grid.bounds,
            rescaleMass: (c, p)=>p.to.rescale.mass,
            rescalePosition: (c, p)=>p.to.rescale.position
        },
        lineWidth: (c, { wideHi: wls, lengthLinear: l, widths: wfs, to: to })=>(0, $6fbc282bb2566ed8$export$7d15b64cf5a3a4c4)(wls[+l] * $df94745e835b5ca5$var$min(...to.screen.size), ...wfs[2]),
        blend: {
            enable: (c, p)=>p.blend.enable,
            func: {
                srcRGB: (c, { blend: { func: { src: o, srcRGB: s } } })=>s ?? o,
                srcAlpha: (c, { blend: { func: { src: o, srcAlpha: s } } })=>s ?? o,
                dstRGB: (c, { blend: { func: { dst: o, dstRGB: s } } })=>s ?? o,
                dstAlpha: (c, { blend: { func: { dst: o, dstAlpha: s } } })=>s ?? o
            }
        },
        depth: {
            enable: (c, p)=>p.depth.enable
        },
        count: (_, { count: c, counts: cs, form: f })=>c ?? cs[f],
        framebuffer: (c, p)=>p.framebuffer
    });
    pointsToScreen.draw = (state = pointsToScreen)=>{
        const s = state.onDraw?.(state) ?? state;
        const { on: on, pass: pass } = s;
        on && pass(s);
        return s;
    };
    /** Which parts of a `pass` are used. */ to.uses = {
        /** Whether a `pass` ticks the `timer`. */ tick: true,
        /** Whether a `pass` clears the screen. */ clear: true,
        /** Whether a `pass` updates the data. */ update: true,
        /** Whether a `pass` draws to the screen. */ draw: true,
        /** Whether a `pass` runs any post-processes or cleanup. */ post: true,
        log: false,
        ...to.uses
    };
    /** How much a `pass` steps each `gpgpu` before the next links use them. */ to.linksBy ??= 1;
    // to.linksBy ??= 0;
    /** How many partial-time-step `pass`es to do per-`step` for accuracy. */ // to.passes ??= 1;
    // to.passes ??= 4;
    to.passes ??= 6;
    // to.passes ??= 9;
    to.passAt = 0;
    to.tick = (state = to)=>{
        const s = state.onTick?.(state) ?? state;
        const { uses: uses, timer: t } = s;
        if (!uses.tick) return s;
        const { time: time, period: p } = (0, $beb29002c2450874$export$9dc4ecf953986f04)(t);
        t.loop = $df94745e835b5ca5$var$abs((time + p) % (p * 2) - p);
        return s;
    };
    to.clear = (state = to)=>{
        const s = state.onClear?.(state) ?? state;
        const { uses: uses, screen: screen } = s;
        uses.clear && screen.clear(screen);
        return s;
    };
    const logData = (pre, suf, framebuffer)=>console.log("mpm:" + pre + ":" + suf, pre + "-" + framebuffer?._framebuffer?.id);
    to.update = (state = to)=>{
        const s = state.onUpdate?.(state) ?? state;
        const { uses: uses, pointsToGrid: pg, grid: g, gridToPoints: gp, linksBy: linksBy } = s;
        const { update: update, log: log } = uses;
        if (!update) return s;
        const { step: pgStep, pipeline: pgPipe } = pg;
        const { step: gStep, gpgpu: gGPGPU } = g;
        const { pipeline: gPipe, clear: gClear } = gGPGPU;
        const { step: gpStep, gpgpu: gpGPGPU } = gp;
        const { pipeline: gpPipe } = gpGPGPU;
        s.chaos = $df94745e835b5ca5$var$random();
        /** Clear the grid output, as `pointsToGrid` can use additive blending. */ gClear(gGPGPU);
        log && logData("g", "clear", (0, $23462767626c8c72$export$d86e3abd7686c23f)(gGPGPU)?.framebuffer);
        /** Update the data from points-to-grid. */ pgStep(pg);
        log && logData("pg", "step", pgPipe.framebuffer(0, pg));
        /** Update the data from grid-to-grid. */ gStep(g);
        log && logData("g", "step", gPipe.framebuffer(0, gGPGPU));
        /** Advance `stepNow` for any next linked steps. */ linksBy && gGPGPU.stepBy(gGPGPU, linksBy);
        log && logData("g", "stepBy", gPipe.framebuffer(0, gGPGPU));
        /** Update the data from grid-to-points. */ gpStep(gp);
        log && logData("gp", "step", gpPipe.framebuffer(0, gpGPGPU));
        /** Advance `stepNow` for any next linked steps. */ linksBy && gpGPGPU.stepBy(gpGPGPU, linksBy);
        log && logData("gp", "stepBy", gpPipe.framebuffer(0, gpGPGPU));
        return s;
    };
    /** @todo Move reset logic from grid-to-points shader to its own process. */ to.reset = (state = to)=>{
        const s = state.onReset?.(state) ?? state;
        const { gridToPoints: gp, update: update } = s;
        const { gpgpu: gpGPGPU } = gp;
        const c = gpGPGPU.clearPass;
        /** @todo Make this less awkward. */ gpGPGPU.clearPass ??= gp.clears;
        gp.clears = gpGPGPU.clear(gpGPGPU).clearPass;
        gpGPGPU.clearPass = c;
        update(s);
        return s;
    };
    to.draw = (state = to)=>{
        const s = state.onDraw?.(state) ?? state;
        const { uses: uses, gridToScreen: gridToScreen, pointsToScreen: pointsToScreen } = s;
        if (!uses.draw) return s;
        gridToScreen.draw(gridToScreen);
        pointsToScreen.draw(pointsToScreen);
        return s;
    };
    to.post = (state = to)=>{
        const s = state.onPost?.(state) ?? state;
        const { uses: uses, grid: grid, gridToPoints: gridToPoints, linksBy: linksBy } = s;
        if (!uses.post) return s;
        /** Reset `stepNow` for any next linked steps. */ if (linksBy) {
            const gGPGPU = grid.gpgpu;
            const gpGPGPU = gridToPoints.gpgpu;
            gGPGPU.stepBy(gGPGPU, -linksBy);
            gpGPGPU.stepBy(gpGPGPU, -linksBy);
        }
        return s;
    };
    to.pass = (state = to)=>{
        const s = state.onPass?.(state) ?? state;
        const { tick: tick, clear: clear, update: update, draw: draw, post: post, uses: { log: log } } = s;
        log && console.groupCollapsed("mpm:pass:" + Date.now());
        tick(s);
        clear(s);
        update(s);
        draw(s);
        post(s);
        log && console.groupEnd();
        return s;
    };
    to.step = (state = to)=>{
        const s = state.onStep?.(state) ?? state;
        const { passes: passes, pass: pass, timer: timer, tick: tick, clear: clear, update: update, draw: draw, post: post, uses: uses } = s;
        if (passes === 1) return pass(s);
        const { log: log } = uses;
        const { time: t0 } = timer;
        const { time: t1, dt: dt } = tick(s).timer;
        const dtp = timer.dt = dt / passes;
        log && console.groupCollapsed("mpm:step:" + Date.now());
        // Data passes, no draw, sub-steps.
        timer.time = t0;
        clear(s);
        for(s.passAt = 0; s.passAt < passes; ++s.passAt){
            timer.time += dtp;
            update(s);
        }
        // Draw pass, no data, full-step.
        timer.time = t1;
        timer.dt = dt;
        s.passAt = 0;
        draw(s);
        post(s);
        log && console.groupEnd();
        return s;
    };
    to.frame = ()=>to.step();
    return to;
}
var $df94745e835b5ca5$export$2e2bcd8739ae039 = $df94745e835b5ca5$export$48f580ce092b95a;


var $c3b1ed7d8eda40f0$exports = {};
$c3b1ed7d8eda40f0$exports = "/** Grid-fade fragment shader. */\n\nprecision highp float;\n#define GLSLIFY 1\n\n#if defined(gridFade_output_fade)\n  #define typeHash 0\n  #define typeGauss 1\n\n  #ifndef type\n    #define type typeHash\n  #endif\n\n  #if type == typeGauss\n    #define qualityTap5 0\n    #define qualityTap9 1\n    #define qualityTap13 2\n\n    #ifndef quality\n      #define quality qualityTap5\n    #endif\n  #elif !defined(quality)\n    #define quality 3\n  #endif\n\n  gridFade_useSamples\n  gridFade_useReads_fade\n\n  #ifdef gridFade_splits\n    uniform sampler2D gridFade_states[gridFade_splits];\n  #else\n    uniform sampler2D gridFade_states;\n  #endif\n\n  uniform float gridFade_stepNow;\n  uniform vec4 gridFade_stateShape;\n\n  uniform float fade;\n  uniform float expose;\n  uniform float scale;\n\n  uniform vec4 colorLo;\n  uniform float dt;\n\n  #if type == typeHash\n    uniform float chaos;\n  #endif\n\n  varying vec2 gridFade_uv;\n\n  #if type == typeGauss\n    const vec2 axis = vec2(1, 0);\n    const float passes = 2.0;\n  #else\n    const float passes = 1.0;\n  #endif\n\n  #if type == typeGauss\n    #if quality > qualityTap9\n      vec4 blur13(sampler2D image, vec2 uv, vec2 resolution, vec2 direction) {\n  vec4 color = vec4(0.0);\n  vec2 off1 = vec2(1.411764705882353) * direction;\n  vec2 off2 = vec2(3.2941176470588234) * direction;\n  vec2 off3 = vec2(5.176470588235294) * direction;\n  color += texture2D(image, uv) * 0.1964825501511404;\n  color += texture2D(image, uv + (off1 / resolution)) * 0.2969069646728344;\n  color += texture2D(image, uv - (off1 / resolution)) * 0.2969069646728344;\n  color += texture2D(image, uv + (off2 / resolution)) * 0.09447039785044732;\n  color += texture2D(image, uv - (off2 / resolution)) * 0.09447039785044732;\n  color += texture2D(image, uv + (off3 / resolution)) * 0.010381362401148057;\n  color += texture2D(image, uv - (off3 / resolution)) * 0.010381362401148057;\n  return color;\n}\n\n    #elif quality > qualityTap5\n      vec4 blur9(sampler2D image, vec2 uv, vec2 resolution, vec2 direction) {\n  vec4 color = vec4(0.0);\n  vec2 off1 = vec2(1.3846153846) * direction;\n  vec2 off2 = vec2(3.2307692308) * direction;\n  color += texture2D(image, uv) * 0.2270270270;\n  color += texture2D(image, uv + (off1 / resolution)) * 0.3162162162;\n  color += texture2D(image, uv - (off1 / resolution)) * 0.3162162162;\n  color += texture2D(image, uv + (off2 / resolution)) * 0.0702702703;\n  color += texture2D(image, uv - (off2 / resolution)) * 0.0702702703;\n  return color;\n}\n\n    #elif quality > qualityHash\n      vec4 blur5(sampler2D image, vec2 uv, vec2 resolution, vec2 direction) {\n  vec4 color = vec4(0.0);\n  vec2 off1 = vec2(1.3333333333333333) * direction;\n  color += texture2D(image, uv) * 0.29411764705882354;\n  color += texture2D(image, uv + (off1 / resolution)) * 0.35294117647058826;\n  color += texture2D(image, uv - (off1 / resolution)) * 0.35294117647058826;\n  return color; \n}\n\n    #endif\n  #else\n    vec4 sampleFade(vec2 uv) {\n      gridFade_tapState(uv);\n\n      return gridFade_data[gridFade_reads_fade_fade].gridFade_channels_fade;\n    }\n\n    vec3 sampleHash(vec2 uv) { return sampleFade(uv).rgb; }\n\n    highp float random(vec2 co)\n{\n    highp float a = 12.9898;\n    highp float b = 78.233;\n    highp float c = 43758.5453;\n    highp float dt= dot(co.xy ,vec2(a,b));\n    highp float sn= mod(dt,3.14);\n    return fract(sin(sn) * c);\n}\n\n#ifndef TAU\n  #define TAU 6.28318530718\n#endif\n\n//Use last part of hash function to generate new random radius and angle\nvec2 mult(inout vec2 r) {\n  r = fract(r * vec2(12.9898,78.233));\n  return sqrt(r.x + .001) * vec2(sin(r.y * TAU), cos(r.y * TAU));\n}\n\nvec3 blur(vec2 uv, float radius, float aspect, float offset) {\n  vec2 circle = vec2(radius);\n  circle.x *= aspect;\n  vec2 rnd = vec2(random(vec2(uv + offset)));\n\n  vec3 acc = vec3(0.0);\n  for (int i = 0; i < quality; i++) {\n    acc += sampleHash(uv + circle * mult(rnd)).xyz;\n  }\n  return acc / float(quality);\n}\n\nvec3 blur(vec2 uv, float radius, float aspect) {\n  return blur(uv, radius, aspect, 0.0);\n}\n\nvec3 blur(vec2 uv, float radius) {\n  return blur(uv, radius, 1.0);\n}\n\n  #endif\n\n  float when_eq_2281831123(float x, float y) {\n  return 1.0 - abs(sign(x - y));\n}\n\nvec2 when_eq_2281831123(vec2 x, vec2 y) {\n  return 1.0 - abs(sign(x - y));\n}\n\nvec3 when_eq_2281831123(vec3 x, vec3 y) {\n  return 1.0 - abs(sign(x - y));\n}\n\nvec4 when_eq_2281831123(vec4 x, vec4 y) {\n  return 1.0 - abs(sign(x - y));\n}\n\n#endif\n\nvoid main() {\n  #if defined(gridFade_output_fade)\n    float end = when_eq_2281831123(fract(gridFade_stepNow/passes), 0.0);\n\n    #if type == typeGauss\n      vec4 to = blur(gridFade_states[0], gridFade_uv, gridFade_stateShape.xy,\n        mix(axis.xy, axis.yx, end)*scale);\n    #else\n      float radius = scale/max(gridFade_stateShape.x, gridFade_stateShape.y);\n      float aspect = gridFade_stateShape.x/gridFade_stateShape.y;\n\n      vec4 to = vec4(blur(gridFade_uv, radius, aspect, chaos),\n        /** @todo Can this extra tap be removed? */\n        sampleFade(gridFade_uv).a);\n    #endif\n\n    gridFade_output_fade =\n      mix(to, mix(to*(1.0+(expose*dt)), colorLo, fade*dt), end);\n  #endif\n}\n";


var $5c5fcc32979e89e5$exports = {};
$5c5fcc32979e89e5$exports = "/** Grid-fade-to-screen fragment shader. */\n\nprecision highp float;\n#define GLSLIFY 1\n\ngridFade_useSamples\ngridFade_useReads_fade\n\n#ifdef gridFade_splits\n  uniform sampler2D gridFade_states[gridFade_splits];\n#else\n  uniform sampler2D gridFade_states;\n#endif\n\nuniform float gridFade_stepNow;\nuniform vec4 gridFade_stateShape;\n\nvarying vec2 gridFade_uv;\n\n/**\n * Convenience to sample entries safely at their texel center.\n * Where `spreadUV` is for lookup ranges, `offsetUV` is for lookup queries.\n *\n * @see [`spreadUV`](./spread-uv.glsl)\n *\n * @param {vec2} `uv` UV texture sample coordinate, expect range `[0, 1]`.\n * @param {float|int|vec2|ivec2} `[size=1.0]` Texture's size, expect\n *   `[width, height]`, or if given a scalar interpret both as `side`.\n * @param {float|vec2} `[pad=0.5]` Texel `pad` to offset, expect range `[0, 1]`.\n *\n * @returns {vec2} The `uv` offset by `pad` to texel center, expect range\n *   `[0+pad, 1-pad]`.\n */\n\nvec2 offsetUV(vec2 uv, float size, float pad) {\n  return ((uv*(size-1.0))+pad)/size;\n}\n\nvec2 offsetUV(vec2 uv, vec2 size, float pad) {\n  return ((uv*(size-1.0))+pad)/size;\n}\n\nvec2 offsetUV(vec2 uv, vec2 size, vec2 pad) {\n  return ((uv*(size-1.0))+pad)/size;\n}\n\nvec2 offsetUV(vec2 uv, int size, float pad) {\n  return offsetUV(uv, float(size), pad);\n}\n\nvec2 offsetUV(vec2 uv, ivec2 size, float pad) {\n  return offsetUV(uv, vec2(size), pad);\n}\n\nvec2 offsetUV(vec2 uv, ivec2 size, vec2 pad) {\n  return offsetUV(uv, vec2(size), pad);\n}\n\nvec2 offsetUV(vec2 uv, float size) { return offsetUV(uv, size, 0.5); }\nvec2 offsetUV(vec2 uv, vec2 size) { return offsetUV(uv, size, 0.5); }\nvec2 offsetUV(vec2 uv, int size) { return offsetUV(uv, size, 0.5); }\nvec2 offsetUV(vec2 uv, ivec2 size) { return offsetUV(uv, size, 0.5); }\nvec2 offsetUV(vec2 uv) { return offsetUV(uv, 1.0, 0.5); }\n\nvoid main() {\n  vec2 uv = offsetUV(gridFade_uv, gridFade_stateShape.xy);\n  // vec2 uv = gridFade_uv;\n\n  gridFade_tapState(uv);\n\n  vec4 to = gridFade_data[gridFade_reads_fade_fade].gridFade_channels_fade;\n\n  gl_FragColor = to;\n  gl_FragColor.rgb *= gl_FragColor.a;\n}\n";


var $a0aeabc1108c89a7$exports = {};
$a0aeabc1108c89a7$exports = "/** Optical-flow fragment shader. */\n\nprecision highp float;\n#define GLSLIFY 1\n\nuniform sampler2D next;\nuniform sampler2D past;\nuniform float gap;\nuniform float lambda;\nuniform float alpha;\nuniform vec2 flip;\nuniform vec4 offset;\nuniform vec2 frameAspect;\nuniform vec2 screenAspect;\n\nvarying vec2 opticalFlow_uv;\n\nfloat when_gt_1540259130(float x, float y) {\n  return max(sign(x - y), 0.0);\n}\n\nvec2 when_gt_1540259130(vec2 x, vec2 y) {\n  return max(sign(x - y), 0.0);\n}\n\nvec3 when_gt_1540259130(vec3 x, vec3 y) {\n  return max(sign(x - y), 0.0);\n}\n\nvec4 when_gt_1540259130(vec4 x, vec4 y) {\n  return max(sign(x - y), 0.0);\n}\n\nfloat when_le_2281831123(float x, float y) {\n  return 1.0 - when_gt_1540259130(x, y);\n}\n\nvec2 when_le_2281831123(vec2 x, vec2 y) {\n  return 1.0 - when_gt_1540259130(x, y);\n}\n\nvec3 when_le_2281831123(vec3 x, vec3 y) {\n  return 1.0 - when_gt_1540259130(x, y);\n}\n\nvec4 when_le_2281831123(vec4 x, vec4 y) {\n  return 1.0 - when_gt_1540259130(x, y);\n}\n\n/**\n * Optical flow GLSL module.\n * May work best if the views are pre-processed (e.g: blur).\n *\n * @see https://forum.openframeworks.cc/t/ofxflowtools-optical-flow-fluid-dynamics-and-particles-in-glsl/15470\n * @see https://github.com/moostrik/ofxFlowTools\n * @see https://github.com/diwi/PixelFlow\n * @see http://thomasdiewald.com/blog/?p=2766\n * @see https://adamferriss.com/gush/\n * @see https://github.com/princemio/ofxMIOFlowGLSL/blob/master/src/FlowShader.cpp\n */\n\n#define opticalFlowPixel_extern 0\n#define opticalFlowPixel_normal 1\n#define opticalFlowPixel_luma 2\n#ifndef opticalFlowPixel\n  #define opticalFlowPixel opticalFlowPixel_luma\n#endif\n\n#if opticalFlowPixel == opticalFlowPixel_luma\n  float luma(vec3 color) {\n  return dot(color, vec3(0.299, 0.587, 0.114));\n}\n\nfloat luma(vec4 color) {\n  return dot(color.rgb, vec3(0.299, 0.587, 0.114));\n}\n\n  vec4 pixel(sampler2D texture, vec2 uv) {\n    vec4 color = texture2D(texture, uv);\n\n    return vec4(vec3(luma(color)), color.a);\n  }\n#elif opticalFlowPixel == opticalFlowPixel_normal\n  vec4 pixel(sampler2D texture, vec2 uv) { return texture2D(texture, uv); }\n#else\n  // To provide external `pixel` lookup function.\n  vec4 pixel(sampler2D texture, vec2 uv);\n#endif\n\n// @todo Sample mimaps at different LODs/scales to capture wider features.\nvec2 opticalFlow(in vec2 uv, in sampler2D next, in sampler2D past,\n    in float offset, in float lambda) {\n  vec2 off = vec2(offset, 0.0);\n\n  vec4 gradX = (pixel(next, uv+off.xy)-pixel(next, uv-off.xy))+\n    (pixel(past, uv+off.xy)-pixel(past, uv-off.xy));\n\n  vec4 gradY = (pixel(next, uv+off.yx)-pixel(next, uv-off.yx))+\n    (pixel(past, uv+off.yx)-pixel(past, uv-off.yx));\n\n  vec4 gradMag = sqrt((gradX*gradX)+(gradY*gradY)+vec4(lambda));\n\n  vec4 diff = pixel(next, uv)-pixel(past, uv);\n\n  return vec2((diff*(gradX/gradMag)).x, (diff*(gradY/gradMag)).x);\n}\n\nvec2 opticalFlow(in vec2 uv, in sampler2D views[2], in float offset,\n    in float lambda) {\n  return opticalFlow(uv, views[0], views[1], offset, lambda);\n}\n\n// Implementations for each dimension.\n\nfloat aspect(in float size, in float scale) {\n    return scale/size;\n}\n\nvec2 aspect(in vec2 size, in vec2 scale) {\n    return scale/size;\n}\n\nvec3 aspect(in vec3 size, in vec3 scale) {\n    return scale/size;\n}\n\nvec4 aspect(in vec4 size, in vec4 scale) {\n    return scale/size;\n}\n\n// These are for `scale` always `float`:\n\nvec2 aspect(in vec2 size, in float scale) {\n    return aspect(size, vec2(scale));\n}\n\nvec3 aspect(in vec3 size, in float scale) {\n    return aspect(size, vec3(scale));\n}\n\nvec4 aspect(in vec4 size, in float scale) {\n    return aspect(size, vec4(scale));\n}\n\nvec2 aspectCover(in vec2 size) {\n    return aspect(size, min(size.x, size.y));\n}\n\nvec3 aspectCover(in vec3 size) {\n    return aspect(size, min(size.x, min(size.y, size.z)));\n}\n\nvec4 aspectCover(in vec4 size) {\n    return aspect(size, min(size.x, min(size.y, min(size.z, size.w))));\n}\n\nconst vec2 v1 = vec2(1);\nconst vec2 v0 = v1*0.0;\n\nvoid main() {\n  vec2 scale = screenAspect*aspectCover(screenAspect/frameAspect);\n  vec2 shift = (screenAspect-scale)*0.5;\n  vec2 uv = clamp((opticalFlow_uv/offset.zw)-offset.xy, v0, v1);\n  vec2 st = fract(uv*flip);\n\n  gl_FragColor.xy =\n    opticalFlow(((st*scale)+shift)/screenAspect, next, past, gap, lambda);\n}\n";


var $4e3a9d42358121f5$exports = {};
$4e3a9d42358121f5$exports = "/**\n * Optical-flow-to-grid fragment shader.\n *\n * @todo Center the flow and cover the grid/screen.\n */\n\n#ifdef GL_EXT_draw_buffers\n  #extension GL_EXT_draw_buffers : require\n#endif\n\nprecision highp float;\n#define GLSLIFY 1\n\n#if defined(grid_output_motionFull)\n  uniform vec2 rescaleFlow;\n  uniform sampler2D opticalFlow;\n  uniform float dt;\n\n  #ifdef rescale_motion\n    uniform vec2 rescaleMotion;\n  #else\n    const float rescaledMotion = 1.0;\n  #endif\n#endif\n\nvarying vec2 opticalFlowToGrid_uv;\n\n#ifdef grid_output_motionFull\n  /** Exponential notation packed into a vector. */\nfloat exponent(vec2 basePower) { return basePower.s*pow(1e1, basePower.t); }\n\n#endif\n\nvoid main() {\n  #ifdef grid_output_motionFull\n    #ifdef rescale_motion\n      float rescaledMotion = exponent(rescaleMotion);\n    #endif\n\n    float rescaledFlow = exponent(rescaleFlow);\n    vec2 flow = dt*texture2D(opticalFlow, opticalFlowToGrid_uv).xy*rescaledFlow;\n\n    grid_output_motionFull = flow/rescaledMotion;\n  #endif\n}\n";


const { min: $43221ea9397f6332$var$min, max: $43221ea9397f6332$var$max, sign: $43221ea9397f6332$var$sign, log2: $43221ea9397f6332$var$log2 } = Math;
const { isFinite: $43221ea9397f6332$var$isFinite, isInteger: $43221ea9397f6332$var$isInteger } = Number;
const { assign: $43221ea9397f6332$var$assign } = Object;
const { parse: $43221ea9397f6332$var$parse } = JSON;
const { createObjectURL: $43221ea9397f6332$var$createObjectURL } = URL;
const $43221ea9397f6332$var$_ = undefined;
const $43221ea9397f6332$var$screenPositions = (0, $c3a4c4b89537eec0$export$cfdc3a7c4cb854c6)();
const $43221ea9397f6332$export$dce0f7906c5e6747 = (size, fit, invert, to = [])=>{
    const [x, y] = size;
    const side = fit(x, y);
    side ? (0, $4d9e51907a8688c0$export$c8a0e366d15bb712)(to, size, side) : (0, $7b6dab4ddb729928$export$dcfbb7940cfb3a48)(to, 1, 1);
    return invert ? (0, $9864db8839f9aff0$export$eb08a4e6e8934de4)(to, to) : to;
};
function $43221ea9397f6332$export$f40320abe5266d8b(to = location.search) {
    const q = new URLSearchParams(to);
    return (to = q.get("query")) ? $43221ea9397f6332$export$f40320abe5266d8b(to) : q;
}
const $43221ea9397f6332$export$cf13531c653ea47b = (at, alt, q = $43221ea9397f6332$export$f40320abe5266d8b())=>q.get(at) || alt;
const $43221ea9397f6332$export$e4c26796fa37df17 = (at, alt, q)=>parseFloat($43221ea9397f6332$export$cf13531c653ea47b(at, alt, q), 10);
function $43221ea9397f6332$export$4ed14f056d634df7(at, alt, q) {
    const s = $43221ea9397f6332$export$cf13531c653ea47b(at, alt, q);
    return s === "true" || s !== "false" && alt;
}
const $43221ea9397f6332$export$62c0e5826d412260 = (l, at, alt, to = (0, $a17f2cccfa5f5eb1$export$d02631cccf789723)(l), q)=>(0, $a0fef7c841dcaa76$export$533b26079ad0b4b)((to, _, i)=>{
        const n = $43221ea9397f6332$export$e4c26796fa37df17(`${at}[${i}]`, alt?.[i], q);
        $43221ea9397f6332$var$isFinite(n) ? to[i] = n : to[i] === undefined && delete to[i];
        return to;
    }, to, to);
const $43221ea9397f6332$export$e42b9bfa6349b9e2 = (at, alt, q)=>(0, $a8bd34883e6c6917$export$871de8747c9eaa88)((v)=>parseFloat(v, 10), parseFloat($43221ea9397f6332$export$cf13531c653ea47b(at, alt, q), 10).toExponential().split("e"), 0);
function $43221ea9397f6332$export$4ffb24a4cbf3cb1f(at, alt, parse = (0, $071d5807df0edd8c$export$f772f42bf67d946c), to, q) {
    const s = $43221ea9397f6332$export$cf13531c653ea47b(at, alt, q);
    const c = parse((s[0] !== "#" && s.indexOf("(") < 0 ? "#" : "") + s).buf;
    return to ? $43221ea9397f6332$var$assign(to, c) : c;
}
const $43221ea9397f6332$export$8069d817115baadd = (q = $43221ea9397f6332$export$f40320abe5266d8b(), at = "")=>({
        pixelRatio: $43221ea9397f6332$export$e4c26796fa37df17(at + "pixelRatio", $43221ea9397f6332$var$max(devicePixelRatio, 1) || 1, q),
        timer: {
            step: $43221ea9397f6332$export$e4c26796fa37df17(at + "timer.step", 1e3 / 30, q)
        },
        g: $43221ea9397f6332$export$62c0e5826d412260(3, at + "g", $43221ea9397f6332$var$_, $43221ea9397f6332$var$_, q),
        pointsToGrid: {
            on: $43221ea9397f6332$export$4ed14f056d634df7(at + "pointsToGrid.on", true, q),
            quads: $43221ea9397f6332$export$4ed14f056d634df7(at + "pointsToGrid.quads", $43221ea9397f6332$var$_, q),
            instanced: $43221ea9397f6332$export$4ed14f056d634df7(at + "pointsToGrid.instanced", $43221ea9397f6332$var$_, q),
            batch: $43221ea9397f6332$export$4ed14f056d634df7(at + "pointsToGrid.batch", $43221ea9397f6332$var$_, q),
            order: $43221ea9397f6332$export$cf13531c653ea47b(at + "pointsToGrid.order", $43221ea9397f6332$var$_, q)
        },
        grid: {
            on: $43221ea9397f6332$export$4ed14f056d634df7(at + "grid.on", true, q),
            detail: $43221ea9397f6332$export$e4c26796fa37df17(at + "grid.detail", 90, q),
            limit: $43221ea9397f6332$export$e4c26796fa37df17(at + "grid.limit", 1e9, q),
            bounds: $43221ea9397f6332$export$62c0e5826d412260(4, at + "grid.bounds", [
                -1,
                -1,
                1,
                1
            ], $43221ea9397f6332$var$_, q),
            boundsIn: $43221ea9397f6332$export$62c0e5826d412260(4, at + "grid.boundsIn", [
                1,
                1,
                -1,
                -1
            ], $43221ea9397f6332$var$_, q),
            boundsHit: $43221ea9397f6332$export$e4c26796fa37df17(at + "grid.boundsHit", 1, q)
        },
        gridToPoints: {
            on: $43221ea9397f6332$export$4ed14f056d634df7(at + "gridToPoints.on", true, q),
            gpgpu: {
                scale: $43221ea9397f6332$export$e4c26796fa37df17(at + "gridToPoints.gpgpu.scale", 9, q),
                steps: $43221ea9397f6332$export$e4c26796fa37df17(at + "gridToPoints.gpgpu.steps", 2, q)
            },
            mass: $43221ea9397f6332$export$e4c26796fa37df17(at + "gridToPoints.mass", 1, q),
            volume: $43221ea9397f6332$export$e4c26796fa37df17(at + "gridToPoints.volume", 5e-4, q),
            volumeSplit: $43221ea9397f6332$export$62c0e5826d412260(2, at + "gridToPoints.volumeSplit", [
                1e-6,
                -0.001
            ], $43221ea9397f6332$var$_, q),
            motionAdjust: $43221ea9397f6332$export$e4c26796fa37df17(at + "gridToPoints.motionAdjust", 0.97, q),
            positionAdjusts: $43221ea9397f6332$export$62c0e5826d412260(2, at + "gridToPoints.positionAdjusts", [
                0,
                1
            ], $43221ea9397f6332$var$_, q),
            wander: $43221ea9397f6332$export$62c0e5826d412260(3, at + "gridToPoints.wander", [
                -0.00001,
                1e-2,
                1e-6
            ], $43221ea9397f6332$var$_, q),
            spawnOn: {
                any: $43221ea9397f6332$export$4ed14f056d634df7(at + "gridToPoints.spawnOn.any", true, q),
                out: $43221ea9397f6332$export$4ed14f056d634df7(at + "gridToPoints.spawnOn.out", true, q),
                slow: $43221ea9397f6332$export$4ed14f056d634df7(at + "gridToPoints.spawnOn.slow", false, q),
                centre: $43221ea9397f6332$export$e4c26796fa37df17(at + "gridToPoints.spawnOn.centre", 0, q)
            },
            speedClamp: $43221ea9397f6332$export$e4c26796fa37df17(at + "gridToPoints.speedClamp", 1e9, $43221ea9397f6332$var$_, q),
            boundsClamp: $43221ea9397f6332$export$4ed14f056d634df7(at + "gridToPoints.boundsClamp", true, q)
        },
        gridToScreen: {
            on: $43221ea9397f6332$export$4ed14f056d634df7(at + "gridToScreen.on", true, q),
            colorHi: $43221ea9397f6332$export$4ffb24a4cbf3cb1f(at + "gridToScreen.colorHi", "#000b", $43221ea9397f6332$var$_, $43221ea9397f6332$var$_, q),
            colorLo: $43221ea9397f6332$export$4ffb24a4cbf3cb1f(at + "gridToScreen.colorLo", "#0000", $43221ea9397f6332$var$_, $43221ea9397f6332$var$_, q),
            angleHSLA: $43221ea9397f6332$export$4ffb24a4cbf3cb1f(at + "gridToScreen.angleHSLA", "hsla(0deg 50% 50% / 0.2)", (0, $6e6bff3bd160b642$export$8f4a7c0bb78e6ea8), $43221ea9397f6332$var$_, q)
        },
        pointsToScreen: {
            on: $43221ea9397f6332$export$4ed14f056d634df7(at + "pointsToScreen.on", true, q),
            colorHi: $43221ea9397f6332$export$4ffb24a4cbf3cb1f(at + "pointsToScreen.colorHi", "#f847", $43221ea9397f6332$var$_, $43221ea9397f6332$var$_, q),
            colorLo: $43221ea9397f6332$export$4ffb24a4cbf3cb1f(at + "pointsToScreen.colorLo", "#0000", $43221ea9397f6332$var$_, $43221ea9397f6332$var$_, q),
            form: $43221ea9397f6332$export$e4c26796fa37df17(at + "pointsToScreen.form", 1, q)
        },
        demo: {
            fps: $43221ea9397f6332$export$4ed14f056d634df7(at + "demo.fps", $43221ea9397f6332$var$_, q),
            opticalFlow: {
                on: $43221ea9397f6332$export$4ed14f056d634df7(at + "demo.opticalFlow.on", true, q),
                media: (()=>{
                    const to = {};
                    const vq = at + "demo.opticalFlow.media.video";
                    const v = $43221ea9397f6332$export$cf13531c653ea47b(vq, $43221ea9397f6332$var$_, q);
                    const y = v === "true";
                    if (y || v === "false") {
                        to.video = y;
                        return to;
                    }
                    let size;
                    const vw = $43221ea9397f6332$export$e4c26796fa37df17(vq + ".width", $43221ea9397f6332$var$_, q);
                    const vh = $43221ea9397f6332$export$e4c26796fa37df17(vq + ".height", $43221ea9397f6332$var$_, q);
                    $43221ea9397f6332$var$isInteger(vw) && ((size ??= to.video = {}).width = vw);
                    $43221ea9397f6332$var$isInteger(vh) && ((size ??= to.video = {}).height = vh);
                    return to;
                })(),
                $root: (()=>{
                    const r = $43221ea9397f6332$export$4ed14f056d634df7(at + "demo.opticalFlow.$root", $43221ea9397f6332$var$_, q);
                    return r === true ? document.body : r && document.querySelector(r);
                })(),
                flip: $43221ea9397f6332$export$62c0e5826d412260(2, at + "demo.opticalFlow.flip", [
                    -1,
                    -1
                ], $43221ea9397f6332$var$_, q),
                offset: $43221ea9397f6332$export$62c0e5826d412260(4, at + "demo.opticalFlow.offset", [
                    0,
                    0,
                    1,
                    1
                ], $43221ea9397f6332$var$_, q)
            },
            opticalFlowToGrid: {
                rescaleFlow: $43221ea9397f6332$export$62c0e5826d412260(2, at + "demo.opticalFlowToGrid.rescaleFlow", [
                    2,
                    5
                ], $43221ea9397f6332$var$_, q)
            },
            gridFade: {
                on: $43221ea9397f6332$export$4ed14f056d634df7(at + "demo.gridFade.on", true, q),
                fade: $43221ea9397f6332$export$e4c26796fa37df17(at + "demo.gridFade.fade", 2e-3, q)
            }
        },
        passes: $43221ea9397f6332$export$e4c26796fa37df17(at + "passes", 2, q)
    });
async function $43221ea9397f6332$export$13fba5ef04f03938(to) {
    // Set up GL.
    const { $canvas: $canvas, pixelRatio: pixelRatio = devicePixelRatio } = to;
    const api = to.api = (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c16566b9f761$exports)))({
        canvas: $canvas,
        pixelRatio: pixelRatio,
        extensions: (0, $df94745e835b5ca5$export$cc3e2d3244e01b7f)(),
        optionalExtensions: (0, $df94745e835b5ca5$export$918e5821fc7288cd)(),
        ...to.api
    });
    const { command: command = api, frame: frame, texture: texture, buffer: buffer, framebuffer: framebuffer, clear: clear } = api;
    (0, $df94745e835b5ca5$export$1c8f61c1db5300d2)(to, ()=>(0, $df94745e835b5ca5$export$48f580ce092b95a)(api, to));
    const { grid: grid, gridToScreen: gridToScreen, pointsToScreen: pointsToScreen } = to;
    const { fields: { index: gIndex }, gpgpu: gGPGPU } = grid;
    const { pre: gPre, size: gSize, merge: gMerge, maps: gMaps } = gGPGPU;
    const demo = to.demo = {
        to: to,
        ...to.demo
    };
    /** Optical-flow interaction process. */ const ofPre = "opticalFlow_";
    const opticalFlowVert = (0, $c3a4c4b89537eec0$export$dc207adda608f979).replaceAll((0, $c3a4c4b89537eec0$export$b4781c2237bde956), ofPre);
    const ofFlipStyle = [
        1,
        -1
    ];
    const opticalFlow = demo.opticalFlow = {
        to: to,
        vert: opticalFlowVert,
        frag: (0, (/*@__PURE__*/$parcel$interopDefault($a0aeabc1108c89a7$exports))),
        count: (0, $c3a4c4b89537eec0$export$832d88422d279bbc),
        gap: 3,
        lambda: 1e-3,
        alpha: 1e2,
        flip: [
            -1,
            -1
        ],
        aspect: [
            1,
            1
        ],
        size: [
            0,
            0
        ],
        offset: [
            0,
            0,
            1,
            1
        ],
        at: 0,
        $root: null,
        on: true,
        ...demo.opticalFlow,
        media: {
            facingMode: "user",
            video: true,
            ...demo.opticalFlow?.media
        },
        input: {
            data: document.createElement("video"),
            min: "linear",
            mag: "linear",
            ...demo.opticalFlow?.input
        },
        frames: (0, $a8bd34883e6c6917$export$871de8747c9eaa88)(()=>texture(), (0, $a17f2cccfa5f5eb1$export$d02631cccf789723)(2), 0),
        /** Overwrite blend, don't look up past values, just set new values. */ blend: {
            enable: true,
            func: {
                src: 1,
                dst: 0
            }
        },
        depth: {
            enable: false
        },
        framebuffer: framebuffer({
            colorType: "float",
            depth: false,
            stencil: false
        })
    };
    opticalFlow.pass = command(opticalFlow.pipeline = {
        vert: (c, p)=>p.vert,
        frag: (c, p)=>p.frag,
        attributes: {
            opticalFlow_position: buffer($43221ea9397f6332$var$screenPositions)
        },
        uniforms: {
            next: (c, { frames: fs, at: at })=>(0, $118b47bfc49fdb1b$export$4997ffc0176396a6)(at, fs),
            past: (c, { frames: fs, at: at })=>(0, $118b47bfc49fdb1b$export$4997ffc0176396a6)(at + 1, fs),
            gap: (c, p)=>p.gap,
            lambda: (c, p)=>p.lambda,
            alpha: (c, p)=>p.alpha,
            flip: (c, p)=>p.flip,
            offset: (c, p)=>p.offset,
            frameAspect: (c, p)=>p.aspect,
            screenAspect: (c, p)=>p.to.screen.aspect
        },
        blend: {
            enable: (c, p)=>p.blend.enable,
            func: {
                srcRGB: (c, { blend: { func: { src: o, srcRGB: s } } })=>s ?? o,
                srcAlpha: (c, { blend: { func: { src: o, srcAlpha: s } } })=>s ?? o,
                dstRGB: (c, { blend: { func: { dst: o, dstRGB: s } } })=>s ?? o,
                dstAlpha: (c, { blend: { func: { dst: o, dstAlpha: s } } })=>s ?? o
            }
        },
        depth: {
            enable: (c, p)=>p.depth.enable
        },
        count: (c, p)=>p.count,
        framebuffer: (c, p)=>p.framebuffer
    });
    /** @todo Handle `merge.update` if `grid` has `merge`. */ opticalFlow.step = (state = opticalFlow)=>{
        const s = state.onStep?.(state) ?? state;
        const { on: on, pass: pass, at: at, frames: fs, input: i } = s;
        if (!on) return s;
        fs[s.at = (at + 1) % fs.length].subimage(i.data);
        pass(s);
        return s;
    };
    const ofgPre = "opticalFlowToGrid_";
    const opticalFlowToGridVert = (0, $c3a4c4b89537eec0$export$dc207adda608f979).replaceAll((0, $c3a4c4b89537eec0$export$b4781c2237bde956), ofgPre);
    const opticalFlowToGrid = demo.opticalFlowToGrid = {
        to: to,
        vert: opticalFlowToGridVert,
        frag: (0, (/*@__PURE__*/$parcel$interopDefault($4e3a9d42358121f5$exports))),
        count: (0, $c3a4c4b89537eec0$export$832d88422d279bbc),
        rescaleFlow: [
            2,
            5
        ],
        /** Additive blend, don't look up past values, just add any new values. */ blend: {
            enable: true,
            func: {
                src: 1,
                dst: 1
            }
        },
        depth: {
            enable: false
        },
        onStep: null,
        ...demo.opticalFlowToGrid
    };
    const ofgLinkG = (0, $df94745e835b5ca5$export$bd2891254e1e5b30)({
        ...(0, $df94745e835b5ca5$export$47b243153dce5032),
        pre: gPre,
        steps: gSize.steps,
        merge: gMerge,
        macros: {
            samples: 0,
            taps: 0
        },
        maps: (0, $9ca80cadf3eaf758$export$798cdecdcbbf9755)({
            ...gMaps,
            ...(0, $df94745e835b5ca5$export$47b243153dce5032).maps,
            derives: null
        })
    }, (c, p)=>p.to.grid.gpgpu);
    opticalFlowToGrid.link = {
        grid: ofgLinkG
    };
    opticalFlowToGrid.pass = command(opticalFlowToGrid.pipeline = {
        vert: (c, p)=>p.vert,
        frag: (c, { frag: f, link: l, to: { head: h } })=>h.glsl(h) + l.grid.macros + f,
        attributes: {
            opticalFlowToGrid_position: buffer($43221ea9397f6332$var$screenPositions)
        },
        uniforms: {
            ...ofgLinkG.state.uniforms,
            rescaleFlow: (c, p)=>p.rescaleFlow,
            opticalFlow: (c, p)=>p.to.demo.opticalFlow.framebuffer.color[0],
            dt: (c, p)=>p.to.timer.dt,
            rescaleMotion: (c, p)=>p.to.rescale.motion
        },
        blend: {
            enable: (c, p)=>p.blend.enable,
            func: {
                srcRGB: (c, { blend: { func: { src: o, srcRGB: s } } })=>s ?? o,
                srcAlpha: (c, { blend: { func: { src: o, srcAlpha: s } } })=>s ?? o,
                dstRGB: (c, { blend: { func: { dst: o, dstRGB: s } } })=>s ?? o,
                dstAlpha: (c, { blend: { func: { dst: o, dstAlpha: s } } })=>s ?? o
            }
        },
        depth: {
            enable: (c, p)=>p.depth.enable
        },
        count: (c, p)=>p.count,
        framebuffer: (c, p)=>(0, $23462767626c8c72$export$d86e3abd7686c23f)(p.to.grid.gpgpu)?.framebuffer
    });
    opticalFlowToGrid.step = (state = opticalFlowToGrid)=>{
        const s = state.onStep?.(state) ?? state;
        const { pass: pass, to: { demo: demo, grid: grid } } = s;
        if (!demo.opticalFlow.on) return s;
        const { gpgpu: gGPGPU, fields: gf } = grid;
        const { maps: gm, passNow: gp, stepBy: gStepBy } = gGPGPU;
        gStepBy(gGPGPU, -1);
        gGPGPU.passNow = gm.valueToPass[gf.index.motionFull];
        pass(s);
        gGPGPU.merge?.update?.(gGPGPU);
        gGPGPU.passNow = gp;
        gStepBy(gGPGPU, 1);
    };
    /** Set up the renders when the input video is ready. */ const ofSetup = opticalFlow.setup = async ()=>{
        const { demo: { opticalFlow: opticalFlow, opticalFlowToGrid: opticalFlowToGrid }, gridToPoints: gridToPoints } = to;
        const { $root: $root, input: input, frames: frames, setup: setup, offset: offset, flip: flip, aspect: ar, size: size } = opticalFlow;
        const gpGPGPU = gridToPoints.gpgpu;
        const { onStep: gpOnStep } = gpGPGPU;
        const $v = input.data;
        const style = $root?.appendChild?.($v)?.style;
        const { videoWidth: w, videoHeight: h } = $v;
        await $v.play();
        /** Aspect ratio, `GLSL`; use `min` for contain, `max` for cover. */ $43221ea9397f6332$export$dce0f7906c5e6747((0, $7b6dab4ddb729928$export$dcfbb7940cfb3a48)(size, w, h), $43221ea9397f6332$var$max, true, ar);
        opticalFlow.framebuffer.resize(w, h);
        // Pixels units; divide `gap` by the input resolution.
        opticalFlow.gap /= $43221ea9397f6332$var$max(w, h);
        // Fill the flow frames with the first frame.
        (0, $33f17267bd9f0c05$export$79b2f7037acddd43)((f)=>f(input), frames);
        if (style) {
            style.transform = `scale(${(0, $a0fef7c841dcaa76$export$533b26079ad0b4b)((s, f, i)=>s + (s ? "," : "") + f * ofFlipStyle[i], flip, "")})`;
            style.objectFit = "cover";
            style.aspectRatio = w / h;
        }
        gpGPGPU.onStep = (gpGPGPU)=>{
            const s = gpOnStep?.(gpGPGPU) ?? gpGPGPU;
            const { passAt: passAt, demo: { opticalFlow: opticalFlow, opticalFlowToGrid: opticalFlowToGrid } } = s.to;
            !passAt && opticalFlow.step(opticalFlow);
            opticalFlowToGrid.step(opticalFlowToGrid);
            return s;
        };
        opticalFlow.on = true;
        $v.removeEventListener("canplay", setup);
    };
    const ofStart = opticalFlow.start = async (state = opticalFlow)=>{
        const { media: mq, setup: setup, input: { data: $v } } = state;
        if (!mq.video) return state;
        try {
            const src = state.stream = await navigator.mediaDevices.getUserMedia(mq);
            $v.addEventListener("canplay", setup);
            "srcObject" in $v ? $v.srcObject = src : $v.src = $43221ea9397f6332$var$createObjectURL(src);
        } catch (e) {
            console.warn(e);
        }
        return state;
    };
    opticalFlow.stop = (state = opticalFlow)=>{
        const { input: { data: $video }, $root: $root } = state;
        const tracks = $video.srcObject?.getTracks?.();
        (0, $33f17267bd9f0c05$export$79b2f7037acddd43)((t)=>t.stop(), tracks);
        $root?.removeChild?.($video);
        state.on = false;
        return state;
    };
    /** Grid fade. */ const gridFade = demo.gridFade = {
        to: to,
        frag: (0, (/*@__PURE__*/$parcel$interopDefault($c3b1ed7d8eda40f0$exports))),
        fade: 2e-3,
        expose: 0,
        scale: 3e1,
        order: "next",
        on: true,
        ...demo.gridFade
    };
    const gfPre = "gridFade_";
    const gfSteps = 2;
    const gfMerge = false;
    const gfFields = gridFade.fields = (0, $df94745e835b5ca5$export$82ee245e4549d21)(new Map().set("fade", 4));
    const gfDerives = gridFade.derives = [];
    const { index: gfIndex, values: gfValues, alias: gfAlias } = gfFields;
    const { fade: gfFade } = gfIndex;
    gfDerives[gfFade] = [
        gfFade
    ];
    const gfMaps = {
        values: gfValues,
        alias: gfAlias,
        derives: gfDerives
    };
    const gfGPGPU = gridFade.gpgpu = (0, $112a804b6949d908$export$2e2bcd8739ae039)(api, {
        to: to,
        pre: gfPre,
        steps: gfSteps,
        stepMax: gfSteps,
        stepNow: 0,
        passNow: 0,
        shape: [
            ...gSize.shape
        ],
        maps: gfMaps,
        merge: gfMerge,
        macros: {
            vert: 0
        },
        frag: (c, { to: { demo: { gridFade: { frag: f, type: type, quality: quality } } } })=>(type ? `#define type ${type}\n\n` : "") + (quality ? `#define quality ${quality}\n\n` : "") + f,
        type: "uint8",
        min: "linear",
        mag: "linear",
        uniforms: {
            fade: (c, p)=>p.to.demo.gridFade.fade,
            expose: (c, p)=>p.to.demo.gridFade.expose,
            scale: (c, p)=>p.to.demo.gridFade.scale,
            colorLo: (c, p)=>p.to.gridToScreen.colorLo,
            dt: (c, p)=>p.to.timer.dt,
            chaos: (c, p)=>p.to.chaos
        }
    });
    gridFade.step = (state = gridFade)=>{
        const { on: on, type: type, gpgpu: gpgpu } = state;
        if (!on) return state;
        const { step: step } = gpgpu;
        step(gpgpu);
        (type === 1 || type === "typeGauss") && step(gpgpu);
        return state;
    };
    /** Grid fade to screen. */ const gridFadeToScreen = demo.gridFadeToScreen = {
        to: to,
        frag: (0, (/*@__PURE__*/$parcel$interopDefault($5c5fcc32979e89e5$exports))),
        blend: {
            enable: true,
            func: {
                src: 1,
                dst: "one minus src alpha"
            }
        },
        depth: {
            enable: false
        }
    };
    const gfsLinkGF = (0, $df94745e835b5ca5$export$bd2891254e1e5b30)({
        ...(0, $df94745e835b5ca5$export$9f9ef40fe2e7f9e0),
        pre: gfPre,
        steps: gfSteps,
        merge: gfMerge,
        macros: {
            output: 0
        },
        maps: (0, $9ca80cadf3eaf758$export$798cdecdcbbf9755)({
            ...gfMaps,
            ...(0, $df94745e835b5ca5$export$9f9ef40fe2e7f9e0).maps,
            derives: [
                [
                    gfFade
                ]
            ]
        })
    }, (c, p)=>p.to.demo.gridFade.gpgpu);
    gridFadeToScreen.link = {
        gridFade: gfsLinkGF
    };
    gridFadeToScreen.pass = command(gridFadeToScreen.pipeline = {
        vert: (c, p)=>p.to.demo.gridFade.gpgpu.vert,
        frag: (c, { frag: frag, link: { gridFade: lgf }, to: { head: h } })=>h.glsl(h) + lgf.macros + frag,
        attributes: {
            gridFade_position: buffer($43221ea9397f6332$var$screenPositions)
        },
        uniforms: {
            ...gfsLinkGF.state.uniforms
        },
        blend: {
            enable: (c, p)=>p.blend.enable,
            func: {
                srcRGB: (c, { blend: { func: { src: o, srcRGB: s } } })=>s ?? o,
                srcAlpha: (c, { blend: { func: { src: o, srcAlpha: s } } })=>s ?? o,
                dstRGB: (c, { blend: { func: { dst: o, dstRGB: s } } })=>s ?? o,
                dstAlpha: (c, { blend: { func: { dst: o, dstAlpha: s } } })=>s ?? o
            }
        },
        depth: {
            enable: (c, p)=>p.depth.enable
        },
        count: (c, p)=>p.to.demo.gridFade.gpgpu.count
    });
    gridFadeToScreen.draw = (state = gridFadeToScreen)=>{
        const { pass: pass, to: to } = state;
        to.demo.gridFade.on && pass(state);
        return state;
    };
    const { onDraw: gsOnDraw } = gridToScreen;
    const { onDraw: psOnDraw } = pointsToScreen;
    gridToScreen.onDraw = (gridToScreen)=>{
        const s = gsOnDraw?.(gridToScreen) ?? gridToScreen;
        const { gridFade: gridFade } = s.to.demo;
        const { on: on, order: order, step: step, gpgpu: gpgpu } = gridFade;
        order === "past" && step(gridFade);
        gridToScreen.framebuffer = on ? (0, $23462767626c8c72$export$d86e3abd7686c23f)(gpgpu)?.framebuffer : null;
        return s;
    };
    pointsToScreen.onDraw = (pointsToScreen)=>{
        const s = psOnDraw?.(pointsToScreen) ?? pointsToScreen;
        const { gridFade: gridFade, gridFadeToScreen: gridFadeToScreen } = s.to.demo;
        const { order: order, step: step } = gridFade;
        order === "next" && step(gridFade);
        gridFadeToScreen.draw(gridFadeToScreen);
        return s;
    };
    demo.view ??= [];
    /** Resize the canvas and any dependent properties. */ const resize = demo.resize = (s = demo)=>{
        const demo1 = s.onResize?.(s) ?? s;
        const { to: to, gridFade: gridFade, view: view, onResized: onResized } = demo1;
        const { $canvas: $canvas, screen: screen, grid: grid } = to;
        const [vw = innerWidth, vh = innerHeight] = view;
        const { bounds: bounds, limit: limit, detail: detail, gpgpu: gGPGPU } = grid;
        const gShape = gGPGPU.size.shape;
        const { size: ss, aspect: ar } = screen;
        const [w, h] = (0, $3920c9be8d12f64a$export$b54ddf06b57709b1)(ss, (0, $7b6dab4ddb729928$export$dcfbb7940cfb3a48)(ss, vw, vh), pixelRatio);
        $canvas.width = w;
        $canvas.height = h;
        /** Aspect ratio, `JS`; use `min` for contain, `max` for cover. */ $43221ea9397f6332$export$dce0f7906c5e6747(ss, $43221ea9397f6332$var$max, false, ar);
        /** Grid bounds resize proportional to screen. */ (0, $a8bd34883e6c6917$export$871de8747c9eaa88)((b, i)=>limit * $43221ea9397f6332$var$sign(b) * (0, $118b47bfc49fdb1b$export$4997ffc0176396a6)(i, ar), bounds, 0);
        /** Grid data resize proportional to screen. */ gGPGPU.resize((0, $3920c9be8d12f64a$export$b54ddf06b57709b1)(gShape, ar, detail));
        /** Grid fade resize matches screen. */ gridFade.gpgpu.resize(ss);
        /** Aspect ratio, `GLSL`; use `min` for contain, `max` for cover. */ $43221ea9397f6332$export$dce0f7906c5e6747(ss, $43221ea9397f6332$var$max, true, ar);
        return onResized?.(demo1, w, h);
    };
    demo.fps = (demo.fps ?? true) !== true ? demo.fps : (0, (/*@__PURE__*/$parcel$interopDefault($78ce2a669c6df413$exports)))({
        style: "color: #fff; background-color: #0006;",
        max: 2e2
    });
    demo.start = async (state = demo)=>{
        const { opticalFlow: opticalFlow, resize: resize, to: { timer: timer, frame: frameMPM } } = state;
        opticalFlow.on && await ofStart();
        addEventListener("resize", ()=>resize());
        resize();
        const timestep = timer.step;
        const checkFrame = ()=>(0, $df94745e835b5ca5$export$1c8f61c1db5300d2)(to, frameMPM);
        demo.queued = !$43221ea9397f6332$var$isFinite(timestep) ? frame(checkFrame) : function loop() {
            return demo.queued = setTimeout(()=>demo.queued = frame(()=>{
                    demo.queued = void demo.queued?.cancel?.();
                    checkFrame();
                    loop();
                }), timestep);
        }();
        return state;
    };
    return self.mpm = to;
}
var $43221ea9397f6332$export$2e2bcd8739ae039 = $43221ea9397f6332$export$13fba5ef04f03938;


const $fbc445317b306564$var$query = (0, $43221ea9397f6332$export$f40320abe5266d8b)();
const $fbc445317b306564$var$test = $fbc445317b306564$var$query.get("test");
const $fbc445317b306564$var$report = $fbc445317b306564$var$query.has("report");
const $fbc445317b306564$var$$root = document.documentElement;
const $fbc445317b306564$var$$canvas = $fbc445317b306564$var$$root.querySelector("canvas");
$fbc445317b306564$var$$root.style.background = $fbc445317b306564$var$query.get("background") || "";
$fbc445317b306564$var$$root.style.cursor = $fbc445317b306564$var$query.get("cursor") || "";
$fbc445317b306564$var$query.has("fullscreen") && addEventListener("keyup", (e)=>e.key === "f" && (document.fullscreenElement === $fbc445317b306564$var$$canvas ? document.exitFullscreen?.() : $fbc445317b306564$var$$canvas.requestFullscreen()));
if ($fbc445317b306564$var$test === "p2g") {
    const s = $fbc445317b306564$var$$canvas.style;
    s.width = s.height = "100%";
    s.border = "1px dashed red";
    s.margin = "auto";
    s.imageRendering = "pixelated";
}
(async ()=>{
    const mpm = self.mpm = $fbc445317b306564$var$test !== "p2g" ? (0, $43221ea9397f6332$export$8069d817115baadd)($fbc445317b306564$var$query) : {
        $canvas: $fbc445317b306564$var$$canvas,
        pixelRatio: 1,
        api: {
            attributes: {
                antialias: false
            }
        },
        head: {
            test: "test_" + $fbc445317b306564$var$test,
            kernelSize: 1
        },
        pointsToGrid: {
            // on: false,
            quads: true,
            framebuffer: null
        },
        grid: {
            on: false,
            // detail: 2e2,
            // detail: 1e2,
            detail: 96,
            // detail: 4,
            limit: 1e8
        },
        gridToPoints: {
            on: false,
            // gpgpu: { scale: log2(96) }
            // gpgpu: { scale: log2(96/3) }
            // gpgpu: { scale: 4 }
            gpgpu: {
                scale: 5.1
            }
        },
        gridToScreen: {
            on: false
        },
        pointsToScreen: {
            on: false
        },
        demo: {
            view: [
                96,
                96
            ],
            opticalFlow: {
                on: false
            },
            gridFade: {
                on: false
            }
        },
        passes: 1
    };
    $fbc445317b306564$var$report && (mpm.onStatus = ({ status: s }, e)=>s !== "done" && postMessage(`mpm:status:${s} ${e?.message || ""}`, "*"));
    mpm.$canvas = $fbc445317b306564$var$$canvas;
    (await (0, $43221ea9397f6332$export$13fba5ef04f03938)(mpm)).demo.start();
    $fbc445317b306564$var$test === "p2g" && $fbc445317b306564$var$$canvas.addEventListener("click", ()=>{
        const { pointsToGrid: pg, gridToScreen: gs } = mpm;
        pg.framebuffer = (gs.on = !gs.on) ? undefined : null;
        console.log("gridToScreen", gs.on);
    });
    return mpm;
})();


//# sourceMappingURL=index.7ac47ff4.js.map
